import React from 'react'
const SvgDataMigrBanner = props => (
  <svg id='dataMigr_banner_svg__Cryptocurrency' x={0} y={0} viewBox='0 0 684 400' xmlSpace='preserve' {...props}>
    <style>
      {
        '.dataMigr_banner_svg__st1{enable-background:new}.dataMigr_banner_svg__st25{fill:#dddcf9}.dataMigr_banner_svg__st26{fill:#fff}.dataMigr_banner_svg__st28{fill:#5c90fe}.dataMigr_banner_svg__st48{fill:#f2f2f2}.dataMigr_banner_svg__st233{opacity:.39}'
      }
    </style>
    <linearGradient
      id='dataMigr_banner_svg__SVGID_1_'
      gradientUnits='userSpaceOnUse'
      x1={0.106}
      y1={199.999}
      x2={683.89}
      y2={199.999}
      gradientTransform='matrix(1 0 0 -1 0 400)'
    >
      <stop offset={0} stopColor='#5c90fe' stopOpacity={0.1} />
      <stop offset={0.287} stopColor='#5180fc' stopOpacity={0.071} />
      <stop offset={0.613} stopColor='#4a75fa' stopOpacity={0.039} />
      <stop offset={1} stopColor='#4872fa' stopOpacity={0} />
    </linearGradient>
    <path
      d='M683.89 112.77V400H201.38L14 291.82c-18.44-10.65-18.54-27.91-.21-38.56L435.84 7.99c18.32-10.65 48.13-10.65 66.57 0l181.48 104.78z'
      fill='url(#dataMigr_banner_svg__SVGID_1_)'
    />
    <g className='dataMigr_banner_svg__st1'>
      <linearGradient
        id='dataMigr_banner_svg__SVGID_2_'
        gradientUnits='userSpaceOnUse'
        x1={272.375}
        y1={254.372}
        x2={298.205}
        y2={254.372}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
        <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
        <stop offset={1} stopColor='#dddcf9' />
      </linearGradient>
      <path fill='url(#dataMigr_banner_svg__SVGID_2_)' d='M296.58 147.5l-12.85 7.52-12.98-7.45 12.86-7.52z' />
      <linearGradient
        id='dataMigr_banner_svg__SVGID_3_'
        gradientUnits='userSpaceOnUse'
        x1={291.659}
        y1={168.477}
        x2={291.659}
        y2={254.372}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
        <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
        <stop offset={1} stopColor='#dddcf9' />
      </linearGradient>
      <path fill='url(#dataMigr_banner_svg__SVGID_3_)' d='M296.58 147.5v78.41l-12.86 7.52.01-78.41z' />
      <g>
        <linearGradient
          id='dataMigr_banner_svg__SVGID_4_'
          gradientUnits='userSpaceOnUse'
          x1={278.745}
          y1={168.477}
          x2={278.745}
          y2={254.372}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
          <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_4_)' d='M283.73 155.02l-.01 78.41-12.98-7.45.01-78.41z' />
      </g>
    </g>
    <g className='dataMigr_banner_svg__st1'>
      <linearGradient
        id='dataMigr_banner_svg__SVGID_5_'
        gradientUnits='userSpaceOnUse'
        x1={286.294}
        y1={290.744}
        x2={312.124}
        y2={290.744}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
        <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
        <stop offset={1} stopColor='#dddcf9' />
      </linearGradient>
      <path fill='url(#dataMigr_banner_svg__SVGID_5_)' d='M310.4 111.09l-12.85 7.52-12.98-7.45 12.86-7.52z' />
      <linearGradient
        id='dataMigr_banner_svg__SVGID_6_'
        gradientUnits='userSpaceOnUse'
        x1={305.578}
        y1={204.86}
        x2={305.578}
        y2={290.745}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
        <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
        <stop offset={1} stopColor='#dddcf9' />
      </linearGradient>
      <path fill='url(#dataMigr_banner_svg__SVGID_6_)' d='M310.4 111.09v78.41l-12.86 7.51.01-78.4z' />
      <g>
        <linearGradient
          id='dataMigr_banner_svg__SVGID_7_'
          gradientUnits='userSpaceOnUse'
          x1={292.668}
          y1={204.86}
          x2={292.668}
          y2={290.744}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
          <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_7_)' d='M297.55 118.61l-.01 78.4-12.97-7.44v-78.41z' />
      </g>
    </g>
    <g className='dataMigr_banner_svg__st1'>
      <linearGradient
        id='dataMigr_banner_svg__SVGID_8_'
        gradientUnits='userSpaceOnUse'
        x1={604.735}
        y1={320.964}
        x2={630.575}
        y2={320.964}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
        <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
        <stop offset={1} stopColor='#dddcf9' />
      </linearGradient>
      <path fill='url(#dataMigr_banner_svg__SVGID_8_)' d='M628.77 80.01l-12.86 7.52-12.98-7.45 12.86-7.52z' />
      <linearGradient
        id='dataMigr_banner_svg__SVGID_9_'
        gradientUnits='userSpaceOnUse'
        x1={624.024}
        y1={235.07}
        x2={624.024}
        y2={320.965}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
        <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
        <stop offset={1} stopColor='#dddcf9' />
      </linearGradient>
      <path fill='url(#dataMigr_banner_svg__SVGID_9_)' d='M628.77 80.01l-.01 78.41-12.86 7.52.01-78.41z' />
      <g>
        <linearGradient
          id='dataMigr_banner_svg__SVGID_10_'
          gradientUnits='userSpaceOnUse'
          x1={611.109}
          y1={235.07}
          x2={611.109}
          y2={320.964}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
          <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_10_)' d='M615.91 87.53l-.01 78.41-12.97-7.45V80.08z' />
      </g>
    </g>
    <g className='dataMigr_banner_svg__st1'>
      <linearGradient
        id='dataMigr_banner_svg__SVGID_11_'
        gradientUnits='userSpaceOnUse'
        x1={438.795}
        y1={357.822}
        x2={476.255}
        y2={357.822}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
        <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
        <stop offset={1} stopColor='#dddcf9' />
      </linearGradient>
      <path fill='url(#dataMigr_banner_svg__SVGID_11_)' d='M474.35 43.57l-18.64 10.9-18.82-10.8 18.64-10.9z' />
      <linearGradient
        id='dataMigr_banner_svg__SVGID_12_'
        gradientUnits='userSpaceOnUse'
        x1={466.762}
        y1={233.263}
        x2={466.762}
        y2={357.821}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
        <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
        <stop offset={1} stopColor='#dddcf9' />
      </linearGradient>
      <path fill='url(#dataMigr_banner_svg__SVGID_12_)' d='M474.35 43.57l-.01 113.71-18.64 10.9.01-113.71z' />
      <g>
        <linearGradient
          id='dataMigr_banner_svg__SVGID_13_'
          gradientUnits='userSpaceOnUse'
          x1={448.032}
          y1={233.263}
          x2={448.032}
          y2={357.822}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
          <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_13_)' d='M455.71 54.47l-.01 113.71-18.82-10.79.01-113.72z' />
      </g>
    </g>
    <image
      width={166}
      height={127}
      xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKYAAAB/CAYAAABlubmQAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAOGhJREFUeNrsfelu3EiWdSxkLlos 22WVoYGnYAwEDOC/fgG/RD9PTb1O10OU//WfqZ9jYNDGjDHjLn9uueRFSmUml4jvnHsjSKYkl901 XmQXAwiRTDGZXA7PXeOGMWMb29jGNraxjW1sYxvb2MY2trGNbWxjG9vYxja2sY1tbGMb29jGNrax jW1sYxvb2MY2trGNbWxjG9vYvrpmx1vwj7Yo9yzG97zB3R22cbx3IzA/GAjjR4KTAnYE6wjMDwTG H37Qe/b99+93NOxv0v7x7SBVEh7v/QjM9wYkgXgZCH/8cfPe/elP3efDvfD5n+JlYL0MqCOLjq2H YyQgN/u//Vt0WHb9z3+OHsuu//TTT8VPP8Wu47ONfu5/G99Nx+qOnX7rwjmMT2YE5DvBOATfv/97 LNmxLv0//iNOLvb/mOT/D/bvQPuPgHR8Un8okX05IP/85z/7+OdNMGYQZtD99a9/nf71r1H6Tz/9 9+y//zte2vM+7Ph+B9oM1iFIR4BebO6PB8gNI0b0x6Qv2v39fWv+ZOzPPxv3YNfYR4+M29t77B4/ Nm5r6wm6cbPZIbpxr18/8//6r3fddGou7dvbxnMf7vv0qfH8Lo/BY92/r8fe3dXfgn5qHz58yGdh eS5Jp7XZ0MoMn11VIzC/EgNvE5A/XALIh7Lc3X0AwDxy87mxj/eMAPHoaCZAnE7vujdvjH/z5sgD eH5np/TcLkvjF4vjYrEwqR8X/Iz/4z7cF9vyXR6Dx/rLX54KUPfwG/yt/NvDc7kMoLyGPwpAv+oL vEQEWrWcf7Swlg1Yyj548MCAtSwBcu+eMWA0WxTavTfWOe3Hx8PtVzjOdcN1Hu/09M3G7+zsXAOE XpsQ9rB8heX1GIKJbWvizZtG1vN202g/PDQRLGqWSxPBqBHnZnBukVY+TjVeZs1/zW6m4o/g+jnn 8lGRjaYMaSzEtX36tLCvXxd2MvG2LA86YJanL53z1s5vWgByz56eEpge/dTumB2zsKd2Or228et1 fYqXgqA8BSg9QHgSd0KMoY3xb3+LcWfneiAoMzDr+ln8y1/auF438c6dBgA9jDg3uQIwKP4+EDdU AqXNYIx6kcDn1+di+toY08YBIoeApGikrxFEZKnbzeePwJD3hCGPjp66yeSOvXNHGfH1a5AhlsXi tXM39uzZ2Qm2d0lQAOvC2aW1KyeAsFtbc7NaLTfuI8R1PDsT4MQZmDHOI0C4DWieAqQxbm3thvDy dWy290IIx3Fv72Ygg0IXjVX1tANoVR3GzKADZnwLe35dPtCvBphvF9tDQP5s7+MpkyUnExXXv/76 zN25c9ABsjh95dzN69afGbcsTp0HOVq7TfZ06/US63NbVStHkLLPgMKqWtspfmudfngC23u1Ep0w TiYzQHHJ9yVOpyDNdgvbCwA1hnmzE9otkGp4BeYki76I16/fChmg+/t3gor4RxDx9+LJiYnQPN4h 3r8OgH4Fxs+mOyVb273YzsYFWfK+VQvbiBFCg+S77w4cHjgMmFdFVb0pqi1fQBSXdViUbeukh7Ca tO0KcHMTwG86nQLXk9kEwn0aYwVM2mmc2OlkYnU9Oq5P2Ln/ZOLku+3CTfRYelz+Bn+rqrz89nR6 y/NcdnZe+H/5lzuw/I1/8sSAze+JDgxQwor/2eVr+poNpC8ZmO90/2RAqttnCMjnYi1vbR0LIMGe nuCYTh3Wd4u29WU7deVkslUSUPgZAGo2UdBpt7aalaUAcQbqnJlau6wbdifr3He9rrFdTwOAymPx mACr/AZ/i7/J366qkwTQQgD63Xf68tDtxHPnS8WXi9c0fOk2AfrDOYCOovxKim3+7+HDJ+7wsIA4 vmNfvjxy3367b/HAHUS5o4herU49RXZVYdPP8Wflm8Z61xjvZlPXNBU+NzCBrGvb2tvWOFhItm0b l4xj/H6ZTR8R4TxN74sAyyb6aQmzx4S4hij3psXvttA1qVdiPbbhzIQGy8lk3rbtaaCYb5oYtrYC lrDtoYM+e/YcFv3tkK34qjKxt+BhHomI34jNb4jzL81A+sIY83KxTffP28Q2ReHuLqipvAP2eeFn s8I/e/Y6sZOB2F6AsXYKilaI3nIS1x07Gojmuq47FmyaZg4Ncoa9+NlceynLAG2Rvf88dewLkM/l u7bt2dWo2F9DPY1Tm1iZYr5n0LK87ieTm8KeW1tl9qEK66sf9LHLjvqBt6FTY75kB739cgBpftPa 5rVkf2Q2bNiPj5+7g4PbatgUQ5ak+D7zBYm0tr7BEgaQD8EWeTnFsg2maK31MWIPK5/70hrXomO7 Y8y21XuJY8fMmGRJjx6cB2M2MHpMO7EFV8CYdetd2YQ2tn5uGrBkSwb1fop1A+ZchskktE2zjW7A nq+FPev6Rrh+3YgV/+SJWvAPHtwNX5uBdOUZ891RGw3rMWJDBvn735+kSA31syNhGjKOGDZgyfXa kCmh2y1L6nllOS+DGCnKYKUulSHBeK1thQ2Lnh23ANQtnNa2TUuAdRv/5z5bXM//y/taSyYt5zxG i2PxmGRSU9pZDRatqmaW9NfJer3Gck3DKRlfZyWupVADqSioG/N6yP40kCgNfr+BNDrY/88saYQl v++iNunGGxXbZMl7wpC7u8+ANmNfvaLIK8CQztH1E6fUH3egR1JXNGBAV+D4fr2uCt/awhS20Pth IdabEqwJTdAW1pVFUTRQFm0BgAqb2mCocbrYtB58K4wJmlPG5KF58sEEbAZcBAjSgg1baqaNLUC9 EUxJVbExDVRV8KBp6rptYPTUZEsehp/xe5OJMCh0Wxem09gCmLxOsOetAIDa7747gP5p7M2bJuDz CPUlQo3p7hzuU5Yslzno7VXVP93VBORFa9vwrf+x16PeZm1n9w+ZZTK5IdZ2BcZRPdLAyqbbZ52s Y2VJI26eRvS/xjZzIFF0yJDYDlIYrBi2XQzbFoyIz7cheHeiIzti2YQdwH+bXbbRW6NL7svv8Ls8 Btm0DhU+C1uWOmmruiioW3TYZOkre5dDBlUX06tXZ6Wyvlrwf/vbq4LeBY3jP/e9/mnO6Z8Pvyj9 0141sd3rkT8IQ74takNZVzwFzR3eldDhy5cUZ8fu9NRh6cCU4LrSQW/cdkUN8desCtEnW+iM3hYe OmTwBqxJdizJnqWLbRkdwWuxbtJ6wP89eC5wG9LYgRJDgTfaYT9oq3RbBRCpvuMkSuwjOqC3gC9Z 07qGAUmwaAMKhYYArdbGmqwItpV1F0zd4nPa4dYW2K4aNynBoLHxfgJWXSf9cwWds7fgZ7MdLMmg Jly7ZsLf/34Ub9zYl5Dn48dPUgSpiu+vf16N+Lu9imI7GzdDQOKGyvkOozbTX41zd1Rsl+VLFdt+ T9w/dP3s7m65+mRVNAmQfm79alWXeNAFwAzRbEsCEv/EskBvJwJQR5BCxzPctiUwXuDZlxbiHK+O GEHAH1UC4EmMIEs8Jhkkxg9gSmMnYJuuIqiaACHegggwGgGjq/HdDNBaAeor3W4anAO3O/DiFJtV qABOqgCRYBRXEyDbNhMaSCcwjEDJ272BxAjSN98IaMW9dO+eidA/zcnJ/QsAHYLxKhhH7iqw5Nuc 5H06mort81Gb4jvTiW0aBhTbr18vxGk9pfN6sZqUu7OSIjGi13WDjcnU2maGJzuHKIUYbedQLeci Vq2Zq0EDsRsNDBjPz0R0W+lGOs55B2cOUW3TEt2kfsn/5DsQ/XZwHCihqhokIwkwELUhUMTTSGrZ eW502hsYSXU2kKYTIwJD3FvqpKeBtFvM576g+pINpOygz+L9bQ768+J9YBzZPyBjXhj8ZS8X23wK j8GQh13GTxbbBcT2mYjta2DMBcBpO/eP37YeTAG9EmIbojvGOolsW4KFwJIQ003Lb5eUjPj5CRkT nEtPOdaDrANQE5xmCXDAtIilMqbzJgYPwgSxBkp1MGZSQxyZBhvRBXqKjHWtiPEIYwasid9Rdowm MaatoG/W2K8KpiWTVmRQWGFVcJHGkLCqiHfdbnxLs8uAVWFIFSre6W4qSxj9J4tQC4O+6Rz0VXUz 3LhhQp9m9/hCgshVY093VVjy8th2FtuHlu6fnHALBhDHc7l/3dMRTcZQBzl2CU7cP+t17/6xTTPD YxSWNK2yZNuGLRo3QVw5ZC2zVZAhxcCJ2xDb24bGisW6dBg6ZEy6gmLcNmnbyLaRdf2/fib/s7qv fCf9D1K/21+28X8xpmxIDK0MCrhvkckLZXFhd2F5hjkHBtJ6XU1zmJPGXXl9u1AG7R30vF9ln+Qs yc+8rzlJ+T3Z8+tmzPORm/O65CYgs5PcuIMD0znJV6sTMOOuKyqwZOGUJb3xZMe2rcX9E4oJXTvC kB56Ix40mBCMSL2SjIgO1pvAsp6QIZ2wJNYdl0Y+AwhKgDMxpusZM0LHhJ5paQAlJzs4xqY7GlUc gDaNaJ4DHZOMGesI/TIzJgykKumYYMxYkTHx/Uq2Q1vjJ2QdL0sdyLQtWDMbTDDrHBi0BXN6LpP+ iRdYDaSB/jmb7YqjnhlM6/WtQPfSZeHNIXteYhjFrxKY5948+1uRm6Mj4+7evSi2b0Bsr4Zi21sB JP2LXFJk07iBECszKGEe08jBt20S01aAiFsOYGIZ4lQ+twmQJjJzqAwU5yBqoIzfK7F/IZ1+UKOx c2w7lXVBhR6wKqKQwh0yHB8yJkTfZIN1WOeyBDhjjb1q7F/hd7C0Ckh0Q7AmQCpIFbyyngBawlBa tzSSYj2BmG+dRI8aGkdFC/FeqHhXCz62s9l2+/Ll5eJ9tTIhG0c8d2bPHx09iJ8TnPZzglITLJQl mW/x+PFjl3VJsuR0+gKy2bvFwrmbN/dSssWOa5ol9UYBJfVIhg/Vym4AyjJZ23QDFaJHRiy9WtgC PAVjmEabAIoOtprajikdgBgBVDJmxGsigQgyLSRrLAhKZx0RKMDExdiQ/IDiPRIJGEDGrmWuBsFJ H3zMrAlggU4b7FtBhAsrAsNYJnDGASBNXieTRmFRsd4BUFx1ZVsjDAo1VdxMBCb1UNU/NdTJXtcE aGh799LLznqv68yejy+4lvjoPgc47ecA5W+JbrqAXs41A+j09JUvzq47f0Nj20Vx5n21JT7JkjHt ufVhVZcU2wTlFKCMMGrqup2IcUNmFF+kEeMGSJq0ACTFNWTwBDQ2FWBCnGdQMreXTGr1e1BRTWJL S6aUIb1JlJMpBZyW/OjSJQJxuFpeMB2aAdtBGTMKaxoBpq1xHDCnrfE9ADEKKAWcYMl4DqAq4k0F 9l4LMMmmhanUMKKLqalhagGgRecfdU0FrXq7Fv9nDbBCvKsP33T+z6Z5ldizDfR9rte9a4mifej3 fPTIxE8JTvvpQZkHgm2Ccnb01Pm7dwhO1+uSHGGoPsmy7MV25yQXaxv6YxbbCsYktgvVKQnABEYB H3XKYKYU28qWFmwZwJY2sSWOJ+JcQclx4ABCZspCoo5DYApjxk1ggjWtejYlLIkPCMqka0YV584x P65WsW6SWFdAEqAh6ZlQPwAXFfEBDGqCS+KenyX9tIjJkvew5M2G8z6Ld7HmxUG/7NizrnfQX4f5 fK/d21Mnfds+hWi/E86D81Mzp/2c4rsD5cw4ZgFNp15Ed1HcEAOHkRvVJbd8AZZsSyuGTds5xyG6 CURvOrEtzEi2S0ZNbEPSH72IbwGoMmMnuinSjYAUuiWOR3ACXAB2EFCqwaPAZHzdOpN1S5c8KpTf Ke5sGBznQyNEcRpWcjEJTAEoxTnFuuibAesAKICE7dqRLalLCugSSEXPJCCTQUT2DApMrvdinkuK +AY6KAAvIr53M2XjSB30ZM4z0T3rmuKdhhFFewvWbAPzPrPe+Vvg/JiupI8IzA0/5aWgZCbQ4eHd pE+qO2i1euMnkwxIJwy5vT1LumRVZpb0AGZtGjVoGjVsYtYfAU4DQHIdNlFiRCMWtxg6wp5uQ3QL KK1VQHZMacGUACPZMqaIj+qVYEwGd0gZwJ6Y4nwJJWM4Zb3xAxvUCDJJzwRrGrXQ8c6qMQSiMgmc ZE0BqLCmGjs0hGLWM6OC1Ti3trHt9c8AgFplUlBzRcOohXgnUBlBAmvWmT2dm9TUPZlAAl0dgAzt jRvbDQ2j2ewagPoiZKv9PDhhkF4wiD4Wa9qPzZZDlxB9ZReZsgclhzjQwCmKHU8Dp2lsUZYqssMK YJwzwwegER2yKGtxjKu+CKh01nYPRJ+MHFrgAKQlWzoaMwrEbJlL+nmcqE5JxgT4QxSn+gCQubN8 C4wfBaU41wV32SUckuqZPIAAp+xgmbWuS2XMmACaLHXonYYOd7qToop3l4CHcxqAUw2iTucUBg0q 5vE5x8wFABLqjQD7PEhdk5z080lNcFK0FwXzmE/bWRXaqgMnmHMB5tzvLPZwzhH/UUW6/RRsmfVK jXU/ktxBDpnd3i6T+L6Fz94AlNcASiOgLAqom+2saMGSoaAemXRIgBIPe+IZsTHtlPqkF6a0SVRz jE6EUeMUoCqip4YMmfVMgtCYTqekXpqNHGVKk1Lgkk6ZOgGZkoMFkKwzJDQpnDkImYieiZtA40fc mVZ9mobuI9szpzCmiHg1iExUgMYeoPilnj0JwmQQRQGmXROkBGi0bQKqMmhr2qoo/Nq2BCa226ZW kNYCzsaVKuLV99lkcFYVRfu1FgQifk81iB7Hw8PDkC7vwlDiLwaY59lyKMKZzJsjOTRwTk5eApBe xHdmStwkMONawMiO/ahPgiVLMWygS06h6amVLRGQIEDkso126kRkm6lJYFVDx6nYtvI/BSS3jQKT LEkHenINZUAWPSAtRbdLaRqOg3oJzJTeaM0GNPmgkjgHODmWHHtrfiaAid/FulVjyBkmdnTsieOK xS6hSw4gMurj7EV7Mnqy1Z6MI8PRwxDxMWaAtvgMIl90VADUNhVBKuLeVdQ9K9eY2kO0N/WqaZgn WoRmOt1u6tq0O5Vp/x80W4jxwESQszNZPyfSf4BI//6jgNN+fLbUZIzd3V0Zh7MFvfLX3ambzwuw 5L6I7xLW93qygOh2wpQZkD6BMjDkBlHdAJAQ4dAfwZTGKCAprrHeRnGSS0/Wtorw5DzPER0CEqco VncS4aJLAixldp53y44trevZkip/TE51UTL10wEwBYJ2g11iAmVizpAAKoAUgIpxRHeSsqgwJ40j ZU8aRCLO6xwVEjCK+AYYIW3JngRnoJHko6zzf/jp9HmsIHHW0DPFP0pgcklwNo5RpGld1kvQ6hzA PIFhtAsGPQ67ZzfbutM3H0Gk3+uZk9WSP5KuaT8tWzJOm0X4bZcKTsHQWRQQMNAnlSkLAHId60lR TGh1T6AKCSCFKYUhDRmTYnyKZzzrPpMekzgni1oR+3iAanWDKalDUmzbJLaFIaOypDrQFYya5W5F p7Sdaygm95DgcCO2vHlXqX7GhFJVNlWsxwFAAU5rZbQklwNgdv5OTfoQN5Lon3QjgVHBnur3VDAG simYk0C0CZDoIQESwHTOrXANCaQe4GyqsizW0HSrJcQ6nkMFcS6iHVZ6Ys6dBrql6JvXrt1qKdIv Y81enH9YC/1DA3NYokV0S2acd2y5Bbb8lWx54GYzivAbftqcFo0kHDhhygzKOUBZE5CxFEYEqUxb E2beFALAYMPMcQkbysn/TQIt9Exmpie3UDJuRK8E8ZU2iggnO3Zie2jgEJgAM9aDiO8Ye3+lFtGy yTWU08KyKN+8DQNR3rFmkLe2B6hY6wLKGBIgO5fSwLUkumcW7fhKcsaLD7QCUNcxJJG+AUizhs6x 4pJj76Bzrr13K/Cz/N8SpNBBoUcKcxKYs9kUy2Xj/ZxgFZFOcFLfZHToMtb8WBb6B84uil32uW7T 4GGG733D1LVnzwoLANqTk2MJMxbFiVsXVsqw4MJllCJ9lBLrpksoQqdkKNH3g8WEFS1Z0siAMcel MzM8vDkeGrqd4+nPcSpzPLA5Hv5cB5dhvxBnMTGrTXFxk8V7dqibbPyIW4pLcahrirqK9HTfEmiT 2yjmbRX1GdBgxK4yse2YWNQDHNN6SaczHG8U1QDTc+mMM/pbszRgKaR83dgP121nvEZePyskAd+4 9sicIcnhtPmldWbquRQXmhWVJtDvq0EJ8XpoiJfXOXdVtfRgR6c1m7Sek3+ukTlj7kl1PM1z+NG+ 7yQJ/2grPqwYz2t6trlgPixxuaB//mdj3rw5svvgpxUeCQEZmWpTWxg/Gtnh8FhoUhCrbSmxal+A 3dQthPs20YfkIabFcT4LfFBt5IOi6FY2lYepIhxSuAziGrIKPhNTaDEZOZ0uCcBF58TYUR2y1yft kCmVLdWHnoVOtP18PrFztKd9oiicUfZhnS08aGFNWEWiJqToED/jUQJtfKeaq4BeVAk1tJK+KycK wRuC7heFqlyuvaCHlB+Oyt6B5lpMzMwgfigiBHqM6imwHBtSgBXX9BcHAJTdte1uWCxeu2v1XjjC K8OadiSY5fKQRRZwrn/6MiI/g0jPJWI8D6l94afLwpez656DxDiMtm0ts8xLTbKQgWHKjq2dAazT EDST23g/g4k795kxEnsEQ7GuoIzS49SqlS7AzEYO/ZQp4ReAtJu6JJnQDsV2trr7nEWTIjzW9vcu oe3CfUzATLdFt1XTUZx2Ij1qJlJygHbiHb/eGUX4jljtFOcmJYGoI95qZCjSwZ50zBizwbPCr6xw yBWuZonPVi66Jb63wgFZ8mvFfcAG0D9VvEOcq0FUxbpyod7b26qPj9/AELrWDMX54SHO9SHO5MGm ++hD6pkfMVH4vBh/ylQ20CJEOeDASmqr1RnEhopygNM76Y0smTHEwV+NgKnAug4QY4QHuqaIoyjG DV1BauSAi1LamhmAMmZnuho9BKbViI6Ka6v6ZWbOqGN5Lopsue02V3nrgapsOexJelzYX/yeVncz mZWlcILost2LYmQiAU0aIatbOV8ZXpyvobRdUCAweNCFVKmaOGZHSSIKXvasV0cdWMdEd9zHAnRb 4CDeBUkXRNfrlj6f2e3tLTDjQl7QLM6fP39mD0UC4iwe9E96OOLyKory3zi5QxHjsMDNyclNEN8b eVi8WEaA8O66UOK9lmTGwjWmBXxVD/McY81YtVTECHT1lMBxseEUD3xgUR6QhBVD7EKLyT9ZRD5c eeAitiV1Tf2S1P+SjzLGJEI3WbJnR2XMxIAZfG+dvi+L855NNtQe0QEo1hNgY3cbbT6oVSM++Z7y gPDEs4R2lJRkWPw2JjEtrCsMy5S7UqJMfLm5dMyMgl6L+9qa/DK2nvjM3oeadr9du7Jh3TBjd/d2 DZjSHh+/sP/0TwfmydoIR79NlbP2yhk/5w0fbRxqm9d//VXBeO0atZUdrXxKNpkqqzRSekV1Ku14 oa0WGIgcZ2NsNh4AtMD0M+1JZ9QpS/CyOSeGhUlTmMgDCJEGhld3EHVJJ6DUexDfCsokumlwDhI1 bAfKAQjfBr4MXjtQSoeM2yWDdOeSmNT0rK0G1MCVpf5W3A950QJfPNyjlFkv665nXxv0fxzZGfmi t9Twqek61XMbHemppyh9xe2tbbNY5Ou8tXFtP//8c3e1H8MA+gii/PsNQZ4bxUBePz09AUAXAlJo RQzCdTeklLtTWKlbYVvcPEtwJqC67s0W5T+GZPHqMAc2GSQW9UGa9L3YpallI0GjNxsC2F5kyQzK Acgu1Skzew7E96XSJIv9vM+5/TrRn2gznZOTO+NsMsToS815oNbkl0mynSApBMhtWuYMKJuXXsbP EbfyG0GiWVp3Kd9/jo2bUsMHNO3yjP5nSLnX9ptvjDk6ei5nzFr1VNE+ZnMfXcU097qPcrkSY3C1 ZltXZ6odEZymqcmactO8L2RQQhgABoaP6Hsh9payyc5uSxcNrVQJXCc9Tv8fNwBnNafCZf8j7ZDh UNV+1wycIdLeBsp3aTXndM9uvQez7T8zXWUMXY/5GqxcHrdt7wHorjPTntM8PP1fEg7yoEPLAKmV pe3Vk0LTjdJ5TUxVpXPcMmDMU7tnPn27skW1Qmjsh1IvNjWicFFBCpc5h+Nb1v+B3/0H3GxZT9Wk pc7MTRl0Uk0hmnPZE6JVyqoUlpMr63xC+nhlBDG7bLOICEeEcJlz86IWUQI406ErGKvpZ85AH9s7 8fXXDkxY5amdoC90dZXyZiRSDZulaeR+0VlHDcnF3iUBSc20seAY3tNnEHPYT/yAkPqMr8gosGwn 0ENoJd2si1bY/J3s51P/YpL06ZA9WIbzDZjeSNlQ+OMlbqLLXEfdvvl7uScaZAmu5E5K50rDRpKO 9TpMTMW6ZPB6Gr5hXEi5d5L/Keuxz6CPvC9cti2BStso3U/BcMylE7VP4poOpziLcb7F8KPZ3d2L sA8g8W5H9UuLlvmlAVPnQWbeHivd4jJk+/btg43HBaWaLzJTLxix7m6MVOGNDUEJue0DkBn43svo riivvq5bTYCQJIi8jjtuNN9RUssk3KcjFLsHmrLJeaAufp0c0SEpgUEBoT2D05hNQF0SWIjnQXwZ KBPgExj7LuAL6tO0phuSMVjyjev8nek6GcIkykKrtqOVWLvVJBAOfNN7o8OHW5argZhvndTrbOVe QMpjyXuemDc9B4bSzNkCjJmv9cXGdd2/31eUy1NfX1Fg2mShfb/xaO4t7w22j8x1mXwJL+Ocs4zM h0VO6cMRsosJiA1unuPNdby5QQZ0SYEqOptDwE13miqWEh7k8+gkM1yHysYuOSL2ceiW5f2sSSMY xcKybRLoIVFnyOfUsWoHoB6sPdudB6PtgDcAcvfQz2Udab6mjMfoHe20SRRkMWUhWTrW5Xq7JA+u c1CbdXVMWUma7KHDNiQ7ibH2VDfJBr0n7Lyvnt37Nt9vvq2Q6KEspyGmIOcJKJMEcvPmrfjLL8/M 3ea35l2/mox56Qkr4T825n+fmm+a/Xhsjs3Ojr6ZIZylZboxXsYUBrBmC+HT6k00UiVNM22cpIJx mECKguiQBGcrWZftIFERjttOOYy1Zu2oeWUlW1wKD9BHwofbChcZ7Rp5SeKyUwHiBWAN2M+cB5ru uAFI039PRXMCf+ocSUkgWn15hPmClJaJQxCm8jIJfJJpxCEVRrKNUgKx3hP9XEZgajkaZsQHXncq 1BXwUkM/SFWMI7rpABqXq7hYnIE8tiWXNM/kRqn3WK3yaB4O/DDff/jqcB+xcCtnlN8X05x1cooD iGmI7fbNzch5bYLMdgONJnDumyRecZMMS++HGmKnBOu16L4WJzD9kBbQhRxiYoRmAwVxgzgdPguD MyZjUzVMLY+h47xT5DomX3XHiBJ41FCh78W3uJJizrvsoz4xu5HeyRQKRg1BDli104t70W0H4cic AheCjqi0jTrLbQpHxj4cafNwX4YhNVHY5qwhSRQOAGwekhGZPCx5nLhkyVLCg685lJz3muFPw4Gn PkrWupnEMPVb4c0bzt4W43W8Lr88N+baNZ7/Y/Pzz4diJRz92OdD9FlVVxiYmgrVB/gZwnry5AmU 6KmZzw90drBmN6ynpzI7wyQAUxOW1Zu4qlpwyfRVHwvLYayavECHMaMzrGgu5f/UE5irUpqgXunY MbdNINABYdlwUJBK8oYYEzE1BQ+DTzRl6QdM4JRs9ZiTOOQz27mXBHj27VGQDsIbOqVktetvJh1S GTONrFQd2cZUvUP0RqneYSS7XbPadfSkSAqJkzMnMzL30rgVQImllZQ3xsHxv7UNbQVrJw9eq4FC jsqsWbKGEoQVO2azqagPdb1MRHESt7f3Qtw1cf9/NABPkuEF5Vky1C94xY2fnjk2DSBS/507d+Pt qpVaOXwqL9vXeBt3gswWVs7aQmo+rqGYlzIG2k5w44KvORyVA6lkRKDPbGDkAYhN7wwfgKzHlJiA E1nigWHdarICHkzMCbR8WMxhjHksjSWT1JodHpKeFrO4F51UvS0xJVeYgRiOCdwXdca8n93QG1V3 DLl0TErQMDRUbJS6RpJzmQsgpHzLfN4EmEmgi1GvWa4zGAZqlnhfl3oPon4uiRuy1PsGcGr2uqkc 7mvb1nKvOXpSK3bwWjkpwbzd2uKEBLuhm5D1ttY5ojGbahzJ1C0fw/D5hInCD2RkpGQY/WpcMTfu RCq2sQb6qQyp6BKFC1viNk58weG5dup17LckCkvGkTeSddQlC3NCqJy97iwz2qfWuW7c+MUk4ZR3 mUdBatZ6oQnCGkt3LuddOo0cpUjRJdnrb0kUNl2ScMxjzDv3lh2wd1DdMm4mCWs5mZjKyShL2qRX mjQaUgogGB2QBpzLkF4BYDCbmevYbk0eatEvCdDSFOurmsH+oUV5zjW4RJw/sk1zLxZ4846OTfyn 2oRTx3AYRPkktiWEU13OsL22rIDero2dFOKcxNNpLOS6Pr82pzKwBqWNaWCXslFo8dA9re3W0eoW scgHTis8pmELau3SbZLqXgogNP4uQ21zIi/1A/FIaxg0DUQz0Q11TvUwbYYpMyCTpd1lrlv1vyaX VRr3s5HapmJbB6MlA0+NN6g0UQsipPE+XGL/Na61clbT3QSgaZyPk2z2ViSFT59xzHnBZRrzw4II MwelSap1TJuyXrZ2sgUwnkhVDk7Aen19ixr/gC3v9ZLhhy4CbT504YNPOBgts2YeXtEPRquqU6mP /puD0cB+HK7LobocGem0sMGUhQ3ADPgsCKM6zf5mWkhXeSOPN5cKbkyHY1mZlAonlTb6gWiDEZKx MF0GUrccJu0mo2iYNJx1yw2jJ2X/pLKEaTBafkGGgDTdQDR6GBIoKdYd9UlXQabWAkItI6MsGaIa Pl4HnJkOiGkbn+NXKrwFOpzXsuZRGiUJUPrmDzNKcjNh2JwLQOeKbjlpWMaUr9741cR5Dki7Vm55 mIzd8F2CM3L4btVAvJcsByOVf8GcqdIGaw+1Uxc9ABmm52sTSRU3GUKRy8BwQJrmMnLcT0y5jax/ GdKYcop3l7KYzKDQQQ9QZpm7TqRnYOp15+iRTQPROqd9B8iOpfux5Y0d+iGTrqnV3+gOCp07iGN7 OGw3pJGRGwPRQqisd2soi6nwgY7nwa9B9PsKd1IKcVFkgwGv9Ljyjx2SjNkIyhdEq45igXUZWe2B WdEvqiDVx8pyq3lTn7VlI2X06pmdQExB7NS4uWUh4gh3jyP9VtD4lngoeIfj0kZ3BpCeMVYBcJzh PjHeiXWDdbsA6LAdzyK7xX7s0WLbLGk04DYsQzYmrFVjKblgOkAYtWC1c4BY6KpoGNP7GXtRHKAf qs/Vpu8xdYcMGLuaRGatmecCrJWl0YbuxJCxvB6cW1jiGDjvKNei19XKeivXJ163M8drt7gPTcts 9SVeK8laj8xWZ5a6qXHvajV+ahbr0iG7Q1DOEiipV3LuyvZJLux62AEyPcvfk0Dw+RlzyJqXDeMd logpj417BZ5bLl/5W7eup3KDZrNETCqkVbB+uteqHEbqFl0spAW2kGG7WmrQi/HTVeRIFYMts75T 9ruwZ1cAAceNQZY0jDJ7JsZMhtEwq703hoaTOQ3Cjoll4sVx5DpEIo2CDKpTSuUNKz7HNrEkS8KY VK+IQyh0DLlL48eVJVkmxoMpyYyZJW0qUcjKG7YtxDUEa6rO9dtZmrAWtvyD1S56n6JaLH7AeXoy OIdFtQrcdpaxLll2cLsr0FpeLD1YpCL/FM9WhhrEVPOSYrsrPZjXB+JdCrSmYQlRKwZPVLRrBWEt hHABoN2QCztILD6X+qaOfHVWSr0iifFrTF8iOVp5I0q1Ny1DmKI3XTkYsqo4xtdSsDXSdWS06gbF eSAI276oFksQYn9OKpCqvAkrtqu6caz4NhuUJFyYFjpS01zham8fMfIjutZG3ZThtMU/M1b57d2w 9fiJM4d3w/r4uTzz2eyW4dRzq3ASAdTIp1PQm4nXnRYLy6NxFF9pilZCarj3YEpa3k30vhOvLoUt JUqiTITbHjiPc3bHMLxJA6jhd62UwRZrWIbPasEBjrMJpQ6v1aG8mkEfc9mY5HQfFD+wXd5S7LwF WgpG9MpcgjAwr09i3Bo6tclhzu1UVUOLaRF0AKSjXgnGdNaJJU72VJeRE7WAdYlw6LphpWFDHZIG TlnD3GsMxXY9bZbNinMDNSVLxRWhrddaHxMvdbu3d2NQH9O8V33MjzmbxWco3Hp5NeHZ7KnjfOLv U7g1z44LI1XqrefZzVhvvY7Knj5K0S2xyKXMtekL/8vgtcSefTXhIPuISA/ZQCKLcry3S8M3YiHD FqL4PL1khnesqaUIUxqvBiQ1KUSjOmLsMP6tRVsl5k/L2ylLSjHWPOoxlX/JDKnV3RSsZMo2lcE2 g/rssLjFsNGS1zpxQF8Ts59RjaJba7Jf7YrCH32SU7uZoEgdJU8IEB8+HO55J+iAeoa9jsz16/vR vHplzoKLN27sQLQscAMt9rF4w+cABwNALP4b2yIW9FkWkIl4DpKNI+Uf8XDAni0eB0QmjH4TUgKE C2QljfbQGBF2deovJIuy2m+IWu5aRnskd5LhyxB0VGVXPiYN87Ups3OQiZSyK4OVZAynKWkcSBK0 qpuUGoxaVSNKHcwoIUa6hAjQ2KrYdgLONuualWulPpEAEsTNmkRqXIEwGZfAW9DU0CEDdUk7xfqS fuI2Trba7W0jNdgBPoju62kGtWeRkZ631WBn/uWnrsH+KWbfjTZbBANwpnir6cH5KHlzDsO1a/vx l1+Mm84bMwP3vXjxGmLdxevFblh53tQlAMo5SNeiv0mWBzprW7PcmY8lWILikmWlvWQmeRehi2qh VBhFAKdGUlzOUjKalUTxyilUZBnVpUTm1ImnooDTphGcHHPE8gFi/mzOZBvp/jfqV0quIb4wqVhr moBK6xAFnXRKQqNaOZiMCCtrLTUvO7HthDnpLWChZbxrEroEvrEsJLwIcVM7MCTMrEZTBGdNQWfR ZI57dBpmUx0bTpFNYHLWCmwDhOsIyRXu3TvcmLXCmM83a8Wnmhb6AjiTGhEVnA/N/ftyI7q5IheL p2Z//058+fIoHhzsM9PFHcMwKvC0vN8VPZNNRlap9SsALUvfujYWVd1I3N0z69i7RmevsGBRJ9wB gdqAOZtWHNoeAHUQp0Hj1FKrMjCMWXdV4aIYRFKAi5m11mhpwlSxlWkd1pquilbMyb6SUkcHehdu lMptfZEsgJJMaVNZQYJRIjxtqwyaWJJLl8Q2NFz8Hy8XVEmcEvXJZjYDUy5hzASttb7N1CxPmgUg oUu20LArpwYOozlPa7LkgYjub7+9K6I7Mz1A+dnn+fmUQyviueGDOQEg5rcT+JQbRB0HoBSdB+zZ /vLL80CHLytCsDyeFnw6leJPVcWHG2iBVtPpRHydIIF1URQroGnVmHpV183KO08f5xIwXdKXGR19 f3ZhI32c7VkbW/oBF/ifdvlflHUr3S7oF8WJngGDsi1+U/GPZh+q+lFN2hZ/adpPjxEXgfvHwP/h +PobeNwLF/nb6nPNvUDH5zjPeOa9w/f8Eor2Epwr18Zr5PVOTLEGb/K2VVt2KqK9RK+qk2a9Dg12 aLYO9prVqmkZ964XT8Pe3kHLaA6raiyXP4vozsD83KD8JMbPuwyigZ+zcyeRRYeTUVH3/PXXZ+7O nQP76lU/90/JKQE4Q1qxEANJ55E03jO86TlLmummfz4/IZVO+5xmuIhpYiqwJKtYcNmmqVhsig4Z +jbJlrDSHePpyQgyw9l3ncmjwDTrSMbgpGRn69LMaKZuYfiAbiudS1Ln74lddMd1GUBpHkkaPFrw vyv2n10/mhlEo2a3mNGj225Ol6JimzNS0GFON9C7ZkM77zz/Q80lmYYeDLOfuxtCJy6XfIOVPR/F u3dNgB4EMfRUMl345h+AAcieAG4D1sRDamuwQ+23Z7CRphUZhLmItcm1fArW6VlGXyyFOaORJdmI 7KkRI7doEnM6YTJlTJwPoytYjwsolKf4rmwDkae4llOT/mfTMmo0ZmESG9q0fz6Gt/6UvyFsKfuG M2VJK1GcxLxLsqQHS0anTAkNAuxfSY6ltZO1XuO02ra4ZmHI0wYyo5ksW9yTl8wIktDi//zPM9y3 2y3dQGTJ16+pT/KeXmTJTVBa87mmhy7MZ2sKzgF7xsSeciN0RKXqnmRP6EF0+gp7qnH03B0c3I64 yXECfjs7I3vuhPrVAirodqd/TqdTMMdax8/UpgV7cpxLw4nrOHMELJEG5lEDK4X6aCk6KF1OzNFk uRl+Bh3TWV+A6cQ653GN7apjMBik0R/TVXeR0tbRJh+mlGsxrfOupv+Sw0FkLkkaWND+8Dl0xyjz 9MB4r3V6PlrZjVT7hd1V4xP6I6lTisVNtgQoZUjEGsduqxNJurYz/BbOtFq1G8YNmDE8ggK/XC4j 5ytPJDAEYsySa5yv/C3syTeXb/DR0VHHnnzD+abzjeebTwYgE2AbzNAk/dM05fXteqh/1vWSyQqV 6ZgTLArWIYMWBZiIrDnxqsNR7wwGEIe+x1Ih0anuF5TxrDCkS4yJbgy2DdgPrGniqbBkiPgs6j6t oX4prOut/l+7fobzAus60V2xftaYRuLc3pPRwew4v6xHWs2hlCgQWRIvaE1dktdKnVulh1ZlOzur W+rm1NF5r/hS4+WWgqv3798PWSpdNZa8UsDs2bO/GQQoU6pSlOiceP85UmEnQKnAX7tm2tPTWyKy KLoowpYQZev1CcC5VXuKdz+Th1kZFe8gwDWoULPAY1iBaVZZtEP9EgOJADUiVhsRs2IECaDaBFAF GsCLZasgFKC6U37G/2tXcS/fDyYZNrEX2TDK8CKcgQuTilEswYirsowKyFoBWVsFpIXY9klsr3+H 2NboWw/IYXhxUP348yPCXLm2EWPfMI4uRo0ewTia2KdPC8uJrPDA7MuXOg8l3UuMHrEAaZ4clZVy h1NIs/DWeQNJ14sislyfSwW7Goh0Xfe5bGEIuTBVcJzyVPJ+e+uHA4XU+JFi65q4wYlHGSOXuR4Z Jy84YrFtnPN1mphUpnkOg4lKdRSjTrVXlvNk3KjYZtIFk3lz5IbhxMePm/jgwV1JHvkZNEmxnaM3 lxk3n8Pi/kKB+W6AqvX+ENb7gwvWu87c+xygvG05nfTpqXMT5iFJSe1dgPNMw5s1LPcBSPGBzOIL W9/3ADXps01QSvW5VKgrSGEQbxWSDIn7KOWsWokHaVGBNDaeICPYAEQFp0zlbBofAESsd3OPc2rn QsOI/dTOW/9na/sSF5C5Kgz5BQHz0lh7d85D9rzMvZSnlj44MDbH3nsGXXjntqXuu/c01jkl4LrQ WLwwZwZo4QSYhawHrZkuwGRmkZTmCilW7iUNmPXoujHopm0iDpPHa8tYeaAUywLGFpmzbhk2JUCZ jrbSMd6NDMwrTQIkKLXZFjAy4WIbdp04ya/fklDiN98chPOAZDTtQV/t9xJAfn7j5gvRMd9lHG3c xM44+i39Uw0k1blU/3xBvUv0srLMBpLpDKSqiuJiol5XlsVKddBiFcXFFKXDcoax5NW95Iw4vmm8 iLGUEpRVd9Tuygm26dhPzv3U61hLAq8cH0vqkU0KEFCPpMtLXF++5fmJUcd+MHSS10/FhUZX2nkn eb4nA2v7nKP8aoPyiwDm+1jv+WHQ4uyjR+r/pIH0X/+l/s+hgTQZGEgEAZioYgQpA5R+QhogZapX XsAooRUvICXA6kD/4lkdm2WD7hmdUQDCmKGVj/W66fylBDVBDisb22GVPQT0GNCwWa/5u0uA8ax+ 9WqRzwuAbJs8pQkjYL21faeztnn972NtX0Vd8osV5R9G/3xsOc6I4v1tBlIW8awHz5l/OYS3aayf u6mr3Roivob4njhxWjYM4xg3ScVOmfgplYUYP2J9Cy3p19VjAtalDI73pYh1VrzgkiL7jKGkMoph E8IicNToUI9s2xeRGeV1/fWK7S+aMd/lXtqMHp33fx524n0j/r4iex6TgchKIuLXa2XQHIOv7EpY lC4mW8U11temzEUF4qpKjIpdVqaqVvQ95rE27Iw8lbFcUT1IfkgeQ8KOazurtrZC5X0Q1YIMuTzn /rl2eqtd/EZs+2sQ218RMH9L/7zc/3mZg359jc7omwKADFDqcjCMaoKFnSDV2HWozHS6nk7jOuui tU1O70r10ojOdQLT2s4hvrYxdGDkcag2OKf+yPQiCCAnkwY965Gaorb+5knY3191GeVfo9j+6oB5 uf75ffw9BtIQoGJsAChkUHHSwwhxbg498Eyc9fP5dE2A2TUBivVpTPHrtL7Okaap9HUCpIIxCBg1 8+dNMmx6QK7XQz2S53lXGF+d5A8vjW1fVSf5H1DH/HAO+nt44o8f9xlMnFKQPlDqouXpS+e+uSGT GPTT1+12U8EwS4215FlE32xt9T8K1LMa79nZwsznWqtJyy3GqPWAXsfj4xh3dq6LDsmKauogV1/k 2/TItzrJdahm/Jqe4lcIzPczkPhnOO6IMzFkgGYjieBjmh0nzdKJmKw9OZGpBmVKGHtq7MKdWE52 sJsOfDL4y2JUOzu7UpTqNfQIAlDBqOPqCcD9/X49A5JFyN4WtfmSnOQjMH+Xg/5HsKeO8RgyKGfZ yE76Z89o0T+TiVlv377NNCI67QHMY3vT3DSvnB7LuVdYXu9/4dUr6AjXAZaXAOcNLI8BSpZAvwXL OlVPAxj/93+fmoODBoC8G3sd8n0B+WVa2yMwz5vxA/rkJFnfJ/rM4n0IUK5nNxNndcsg5exuZFLO d0Og/vrrkWVxWpklZr//sX4ShCPTNPv44edSWL8H452OHbnXeUAORfUfDZBflfHzXnL9HQZS76TX TJzsZsqG0v7+YzFG/vM/n4hFDzBJahmNJ1r3dO/QiOKSn0l/vU7rt1t+j9/f27szcPvo7/D3hpb2 1+j+GYH5Hv7PyyJIbBet+IcyDimDlO6mb789E6CqVa9gzZ2+xuH2an/V7cvv8fsZjDwuX4Lh7/Vi +4evzv0zAvP/ANCLbqajDjSZSf/+93viuqHbKYOV/fC1smDe1n4o+3F/fk+ZcROMl/giY1/a7+tx /4w65gew4LMVn0DbNeqjiVk3GkOgw+0HDx5cAFKukjZw96T5cX64MAXNH0WPHIH5O42kdwH1H21Z Zbhs+pERjCMwfzeLXgQap8D+LaReZMMRkCMwP/B9iiZ+APj0U5abEYwjMD8uYN9xe0cAjm1sYxvb 2MY2trGNbWxjG9vYxja2sY1tbGMb29jGNraxjW1sYxvb2MY2trGNbWxjG9vYxja2sY3tk7f/L8AA BEH+shS1HWYAAAAASUVORK5CYII='
      transform='translate(177 291)'
      overflow='visible'
    />
    <linearGradient
      id='dataMigr_banner_svg__SVGID_14_'
      gradientUnits='userSpaceOnUse'
      x1={207.014}
      y1={57.543}
      x2={312.514}
      y2={57.543}
      gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
    >
      <stop offset={0} stopColor='#00dcf3' stopOpacity={0} />
      <stop offset={0.13} stopColor='#08c2f2' stopOpacity={0.104} />
      <stop offset={0.423} stopColor='#188bef' stopOpacity={0.338} />
      <stop offset={0.676} stopColor='#2463ed' stopOpacity={0.541} />
      <stop offset={0.877} stopColor='#2b4beb' stopOpacity={0.702} />
      <stop offset={1} stopColor='#2e42eb' stopOpacity={0.8} />
    </linearGradient>
    <path
      d='M258.93 375.21c-3.21.01-6.42-.69-8.88-2.1l-40.25-23.09c-2.49-1.43-3.87-3.37-3.88-5.46-.01-2.08 1.34-4.01 3.79-5.45l39.86-23.31c4.86-2.84 12.81-2.86 17.72-.05l40.25 23.09c2.49 1.43 3.87 3.37 3.88 5.46.01 2.08-1.34 4.01-3.78 5.44l-39.86 23.31c-2.44 1.43-5.64 2.15-8.85 2.16zm-.52-60.46c-3.01.01-6 .68-8.28 2.01l-39.86 23.31c-2.1 1.23-3.25 2.82-3.24 4.48.01 1.68 1.19 3.28 3.32 4.5l40.25 23.09c4.6 2.64 12.05 2.62 16.61-.04l39.86-23.31c2.09-1.22 3.24-2.81 3.23-4.48-.01-1.68-1.19-3.28-3.32-4.5l-40.25-23.09c-2.29-1.32-5.31-1.97-8.32-1.97z'
      fill='url(#dataMigr_banner_svg__SVGID_14_)'
    />
    <g className='dataMigr_banner_svg__st1'>
      <linearGradient
        id='dataMigr_banner_svg__SVGID_15_'
        gradientUnits='userSpaceOnUse'
        x1={223.803}
        y1={81.396}
        x2={295.603}
        y2={81.396}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0.117} stopColor='#dddcf9' />
        <stop offset={0.562} stopColor='#fff' />
        <stop offset={0.708} stopColor='#f9f8fe' />
        <stop offset={0.915} stopColor='#e6e6fb' />
        <stop offset={1} stopColor='#dddcf9' />
      </linearGradient>
      <path
        d='M291.97 317.07c3.28 1.88 3.3 4.94.06 6.84l-27.42 16.03c-3.25 1.9-8.53 1.91-11.81.03l-27.68-15.88c-3.28-1.88-3.3-4.94-.06-6.84l27.42-16.03c3.25-1.9 8.53-1.91 11.81-.03l27.68 15.88z'
        fill='url(#dataMigr_banner_svg__SVGID_15_)'
      />
      <linearGradient
        id='dataMigr_banner_svg__SVGID_16_'
        gradientUnits='userSpaceOnUse'
        x1={295.592}
        y1={59.719}
        x2={223.697}
        y2={59.719}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0.117} stopColor='#dddcf9' />
        <stop offset={0.562} stopColor='#fff' />
        <stop offset={0.708} stopColor='#f9f8fe' />
        <stop offset={0.915} stopColor='#e6e6fb' />
        <stop offset={1} stopColor='#dddcf9' />
      </linearGradient>
      <path
        d='M294.42 320.75c-.01.09-.01.18-.03.26-.01.07-.03.14-.05.21-.02.08-.04.17-.07.25-.02.07-.06.14-.09.2-.04.09-.08.17-.12.26-.03.06-.07.12-.11.19-.06.1-.12.2-.2.29-.07.09-.14.19-.22.28-.02.02-.04.04-.05.06-.11.12-.23.23-.35.35-.08.07-.17.14-.26.21-.08.06-.15.12-.23.18-.09.07-.2.14-.3.2-.1.07-.2.14-.32.2l-27.42 16.03c-.25.15-.52.28-.79.4-.08.04-.16.07-.24.1-.21.09-.43.17-.66.25-.08.03-.16.06-.24.08-.14.04-.28.08-.43.12l-.33.09c-.15.04-.31.07-.46.1-.11.02-.21.05-.32.06-.31.06-.63.1-.95.13l-.3.03c-.19.02-.37.03-.56.04-.12.01-.24.01-.36.01h-.46c-.13 0-.26 0-.38-.01-.14-.01-.28-.01-.42-.02l-.39-.03c-.14-.01-.28-.03-.42-.05-.13-.02-.25-.03-.38-.05-.15-.02-.3-.05-.44-.08-.12-.02-.23-.04-.35-.07-.17-.04-.35-.08-.52-.13-.1-.03-.19-.05-.29-.08-.31-.09-.61-.19-.9-.3l-.42-.18c-.07-.03-.15-.06-.22-.09-.21-.1-.42-.2-.61-.32l-27.68-15.88c-1.65-.95-2.48-2.19-2.48-3.44v22.69c0 1.25.83 2.49 2.48 3.44l27.68 15.88c.2.11.4.22.61.32.07.03.14.06.22.09.12.06.25.11.38.16.01.01.03.01.05.02.29.11.59.21.9.3.02.01.05.02.07.02.07.02.14.03.21.05.17.04.34.09.52.13l.14.03c.07.01.14.02.21.04.15.03.29.05.44.08l.18.03c.06.01.13.01.2.02.14.02.28.03.42.05.07.01.13.02.2.02.06 0 .12.01.19.01.14.01.28.02.42.02.07 0 .14.01.21.01h.86c.05 0 .09-.01.13-.01.19-.01.38-.02.56-.04.08-.01.15-.01.23-.02.02 0 .05-.01.07-.01.32-.03.64-.08.95-.13.02 0 .03 0 .05-.01l.27-.06c.15-.03.31-.06.46-.1l.33-.09.43-.12.09-.03.15-.06c.22-.08.44-.16.66-.25.08-.03.16-.07.24-.1.27-.12.54-.25.79-.4l27.42-16.03c.03-.02.07-.04.1-.06.08-.05.14-.1.21-.14.1-.07.21-.13.3-.2.08-.06.16-.12.23-.18.09-.07.18-.14.26-.21.02-.01.04-.03.05-.04.11-.1.21-.2.3-.3.02-.02.04-.04.05-.06.06-.06.11-.13.16-.19l.06-.09c.07-.1.14-.19.2-.29.03-.04.06-.08.08-.12l.03-.06c.05-.09.08-.17.12-.26.02-.05.05-.1.07-.15.01-.02.01-.03.01-.05.03-.08.05-.17.07-.25.01-.06.04-.11.05-.17 0-.01 0-.03.01-.05.02-.09.02-.17.03-.26.01-.06.02-.11.02-.17v-22.76c.01.1 0 .18-.01.26z'
        fill='url(#dataMigr_banner_svg__SVGID_16_)'
      />
    </g>
    <linearGradient
      id='dataMigr_banner_svg__SVGID_17_'
      gradientUnits='userSpaceOnUse'
      x1={237.211}
      y1={55.584}
      x2={252.966}
      y2={55.584}
      gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
    >
      <stop offset={0} stopColor='#f9ad7a' />
      <stop offset={0.286} stopColor='#f9b781' />
      <stop offset={0.768} stopColor='#f9d193' />
      <stop offset={0.995} stopColor='#f9e09d' />
    </linearGradient>
    <path
      d='M249.47 346.79c1.34.77 2.42 2.63 2.42 4.17 0 1.53-1.08 2.15-2.42 1.39l-10.94-6.28c-1.34-.77-2.42-2.63-2.42-4.16 0-1.54 1.08-2.16 2.42-1.39l10.94 6.27z'
      fill='url(#dataMigr_banner_svg__SVGID_17_)'
    />
    <linearGradient
      id='dataMigr_banner_svg__SVGID_18_'
      gradientUnits='userSpaceOnUse'
      x1={292.818}
      y1={81.391}
      x2={226.589}
      y2={81.391}
      gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
    >
      <stop offset={0.117} stopColor='#dddcf9' />
      <stop offset={0.562} stopColor='#fff' />
      <stop offset={0.708} stopColor='#f9f8fe' />
      <stop offset={0.915} stopColor='#e6e6fb' />
      <stop offset={1} stopColor='#dddcf9' />
    </linearGradient>
    <path
      d='M258.71 338.59c-1.72 0-3.37-.37-4.52-1.03l-27.68-15.88c-.82-.47-1.08-.91-1.08-1.02 0-.06.18-.5 1.04-1l27.41-16.03c1.14-.66 2.77-1.05 4.5-1.05 1.72 0 3.37.37 4.52 1.03l27.68 15.88c.82.47 1.08.91 1.08 1.02 0 .1-.25.54-1.04 1l-27.42 16.03c-1.13.67-2.77 1.05-4.49 1.05z'
      fill='url(#dataMigr_banner_svg__SVGID_18_)'
    />
    <linearGradient
      id='dataMigr_banner_svg__SVGID_19_'
      gradientUnits='userSpaceOnUse'
      x1={259.735}
      y1={60.953}
      x2={259.735}
      y2={161.549}
      gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
    >
      <stop offset={0} stopColor='#5c90fe' />
      <stop offset={0.287} stopColor='#5180fc' stopOpacity={0.713} />
      <stop offset={0.613} stopColor='#4a75fa' stopOpacity={0.387} />
      <stop offset={1} stopColor='#4872fa' stopOpacity={0} />
    </linearGradient>
    <path
      d='M294.48 319.99l-.16-58.69h-.01c.07-1.3-.75-2.61-2.46-3.59l-27.69-15.88c-3.27-1.88-8.56-1.87-11.81.03l-27.42 16.03c-1.08.63-1.78 1.39-2.14 2.19h-.28v1.26l.21 58.44c-.07.36-.07.72 0 1.07v.01c.21 1.05 1.01 2.07 2.41 2.88l27.69 15.88c3.27 1.88 8.56 1.87 11.81-.03l27.42-16.03c1.7-.99 2.5-2.29 2.43-3.57z'
      fill='url(#dataMigr_banner_svg__SVGID_19_)'
    />
    <g>
      <linearGradient
        id='dataMigr_banner_svg__SVGID_20_'
        gradientUnits='userSpaceOnUse'
        x1={247.26}
        y1={80.783}
        x2={278.571}
        y2={112.095}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0} stopColor='#c3e1fb' />
        <stop offset={0.185} stopColor='#bcdffb' />
        <stop offset={0.448} stopColor='#aadafa' />
        <stop offset={0.756} stopColor='#8bd2fa' />
        <stop offset={1} stopColor='#6ecaf9' />
      </linearGradient>
      <path
        d='M266 289.82c.78-.45 2.04-.46 2.82-.01l20.04 11.57c.78.45.78 1.18 0 1.63l-31.39 18.24c-.78.45-2.04.46-2.82.01l-20.14-11.63c-.72-.42-.72-1.1 0-1.52L266 289.82z'
        fill='url(#dataMigr_banner_svg__SVGID_20_)'
      />
      <linearGradient
        id='dataMigr_banner_svg__SVGID_21_'
        gradientUnits='userSpaceOnUse'
        x1={-1958.256}
        y1={78.813}
        x2={-1990.176}
        y2={110.732}
        gradientTransform='rotate(180 -856.4 202.128)'
      >
        <stop offset={0} stopColor='#c3e1fb' />
        <stop offset={0.185} stopColor='#bcdffb' />
        <stop offset={0.448} stopColor='#aadafa' />
        <stop offset={0.756} stopColor='#8bd2fa' />
        <stop offset={1} stopColor='#6ecaf9' />
      </linearGradient>
      <path
        d='M233.97 308.98v.01c.01.03.01.06.02.09v.01c.01.03.02.06.04.09 0 0 0 .01.01.01.02.03.03.06.05.09l.01.01c.02.03.04.05.06.08l.01.01.08.08.01.01c.03.03.06.05.1.08l.01.01c.04.03.08.05.12.08l20.14 11.63c.04.02.09.05.13.07.01.01.02.01.04.02.04.02.08.04.13.05.01 0 .01 0 .02.01.05.02.09.03.14.05l.1.03c.03.01.05.01.08.02.04.01.07.02.11.02.03.01.05.01.08.02.01 0 .02 0 .03.01.05.01.09.01.14.02h.04c.03 0 .05 0 .08.01.04 0 .09.01.13.01H256.17c.03 0 .07 0 .1-.01.03 0 .06 0 .09-.01.03 0 .07-.01.1-.01s.06-.01.09-.01c.04-.01.07-.01.11-.02.03-.01.06-.01.08-.02l.12-.03c.03-.01.05-.01.08-.02.01 0 .03-.01.04-.01.04-.01.08-.03.12-.04.01 0 .02-.01.03-.01.04-.01.07-.03.11-.05.02-.01.03-.01.05-.02.05-.02.1-.05.15-.08l31.39-18.24c.22-.13.38-.28.48-.44.02-.04.04-.07.05-.11.02-.05.04-.11.05-.17.01-.04.01-.07.01-.11l.01 1.51c0 .3-.19.6-.59.82l-31.39 18.24c-.05.03-.1.05-.15.08-.02.01-.03.01-.05.02-.03.01-.06.03-.09.04-.01 0-.01 0-.02.01-.01 0-.02.01-.03.01-.04.01-.08.03-.12.04-.01 0-.03.01-.04.01-.01 0-.02.01-.03.01-.02 0-.03.01-.05.01l-.12.03c-.01 0-.02.01-.03.01-.02 0-.03.01-.05.01-.03.01-.07.01-.11.02-.01 0-.03.01-.04.01-.02 0-.03 0-.05.01-.03 0-.07.01-.1.01-.02 0-.03 0-.05.01h-.04c-.03 0-.07 0-.1.01h-.28c-.05 0-.09-.01-.13-.01h-.12c-.05-.01-.09-.01-.14-.02-.01 0-.02 0-.03-.01h-.02c-.02 0-.04-.01-.06-.01-.04-.01-.07-.01-.11-.02-.03-.01-.05-.01-.08-.02l-.1-.03c-.01 0-.01 0-.02-.01-.04-.01-.08-.03-.12-.04-.01 0-.01 0-.02-.01a.694.694 0 00-.13-.05c-.01-.01-.02-.01-.04-.02-.05-.02-.09-.05-.13-.07l-20.14-11.63c-.01 0-.02-.01-.02-.01l-.09-.06c-.01 0-.01-.01-.02-.01a.7.7 0 01-.1-.08l-.01-.01c-.01 0-.01-.01-.02-.01-.02-.02-.05-.04-.07-.07l-.01-.01-.04-.04c-.01-.01-.02-.02-.02-.03l-.01-.01c-.01-.02-.03-.04-.04-.06 0-.01-.01-.01-.01-.02 0 0 0-.01-.01-.01-.01-.02-.02-.05-.03-.07 0-.01 0-.01-.01-.02v-.01a.185.185 0 01-.02-.07v-.02c0-.03-.01-.05-.01-.08v-.02l-.01-1.51c0-.02.01.01.01.04z'
        fill='url(#dataMigr_banner_svg__SVGID_21_)'
      />
      <linearGradient
        id='dataMigr_banner_svg__SVGID_22_'
        gradientUnits='userSpaceOnUse'
        x1={233.937}
        y1={116.053}
        x2={268.277}
        y2={116.053}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0.117} stopColor='#dddcf9' />
        <stop offset={0.562} stopColor='#fff' />
        <stop offset={0.708} stopColor='#f9f8fe' />
        <stop offset={0.915} stopColor='#e6e6fb' />
        <stop offset={1} stopColor='#dddcf9' />
      </linearGradient>
      <path
        d='M265.48 263.63c.78-.45 1.42-.09 1.42.81l.13 23.14c.01.9-.62 1.99-1.4 2.45l-31.39 18.24c-.78.45-1.42.09-1.42-.81l-.14-23.26c0-.83.58-1.85 1.3-2.27l31.5-18.3zm-31.35 42l31.68-18.41-.12-22.16-31.68 18.41.12 22.16'
        fill='url(#dataMigr_banner_svg__SVGID_22_)'
      />
      <linearGradient
        id='dataMigr_banner_svg__SVGID_23_'
        gradientUnits='userSpaceOnUse'
        x1={-1978.372}
        y1={115.933}
        x2={-1946.572}
        y2={115.933}
        gradientTransform='rotate(180 -856.4 202.128)'
      >
        <stop offset={0} stopColor='#2a2284' />
        <stop offset={1} stopColor='#1f0939' />
      </linearGradient>
      <path fill='url(#dataMigr_banner_svg__SVGID_23_)' d='M234 283.46l.13 22.17 31.68-18.41-.12-22.17z' />
      <linearGradient
        id='dataMigr_banner_svg__SVGID_24_'
        gradientUnits='userSpaceOnUse'
        x1={-1978.194}
        y1={138.61}
        x2={-1939.038}
        y2={99.453}
        gradientTransform='rotate(180 -856.4 202.128)'
      >
        <stop offset={0.117} stopColor='#dddcf9' />
        <stop offset={0.562} stopColor='#fff' />
        <stop offset={0.708} stopColor='#f9f8fe' />
        <stop offset={0.915} stopColor='#e6e6fb' />
        <stop offset={1} stopColor='#dddcf9' />
      </linearGradient>
      <path
        d='M232.24 283.89v-.06-.04-.02c0-.02 0-.04.01-.06 0-.02.01-.04.01-.07 0-.02.01-.04.01-.06s.01-.05.01-.07c0-.01 0-.02.01-.02v-.01c0-.01 0-.02.01-.03.01-.02.01-.05.02-.07 0-.02.01-.03.01-.05v-.02c.01-.02.01-.05.02-.07.01-.02.02-.04.02-.07v-.02c.01-.01.01-.03.02-.04l.03-.06c.01-.02.01-.03.02-.05v-.02l.03-.06c.01-.02.02-.05.03-.07 0 0 0-.01.01-.01 0 0 0-.01.01-.01l.03-.06c.01-.02.02-.04.04-.07.01-.01.01-.02.02-.03l.01-.01a.21.21 0 01.04-.06c.02-.03.04-.06.05-.09l.01-.01c.03-.04.05-.08.08-.11v-.01c.02-.03.04-.05.06-.08.02-.02.03-.04.05-.06.02-.02.03-.04.05-.06s.03-.04.05-.06l.01-.01.01-.01c.01-.01.02-.03.04-.04.02-.02.04-.04.06-.05l.02-.02.01-.01.03-.03c.02-.02.04-.03.06-.05.01-.01.02-.01.03-.02l.01-.01.02-.02c.02-.02.04-.03.06-.04.01-.01.03-.02.04-.03 0 0 .01 0 .01-.01l.01-.01c.02-.01.04-.03.06-.04l.06-.03.01-.01 31.49-18.3c.02-.01.03-.02.04-.03.01 0 .01-.01.02-.01s.02-.01.02-.01c.01 0 .01-.01.02-.01s.02-.01.03-.01.01-.01.02-.01h.01c.02-.01.04-.02.06-.02.02-.01.04-.01.06-.02h.01c.01 0 .01 0 .02-.01.01 0 .02-.01.03-.01h.01c.01 0 .02 0 .02-.01.01 0 .01 0 .02-.01h.02c.01 0 .02 0 .02-.01h.28c.02 0 .04.01.07.01h.01c.03.01.06.01.09.02h.02c.01 0 .03.01.04.02.01 0 .01 0 .02.01.02.01.04.02.05.03l.44.25c-.02-.01-.03-.02-.05-.03-.01 0-.01-.01-.02-.01-.01-.01-.02-.01-.04-.02h-.01a.292.292 0 00-.09-.02h-.01c-.02 0-.04-.01-.07-.01h-.25c-.01 0-.02 0-.04.01-.01 0-.02 0-.03.01-.01 0-.03.01-.04.01s-.02 0-.03.01c-.01 0-.03.01-.04.01s-.01 0-.02.01c-.04.01-.09.03-.13.05-.01 0-.01.01-.02.01-.02.01-.03.01-.05.02-.01 0-.02.01-.02.01l-.06.03-31.49 18.3c-.04.03-.09.05-.13.08 0 0-.01 0-.01.01l-.12.09-.01.01c-.04.03-.08.06-.11.1l-.01.01-.11.11-.01.01c-.04.04-.07.08-.11.13-.04.04-.07.09-.11.14v.01c-.03.04-.06.08-.09.13-.02.03-.04.06-.05.09-.01.02-.03.05-.04.07-.01.01-.01.02-.02.03-.02.04-.05.08-.07.12 0 0 0 .01-.01.01-.03.05-.05.1-.07.15v.01l-.06.15v.01c-.02.05-.04.1-.05.16v.01c-.01.05-.03.1-.04.15v.01c-.01.05-.02.1-.03.16-.01.05-.01.1-.02.15v.01c0 .05-.01.1-.01.15l.13 23.25c0 .05 0 .11.01.16v.01c0 .05.01.09.02.13v.02l.03.12c0 .01 0 .01.01.02a.3.3 0 00.04.1v.01c.02.04.04.07.06.1l.01.01c.02.03.04.05.06.07.01.01.01.02.02.02.02.02.03.04.05.05.01.01.02.01.02.02.03.02.05.04.08.06l-.44-.25a.555.555 0 01-.08-.06c-.01-.01-.02-.01-.02-.02-.02-.02-.04-.03-.05-.05-.01-.01-.01-.02-.02-.02-.02-.02-.04-.05-.06-.07l-.01-.01c-.02-.03-.04-.06-.05-.1v-.01a.488.488 0 01-.03-.07c0-.01-.01-.02-.01-.04 0-.01 0-.01-.01-.02 0-.01 0-.01-.01-.02-.01-.02-.01-.05-.02-.07 0-.01 0-.02-.01-.03v-.02c0-.01 0-.02-.01-.03 0-.02-.01-.04-.01-.07v-.05-.02-.07-.07l-.13-23.25c-.03-.01-.03-.03-.03-.05z'
        fill='url(#dataMigr_banner_svg__SVGID_24_)'
      />
      <path className='dataMigr_banner_svg__st25' d='M265.81 287.22l-31.68 18.41-.12-22.16 31.68-18.41.12 22.16z' />
      <path
        className='dataMigr_banner_svg__st26'
        d='M257.75 286.07c.31-.18.56-.04.56.32 0 .35-.25.79-.55.96l-15.13 8.79c-.31.18-.56.04-.56-.32 0-.35.25-.79.55-.96l15.13-8.79zM252.48 285.17c.31-.18.56-.04.56.32 0 .35-.25.79-.55.96l-10.99 6.45c-.31.18-.56.04-.56-.32 0-.35.25-.79.55-.96l10.99-6.45zM248.78 283.31c.31-.18.56-.04.56.32 0 .35-.25.79-.55.96l-8.28 4.82c-.31.18-.56.04-.56-.32 0-.35.25-.79.55-.96l8.28-4.82z'
      />
      <path
        d='M277.24 297.5c.34.19.34.51.01.7l-28.14 16.46c-.33.2-.88.2-1.22 0l-9.82-5.63c-.34-.19-.34-.51-.01-.71l28.14-16.46c.33-.2.88-.2 1.22 0l9.82 5.64z'
        fill='#c3e1fb'
      />
      <g>
        <path
          className='dataMigr_banner_svg__st28'
          d='M245 305.65c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-.4-.23c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l.4.23zM247.5 306.29c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM245.48 307.47c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM242.98 306.83c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-.4-.23c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l.4.23zM240.96 308.02c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-.4-.23c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l.4.23zM247.03 304.47c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-.4-.23c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l.4.23zM267.25 292.64c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-.4-.23c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l.4.23zM270.83 294.74c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM268.85 295.9c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM266.34 301.56c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63z'
        />
        <g className='dataMigr_banner_svg__st1'>
          <path
            className='dataMigr_banner_svg__st28'
            d='M265.23 293.82c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-.4-.23c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l.4.23zM269.06 293.68c.08.05.08.12 0 .17l-2.51 1.47a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l2.51-1.47a.3.3 0 01.29 0l1.09.63zM263.21 295.01c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-.4-.23c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l.4.23zM265.75 295.62c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM272.64 295.78c.08.05.08.12 0 .17l-2.58 1.51a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l2.58-1.51a.3.3 0 01.29 0l1.09.63zM266.87 297.06c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM269.37 297.69c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM274.45 296.82c.08.05.08.12 0 .17l-3.39 1.98a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l3.39-1.98a.3.3 0 01.29 0l1.09.63zM264.8 298.27c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM276.26 297.86c.08.05.08.12 0 .17l-2.51 1.47a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l2.51-1.47a.3.3 0 01.29 0l1.09.63zM267.39 298.85c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM270.34 299.22c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM272.98 299.78c.08.05.08.12 0 .17l-1.71 1a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.71-1a.3.3 0 01.29 0l1.09.63zM268.36 300.38c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM270.5 301.23c.08.05.08.12 0 .17l-1.71 1a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.71-1a.3.3 0 01.29 0l1.09.63z'
          />
        </g>
        <path
          className='dataMigr_banner_svg__st28'
          d='M261.18 296.19c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-.4-.23c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l.4.23z'
        />
        <g className='dataMigr_banner_svg__st1'>
          <path
            className='dataMigr_banner_svg__st28'
            d='M261.66 298.01c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM262.78 299.45c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63z'
          />
        </g>
        <path
          className='dataMigr_banner_svg__st28'
          d='M259.16 297.37c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-.4-.23c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l.4.23zM257.14 298.55c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-.4-.23c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l.4.23zM260.27 305.11c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63z'
        />
        <g className='dataMigr_banner_svg__st1'>
          <path
            className='dataMigr_banner_svg__st28'
            d='M254.2 308.66c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM252.16 309.86c.08.05.08.12 0 .17l-5.22 3.05a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l5.22-3.05a.3.3 0 01.29 0l1.09.63z'
          />
        </g>
        <path
          className='dataMigr_banner_svg__st28'
          d='M256.23 307.48c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM256.22 309.58c.08.05.08.12 0 .17l-1.71 1a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.71-1a.3.3 0 01.29 0l1.09.63z'
        />
        <g className='dataMigr_banner_svg__st1'>
          <path
            className='dataMigr_banner_svg__st28'
            d='M263.35 301.22c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM255.59 301.56c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM258.74 301.82c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM261.32 302.4c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM264.32 302.75c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM256.71 303c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM259.3 303.58c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM262.29 303.93c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM257.28 304.77c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM258.25 306.3c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM268.13 302.62c.08.05.08.12 0 .17l-11.14 6.51a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l11.14-6.51a.3.3 0 01.29 0l1.09.63z'
          />
        </g>
        <path
          className='dataMigr_banner_svg__st28'
          d='M259.64 299.19c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM257.62 300.37c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM255.12 299.74c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-.4-.23c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l.4.23zM253.09 300.92c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-.4-.23c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l.4.23zM254.69 304.18c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63z'
        />
        <g className='dataMigr_banner_svg__st1'>
          <path
            className='dataMigr_banner_svg__st28'
            d='M252.67 305.36c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM255.25 305.95c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM250.65 306.55c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM253.23 307.13c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM248.62 307.73c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM251.21 308.32c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM246.6 308.91c.08.05.08.12 0 .17l-3.28 1.92a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l3.28-1.92a.3.3 0 01.29 0l1.09.63zM249.21 309.48c.08.05.08.12 0 .17l-4.08 2.39a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l4.08-2.39a.3.3 0 01.29 0l1.09.63z'
          />
        </g>
        <path
          className='dataMigr_banner_svg__st28'
          d='M249.53 305.1c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM251.55 303.92c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM253.57 302.74c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM251.07 302.1c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-.4-.23c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l.4.23zM249.05 303.29c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-.4-.23c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l.4.23zM243.4 308.68c.08.05.08.12 0 .17l-1.9 1.11a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.9-1.11a.3.3 0 01.29 0l1.09.63zM263.68 296.83c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM260.76 300.63c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM265.37 300.04c.08.05.08.12 0 .17l-1.26.74a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.26-.74a.3.3 0 01.29 0l1.09.63zM251.26 312.48c.08.05.08.12 0 .17l-2.51 1.47a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l2.51-1.47a.3.3 0 01.29 0l1.09.63zM253.74 311.03c.08.05.08.12 0 .17l-1.71 1a.3.3 0 01-.29 0l-1.09-.63c-.08-.05-.08-.12 0-.17l1.71-1a.3.3 0 01.29 0l1.09.63z'
        />
      </g>
      <g>
        <path
          className='dataMigr_banner_svg__st28'
          d='M261.76 310.01c-.24.14-.24.37 0 .51l4.94 2.85c.24.14.63.14.87 0l7.68-4.46c.24-.14.24-.37 0-.51l-4.94-2.85a.954.954 0 00-.87 0l-7.68 4.46z'
        />
      </g>
    </g>
    <g>
      <linearGradient
        id='dataMigr_banner_svg__SVGID_25_'
        gradientUnits='userSpaceOnUse'
        x1={440.39}
        y1={187.444}
        x2={461.455}
        y2={187.444}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0} stopColor='#00dcf3' stopOpacity={0} />
        <stop offset={0.13} stopColor='#08c2f2' stopOpacity={0.104} />
        <stop offset={0.423} stopColor='#188bef' stopOpacity={0.338} />
        <stop offset={0.676} stopColor='#2463ed' stopOpacity={0.541} />
        <stop offset={0.877} stopColor='#2b4beb' stopOpacity={0.702} />
        <stop offset={1} stopColor='#2e42eb' stopOpacity={0.8} />
      </linearGradient>
      <path
        d='M459.22 207.72l-20 11.7c-.35.2-.34.7 0 .9.16.09.36.09.52 0l20-11.7c.34-.2.34-.69 0-.9-.15-.1-.35-.1-.52 0z'
        fill='url(#dataMigr_banner_svg__SVGID_25_)'
      />
      <image
        width={76}
        height={76}
        xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAASFJREFUeNrs2NFqwzAMhWHLSbf3 f901iVaDXc5EulsL/H9gEnplDrKstBQAAAAAAAAAAAAAAAAAc1jGTbn7e19m5gT2OSS72Zf3lSI8 SxRW7fvR5bKu9pwdmiUKa5OnBtaCOuU5NbQ9UVi7rE2OYwvp+VqHVtqSgUkl1b6Xr772/vvZgyoa Vgt6VpXNDmyEtklg36/1kMB+5DiOo1mWqzC5FS2E9ujBWa+uS/rb9J5bk1SYhfe40shwJHV0OKVv jQo7pdH7soG1pt2E0eGQnqU9LAa3bIV5GB2K9KzxfoSxwlc/kpccvxFeDXPYnwqbObhmmfTHLFbD baiDantey38afRgxbi8FPr7/+Vvn7pIoAAAAAAAAAAAAAAAAABb2K8AAKg2A8z3GDrYAAAAASUVO RK5CYII='
        transform='translate(421 170)'
        overflow='visible'
      />
      <path
        className='dataMigr_banner_svg__st26'
        d='M460.38 208.21c0 .67-.54 1.22-1.22 1.23-.67 0-1.22-.54-1.23-1.22 0-.67.54-1.22 1.22-1.23.68 0 1.23.54 1.23 1.22z'
      />
    </g>
    <g>
      <image
        width={205}
        height={150}
        xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAM0AAACWCAYAAAB99QxdAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAATpJJREFUeNrsfemS3MbVZS5AVXX1 wkWiOLQ1DsYX/KW/egG+hJ5H9utYD2E9gPnTipgIxgTDQ5shtcStu2sDMnPOuTcTQFV3kxRFUk0R kEAsXQsKyJP33N2YcRmXcRmXcRmXcRmXcRmXcRmXcRmXcRmXcRmXcRmXcRmXcRmXcRmXcRmXcRmX cRmXcRmXcRmXcRmXcRmXcRmXcRmXcRmXcRmXcRmXcRmXcRmXSxY73oLfc0ly/1N686dl+8eWxvs3 guYPD5D0noa5tSOQRtB8IkD529/0/n/77Rt+3N/kf9n59ttv0+UgGgE0guYPAJa//e1vuNffngPI d999h/PfdMfffLP79+1j/D1dAD5+brpEAo3gGZerOwGllLbWv/71r+6vf00O+7L+/e9/93//e/LY 79Z//CNVZcWxrP/85z9rruV4+Jp//OMf1fD9+fO678jfd+5axsczLlccLBcDhQO+gEOBkWTFcf2v f/1r8q9/pVes/5rwdYP3dID6NQAaH9dIz35fEnZ+ENoBrbKkWt9//z3O3TeHhw+w/dp8/bUxP/yg r5tM+tdX1euexSPTtncz1XpoNpt7sr9cKi3D56bvv8c33ddj0D5QuW/SZfQNes9I295yceMteAuw mHOzti2AIVi4f+uWbg8P71sMZLu397W9ds24hw+Nm8+Ne/HisZ/NuH3iX7wwfjo17uXLH31Z9/b6 ff5tOr3r+Dq+Zza7J58xnz9y/Mxr1x46ANHxex48kGeK7/9Gvp/Xk/UoWwwPBfCj5BlB84EUfAy0 1CngdiBdOrA8ePDAHR4ay4HMAV2AUkBCEPzP/3wJkBh/cFBjNf7s7Gk1n9d+Pr8t68nJ7W6ff6tr I6/DewGkY8/3Ekj8zOPjmXw+v2dvj9/7g3z/ELyvAk/xF43LCJp3Dpa0AxYOwiJZQI0ELEOpQknA AU2gqNQ4FpAQBI8fP6sw4DHwP/ebzYtqMrmJbcVzW+tm87Li+cXCVATM2dlznL8FMJkMHOMJQAKR ACJ4JpOvbJE+bwIe/q4RPKNO8170FpqNv80jrtdZSMEe2K+hVFBXoZ5C/YSr98Y6p+uLF0+dcze7 Y66LxYk7O7N4/wF0jFO7XFq7v3/+GmLcx7A+5eBOMR4kvCbp/gusSdajoxvxp59MaluTmuZJ2mxC unOnxXGbqP9Q9xnqPTRlF/P1rs4z6jsjaH6DdBkcclb+Vv0qULAFLBh8BjqEJSXaBcuzZ8fO+1uy X1XPAZjrAhLnDnHuFFsMTbtv1+uF7BmzZ5xb2tVKPm8A2j1cxRLAMWlvby9xm9IZ9vfjyQmBc5Lm 88PI8wCMbEP4OV2//nne5/lHF4Dne4Dn/hZ4jBmNBSM9e4dUjIAx35Hm3MoKftFZen1FlXnVN2az SqiTUixfNc1pPZ0egmIt6hA81v06xtVkMnE1vm5i7XqakpvMZm7CbVmN0fPTqZ2EsJrwPXzvyckS 50w9mRzis8/qzUbom9A5Uj4ACtfxs4cuJEYE1XseuZ623c+07fstvWzUd0bQ/Cqp+1q95ZZaw6ho c/D99NMjNzs+DxbqKNRDOIjXa1MpSDxAspzEBcFgMxhm3J9OJjxuuJ3ia2Rb9ssK4EzT2sp7CpB6 ELmaYCR4plOH7z4RfYjgoe5E8Kjeo+ChVIS0yQaD+6KPjfrOSM9+tQl5JwjFvone8ssvxn35pbHP nxtX189AuW6AXp34qrKgZpYUzDWN9dxCh3Fty30DOmZcCNbbBvtTY3FeBrJtDU6RFTXy/VWqU9NN +iZVVYqqyxhuYxVTrKtpiHEdY0gx1LMQwjIG7E8mc+ybCCkYSdu4Ftr2+LFJn30m50DZTPrqK5Me gGeenHyd3kDfOUfjRkkzmpA7qtL7WtQiNjQdU6r85S/GkQaRhk0mN7itONPXtas4+y8gVeraCv2i lKA0oWQxjZvVkB7WtbO2DXsADLZ2r7V2D4MSGs1kZoPLx62soFnyGlzODK/B2s4MpNHabGZrfFaE tMLniBTDNdSkbiEsako6UrfZrKdtvG5eP616van6a/sqS9uAsplP3b/zqYLmtVTs1XqLwWB7KuZf NQmfCA3bPKe+omApesh67RQoQrdwRgY8AEBw1JMZpNAeRMIc5/ZsDHOIjLlzOK6rPRd5vt7jqq8J e7KGIMAigAg+AFMo3Hq9EapH4ISz1Q54juQ6eb28bl7/X/5yRxyqxVTN37ltph71nZGemctDXy6i YgZU7CFo0/HxY3f37pdiEfvC37IvoVyDnoGCGbdanXrvD6BIGL+pVtg3Pixs5bxQMR8i9rGN3lQO lCzGtgo4lnPR+govA1Dwrsrib44EqDLeBIsXY1JvcW3eg5aBSuG00DIXTYjOB/wdW6yxCc5VLbfe Vy1oGbYJxyZUbQqhNqHFdjIh9k7jbHYg1I2U7ejIxJ9+Ok43btyKYml7+Ci1Xw4sbSf43tdSNp2H RknzR6Vi5s2p2KO5evD/Z5/e+5/9bFn5U1AxnbFN1bw4UwV/sZqcpZXM8JQsscZsj9m/gVRpQaOw crSCbtGubCFB7NxytRaSJe5zm1LYd8liNfvRhf2UIrZmv3IGr7H7yenr+jXMASyVUEGkFaSQSp/e eKC0TeghVl4nr7dY2/g7njx5UdF4QekplrbDgbGA0QVf/ODotB2do58WaN6aipG6kMKczNVzP7nd 6y2kPAH0B3SorrFijIkljHoL9Y22bZU+1fUsRie6itAvAsXpwMc1CRgiHTZYZesAkJQOrPWyhU5/ AAq3bwEoAG2fAIp4nwCHwAsRVM7u1Vn/IXiwvwUe0DdiYCLXiZUUktdPE/jenq+yPqZm6oOf/T4m CU4Wj3J0wev0Hc0VGoJnpGefBhWTUJhH7t49ECafqdgXoGIvlYrRKub9IWjYwjc1XuK5znzbrisM 5MoHUwWPLWgYaFbtfY1tqJ3zFaRInVpbR2tI1SoQp5qvhDSpQGo8rtJzAvNADCSPM3gRtjS5JbVU RUb6i+8f5wIGZ4CEafG5wUYD9cg1+GxsfZNSK1tcA7ZVg48gXWt9wNablsekbaRvIeDCoC7FeBab Zh8U7mWcz/nO6xGTR3zy5Md08+ZtsbIVS9v5yII+mtp8Is7RP6ikeQsq9ogKMERHnakYKAupC2nM hOvkENJlKdJFHY+kYhudyUmFQMeo5CtNqmcmgDaBOmHwk16RRs0dKBclRhJpEiFNKDG8SJkiWfC5 B7j4A2fsgUicwblKXqPvk22S981VUhlIrs2+SB8xIKjkUWtbO+P11UXypELZ3GQBylbX+5VKHieO WIglkToMIM3xba43FuzGtN365IwFf7QfRLCYIVhKenGRLnzNRaEvT5/+6O7cuW1fvFDJotKlKPkL KPmULHs+hDUGmEoWyIlOsmB81FDM6+Rt7bh1ZUvrFTQLIAnfDebkIHkgaZKtMJwqDHZIHJU09N/I M0lYbZ63k/5LceOsCYkrJU2CpLGphXRqIIBaSJqGEsfG1Mh+NI3xfgPJ0sRN2wb5OyQPDtykbiBl Wlx7W1UTSJwVDQPZWBBDeJnibHIQwvwFpEyEFLoRr1/XEJ1Hjx6n9bpN9+/fjT8APcvlV4nhPPc/ IWPBHwY0v5WKTSZeAipXq5fZOXlI4PiGQ48WMQGLgQ5g/WrVgH5NMPhb0K+6IlhAqkDBwoRgMSZM XPI12FYdkpm4DBxID0zyBI4hLRPQaAamEV9oJC7wpu65YJSCqgEb4GfWRP6HA6VmIQbrARiAB69s MFs0eE3jjdsQNBHgARI3CqAMJJsaF7B1oG+uAX0r4NmmbLSygY6JpQ1AirPZYdh2jj5Jn312522d ox89cP4A9OxiKqYFK96Eimnoy2SJaXmjSr5SMQ50ACGtQWMMnZSybjZU7ifTrGjP6DcJWEnDbAVK lExnGaOib0HJcH1CwRLpWNIVk/YBIHCAi9sXuiVUzSlFi0mpGY4NjQWJry10bttQYPNnJqvGgqjU bb+S7ycdNKBvcV6JIcLuBfqFcL3Qbma2NeokzZQNNFIo29kZY+JMreE5TsKBSliOOkfv5Ptm3Fs4 Rz/65Df7cYPFvHsqVtGkbKDgr6qKgghUDAo0aJit4ob0S6ULCI9IEK4gSwIsCASc87XhvosTY/Q8 X5OCmYCAAYR4vYmkahU4WIWf4GkMMCpiJLe/PBfrOEM7Bs4IPQNgAs6AnlHapJZShpSMkgZ3A9LG cH+TZJs2YHsbfNImxsBgng0AtsEniBTCLwJ1M01YN60jbZuajrKFZQoVt1UKlDxNQ+nDsJwTkTwb fOLBQcT2Jo5fZSzQSOpiIPijULaPEjRvluNCsPzA2BL7+HFl792724Xs71Kxa6BiqwuoGIHiI8Di SaMMKFmoQWOgu1R1SwqmIBBwuAwayG5RsjHycd4IaEjTYoJeA50GWK+TyRTNiP9SgUN9JpkCmOFz EUMu3hdxNpgtnYagYXiaE8CQnhEsKYOHK4Cm25jBUzk5JnAwJyh9wyoACqRpDbMIAJ5aaJv3U9F5 3tQ5+vDho/TlwDn6R9R33McnXQaiXaTLt+ZiKkbp8hUkyz2rVMz0VGyCoTCgYs0FVMyYViOMayNU DOCahaCxYQF0B4CidSw7Go1QoSTUyCpdSrqPK95XmmZBtTJFM3gfViBB91Oa429zfA/Og1Z125S3 Zo4xJd9jSP+4tXmbhK7J95hsnbOkg6lQwSR0TZyjlVfqKGsU2obvlLAcAIC/Db+znmKi6ZyjtBAW 5+iiOEdfXO4cPTy863jPKdn5DLRuwZs6Rz+OSbz6qKnYdo6LyQ5KphpvUTFwcKFiNJ1W1Q2lYtif VAdQZIw/SaBiyeKhg4qFDaSKraC31FT0AZSaEsWGqqZEgaQRuoWBN8Fki8GVRKokbylJJtA9phj0 rDMz4d9An2roLtgalTAp1YyU4XcYsZzFSvI4aT0zoGbMSKO6jyN8h2ERJv58o86aCGEEKRODxEQD 2fhDS0lBquZAx1jmyThuSQHx3TjGJ+F7TQ2QqCEC0hLSj9IHzz9UgWHVlEihxX6qaGWr69QwEhvf IdY9ziJhQmsbLgCCOrQL3M/DUFWncTK5FpiJCqliDw5+Ti9ffm6ZPUpjAfSdBH2ne3oAT2EFRdoU O6HJlk971Y0FV13S/OoclzlzXLYCK2v/n//0gZUMIanrgwojvqbCu4B0Kd58ruLLEAWZin6Nmbea YXDthRJIidlZZm7O6jLb+7lIlDyzG4fZ3Lm5s1gpJTDTG5FEIlkgIdweBjHmYMzsBqtz+J6E/YRz dobXM9Rmhr/hV+A6IOWAH5w3+DuUd0nltHt4HT8bkiip9OGxKd+V9vn91kSVdFijUWnHawUJlesu ITlJjBf4bVWlkQsiecKeRjSYrbweGgvqeq9m8hz9VryXzfMieRhJXUn9gj9yMOiVvbC3zXGZ/oJ5 dpDjUlVQzf01kS6bjfOHh3PXnKyqVpR86C171sdVU4ehCdmbuij6mjBG3SROPLeOx25iaW2CpBEp Q6kS09SUfaPv4exOCQMRAb0m+2cg7DAVYIa3DL/EvE11n0X+DHNuOMWqn2brVsgZjHvAFxwMfwx4 nRgFzJZBIDERh1JH9Bsneo2l1OHxBgBc26zr8FiMBdR1rMv6jxyLXlR8PZEGBkge6k6Qsm0XYSDm aZqppy3ufTg5WUTx8YTeRP1HDQZ1V5OKvX2OSzXIcWH2JD3cL3JgJUPlGTJfHzIkTIIqJ01Db/lE 4sU0bD9IACS5vnjyZRaOMiMbm2foyNk7duZk0WMwsxvO7knf45j0b5NKF+5DUgAfkCqQIBFrSkwR mHKLc6R50xR5bHAtQu3yln/TFYN/hl8/BUfTz5EV1+woFaNKH5FmlD7Yt1lvwrWDuuG8FdN0kYop 5Xi3LDkZPEo9J6oEkogGlTwa0waGNusiIFKOaYOkLmkIvMeQQNWbBoOaj1TfuVKS5nVWsW0T8kNR 8vtCFgwufCqSZbHAtF4dQdKcATjWi+m4wbpvPWZA9eh76hWNSBZ682kVE6fkjnTh1iUPCZOlCa1j 0FsAEDorRbJEnPd0akKiJOo1kC7UY6g/aBQA9BfRYSBZkhFdhoH+21azJGkBGCTq3syLGJtxGqdi 5v6i23TmZ6uWNHymrPhbdnZC8kA64LgR/UUkDiURpAilSlJJw33v3RqfKibqaE22rgVGGGTLmzpH a+s3a8gQRhlMIH2CM+1FzlG1tM07S9swc3S9/jwWfefyeLarXezDXSnpMrg3ahXbLsDH/a+zz4Uz VsnNr9XR5lk7rK6v+y4KOTjh3nXtaobIr9e2ixWzjEJuncSKGYkX66VL7EL3/dxLbFdSi5QX69W+ hd7isvNQHZeqr4huAKnCGZ86i8sOUEoW/J16CsBmSds6QwFUe9mK0k6F3dIk3a+kd1TkSfnEmJCS AFnoHz5DjA8OUihLMNGBIHjB5OT3iP6URM/JVjj+Lkgd6F2YRvD7HH6vOkf1dxZ9zXaWQUofsRpC 76nralZB1+PvYiR3SYBLA+coACPWSNF3mj+evuOugnRJl1Kx71+b4/K/JrfcVo5L01Oxkmq8XjdT s2k7M2pLJZ9BlVTyrQ4sUYRTb0I2xYwcMygynRETMM4bUfB7KkbA4HgPg68DCx6tAsUo5VL6Resa Bjr1HPXX0MpVWSNxaLLirtT96vQ8SwakEr/G92SpBhpHCWjNgMrZpN9Po4JNAp6UTdtJAZRpZdRI ArNtJrfZsCF/DwQSJxEjEQ8hKICYG8S0B2hTs6YJHXg0GHQta3xtMOjxIBi0VMr5oauUY65oCoL9 faXL5Yr+ZVRMvPnVbftiQvPxc6zXcwblgIpBPJCCSeZkUBrGWLHdwEr11stA7B2SpF+BpmRLqjaB xi3KfjR5YJK6OVNme/H+ywCmpx9SAhKoimLmzQNdt970gZni/Scls+rul7pnKZUJowwGO2AmtnjV ZbjQGJ2UrolhwBh1etqkBgJLUzSUNHGAmmwoMAl0zTT4e+OEqkHhd+r8hC7TKF3rDQSQVmI0iDRF RxoRjEQXJEYTeL7P432tGAjEORpA13aCQUFbQzEYlGDQWbsfnoOqzZsXsd3fDgZdr19V7ENTEK6C oaD6vaTLReEvA0Vf9vcGVOzuXfXm/+lPtyXHZSKhLx6gMBKFHGoHetbnuIgfRGbvtq4qAkapj/eV BFbiT3VlA2Z/gMBn7z19LDjGKAZIROFmdLKct8XTb7OXX/0utJQprXKpxvCt6eG3el/F099tU/KM vhTpHhNTZ6yGzFiLwUUASSANwTMs+KIqjdaz0JPElwAtSnQNdRt+ZoqYC2Q/4Lo93uKxpZQSf45Y 67imWCUrVruNBI1G8eNs6DvqgM5AUkYq0J8DaQfaVqueJlHamxAho22oWDaHQGP0RLRt5WroUS2+ 2wEiqRZrG3U2RjDgOQI8zjWB/p152FQ+thsHnYeWN/GtxeNjY2/eNBGTYzrv37l1iW+nqHwfDjju KgDmogzKoVVsf5BurDkuSsVoqSk5LvQd7Oa4GNAGAEY8+iHrLV1gpdUsymI1Ipcn9So0hTqLyRRG LGfZKtbpLaIrpD2hQNBXRJ+wnaWr1zuM6WlWpmB4yuwjI2ZnpgawxBNNz0mAJYMsSyXr9Jjnk7zW SsJafr+V92eQukrAm+mb6Dt5pcUNq1jbxNJGK15SXxFGwJ5EF4hOprStRBb0ljbNGGU0A19biZ4j qdqi/1W5ig4jJl4XDNoO9B2lbKrvnP1Hi31s5+88cn19tsNBIKhGgAwtbB9Sz/mQ9Gwr12Wou7CH y33WeM3AAWAsb9quVaxagIrduJiKqUVsA4kyzTkulCqtBEg6xoqlMMmUC8fFm29UKafvBfoGLWGX UTGRLqboEk5mYNEvVJLUA6uYbk1ZMdgpYXTG7axkuu0nizx5dtSMk4taioYULZmeponUiXmuxRjG L2AKAZgOLWuQXmphMwmrRA8EkTi0tDlLq1qbJUWXVkDK1vt2SOfSJvEY9AzAXqdsWRNLGwNBTe/f obWNsa6vDQYNzN9ZC12r6xIMCto2iGdrGiOUbTcF4aJYtiFd+1BUzf5egBnWRO6DK7/qwl9o1+8d lDe6yi90UNb1tt4CbiCRyARKcVCmpp1IQhijkMXjH/qoY2NzYKWXsBfqLp1SLSCi81KtVPk8S/lJ sKURa5ZYsbivJuSiu2RTsiaWSQgKQVKkR67ZvAsW4Vu2dGhWsAwlczGzpkuAMwSP6jmsWKOAYUKO UjZ1hApoyraF1GnwNuo/W+ARYABAtgCogCUl0W3EZG0VPDGDRsGzGwzaauJbAGgc9B03SH5j+nWu lFPXs/bk5CxOoE0OTdQASrxxw3SBoF98cTdS1ym/+/cCjv19ALMbjVx0l1IqqUiXm13YvkoWl6WL GUiXHLa/NnX0WdGnkt+K916UffHkSwSyUgSCht58lTK9/8VK7WS+FiBJnVm3lmMBis0+lwyYXbAw Tkt0hwjguE6yqLe/6DDbgOklTN7anRDnXuV9JXBEx0lpB0AKHAIo1xVQ345GFLQ2x67h0kTy4NpF qTep9+8QPCJtTMpA6YFEY4EaD1IXSa2gAVggbcQPFHPyGySPDb6B2rbl32F0AaVOVc3aWkpNGUlB KFEFRepwq+kHD9O9e/fEZ8XUg+Pj++lDA8deBcCwJjJD92kZm049pIt31Zlz/ibDXyBJqoVvmrnk uOxnByXzXNbZKuYhYaI3QsUoUVzK0iUr7z5LDIwskSwKENCwlKZQJYpDUn0eGTCRwZZCwzTQknqJ 5r8koWJJAhs1oHEoXbJFLEsZYVjZabkNmF66bEuZS29kljap2AeygeA8eNQSZXPYDbcsyIHLyZLH qOQZUrYieQQ8EWCSjNAt56jJUsd0jtEMlmxZi0Pg2JzLY7KVDRKH4KkApCD5PI0U/fAB0mem0qfU aiOA2jaGXuo8jwcH1wPDcZbLNvZ07Yf01Vdfxd8DOO8VNLsOy4vMyVT21ZSsQZakZcxzuVEduVVN wDDPZVWkiscNF6Bg5pYcF9VdTN009OZX4tXvKJgkg5kMFHUqRtkH/cqRyFasZhKykq1hKl1ijkzW nP4BFZMU5ZzbH5NKGeYkp+Rzjr+ulDJWUGO1cayxHTpUd1GyVuLMiqxJ559Jtp5ddKzWNPnwbeAk aji2lzq4lKBm6lj2BTya0KYR0x14IHEgmSWywAh4SNlyVIHk75Cq2UzVUg8kp5IHVyS0rYtns2Jh awggKwBK2VRddXk8eCQAlWnPzlYqdZpFaKHrUOcpUmezOY6MY+tN0wqcy6naRwaa84BRHeYiwBAo HvrL6fS5p99FpQuzJ5dV0V1UuSdgphVDXqi7eC8B7NBdNPSlp2JZgQ9xStAoHTPTovQTKAIeq+Ey LgMmxRzKb6JQMdFfMlAKaAgSTN3qexET8pCKFUV/mExmO5D0wOljqbaA82ZPLPW2Ad1P+oFbAOro 2lawJ8HD9ILU6zpGaVtfFkrMxNm304NHjATOdgluNgeCFt9OCQbd1Xc0RId/76jaxorEaRsCaTLh ftO6FgCaZYNBA4lTMeBgAQDNW5qlnz59Eff2roWi5xTg3LvXhRcNy0m915oE7wk0W47LgZWsp2RD wJycPPXUX1hbjEo+dZe2tVXbbqqaSn41E8DMGIlcYYBvwoR0rCj2hmnGSemYWMigEqnOYouXXPwt mH6nKl3sjs5iRNFnVHKhYkaclb10KWApVEwAQ1Nwli5dlPJ29uUFVGyLhl0kVbZAtCtltqKf86DQ F+xKHNs5Q4uxIImV4byxoOg7uC9t7xw12TkqPh6JnhbnKPUdOkit5OxkY0ECcFzWd1LWd8y67Mt5 SCExGAQp9iG0jcBhPFuwDfQdTH+2zvpPairqOqBrNBK07RkkTgyzdQybDJzl8kmmag/Tixf3YrGq 8be+b5pm36eU6RyX35W8l20dRiSMh4Q5Nb4HzIFIGCj8VVhCV5EySZpbL1taxQiQLkzfTNSEHKZq FXOi2NM/QelykQk5pYEPJWlgZUlFzgp+rRQs9SnJA7D0VMyqZMlUbChhiod/qLcUMOwA542lzXma VgCzTdku13dYi1DMcyp1rIJny8q2Q9m4lSBQCQpV8KRiLDCSKv1KfQd3ZF3oGh71OojeEzbGK4hs 8Jm+tQ2I9oaWtjYDh0YC56YNxkkHnDWAoxLnOIqOc7KOiy/uxmKOPj426X3TNPu+pcyQltFpSSsZ fTBFh5mCktGzT8C0rasOq7k/i+u6+FoAnnqzaSd8BZ5hr9grYKadzyUaMR1HBmOmHIflVPFX/4ud bOks4nfpKFgtCn5PwURvwW+pir9FIpKNk9pkyQwjkwtQ7EC6dPRrBywXgsO+xVNL5mId57XgEdpW ag4UKxuBo5EFpG+q72RLm1I121E2mqhNNlHTUGC26FrWdwgY6zqwUOok0XnsGqjN4AFwGKojoPPY NgBPJToQaFfj2k1jp9WmA05jwDtMO2tMaEDXDtYm/BcUjREEoPMxh97EwW8dSON3K23cu5cyW8GX pvhiqMdoDJmG8k+nP4vSTx2mSBiakwtgCBYFiZlUVZ1plp1V9O6bnOsR7R4o1yDQknn2fQ6JBFZK UKUtgYqS2yIZj503n1mRJadl6NHP8WQmB1RKWE7SOmViAEjFgTnQZZIroTEXUbNt2mXfftLqjQrl nu8ClPuy9oCW+DaVkpSQvP4+Fq6LLODkIZSVqQ2mRFSnqa7QC9mGSiO2mRO0p1mnuKfM4XFuT3N4 Bveez4EBsAwYjWnOioslatpKJDYjFQJgwADTMIV8mfK5x2pSV2rkqaqwrpp6Bbq+qFb1KfVd91La Iv7stKepji2OMY61HGFihgGeVzj2rKccJTyGQoYZloxSJhJ++eWJ29urIHFu2eKDAWBcR8mCSpjN Ros5QDWc4Cqpk4hUYUgIMUfJwv2kiVi40XEaNaNSE7os9RwnZmWNClYzMz35qrf0PpeUB4zUVc5U zEiuy4CK2Z6K2R3dZThodbCmoUSxO5Yv+Vv6jU+y0LuhlBlItLQr0bLTtMRrOZl59crybxCpKQYD kDUWLaS+UwwcIUWCqwDNenXa2hzTlmPsUqwkosA63kevMXcg2GDhAEolPqwYvYYP4fuCdIvD3Jc0 QChzwEoUq5ZBaIlmCOa1es+5bZk2Gz6S0zSZHKQYP0+MRzw6upXa9l4i9WdeTv+rv736fppel+kS yDrlnzkTdF4yjuxPU9OF89f1IYkXZpGVmI85u0TqLJXJvSn7kH6v0mYKOjaDiJ+GmJhHLzOgy38T A4B1DL2fnndQaviLgMbmYEXRYWQQVH3oi+ouGmwog8P+Vir2q61kv/ZBXmww2DEWvFrf6ZyjljRt oO/khDfVd5SyaRCoKXqP6Dcm+3ZMV3tNqVlkJIGao2kcoDVN911ayb5zKxPCGnrOSv6Ov+GS12xI XdfV2mHbQsfZbFTXqevYrtf77Wz1PKz3roejIxNoTbu7MPHBjm4zuAfGvKO2h+8FNEOLGZPHKGUY fPfLL1Ps33Gz2TNpt7den1bUY+p6XtWgZSsxGzegY5MMGDNl2n9L8S2gIFj8FLOW5IsQKJGpw6AM kreScAwpo8o/qESuBoOps6+lXByUAxNyKQ17uVXsYm/+rzAhf7hgwst9Om9oLBg6Ry/Rd4pTNG9t jigQE7UYCWL265jeelYAI2CxGSwGILErfOEaN3pF0OC6VgSMT37VEjxQ+TGViu4DEDUOwPE2Ng2A A2nTQpcJmJQDIwao2wxN0GpJ+xtYz7fpXeo11fuSWt99p2H+h4dfG/JNY+6Zuv5R9Bk2dF0sTkDR SH/m4KUrv2hsVaemSvUkpyKzFlmQ0kg+GCj7uRpKBgy5cAEMHvMsyd+zMSDnwCRda/ApVfSNhu4r lchm5Oyg7KlYcgUwJseLDQHzNlTsw0aRd9+XLqNs1u5YFXrqJnU9GG9NqGStSP5LEgwqhaUGDtzE UlLsAeI0hCjnCLEkVYrODF9bJLSG8bMsNd7Y5wwlMDgBKN8YaawIQUqLOkg+toVr1pE1F90cUgVy q/bW6Rg6jDT1//ijsZ99piW8lssH5uuvS1rBt8MUi6tGz9RqNqRmg6jlXPjiGBLmltPUVydSJkZt jETJUmFtQMcoXaD+TYuCKCDxBEnMrSP6ohJSpIIULWZlPofIiIOT8Wa4v6w1NohEzlYx28WK4Vl5 d6mD8upRsd9C2bbOFedoEslyiX+nD8cp/h21rGX/jrMthnY2UWsA6DDZTSKls+lZpExUSUPpgo9f QYwvKV3w2iXQIcf4dEgcSh5KIi+UjdKH0gZPadM0sfF+D3TNgKa9CJPJNWx/jEdHt8NiYbL5+XtQ tOM0dHa+K9PzO5M06RLli8gHNbP+x7v21l9umf/85zkAdJ1zEaTOUovkQce3zZkP9cRPTO1b00Ip D6KsGynMFyYmeAl7EeolFVtstnSlXJPLaKKY6jY5MrnXYcSMnJPDSh4LY8VUugwAw1lzi46lc1aw IlF6pX433s5ciWVHypyXRKkU5kvFyqQ5pNu6Dud7m/LkIbInSepoFLmBv8n9ivJem0OHOg4ogsXJ l2rLECcJDGJqxO0Xn5Bj4pyJAa8NjH3DA2ijGmlYVkuCQ6xMcglMmaUQrVu7hWP5NrASYS+3b982 oGgS+EvQGHP/vd3Xd0fPBsKQvhlWvWSu9x6NiuauOQY1mz69ba9fv242m2IS3cMPXrsQNr6aTkTE g7hWWMTCAnomVA23pYpSGVK6iRE4UhtZlHwJi0laASaZzkxadJjObJx6CWNK6H7npEw5dF+dlKqb WbsTJ2Z3JMjvTsV+C3hydEIaWOEuJCEyeUhYjoiZUpNNbodQOZuDSC2Zhs33QSFWRBZJCNNMhYXR waopDARLG6kn0Q/EaIRcrUeos2O3XuMrV7m2bWh4zhMsDdv4+I1g0x4dHWE8PbO//HID+3rl7KbC yjbva3n3mZsiaOjMVKRTn3ny5LG9bW4b1Wd0Xa8XkMQr3gQ7ZUGkoDekthVYbPCxCZIrk8pN7Jsg VRqir5mKGtms4S9avYXF+KxYxhhoWRyVyfSZkiYDRs3ItnsYeYos2ZLuVZHJQ7Ds+mCu6tLXIdgy 3AykjDXbvzepIzfrddYMAlKl9FTOKB1EeqvlMVXluRnJUI0AgfMmS3sCgsdSkpddE62mVdDkj4mR 5mnPjtdWakphW+Mxhsa5Vp6TgKWMo9NTXusN+T0//vjEKrv5YetZFH/Nu8ru/AA1Au6Z//2/1UVo Tow5PX0JkDhQtgNzdraCOJ3aptnoQwhWtpbAsYEqIG6g9qTUG8sbHfhHH2n/L6H5MeV6AFaDKa1K k1JbDDcXABA/i6QRi6prt3QXN/BVbOktg+Mrq7u8pS6bdo9LtmgukzQ0Hgx/s00pS2E1EAiZzTpR DinKExGPXZ6YcN85ziOfB/ajUVoMGaSTly2FRvgsSC9YzzrRbmdDEBMr7XIq8clU8Lfl8sxeu7Zv jo+f2z//+br597/LVX5l7t8/N5NfYUlzyfLLL8e4Rc9EnBpzYJbLpZ3NZmqSH3ivZYubBLDQiOKk a55sOfCjL1s7kBJ609nVNXK2ksIVZTa02WysD0MOSShc8ZL3XvPtwb+d63IxQD5SwGz/sJ3jQebo QLIWimrzb07dagcWxQKkfLt0P0tsu2Oud4PXJ7G0SRi2rHwmTPixQcFZMWegbcVFjQlWKzEwxGBu MPGegPKXX3HHPH786L0/k/cKGqYw90csF69i1GGGmM/3zHq9slTe+gfHZMIAGVHl+BSfXW1SssWq OMg3O+aH1z2waPOj0KouxcJlu4ckroaUiXfqChTagem1DAD7WmDYj7zx4tvUDXur91xwLteeyjfS 0ROWynHuaC0LHUHeezkGcGRb11Bb1/kFC2P29w+TeV7e8eSD3LvfpVjgfG8/8QfrTZj297W4y2Qn 12Ed3FCd8/Qmbz0RgY7LaSJiQTW2OPD0IL+S8r44VmzaLlxR8lBMGj7qQejJrn7wUS92t7y8KdHS XYRPKoaDPuGtP6emabGFpC0nad9YN2kVezYMofIveXFdeV0rQoU2uGF5qvze1Nd4Y7UN7jdNSykj 8dTEzCztpTyEesxg+fLLu3jfDx8vaNj5tz86xvpM9k5lkliaKX34uAW8SbL6XLxo6+ZF4Eb+odVF jtm41RBLKm/ybY8EDsOYihdbQ9/zw4v94+8e7PAB7Q6ioef8soF2fuB9PIC5LGpgGG6T8t+GoMg+ HY2QFi6XsuDQqAE21JVaBKKNSG5OztVxzNfRfYbkJD4/xzaI7G2j5yUZjo85iD+Iz92JgbpNkDSx qmox7zCgcInxs7dHf8yJOTq6zrAZc/v2ne5X0XrGbM5sCninbskPJmk+++wWbseN9PLlS4HNHmOM 00weRJ1BIzclVdFjTbxhcvOkJJ7kuVtpm2dL0W+tKJk0eYprKQguzjdMbJzejCkPjj6AJLFUxJDV h1todNTBYLdCMIaVLYcz8C6wPj5mdv74opCa/LsLm0oDZpUnJikPFaRIodU8HKcpBLz/4vDEy/iM tNJnLiHFBDe2c+c+/hjwKfIcU+knmpwACa+OYquWMdCkPLnGJR9gVPfqwQGv/lmelLMZYGuyNhJG 8wq2eBVB89D8v//32Pz4I/efmoODI5UL7I2UVrLPdD/oenJzWIC+weoiAcCZyLP3SmulTtcgozCv 3b7kt0c5trm2VwksLL1cNKGqT+/lAxkOhBzVmBO0unyTPMOmoWTZlUzpqkudASjOHXc0bCcGzeZ7 kieX0N0bAkUAkwe56UtC5XTpnOWpK0visjyUsxKLJpEC7Nom53Nim2yt9A6VZ8kuBJw1k2fBjQpr HXTyNGkyMXE63Ys6jo4EPJyUDcYZx9uD93wv37nJeZgx9+DBA7vZfJ3u3DGJVOzly5vdDJHSmbgB 2NNulXJrPFIrVwUHIkunl6P0kDYO9BL7JrLkK+3/jj4Wp7aCpC33hCaL8TNaVU+UV9g84OXQZGVH /NQgg2JqE9OC1GFXymGGEQEX6jADS1oa+DkKeK6UVW1HLzknXfLfeilqz0c967anYVKQMDeWYhiN 2akrYBjxbDRoE7dyUxLQSuHB5CIT0PS8pkJjn44YtgdxDR4+EwJaT17mK6kJzaKH3icpsDGfz2LT nMk44njCaJFte+fLtFnw+h+of0OkzzdXFzR5sGwtDJpjGI159Mj893Bq/vKXOxK2zR+YTg3L90U/ SbGK0+DDhql8uDmN9JOkVHAML485V0P8NNkpGWWs5+Lh6iZIwzpiTj3Q8hLbKa95fEg7y5z2K+ek DrKVqrAFQB1ghj6bLnxm4Oawu0C5YuC5VHcxpWFDSuf0lqyEZ8qaeukiaQKU2poabZNIm452mdya 3UgGp0iSnAot4NhODXASS7bGnV5HyeI0Uj/Asrh6kPQC9sRpKynr1ITJpBLAVFUKpN3suDafH8bN 5hlA83n673+fmJOTtfnii0UJ1hzWC3in1s53HrC5O9jMIGBTi2iwjwxzaU6rumYtZleXtGZmaTJv Bkx3CjhPvamnQdMCZnhs7Pal9YiNnUWrtZMhM2api0EzkksjTZdK7FlurKThNBKHVgp905ap7chN urgM06B8rPSPjVJ43PyadObdegC/t6K/Xf5pW2/bDdLs82qiKO3CERj+ggktJi3AYbZSA7TwRm6U y/waShpNde7SAtwKn6hpAVGsQCAa2Md5zIgrPIpVsG1OI+BaaS2BkgbtNFhzujFts34RNnshHC5u hubscVzdWsV7L+7F7y/MpykWvytFz/rAPy60XLCT7+GhESsHK8F7T1HKW/887e1dxyxxFiftLLST FU1jWGUGYztMhxc6tniEnHEyxqneRE5x9GQ6Nb4wljA7bMQ6bfkx4tBhRghDy4NQvvLw1VNK60LM VTHJ5SqlIJQ2/Bzn+oJ/STMcNf5q6OgzF0QPd5RtW/J01TDtVaNi2byeMi2Lot4Penvqzc1WsRhF FyRljpQwyYreaHLnNSPAkX6djdZ6ttKaIxbAWAKEUc5hjee0wvk1bvgKD2jtAZiQQQXAsGaAFNqo qqoBUIT60TBQsRInRsbGnMYwP4htdS1eOzSxffEE1KwFNbuXHlxKzd5djYD3Ekaz20OEFI01qgic EI4hb29JDgRF7Cos4iSwYLd1EL1tFWWKI1F2FcESZULTHHcpMyaGnCQBGBIta/PMSD5mBCRWomYz raDCKkYFq5YeydYUSxqlTlR/gYTpVPo5bFnhNAhXOZsELFLKSHpaTnMeRhJcpu/sSJn3RtlKZubb UrHziWcyIwWRrVKZBmBxakRRQ0wuLig0zJbiGqyR1mgoZZd4RgmxZgEN3EABDwMOi9QRoCSRKJAy Zm1ZYCM0GzyJTQ1q1wbTzFxqwNOlQW5b41n6eQjNidR6jvFpevLkZrq5CfjjXelpY77/WprfDqnZ O7/f79HLbPtENKY7P3RszFRalZOqlXTnSbuomnpexbgWmgbg1OucXyNpz6BrIaczO61tltObma1p p0nqA5S0Z1ad6QsBWk0l6Cv+5+ZLNgd1lpQBa7RcU2m+lDM6c0HAvszs+WKAF2dyvqq+2TsGT7qM mr0dFcudB/oMTSlh21WjyVU4U7Z4Sa1n1j8blK5lGScIqUHVTdFjuuxNK9s+/ZlgoYSpZNtX5ZRM TawN9CROqJsN66BpxmbbPour1Y2g9c/WcbFgGacH9NukUqbWvKdqNO941ru4SKDZKd80LBBYgNM0 S8bkSVEN1XFMzRrNG4KHGZhewYPh3JVu4ja3zJDjlJPQ8Pi7ZDSzVdA8TUpPS6P9K7W4RtwqO7vT LkMsdbmKy/mys8Zk4jboZJZjtt5A33l78PyaGmjGnJMucbfN+uXFA3PovprvG619kWueSU0ABUvq ugyopYz6jEgX7EudAFbZ9Cp1wPS005oHaIJU3ISEAUikQVTDJribUvvMe0ialkk1qZ02c3ZKZbFA vOrneHT0edBKmw8TdRmTW6wb85HVPdstFDiUNqWy5i+/GId9goirZxnatj2rjo72AR4jEkc6AUQt N+tzYfPkS9fl3Nov2Kn3ud1fLhLY95hhjYBcSVMApHk2Utg8aQPYLfCY7W4AJldY4ZaAcdJ0qS9w rqm9MjwvrE4zNBi8S2PBby+gcVkNAAULrWMu+7PMQLLkes5bxQKlBoBSNNFf8DlrlTIsGqh1zbTu GaSJdwIcE0qhQO6n3E06ac2zsGlsXW98UKD4vQKYPUiW01zXOQAo1wUsF9U82y1N+5FU2Lxc2hRL GutUkaaxhBOtadxC+vj1s7OqEuCs+gqbAE6s2EKj1gqbiYUDq1y7OeR6zV4rbQoocjnaQWeAriNA bnUuxQLz1uYWGrmNOalbbhTbg6fUEqB9u6RH29w30/yqkrRvL3lel7o8VPS3U5fTtoQxw+qafTeB YhVLg/41pnMaa7sMI90EeirWV5yxa+nHKaZllS7qg0lajpbnvNA06SoQusLouTRtrd0EKFlKQXQA RKQLV3YRGAKmtN4oPWuGzZ7et5R5T6B5dbcAtoJj86bSi4ZtAev6c1eAQ6lDqsai56RrPpgqQOpA v8ntNLRLgBY+r1QClcLnXZlakzud2Y6ila4BpjRqYndl56BvRilLK+Vpk3YJMGmQIp2zCMWpako9 tF7fsYOqNaZrOpt+E3j6GfLiwNDL9Zbtes7ni6BfUsfZdZES7VC6lNYb54ufZzpWHJakYpjwCZ7Y dRAAkACWWPraBAVJ6XMTBYTVJpefFVDiWbfBDwFDCWMCC6C3Pz+PLNc07FXT1wPoAbMted+9lHlv oDGDvjSX0TTRb46N83elQiIkzjPPjmda09l5CGvfBFf5fW3glFtqSIdm7+vS9WyS24RLl2at0WwF NNrEadC1udR0LsAhjQNoWEnSpCJ9Uq7vXLJARc95tb7zGv/Obtr0trHg9eB5E7BcVn4255Wda7dB i2KhYl0oDC1itnQKSF3R85StYq5QMJafzUCRLgEpqi9mWOhcytFGBUh0WqsZ+6U7WgEJAWPbuvGz TMOk6PkUQFmGCaRLyx41GyhAsyMp0XQdMGxubgMmFwf8YB0D3idotmjaoIOzvaz7WfXMOLY5Xy5f +Jv1NaflR13XzIlSx7kpaNKGBoIqsqHTdCJ6T9sG7aXJ/jRBJQ9B45xnYQ7oPlGLoxewlHYcVjsO EFhSU4B6TxoYC3LLDRoLCCC2One5yeywXprLTWbP9dbk1mk+/XaPmnQpeIZS5pIQnjcqdN53Rdum YsNazWngoCwFzrUXp3rkremli9F2Grm4ecwAsWIVK13R6NkfttmQqIDcIcCytQZ70kh3AEquSqWL L13RptgutXU6qFgjfTjZl+YZJEuI63WADnM7tqBkpeB5DxjtTfMhAPOeQXNp6/NzwCk6DkuMTiZe m9JKn5rttoGlsRONBFq+dkvqZJ1HKRtBVCRPykU4XDYilM4BLtO2sk8rW2+eNrlYh82FOVTf6Sib 1Tx4c651oNkqNmg6Y0FP294UPJdImR2wnG+pcVH/zaF02QLLkIoNq2RmBb9YxBKtZNRNVNpoL5qu hUYQEHVUzPRUjD1ptJ2GyZ0AmpaA0cLmKl3Ye7M+nCkVw/q87dsHdn03Hz1Oq1tfxssa1n4owLx3 0LweOKzxvNc1qGWd5y+/vGO1Qa3J/TZPAJJDpy0E2W9zD+BZC2jUwqYNn0qDWlraIgED6cOem0rd 1ApX9J3Sf1MlUAbWUAIROK50Fsh+ndK7JlvYxM+TSuHBQStB0XlsTsk+33fTDGoRnAdPH852QbSF GYKl7Hc0rHQ+y/6W0ul5WFJ2t1ltpl8aMyZ0TIMst1po5HaAKSv8vc5C737qmtiyE0C0ChIzoGKW TWql41lundGupWUgo5i152baki7YB2COwhHo2E+BLQNvxc8+M5d0eP5wlOyDguZS4EjPmr4VOqMG St+avhW6AqcUSvf+gPuQPkYo20D6dOCh9BFjAQc5uztz2+k7cdLpPaUHZyeB+i5pxaeTxMLmpFyU FcOAzfpO6cFptEJOKg7SvoB6MVGbQYdnowWPiJ1zVTuLlOmp2VahzAFg+ka1l7XN0HyhARXbKSNb TMgaxs/W524jnZ23qFiWHNRdHD36uU0gHZI2d3UmoIpVzJqu0xl1FlrECJhYJIvTprQESm5Qq2AR 3WUf+710uXbNxCdPfkxCxwbNaR88eGBOTr6+UOn/UIB5b2E0l4R5yCigKTADJx1/d797DWYQQ/Ph aqV0bbl8Yj777E6C1AEbf5YmkBG5LTq2B3EaZnEjVWrWminYDQ7mXmhPFUifvE2MmMagcS2GKgaH UhGXYiPHpdNXbglORdimUuBbwNEabTkhcVf997ni2wk5Aa7iAM6lp3wOp2e1FQZdS8nbUhasCxsY VO+0ubezFrfYBkupe6HhPTpocqR2l/+j1S+1mzMzhdNuT80ckQwpit+aOzlbyXfppEtpcc6qmFq0 HACBYo8LFynDtujsPcPcGDEG4DhgHgMEGld56ezsfSUxaK0BYOoKKgnuP+7ddEq9ZSXmY66TCbs7 QbJMGKZzKC0BJczq37fi2aZJ87nJdOye/F5GL+dszN8NMMZ8wMzN4Y/KwBEu+p3eBRG5DINgAeu7 d42ERtBiworwDJfYYP46Pn7OTljtZnPSrr2hEokHHeUhT6eTLjIWkFgzww2iaZkcVmbHJoP9tHDO LyACFji3wGx85pI7s8meJewnVi6IrF7AY3vGvydmZtu8Jov3WKam6+eZyDiqFc6vNCREV/oocoMj jcmKjJ0S2qIZpiZ1Ffijps4PkuESQNcnfA33iySRhPuk8WAFEBLiAhaTcixY0UVo2TIS19Vd3wrX g+uVa8dUZRaJvwe/j78fANItfj/vEcCB+2N03+V7kozcP97PlvfWtLgfaQmlRMvJ4p40zQb3oSol ZXM52WWz2TBKOTbXr8+b6fqgnUwCnudTPGNW/mdp2Vth/dmjeOvWKrIRbaFjvYVMx87vBZgPRs+2 XddpN8fR5qhoeyvTtdLIthgJtPvzj+7Ondv2xYvzlG2zWYihwEPnYYh08e0Uyla6qoneA+qWXDVo nZ51nNyz02UnqPhyxEHaW91MaZneNbW1YigAcLNfx4mFzfaO0ar36xRjgVI1qb2W/TuDXB2beZrt prNockf1XIesK0ohp7K/JWmr85yTf2nTWauKPq6hccU5OaBitIAlW5ySAFrUVucue/aLZcxmX010 nBj8xkUjFjFSvcjQ9HYj/hbv620qJjrLNhUL4ee0Xn+OCfJJ6tudq+5C69iw5bnS+78N05c/OGA+ qKTpEWLTjkm1kzosWF2kDsMiKHVoj2eoBItb//vfTyLbKqzXP0PyPAvLZWjX6xM8mHkDCdT4/Rke 7JT3PEfX6gqJpZG0kDzGq+TxMlN6rJg1o+ukjkicPKOCTZ1Fo1IJ8zskTNQZVmdikT6asm6XLEwV 2SaCuSHWsmXEQOroAE3Z71F8IeoPoY6hEiNLja51nxn4UuRvfE1HG5VepZRbl+cOzMmUwMi8ihRM q0jJErHatMT7FgDBMon0xG/rpCqlb8K+EWli830wSaWQ/Hb+Zt43jGuR4JAuwOAKityqu+eTaj2d 1iJhQMP02fgAPWe/wUQI6XLYsv0f+2Yyfuzs7DH0mDtSvJzPXAMvVbpoEfNeuhTA5Kp1v0uK+e+a WXhBvFUndRhB0Jumf4DUmdjHjyt77x5FyZeW5ukvvrhlX75UqZP1nSx5lip5/Cxb2miibiQ0Ryxs XVybEUNBKyZqtbQV83TnFN0ySUsXaA3FGRgLNASnNI/ajmfrjQWp6pPeSkSBcb1T1HVF9uS+uHxr YleVvM97kbrImbYVgBUlfxACQ9OxZejLbs8YgEtiwlyJFUtULVSHyf4XlTIhh/e7EuafrWOQLq5I lgZgr7WVuZdq5W04SyHU2So2of5C6fIyzufQeNoI2nVTzciBSr4q+pvNvXSJ7+VKSJcrA5oLYtWG Zulsmn41Zauq2zj31J2eOul3A2A4mqhJ2djLEwDxvgVto4l6j9a2bKpemzr64ufBoG8VOK0J4hTt TNTF4uZ6sEAP0SjqTOW02HqaRP17HwzaOUdzi480yBilMzQ7RekEdbkXjFrVnDrwlQwkwYaV0lQp DfUbs92dLGniUbsbWKkhL9mEnGymYwRBHMSHZUtYVG++jaLwZyel2aivpQVIkoDF2ioDphIHZVVN AJYVwKJUjPFiBIyakIdWMZNuZq/+eSpmzNAytpuX9b7CYq6k9ex1ETe50nxnXRsAmuJZDiCuWQ0+ DcEDypYUPDfTn/9s4lDfmWNaW63OMKvZeHAwD4uTVawaqescoCoHwETKDGFoVQzUYdUTjDoo7K5V 6ZNUsXae/L/R2Tm2EVTKSY4cByU+yXIGZySBlAdtu2BQk5ROieIfayngzkhqrYzPBNTsFM01piWC ILeKMsPKn6lEJWmFmKQZqEMJI2WT8D1OvzM7KXtDhHjlU3E+5n4xck5MjxvQ0jWUegzfINYwoXjO ZUOCShdc4SYFj/vQ4PdU7L7c1jNImCUkCfSYtFyJg3JxsojUXfb3D0IILyLL1dEqxpix9t8mHX0m dDvlyORUzMj6rLctY93kqTVur0y1H3dVLkSam2yLXWn9VpxXzPnetbL1+o7Z0ndwDroO19jSUoMH 1OyLvhPVimOlapRYdzCExZLkk1+CXghPp0XIiaXNiaWtpVWNHD+ZM5yH3qO8HwPsjFYmQ/1H9AIr 1jYrOg91JbMUC5VY2qj3QKdI/D7oPgOdhx52XbP3PSvaNu/ruVR0I9VZ8H6ptGjsSlcW9bFixeJ3 0iKGOyrXLTqJkYKUC7UU5muV607QWQL0ldBZxAAi+d3eO5zjfYEu2KZVDd0IHHdVcvehr4j+OIce 6eYz6C9nLXUX3ndaOmnxpOWTz4eW0PXJo6hUTK1ikCw0I8fybC+zjF0lwFwRevbrKNtF+s5XmLK+ //6Rm04ryzg2RoBpVMEzCcnxi2tutYG+cwS+sXFZ39FAUPCinrJtmtq7SUXapi08rMSzaQqC9MLJ PXDUsuaS6jSRhTwGug8dokN9p48msDlfB5LHOHWEsoq+tVsNcWkoG6g0pfxUzPkwTArrivPZXISv ZFGaEgrjNLiyC6zMOonJXck0qPIib/7FVKyE7JdYMVKww2rW8s4w/CWEU9CwA6FhFzsoz1vF7h/f T+abq03FPiLQvK2+89AypZqUrY8qeAqBcdP2ITkKHNF3ioma8Ww0FngFz3rd1lPoOhjGks/jMdjp i5OUhDabqM0whu28WVrarzOaIEdOC5BSHKQc2KLn9KZom+PUjNmiZ0kLTUt4TNTCbsOQGKFkmYY1 iQNfwvhjM8zVNwOl33YBlhlIpvfmc1tVfX4LvfghbNoZqViA3hLWgcGVEwClnWSwNKBi8xei5DfN DaFijx9fZkJWvaULgaFk+UjAcoV0mnep79zbMhaAFqSnTxsWK6R/J00mIS0WNBYcRO/Poqv3qd+I H6UBvWcbO9CIUNc+QP+umk0bpq5mFABmWNfmeDaNMDCu0cEai99DvOwljksjC9hVGq+LBFnXil2A KAGf0iTXSQ+d3CDJaSsQDQJQyOSATK1GLeExRmoiJ00QUz2qC7bktVjxpTgJmCyxYVaK9DHQ0uq+ VcqngEkNo5OAD3EYMzdfogUaViqlbldJjguljLVTRlwE/Jiw2LDARWJxrRA3AeAIYhXDPQSNXqdr 10jFNok1vXsTss4EAMyVs4p9dDrNu9J36N8BQM75d3AMfQejfnLU0ldAn0HTnHIgQOdZNEXfsVnf wSBZZ/6+ak2zapp25emfoL4Dzi/+iqGXXFYrOgJuqnjRRX+IUXxAEZdkio8H7zHZ10MPPHCh+yXa wIgOtOAKUC5l7f6eRD/h99usr5jsQ1F/i8n6FXQV2Vfdi3oYpI/6W6C3mKTREfw9iTqXF/1rlRoP vcWoJz83iNXYsukG5wVUvG/NVP0tvJ/UJReLJog3f633nSFRL17ci6DOERPahXrLVfC5/GFBsw2e EorzbRo6Ri8yFlDhvLsw4jijA+3o9POgxgJzzjmqBgPh8Bu3SZuZ1QGDSXNdpQoDyS+b1Kw0JEeV bZdBoA7PgEFoOueoDFI6CY3uG4LIug5IZUBLmI6GsnSfZSTER1eG7qROmc/hPEbDfSLfI98DkBgA k6CQ7zOy2hwi5EThV2NFcc4SMAx/kUnAeQUMw14qdVJaO1k3VsFi7Wyjk8upGFgmS4a+PJP7yPvJ SYmTE8HCyYqTFievy8Jf+lTkAhb7URWR/4hbE73eWGC+N/bB4UDfeVzZqoui3naODvWdw8O5YyQ1 HaPFYFAiqQEM6fnZh+SYLpK6OEdd8rUYAXKCG1MTghoJ6iR1CRjk6XI2aMRWjAKa/ZnrDKTSsnDg 1BR6JiH+qddnQBPFySjVYWIjtMxqSdgoxxpQWREApij4fY5L8bVQd5nNUrNcJgl41aQwUtWi6CsV Y9g+640pFbsVQ3icHj5s0/37d8VQMYxEHjoozblSU/aj7fDzkffz+u3O0T6e7blTfefI1Zsz7w73 XdMs1TnqZ75t1xrLluPahvFspW6B4/HQWCBO0iigsQBSpI6TuvbsktSWpHeo81JP2jiHgV4MAV2V gCTFB7J/JrcTKZ0RSpV+6ClNFEuXZkzGGBrJmIwttDYvSWGMQBZr2G6Oy1bYvoJl0i6g6M9/tVXs vDd/1ypmzwFoBM0VDslh6s4ueJj4Vtd37HT6s/P+c3tpMCjA07avDgYVE3WWOtwGMQT4ukgYlyvf ACga3Gkiz2kj3iQpBLk3qCTelCK40i1MOolqOV2NACh9XnJOjBWpQZ3DdZYwAokV5VWqaKUXAsbl wMphjguB4r2akieTvZxBSaX+Rdzfj5JyfP3656+1il11b/4nYD37dfqOGRT0yPqOLQ8uW23E0sZW DF99pR0NoO8kBc/n6csvxb8j+TtLaCx1fQIAHUa/PoubyslMC5BANKgnvpamRFLyKfjkQV5C63zV RM0Upc264RiUdu0x1oESx3q2Z69zgQ6haOqrcS5A2jgpLM0+h/lXsMg1a1Sn4qMRC1rL2soM+ASj 1Lx+1iGzXgqQM3oBKKcfpvEs7BdoHQOo2INvUjVtBEiM2cpxYTq0X+OVkC6bzUl0s8PAGKLPP78W f/rpOJGKNc1j6IstQbJFxV7pzf/IqdgfWtK8vXNU9R0NBr1Y33lVMOjQObrZNLVzk60MUkockj6o IeIwtc5KhZsovpoooXLS9l06V1tnS+20YWqAJgtIrk0naQicEIP1rsvABI5aAkckj9A1nyVQaifY ArRtCaw8l27Myi+zfba4jCMV+yRB8270nTcJBiVlI2j2sB8GxgKtmNPWMQOG5wQ8bRDAAEz4e6yA ObxU6wkY7azjonSjzv2oFTWQMi4XyihFySHZUhB/DYEieSzaLY66TS5eoanGLigVk8BKOijbPrBy N8cl/vIsNQegYmtQsWakYn9oevZ2ztH7O87RXxcM6tw+o4v9dGpCQ6mznY8PduZbA+mTvBTjY63I StKrIwDDUlD4OAxwMChLncZFqQGl8c7ShpcXKmXVTNdvUjM5mVJNacHelABIZBy3SA+mMgMKWJtN a1yN709tQ2uYZRE+E5YAzOEgsLKuD4I0hHWH8WBt4k97bbpxdCv+30eP061bX8a7NHZ/9elSsY/e T/NunaOX+3feNBj0nHN00zlGN01Ou66qSgIeU6qWTUxLDPAFpMzCMyjS+TOu4ldx6cxpT8UzKDXZ z6P7PC8rg0XFx5Kyv4WrXzSpEQclA06bZqMp2FW1qmtsJ2nNVHAtAxs3cwZWPj8riXv4DQys1HTj Br+1OChv5XJJD5am5Oe/LrDykwDMJ0DPfqu+8/pg0MXimkqgzRmY2774d7xfQcbM/EL8PJbpCD7T NtkPoSWNk32L09BFcoXOCuO6lTgZn6+PYstLQ54qSikAkTZeuh9Dr8d+RR0lxAiVhSE/kX4WjRGj 3kIKVncJYZeZkD/+HJcRNFdS39kNBtXChiUYtDcWqIPU+z2eo39HwOGhsrcCGtGBMpDAmmwt2Zsg XXSPWgCKzaxMK/lk5M9gdTjynkVFteMogaNAkSIbEgtGsGTlfgssNB+fnJyBiqne0kD7URNyCaw0 aVhXbJjj8koH5RXLcRnp2QfTd7Yr5Ax5+m69AsZRFcpG+kIaw3gr0jbSm+b4OfUDVluRnBKlbcuG YSikbRqSojFtk4lWbAEQllWlOTwp5/IAbaBbuh3uD19TabyY0jCp/KIhP9NpWm82SsOYP6ShQaft tWt9bv6dO9fa1artclxO3i7H5ZMFzCcOmlfpO782GPRm2P/z9ZbNhliSqJSZUvCc5YIfpdRU1OSt jQKoyeWmoLALAPAZAJOBbmJWXLnPc/L3TdISSXUtQDFmIoGV0xRFZ9lspvI9LGRBsDAolUCmDkZg H0Jv+e9/c5mkCwIrT06+T/cvDKzcjRUz6VMeM588aLbBU6TO64NBi7GAwaCdsWBhwv7+9VYjqRU8 HLgYoI1zexvnMPuvZxtjpiIVEgb7ZDLRKi4TBURdx1UBElfu81xSpT4HUxp5r7UrBYmd6WdLLbh5 Q8lCsGj2pAZVEtj/Xr46sFKkK3/vHySwcgTNB6RsPXjMheAhfSGNIZ2RSOq7Cp6lgMeIpa2AhwOX 1IjR1LS2aZHDs4aDXKWDJoKt1yJ9hMIRENO8KjiUdvE1w/fwM7Q8kiH9avgd+l1GpN6fIf2YEqFR yCZcXiapSJdvRMpuJ4WNYBkNAe/QWCD/DiKpMWubhw9LTJsUcbeaAKfZo7S8LRYv3TV3ZJfVqRQJ lDI0tNYuITcc2yvOzXK53Houe3t7acHRHk3Crvhs6OKczw8oLbD/EvtH0hZQI5BvimI/LMAHoKQf fvjBlISwXSV/tIqNoHm30HltMOi2pW0Inj66gL7/W2J5I3iGqz019syd2NxVAMuBOTjQvdNT+dfs 7x+wczGAc5jwt6QA6VfWEGMdZA3XL/XEClikVvawY5gZTcgjPfsQxgKzbSwYUrb7Wd/5XowFAI+Y b0nbisGAyjcpEunSanWcq4Q+VWepWLZCW1UHDRPjJpMXoFe6cl+T5fQ1pF98DwRSq87WY/nMo1Oz lTnJ7xbnJK7lp5+MZE8W6WK2vfkjFRtB8x652mv1nfPgGUYXrNePRLfg4D49baD33GwPM4j2F9fb /X0C4xpAsr3yHP+2wGsKSBgSw88oYLxzzXQKPr/zMrB86t78kZ5dUX3nu+++sywcQdpmzH3D5lXG fG0YYWDMV4axbXwdqdtwy+XHH3X/T3/S4//+V7e3b/eDnLRruKVEMUb1lR0vvhk0Phqp2ChprrKl TX080HNisbapn+crsVrR1FskkEqhhyKJuF67RiuXCf/n/zyKXMtx+TtfW97Hz+Bn8TPVz7JtDest YttUbDQhj8sVkjz9+te//tVpc1pd//73JEXPuf7jH6niqo1uU/XPf6a6rCycftG68xp53+Bz5HPz d3Tfma+hu6bzbQnHZaRnV5C27VK3Qt8gj4wU/xgsDBR91ScPLF/5c+Tfjn5dRMFGGjaC5qMGTwFQ pnMXLjRjX3R+EDS5+3lDemhGsIyg+UMDaBdIrwJTAcdlABmBMoLmkwXQWz3EESgjaD5FIHV76VXA 6I5GgIzLuIzLuIzLuIzLuIzLuIzLuIzLuIzLuIzLuIzLuIzLuIzLuIzLuIzLuIzLuIzLuIzLuIzL uIzLuIzLuIzLuIzLuIzLuIzLuIzLuIzLB1n+vwADAKrlwxirQGXnAAAAAElFTkSuQmCC'
        transform='translate(278 200)'
        overflow='visible'
      />
      <linearGradient
        id='dataMigr_banner_svg__SVGID_26_'
        gradientUnits='userSpaceOnUse'
        x1={302.631}
        y1={138.325}
        x2={460.494}
        y2={138.325}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0} stopColor='#00dcf3' stopOpacity={0} />
        <stop offset={0.13} stopColor='#08c2f2' stopOpacity={0.104} />
        <stop offset={0.423} stopColor='#188bef' stopOpacity={0.338} />
        <stop offset={0.676} stopColor='#2463ed' stopOpacity={0.541} />
        <stop offset={0.877} stopColor='#2b4beb' stopOpacity={0.702} />
        <stop offset={1} stopColor='#2e42eb' stopOpacity={0.8} />
      </linearGradient>
      <path
        d='M380.81 309.23c-2.29.01-4.57-.48-6.33-1.48l-70.31-39.79c-1.82-1.03-2.83-2.44-2.85-3.98-.02-1.52.96-2.94 2.74-4L373.22 219c3.5-2.07 9.24-2.12 12.8-.11l70.31 39.79c1.82 1.03 2.83 2.44 2.85 3.98.02 1.52-.96 2.94-2.74 4l-69.16 40.99c-1.78 1.05-4.12 1.58-6.47 1.58zm-1.12-90.85c-2.17.01-4.34.5-5.97 1.47l-69.16 40.99c-1.47.87-2.27 1.99-2.26 3.15.01 1.17.85 2.28 2.35 3.13l70.31 39.79c3.28 1.86 8.59 1.81 11.82-.1l69.16-40.99c1.47-.87 2.27-1.99 2.26-3.15-.01-1.17-.85-2.28-2.35-3.13l-70.31-39.79c-1.62-.93-3.74-1.38-5.85-1.37z'
        fill='url(#dataMigr_banner_svg__SVGID_26_)'
      />
      <linearGradient
        id='dataMigr_banner_svg__SVGID_27_'
        gradientUnits='userSpaceOnUse'
        x1={447.812}
        y1={138.985}
        x2={315.508}
        y2={138.985}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0.117} stopColor='#dddcf9' />
        <stop offset={0.562} stopColor='#fff' />
        <stop offset={0.708} stopColor='#f9f8fe' />
        <stop offset={0.915} stopColor='#e6e6fb' />
        <stop offset={1} stopColor='#dddcf9' />
      </linearGradient>
      <path
        d='M446.5 263.08v.06c0 .05-.01.1-.02.15 0 .07-.01.15-.02.23v.04c-.01.05-.03.1-.04.15l-.06.22c-.01.01 0 .03-.01.05-.02.04-.04.09-.06.13-.03.08-.06.15-.11.23-.01.02-.01.03-.02.05-.02.04-.05.07-.07.11-.05.09-.11.18-.17.26-.01.02-.03.05-.05.07-.04.06-.09.11-.14.17-.01.02-.03.04-.05.06-.08.09-.17.18-.26.27-.01.01-.03.02-.04.03l-.22.19c-.07.05-.13.11-.2.16-.08.06-.17.12-.26.18-.07.04-.12.09-.19.13-.03.02-.06.04-.09.05l-58.28 34.54c-.22.13-.45.25-.69.36l-.21.09c-.19.08-.38.16-.57.22-.04.02-.09.04-.13.05a.31.31 0 00-.08.02c-.13.04-.25.07-.38.11-.09.03-.19.05-.28.08l-.41.09c-.08.02-.16.04-.23.05-.01 0-.03 0-.04.01-.27.05-.55.09-.83.12-.02 0-.04 0-.06.01-.06.01-.13.01-.2.02-.17.02-.33.03-.5.04-.04.01-.08.01-.12.01h-.2c-.13.01-.27.01-.4.01-.05 0-.1.01-.15 0h-.19c-.12 0-.25-.01-.37-.02-.05 0-.11 0-.17-.01-.06 0-.11-.01-.17-.01-.13-.01-.25-.02-.37-.04-.06-.01-.12-.01-.18-.02-.05 0-.1-.02-.15-.02-.13-.02-.26-.04-.39-.07-.06-.01-.12-.02-.19-.03l-.12-.03c-.16-.03-.31-.07-.46-.11-.06-.02-.13-.03-.19-.04-.02-.01-.04-.01-.06-.02-.27-.08-.53-.16-.79-.26-.01 0-.02-.01-.04-.01-.11-.04-.22-.09-.33-.14-.06-.03-.13-.05-.19-.08-.19-.08-.37-.17-.54-.27l-17.95-10.16-1.54-.87-5.42-3.07-.81-.46-3.39-1.92-1.18-.67-1.65-.94-1.09-.61-5.72-3.24-3.35-1.89-17.14-9.7c-1.45-.82-2.19-1.91-2.19-3.01l-.05-8.41-.01-1.13-.1-17.07-.01-1.13-.07-12.11c0 .27.05.55.14.82.28.81.96 1.57 2.05 2.19l17.37 9.83 3.35 1.89 5.72 3.24 1.09.61 1.65.93 1.18.67 3.4 1.93.81.46 5.42 3.07 1.54.87 17.72 10.03c.17.1.35.19.54.28.06.03.13.05.19.08.12.05.24.11.37.16.25.1.52.18.79.26l.25.06c.15.04.3.08.46.11l.3.06.39.06c.11.01.22.03.33.04.12.01.24.03.37.04.11.01.22.02.34.02.13.01.25.01.37.02.11 0 .22 0 .34.01.14 0 .27-.01.4-.01.11-.01.22-.01.32-.01.16-.01.33-.03.49-.04l.26-.03c.28-.03.56-.07.83-.12.1-.02.19-.04.28-.06l.4-.09c.1-.02.19-.05.29-.08.13-.03.25-.07.38-.11.07-.02.14-.05.21-.07.2-.07.39-.14.58-.22l.21-.09c.24-.11.47-.23.69-.35l58.28-34.54c.1-.06.19-.12.28-.18s.18-.12.26-.18c.07-.05.14-.11.2-.17.08-.06.16-.12.22-.19.11-.1.21-.2.31-.31l.05-.05c.07-.08.13-.16.19-.24s.12-.17.17-.25c.03-.05.07-.11.1-.17.04-.07.07-.15.1-.23.03-.06.05-.12.08-.18l.06-.22c.01-.06.03-.13.05-.19.01-.08.01-.15.02-.23 0-.07.01-.14.01-.22l.07 12.07v1.13l.1 17.12.01 1.13.03 8.39z'
        fill='url(#dataMigr_banner_svg__SVGID_27_)'
      />
      <path className='dataMigr_banner_svg__st25' d='M382.53 296.83z' />
      <linearGradient
        id='dataMigr_banner_svg__SVGID_28_'
        gradientUnits='userSpaceOnUse'
        x1={383.752}
        y1={104.811}
        x2={383.752}
        y2={104.811}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0.117} stopColor='#dddcf9' />
        <stop offset={0.562} stopColor='#fff' />
        <stop offset={0.708} stopColor='#f9f8fe' />
        <stop offset={0.915} stopColor='#e6e6fb' />
        <stop offset={1} stopColor='#dddcf9' />
      </linearGradient>
      <path d='M382.53 296.83z' fill='url(#dataMigr_banner_svg__SVGID_28_)' />
      <linearGradient
        id='dataMigr_banner_svg__SVGID_29_'
        gradientUnits='userSpaceOnUse'
        x1={415.036}
        y1={144.424}
        x2={348.159}
        y2={211.301}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0.117} stopColor='#dddcf9' />
        <stop offset={0.562} stopColor='#fff' />
        <stop offset={0.708} stopColor='#f9f8fe' />
        <stop offset={0.915} stopColor='#e6e6fb' />
        <stop offset={1} stopColor='#dddcf9' />
      </linearGradient>
      <path
        d='M444.08 220.23c2.89 1.63 2.92 4.32.09 6.01l-58.28 34.54c-2.84 1.68-7.49 1.72-10.37.09l-59.24-33.53c-2.89-1.63-2.93-4.32-.09-6.01l58.28-34.54c2.84-1.68 7.49-1.72 10.37-.09l59.24 33.53z'
        fill='url(#dataMigr_banner_svg__SVGID_29_)'
      />
      <linearGradient
        id='dataMigr_banner_svg__SVGID_30_'
        gradientUnits='userSpaceOnUse'
        x1={322.208}
        y1={177.862}
        x2={440.97}
        y2={177.862}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0.117} stopColor='#5c90fe' />
        <stop offset={0.562} stopColor='#466cf5' />
        <stop offset={0.691} stopColor='#4265f3' />
        <stop offset={0.875} stopColor='#3853ef' />
        <stop offset={1} stopColor='#2e42eb' />
      </linearGradient>
      <path
        d='M380.63 257.18c-1.25 0-2.22-.29-2.71-.57l-57.13-32.33 56.16-33.29c.49-.29 1.47-.6 2.76-.6 1.25 0 2.22.29 2.71.56l57.13 32.33-56.16 33.29c-.48.29-1.47.6-2.76.61z'
        fill='url(#dataMigr_banner_svg__SVGID_30_)'
      />
      <g>
        <path
          className='dataMigr_banner_svg__st25'
          d='M426.39 247.15l-20.63 12.25-20.08 11.91c-2.7 1.6-7.14 1.64-9.88.09l-61.64-34.96.01 1.13 61.15 34.68c1.49.84 3.43 1.26 5.37 1.25 1.99-.01 3.99-.46 5.49-1.34l19.59-11.62 20.64-12.25-.02-1.14z'
        />
      </g>
      <g>
        <path
          className='dataMigr_banner_svg__st25'
          d='M365.05 283.43l10.79 6.12c2.75 1.56 7.18 1.52 9.88-.08l.03-.01 60.69-35.89.01 1.13-60.24 35.62c-.15.09-.31.18-.47.26-1.44.72-3.23 1.09-5.02 1.09-1.94.01-3.88-.41-5.37-1.26l-10.31-5.85.01-1.13z'
        />
      </g>
      <g>
        <g className='dataMigr_banner_svg__st1'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_31_'
            gradientUnits='userSpaceOnUse'
            x1={391.203}
            y1={176.55}
            x2={372.616}
            y2={208.743}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M411.22 205.35c3.42 1.96 3.45 5.16.06 7.14l-24.52 14.34c-3.39 1.98-8.9 2-12.32.03l-24.76-14.21c-3.42-1.96-3.44-5.16-.06-7.14l24.52-14.34c3.39-1.98 8.9-2 12.32-.03l24.76 14.21z'
            fill='url(#dataMigr_banner_svg__SVGID_31_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_32_'
            gradientUnits='userSpaceOnUse'
            x1={415.309}
            y1={175.886}
            x2={348.56}
            y2={175.886}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M413.8 209.09c0 .04 0 .09-.01.13 0 .04-.01.08-.01.11-.01.04-.01.09-.02.13-.01.04-.02.08-.02.12-.01.04-.02.08-.03.13l-.03.12c-.01.04-.03.08-.04.13-.01.04-.03.08-.04.11-.02.04-.04.09-.06.13-.02.04-.03.07-.05.11s-.04.09-.07.13c-.02.04-.04.07-.06.11-.03.05-.06.1-.1.15l-.06.09c-.04.06-.08.11-.12.17-.02.02-.04.05-.05.07-.07.09-.15.18-.23.26-.02.02-.04.04-.06.07-.06.07-.13.13-.2.2l-.09.09c-.04.04-.08.07-.13.11-.04.03-.08.07-.12.1-.04.04-.09.07-.14.11l-.13.1c-.05.03-.1.07-.15.1s-.09.06-.14.09c-.05.03-.1.07-.16.1-.07.04-.13.08-.2.12l-24.52 14.34c-.13.08-.26.15-.4.22l-.12.06c-.11.05-.21.1-.32.15-.04.02-.07.03-.11.05-.14.06-.29.12-.43.18-.03.01-.05.02-.08.03-.12.05-.25.09-.38.13-.05.02-.1.03-.16.05-.07.02-.14.04-.21.07-.06.02-.12.04-.18.05-.07.02-.14.04-.22.06-.06.02-.12.03-.18.05-.07.02-.15.04-.22.05-.06.01-.12.03-.18.04-.08.02-.15.03-.23.05l-.18.03c-.16.03-.33.06-.49.08-.02 0-.05.01-.07.01-.14.02-.29.04-.43.05-.06.01-.11.01-.17.02-.09.01-.19.02-.28.02-.06 0-.12.01-.18.01-.1.01-.2.01-.29.02-.05 0-.11.01-.16.01-.08 0-.17 0-.25.01h-.61c-.08 0-.17-.01-.25-.01-.06 0-.12 0-.17-.01-.09 0-.18-.01-.27-.02-.05 0-.1-.01-.15-.01l-.34-.03c-.02 0-.05 0-.07-.01-.14-.02-.28-.03-.42-.05-.02 0-.05-.01-.07-.01-.12-.02-.23-.03-.35-.05l-.15-.03c-.09-.02-.18-.03-.27-.05l-.14-.03c-.1-.02-.2-.04-.29-.07-.05-.01-.11-.03-.16-.04-.09-.02-.18-.05-.27-.07-.05-.01-.1-.03-.15-.04-.14-.04-.28-.08-.41-.13a.185.185 0 00-.07-.02c-.16-.05-.31-.11-.46-.17-.06-.02-.12-.05-.18-.07-.05-.02-.1-.04-.14-.06-.07-.03-.14-.06-.2-.09-.04-.02-.09-.04-.13-.06-.07-.03-.15-.07-.22-.11-.04-.02-.07-.03-.11-.05-.11-.06-.21-.11-.31-.17l-24.76-14.21c-.43-.25-.81-.51-1.13-.79a4.49 4.49 0 01-.44-.43c-.27-.29-.48-.6-.65-.91-.24-.47-.36-.96-.36-1.45v14.2c0 1.3.86 2.6 2.58 3.59l24.76 14.21c.1.06.21.12.31.17.04.02.07.04.11.05.07.04.14.07.22.11.04.02.09.04.13.06.07.03.13.06.2.09.05.02.1.04.14.06.05.02.09.04.14.06.01.01.03.01.04.02.15.06.3.11.46.17.02.01.05.02.07.02.14.04.27.09.41.13.02.01.05.01.07.02.03.01.05.01.08.02.09.02.18.05.27.07.05.01.11.03.16.04.1.02.2.04.29.07.04.01.07.02.11.02.01 0 .02 0 .03.01.09.02.18.03.27.05l.15.03c.12.02.23.04.35.05.02 0 .04.01.07.01.14.02.28.04.42.05.03 0 .06.01.09.01l.33.03h.01c.05 0 .09.01.14.01.09.01.18.01.27.02.06 0 .11 0 .17.01.08 0 .17.01.25.01H380.85c.08 0 .17 0 .25-.01h.05c.04 0 .08 0 .12-.01.1 0 .2-.01.29-.02.06 0 .12-.01.18-.01.09-.01.19-.02.28-.02.03 0 .07-.01.1-.01.02 0 .05-.01.07-.01.15-.02.29-.03.43-.05.02 0 .05-.01.07-.01.17-.02.33-.05.49-.08.02 0 .03 0 .05-.01l.13-.03c.08-.01.15-.03.23-.05.06-.01.12-.03.18-.04.07-.02.15-.03.22-.05.06-.01.12-.03.18-.05l.22-.06c.06-.02.12-.03.18-.05.07-.02.14-.04.21-.07l.09-.03c.02-.01.04-.02.06-.02.13-.04.25-.09.38-.13.03-.01.05-.02.08-.03.15-.06.29-.12.43-.18.04-.02.07-.03.11-.05.11-.05.22-.1.32-.15l.12-.06c.14-.07.27-.14.4-.22l24.52-14.34c.04-.02.07-.04.11-.06.03-.02.06-.04.1-.06.05-.03.11-.07.16-.1s.09-.06.14-.09c.05-.03.1-.07.15-.1.04-.03.09-.06.13-.1l.14-.11c.04-.03.08-.07.12-.1.04-.04.08-.07.13-.11.02-.02.04-.03.05-.05.02-.01.03-.03.04-.04l.2-.2c.02-.02.04-.04.06-.07l.23-.26.01-.01c.02-.02.03-.04.05-.06.04-.06.08-.11.12-.17l.06-.09c.03-.05.07-.1.1-.15.01-.01.02-.03.03-.04l.03-.06c.02-.04.05-.09.07-.13.02-.04.03-.07.05-.11s.04-.09.06-.13c.01-.02.02-.04.02-.06.01-.02.01-.04.02-.05.01-.04.03-.08.04-.13l.03-.12c.01-.04.02-.08.03-.13.01-.02.01-.05.02-.07 0-.02 0-.03.01-.05.01-.04.01-.09.02-.13.01-.04.01-.08.01-.11 0-.04.01-.09.01-.13 0-.03 0-.05.01-.08v-14.28c-.05.04-.05.09-.05.14z'
            fill='url(#dataMigr_banner_svg__SVGID_32_)'
          />
          <path
            className='dataMigr_banner_svg__st25'
            d='M380.62 233.18c-2.46.01-4.79-.54-6.55-1.55l-3.58-2.05v-1.21l4.1 2.35c1.61.92 3.75 1.43 6.02 1.42 2.28-.01 4.41-.52 6-1.45l4.01-2.34v1.21l-3.48 2.04c-1.73 1-4.05 1.57-6.52 1.58z'
          />
          <path
            className='dataMigr_banner_svg__st25'
            d='M380.63 236.04c-2.46.01-4.79-.54-6.55-1.55l-3.58-2.05v-1.21l4.1 2.35c1.61.92 3.75 1.43 6.02 1.42 2.28-.01 4.41-.52 6-1.45l4.01-2.34v1.21l-3.48 2.04c-1.73 1-4.05 1.57-6.52 1.58z'
          />
          <path
            className='dataMigr_banner_svg__st25'
            d='M380.64 238.9c-2.46.01-4.79-.54-6.55-1.55l-3.58-2.05v-1.21l4.1 2.35c1.61.92 3.75 1.43 6.02 1.42 2.28-.01 4.41-.52 6-1.45l4.01-2.34v1.21l-3.48 2.04c-1.74 1.01-4.05 1.57-6.52 1.58z'
          />
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M380.6 226.08c-1.91.01-3.75-.42-5.05-1.16l-24.76-14.21c-.89-.51-1.45-1.14-1.45-1.64 0-.49.54-1.11 1.41-1.62l24.52-14.34c1.28-.75 3.11-1.18 5.02-1.19 1.91-.01 3.75.42 5.05 1.16l24.76 14.21c.89.51 1.45 1.14 1.45 1.64 0 .49-.54 1.11-1.41 1.62l-24.52 14.34c-1.28.75-3.11 1.18-5.02 1.19zm-.3-33.42c-1.78 0-3.48.4-4.65 1.09l-24.52 14.34c-.83.48-1.04.9-1.05.98.01.07.22.5 1.08 1l24.76 14.21c1.19.68 2.9 1.07 4.68 1.07s3.48-.4 4.65-1.09l24.52-14.34c.83-.48 1.04-.9 1.05-.98-.01-.07-.22-.5-1.08-1l-24.76-14.21c-1.19-.68-2.9-1.07-4.68-1.07z'
            />
          </g>
        </g>
        <g className='dataMigr_banner_svg__st1'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_33_'
            gradientUnits='userSpaceOnUse'
            x1={391.198}
            y1={196.93}
            x2={372.611}
            y2={229.123}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M411.16 184.97c3.42 1.96 3.45 5.16.06 7.14l-24.52 14.34c-3.39 1.98-8.9 2-12.32.03l-24.76-14.21c-3.42-1.96-3.44-5.16-.06-7.14l24.52-14.34c3.39-1.98 8.9-2 12.32-.03l24.76 14.21z'
            fill='url(#dataMigr_banner_svg__SVGID_33_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_34_'
            gradientUnits='userSpaceOnUse'
            x1={415.304}
            y1={196.266}
            x2={348.556}
            y2={196.266}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M413.74 188.71c0 .04 0 .09-.01.13 0 .04-.01.08-.01.11-.01.04-.01.09-.02.13-.01.04-.02.08-.02.12-.01.04-.02.08-.03.13l-.03.12c-.01.04-.03.08-.04.13-.01.04-.03.08-.04.11-.02.04-.04.09-.06.13-.02.04-.03.07-.05.11s-.04.09-.07.13c-.02.04-.04.07-.06.11-.03.05-.06.1-.1.15l-.06.09c-.04.06-.08.11-.12.17-.02.02-.04.05-.05.07-.07.09-.15.18-.23.26-.02.02-.04.04-.06.07-.06.07-.13.13-.2.2l-.09.09c-.04.04-.08.07-.13.11-.04.03-.08.07-.12.1-.04.04-.09.07-.14.11l-.13.1c-.05.03-.1.07-.15.1s-.09.06-.14.09c-.05.03-.1.07-.16.1-.07.04-.13.08-.2.12l-24.52 14.34c-.13.08-.26.15-.4.22l-.12.06c-.11.05-.21.1-.32.15-.04.02-.07.03-.11.05-.14.06-.29.12-.43.18-.03.01-.05.02-.08.03-.12.05-.25.09-.38.13-.05.02-.1.03-.16.05-.07.02-.14.04-.21.07-.06.02-.12.04-.18.05-.07.02-.14.04-.22.06-.06.02-.12.03-.18.05-.07.02-.15.04-.22.05-.06.01-.12.03-.18.04-.08.02-.15.03-.23.05l-.18.03c-.16.03-.33.06-.49.08-.02 0-.05.01-.07.01-.14.02-.29.04-.43.05-.06.01-.11.01-.17.02-.09.01-.19.02-.28.02-.06 0-.12.01-.18.01-.1.01-.2.01-.29.02-.05 0-.11.01-.16.01-.08 0-.17 0-.25.01h-.61c-.08 0-.17-.01-.25-.01-.06 0-.12 0-.17-.01-.09 0-.18-.01-.27-.02-.05 0-.1-.01-.15-.01l-.34-.03c-.02 0-.05 0-.07-.01-.14-.02-.28-.03-.42-.05-.02 0-.05-.01-.07-.01-.12-.02-.23-.03-.35-.05l-.15-.03c-.09-.02-.18-.03-.27-.05l-.14-.03c-.1-.02-.2-.04-.29-.07-.05-.01-.11-.03-.16-.04-.09-.02-.18-.05-.27-.07-.05-.01-.1-.03-.15-.04-.14-.04-.28-.08-.41-.13a.185.185 0 00-.07-.02c-.16-.05-.31-.11-.46-.17-.06-.02-.12-.05-.18-.07-.05-.02-.1-.04-.14-.06-.07-.03-.14-.06-.2-.09-.04-.02-.09-.04-.13-.06-.07-.03-.15-.07-.22-.11-.04-.02-.07-.03-.11-.05-.11-.06-.21-.11-.31-.17l-24.76-14.21c-.43-.25-.81-.51-1.13-.79a4.49 4.49 0 01-.44-.43c-.27-.29-.48-.6-.65-.91-.24-.47-.36-.96-.36-1.45v14.2c0 1.3.86 2.6 2.58 3.59l24.76 14.21c.1.06.21.12.31.17.04.02.07.04.11.05.07.04.14.07.22.11.04.02.09.04.13.06.07.03.13.06.2.09.05.02.1.04.14.06.05.02.09.04.14.06.01.01.03.01.04.02.15.06.3.11.46.17.02.01.05.02.07.02.14.04.27.09.41.13.02.01.05.01.07.02.03.01.05.01.08.02.09.02.18.05.27.07.05.01.11.03.16.04.1.02.2.04.29.07.04.01.07.02.11.02.01 0 .02 0 .03.01.09.02.18.03.27.05l.15.03c.12.02.23.04.35.05.02 0 .04.01.07.01.14.02.28.04.42.05.03 0 .06.01.09.01l.33.03h.01c.05 0 .09.01.14.01.09.01.18.01.27.02.06 0 .11 0 .17.01.08 0 .17.01.25.01H380.79c.08 0 .17 0 .25-.01h.05c.04 0 .08 0 .12-.01.1 0 .2-.01.29-.02.06 0 .12-.01.18-.01.09-.01.19-.02.28-.02.03 0 .07-.01.1-.01.02 0 .05-.01.07-.01.15-.02.29-.03.43-.05.02 0 .05-.01.07-.01.17-.02.33-.05.49-.08.02 0 .03 0 .05-.01l.13-.03c.08-.01.15-.03.23-.05.06-.01.12-.03.18-.04.07-.02.15-.03.22-.05.06-.01.12-.03.18-.05l.22-.06c.06-.02.12-.03.18-.05.07-.02.14-.04.21-.07l.09-.03c.02-.01.04-.02.06-.02.13-.04.25-.09.38-.13.03-.01.05-.02.08-.03.15-.06.29-.12.43-.18.04-.02.07-.03.11-.05.11-.05.22-.1.32-.15l.12-.06c.14-.07.27-.14.4-.22l24.52-14.34c.04-.02.07-.04.11-.06.03-.02.06-.04.1-.06.05-.03.11-.07.16-.1s.09-.06.14-.09c.05-.03.1-.07.15-.1.04-.03.09-.06.13-.1l.14-.11c.04-.03.08-.07.12-.1.04-.04.08-.07.13-.11.02-.02.04-.03.05-.05.02-.01.03-.03.04-.04l.2-.2c.02-.02.04-.04.06-.07l.23-.26.01-.01c.02-.02.03-.04.05-.06.04-.06.08-.11.12-.17l.06-.09c.03-.05.07-.1.1-.15.01-.01.02-.03.03-.04l.03-.06c.02-.04.05-.09.07-.13.02-.04.03-.07.05-.11s.04-.09.06-.13c.01-.02.02-.04.02-.06.01-.02.01-.04.02-.05.01-.04.03-.08.04-.13l.03-.12c.01-.04.02-.08.03-.13.01-.02.01-.05.02-.07 0-.02 0-.03.01-.05.01-.04.01-.09.02-.13.01-.04.01-.08.01-.11 0-.04.01-.09.01-.13 0-.03 0-.05.01-.08v-14.28c-.04.04-.05.09-.05.14z'
            fill='url(#dataMigr_banner_svg__SVGID_34_)'
          />
          <path
            className='dataMigr_banner_svg__st25'
            d='M380.57 212.8c-2.46.01-4.79-.54-6.55-1.55l-3.58-2.05v-1.21l4.1 2.35c1.61.92 3.75 1.43 6.02 1.42 2.28-.01 4.41-.52 6-1.45l4.01-2.34v1.21l-3.48 2.04c-1.74 1.01-4.06 1.58-6.52 1.58z'
          />
          <path
            className='dataMigr_banner_svg__st25'
            d='M380.58 215.66c-2.46.01-4.79-.54-6.55-1.55l-3.58-2.05v-1.21l4.1 2.35c1.61.92 3.75 1.43 6.02 1.42 2.28-.01 4.41-.52 6-1.45l4.01-2.34v1.21l-3.48 2.04c-1.74 1.01-4.06 1.58-6.52 1.58z'
          />
          <path
            className='dataMigr_banner_svg__st25'
            d='M380.58 218.52c-2.46.01-4.79-.54-6.55-1.55l-3.58-2.05v-1.21l4.1 2.35c1.61.92 3.75 1.43 6.02 1.42 2.28-.01 4.41-.52 6-1.45l4.01-2.34v1.21l-3.48 2.04c-1.73 1.01-4.05 1.58-6.52 1.58z'
          />
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M380.55 205.7c-1.91.01-3.75-.42-5.05-1.16l-24.76-14.21c-.89-.51-1.45-1.14-1.45-1.64 0-.49.54-1.11 1.41-1.62l24.52-14.34c1.28-.75 3.11-1.18 5.02-1.19 1.91-.01 3.75.42 5.05 1.16l24.76 14.21c.89.51 1.45 1.14 1.45 1.64 0 .49-.54 1.11-1.41 1.62l-24.52 14.34c-1.28.75-3.11 1.19-5.02 1.19zm-.31-33.41c-1.78 0-3.48.4-4.65 1.09l-24.52 14.34c-.83.48-1.04.9-1.05.98.01.07.22.5 1.08 1l24.76 14.21c1.19.68 2.9 1.07 4.68 1.07s3.48-.4 4.65-1.09l24.52-14.34c.83-.48 1.04-.9 1.05-.98-.01-.07-.22-.5-1.08-1l-24.76-14.21c-1.19-.69-2.9-1.07-4.68-1.07z'
            />
          </g>
        </g>
        <linearGradient
          id='dataMigr_banner_svg__SVGID_35_'
          gradientUnits='userSpaceOnUse'
          x1={366.812}
          y1={271.287}
          x2={398.896}
          y2={271.287}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path
          d='M397.2 122.72c.03 2.39-1.51 4.78-4.64 6.62-6.24 3.65-16.4 3.67-22.69.06-3.14-1.8-4.73-4.17-4.75-6.54l.02 5.85c.01 1.19.41 2.38 1.2 3.49.79 1.12 1.98 2.16 3.55 3.06 6.29 3.61 16.45 3.58 22.69-.06 3.1-1.82 4.65-4.19 4.64-6.56l-.02-5.92z'
          fill='url(#dataMigr_banner_svg__SVGID_35_)'
        />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_36_'
          gradientUnits='userSpaceOnUse'
          x1={398.892}
          y1={226.784}
          x2={366.811}
          y2={226.784}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path
          d='M370.01 181.46c6.3 3.61 16.45 3.58 22.69-.06 3.13-1.83 4.68-4.23 4.64-6.61-.03-2.37-1.62-4.73-4.75-6.53-6.3-3.61-16.45-3.58-22.69.06-3.13 1.83-4.67 4.22-4.64 6.6.02 2.37 1.61 4.74 4.75 6.54z'
          fill='url(#dataMigr_banner_svg__SVGID_36_)'
        />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_37_'
          gradientUnits='userSpaceOnUse'
          x1={366.811}
          y1={216.601}
          x2={398.891}
          y2={216.601}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path
          d='M392.7 181.4c-6.24 3.65-16.4 3.67-22.69.06-1.57-.9-2.76-1.95-3.55-3.06-.79-1.12-1.19-2.31-1.2-3.49l.03 11.07c.01 1.19.41 2.38 1.2 3.49.79 1.12 1.98 2.16 3.55 3.06 6.29 3.61 16.45 3.58 22.69-.06 3.12-1.82 4.66-4.21 4.64-6.58l-.03-11.04c.01 2.36-1.53 4.74-4.64 6.55z'
          fill='url(#dataMigr_banner_svg__SVGID_37_)'
        />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_38_'
          gradientUnits='userSpaceOnUse'
          x1={366.811}
          y1={278.844}
          x2={398.892}
          y2={278.844}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0.117} stopColor='#5c90fe' />
          <stop offset={0.562} stopColor='#466cf5' />
          <stop offset={0.691} stopColor='#4265f3' />
          <stop offset={0.875} stopColor='#3853ef' />
          <stop offset={1} stopColor='#2e42eb' />
        </linearGradient>
        <path
          d='M369.87 129.4c6.3 3.61 16.45 3.58 22.69-.06 3.13-1.83 4.68-4.23 4.64-6.61-.03-2.37-1.62-4.73-4.75-6.53-6.3-3.61-16.45-3.58-22.69.06-3.13 1.83-4.67 4.22-4.64 6.6.02 2.37 1.61 4.74 4.75 6.54z'
          fill='url(#dataMigr_banner_svg__SVGID_38_)'
        />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_39_'
          gradientUnits='userSpaceOnUse'
          x1={374.502}
          y1={278.849}
          x2={391.192}
          y2={278.849}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path
          d='M381.2 127.44c-2.27.01-4.41-.5-6.01-1.42-1.52-.87-2.36-2.01-2.38-3.2-.01-1.19.81-2.34 2.32-3.22 1.59-.93 3.71-1.44 5.98-1.45 2.27-.01 4.41.5 6.01 1.42 1.52.87 2.36 2 2.38 3.19.02 1.2-.81 2.34-2.32 3.23-1.58.93-3.71 1.44-5.98 1.45zm-.08-8.76c-2.18.01-4.21.49-5.72 1.38-1.34.78-2.07 1.76-2.06 2.76.01.99.76 1.97 2.11 2.74 1.52.87 3.56 1.35 5.74 1.35 2.18-.01 4.21-.49 5.72-1.38 1.34-.78 2.07-1.77 2.06-2.76-.01-.99-.76-1.97-2.11-2.74-1.52-.87-3.56-1.35-5.74-1.35z'
          fill='url(#dataMigr_banner_svg__SVGID_39_)'
        />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_40_'
          gradientUnits='userSpaceOnUse'
          x1={403.255}
          y1={213.39}
          x2={409.675}
          y2={213.39}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#2afadf' stopOpacity={0.5} />
          <stop offset={0.275} stopColor='#36d1ea' stopOpacity={0.637} />
          <stop offset={0.596} stopColor='#42a7f5' stopOpacity={0.798} />
          <stop offset={0.849} stopColor='#498dfc' stopOpacity={0.925} />
          <stop offset={1} stopColor='#4c83ff' />
        </linearGradient>
        <path
          d='M402.69 189.51c1.26.72 3.29.72 4.54-.01.63-.37.94-.85.93-1.32s-.32-.95-.95-1.31c-1.26-.72-3.29-.72-4.54.01-.63.37-.93.84-.93 1.32.01.48.32.95.95 1.31z'
          opacity={0.8}
          fill='url(#dataMigr_banner_svg__SVGID_40_)'
        />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_41_'
          gradientUnits='userSpaceOnUse'
          x1={394.667}
          y1={295.388}
          x2={394.667}
          y2={211.501}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#2e42eb' stopOpacity={0.8} />
          <stop offset={0.123} stopColor='#2b4beb' stopOpacity={0.702} />
          <stop offset={0.324} stopColor='#2463ed' stopOpacity={0.541} />
          <stop offset={0.577} stopColor='#188bef' stopOpacity={0.338} />
          <stop offset={0.87} stopColor='#08c2f2' stopOpacity={0.104} />
          <stop offset={1} stopColor='#00dcf3' stopOpacity={0} />
        </linearGradient>
        <path
          d='M401.52 106.2l-6.15.02-11.04.03a6.42 6.42 0 00-6.4 6.44l.03 9.63v.03c.01.47.32.95.95 1.31 1.26.72 3.29.72 4.54-.01.63-.37.94-.85.93-1.32v-.02l-.02-8.82c0-.44.36-.8.8-.8l6.76-.02 8.82-.02c.44 0 .8.36.8.8l.21 74.78c.01.47.32.95.95 1.31 1.26.72 3.29.72 4.54-.01.62-.36.93-.84.93-1.32l-.21-75.59c-.02-3.57-2.9-6.43-6.44-6.42z'
          fill='url(#dataMigr_banner_svg__SVGID_41_)'
        />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_42_'
          gradientUnits='userSpaceOnUse'
          x1={379.643}
          y1={279.313}
          x2={386.063}
          y2={279.313}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#2afadf' stopOpacity={0.5} />
          <stop offset={0.275} stopColor='#36d1ea' stopOpacity={0.637} />
          <stop offset={0.596} stopColor='#42a7f5' stopOpacity={0.798} />
          <stop offset={0.849} stopColor='#498dfc' stopOpacity={0.925} />
          <stop offset={1} stopColor='#4c83ff' />
        </linearGradient>
        <path
          d='M378.9 123.65c1.26.72 3.29.72 4.54-.01.63-.37.94-.85.93-1.32s-.32-.95-.95-1.31c-1.26-.72-3.29-.72-4.54.01-.63.37-.93.84-.93 1.32 0 .47.32.95.95 1.31z'
          opacity={0.8}
          fill='url(#dataMigr_banner_svg__SVGID_42_)'
        />
        <path
          className='dataMigr_banner_svg__st25'
          d='M404.96 188.73c-.62 0-1.21-.13-1.61-.36-.17-.1-.26-.19-.29-.23l-.21-74.73c0-1.17-.96-2.12-2.13-2.12l-15.59.04c-1.17 0-2.12.96-2.11 2.13l.02 7.51H383l.04 1.31c-.03.04-.11.12-.27.22-.4.23-.98.37-1.6.37s-1.21-.13-1.61-.36c-.17-.1-.25-.18-.29-.22l.03-1.3h-.03l-.02-8.4c.04-2.77 2.3-5.02 5.09-5.02l17.19-.05c1.36 0 2.64.52 3.61 1.48s1.5 2.24 1.5 3.6l.21 75.54c-.03.04-.11.13-.28.22-.41.23-.99.37-1.61.37z'
        />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_43_'
          gradientUnits='userSpaceOnUse'
          x1={393.931}
          y1={257.454}
          x2={393.931}
          y2={240.393}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#00a8e3' />
          <stop offset={0.435} stopColor='#2894f2' stopOpacity={0.565} />
          <stop offset={0.789} stopColor='#4288fb' stopOpacity={0.211} />
          <stop offset={1} stopColor='#4c83ff' stopOpacity={0} />
        </linearGradient>
        <path
          fill='none'
          stroke='url(#dataMigr_banner_svg__SVGID_43_)'
          strokeWidth={2.701}
          strokeLinecap='round'
          strokeMiterlimit={10}
          d='M392.34 159.87l-.04-14.36'
        />
        <path
          className='dataMigr_banner_svg__st48'
          d='M374.57 174.19c0 .92-.74 1.67-1.67 1.68-.92 0-1.67-.74-1.68-1.67 0-.92.74-1.67 1.67-1.68.93 0 1.68.74 1.68 1.67z'
        />
        <circle className='dataMigr_banner_svg__st48' cx={384.34} cy={177.89} r={0.95} />
        <path className='dataMigr_banner_svg__st48' d='M389.81 170.87a1.34 1.34 0 11-2.68 0 1.34 1.34 0 012.68 0z' />
        <circle className='dataMigr_banner_svg__st48' cx={371.89} cy={151.8} r={0.95} />
        <path
          className='dataMigr_banner_svg__st48'
          d='M389.84 142.86c0 .52-.42.95-.94.95s-.95-.42-.95-.94.42-.95.94-.95c.53-.01.95.41.95.94z'
        />
        <circle className='dataMigr_banner_svg__st48' cx={374.48} cy={141.44} r={1.47} />
        <path
          className='dataMigr_banner_svg__st48'
          d='M391.53 163.09a.414.414 0 11-.83.01c0-.23.18-.42.41-.42.24-.01.42.18.42.41zM382.52 146.44a.414.414 0 11-.83.01.414.414 0 11.83-.01zM381.33 170.28c0 .38-.31.69-.68.69a.69.69 0 01-.69-.68c0-.38.31-.69.68-.69.38 0 .69.3.69.68z'
        />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_44_'
          gradientUnits='userSpaceOnUse'
          x1={371.772}
          y1={246.664}
          x2={371.772}
          y2={229.603}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#00a8e3' />
          <stop offset={0.435} stopColor='#2894f2' stopOpacity={0.565} />
          <stop offset={0.789} stopColor='#4288fb' stopOpacity={0.211} />
          <stop offset={1} stopColor='#4c83ff' stopOpacity={0} />
        </linearGradient>
        <path
          fill='none'
          stroke='url(#dataMigr_banner_svg__SVGID_44_)'
          strokeWidth={2.701}
          strokeLinecap='round'
          strokeMiterlimit={10}
          d='M370.21 170.72l-.04-14.36'
        />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_45_'
          gradientUnits='userSpaceOnUse'
          x1={380.017}
          y1={263.312}
          x2={380.017}
          y2={246.25}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#00a8e3' />
          <stop offset={0.435} stopColor='#2894f2' stopOpacity={0.565} />
          <stop offset={0.789} stopColor='#4288fb' stopOpacity={0.211} />
          <stop offset={1} stopColor='#4c83ff' stopOpacity={0} />
        </linearGradient>
        <path
          fill='none'
          stroke='url(#dataMigr_banner_svg__SVGID_45_)'
          strokeWidth={2.701}
          strokeLinecap='round'
          strokeMiterlimit={10}
          d='M378.41 154.05l-.04-14.36'
        />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_46_'
          gradientUnits='userSpaceOnUse'
          x1={387.623}
          y1={236.011}
          x2={387.623}
          y2={218.94}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#7548f1' />
          <stop offset={0.318} stopColor='#655ff7' stopOpacity={0.682} />
          <stop offset={0.745} stopColor='#5379fd' stopOpacity={0.255} />
          <stop offset={1} stopColor='#4c83ff' stopOpacity={0} />
        </linearGradient>
        <path
          fill='none'
          stroke='url(#dataMigr_banner_svg__SVGID_46_)'
          strokeWidth={2.701}
          strokeLinecap='round'
          strokeMiterlimit={10}
          d='M386.09 181.34l-.04-14.37'
        />
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_47_'
            gradientUnits='userSpaceOnUse'
            x1={382.863}
            y1={272.957}
            x2={382.863}
            y2={217.471}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0} stopColor='#2afadf' stopOpacity={0} />
            <stop offset={0.134} stopColor='#2cf3e0' stopOpacity={0.081} />
            <stop offset={0.332} stopColor='#30dfe4' stopOpacity={0.199} />
            <stop offset={0.569} stopColor='#37bfeb' stopOpacity={0.341} />
            <stop offset={0.833} stopColor='#4192f4' stopOpacity={0.5} />
            <stop offset={1} stopColor='#4872fa' stopOpacity={0.6} />
          </linearGradient>
          <path
            d='M397.23 128.66l.13 46.2c0 1.76-.85 3.53-2.57 5.07-.59.53-1.28 1.03-2.07 1.49-6.24 3.65-16.4 3.67-22.69.06a13.1 13.1 0 01-2.16-1.53c-.55-.49-1.02-1-1.4-1.53-.79-1.12-1.19-2.31-1.2-3.49l-.13-46.2c.01 1.19.41 2.38 1.2 3.49.38.53.84 1.05 1.4 1.54.61.54 1.33 1.06 2.16 1.53 6.29 3.61 16.45 3.58 22.69-.06.79-.46 1.48-.96 2.07-1.49 1.72-1.55 2.58-3.32 2.57-5.08z'
            fill='url(#dataMigr_banner_svg__SVGID_47_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_48_'
            gradientUnits='userSpaceOnUse'
            x1={365.221}
            y1={243.508}
            x2={397.316}
            y2={243.595}
            gradientTransform='matrix(1 0 0 -1 0 400)'
          >
            <stop offset={0} stopColor='#4c83ff' stopOpacity={0.6} />
            <stop offset={0.151} stopColor='#498dfc' stopOpacity={0.51} />
            <stop offset={0.404} stopColor='#42a7f5' stopOpacity={0.358} />
            <stop offset={0.726} stopColor='#36d1ea' stopOpacity={0.165} />
            <stop offset={1} stopColor='#2afadf' stopOpacity={0} />
          </linearGradient>
          <path
            d='M396.65 132.35l.12 42.5c0 1.63-.82 3.23-2.38 4.62-.57.51-1.23.98-1.98 1.42-2.95 1.72-6.89 2.67-11.1 2.67-4.16 0-8.06-.93-11-2.61-.78-.44-1.47-.93-2.06-1.46-.51-.45-.95-.94-1.3-1.43-.72-1.01-1.09-2.07-1.09-3.15l-.12-42.53a10.705 10.705 0 001.6 1.81c.65.58 1.41 1.12 2.25 1.6 3.11 1.79 7.23 2.77 11.58 2.77 4.42 0 8.57-1.01 11.7-2.83.81-.47 1.54-1 2.17-1.56.66-.58 1.19-1.18 1.61-1.82m.58-3.69c0 1.76-.85 3.53-2.57 5.07-.59.53-1.28 1.03-2.07 1.49-3.14 1.83-7.27 2.75-11.4 2.75-4.08 0-8.16-.9-11.29-2.69a13.1 13.1 0 01-2.16-1.53 9.476 9.476 0 01-1.4-1.54c-.79-1.12-1.19-2.31-1.2-3.49l.13 46.2c.01 1.19.41 2.38 1.2 3.49.38.53.84 1.05 1.4 1.53.61.54 1.33 1.06 2.16 1.53 3.13 1.79 7.21 2.69 11.29 2.69 4.13 0 8.26-.92 11.4-2.75.79-.46 1.48-.96 2.07-1.49 1.72-1.54 2.58-3.3 2.57-5.07l-.13-46.19z'
            fill='url(#dataMigr_banner_svg__SVGID_48_)'
          />
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_49_'
            gradientUnits='userSpaceOnUse'
            x1={382.846}
            y1={273.62}
            x2={382.846}
            y2={220.395}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0} stopColor='#2afadf' stopOpacity={0} />
            <stop offset={0.134} stopColor='#2cf3e0' stopOpacity={0.081} />
            <stop offset={0.332} stopColor='#30dfe4' stopOpacity={0.199} />
            <stop offset={0.569} stopColor='#37bfeb' stopOpacity={0.341} />
            <stop offset={0.833} stopColor='#4192f4' stopOpacity={0.5} />
            <stop offset={1} stopColor='#4872fa' stopOpacity={0.6} />
          </linearGradient>
          <path
            d='M394.63 128.01l.12 45.43c0 1.48-.71 2.96-2.16 4.25-.49.44-1.07.86-1.74 1.25-5.23 3.06-13.75 3.08-19.03.05-.69-.4-1.3-.83-1.81-1.28-.46-.41-.85-.84-1.17-1.29-.66-.94-1-1.93-1.01-2.93l-.12-45.43c3.87-.01 24.55-.06 26.92-.05z'
            fill='url(#dataMigr_banner_svg__SVGID_49_)'
          />
        </g>
      </g>
      <g>
        <path
          className='dataMigr_banner_svg__st25'
          d='M358.55 295.92a.49.49 0 01-.49-.49l-.12-43.57c0-.18.1-.34.25-.43l5.92-3.32a.53.53 0 01.49 0c.15.09.24.25.24.42l.01 3.38a.49.49 0 01-.98 0l-.01-2.55-4.94 2.77.12 43.29a.5.5 0 01-.49.5z'
        />
        <path
          className='dataMigr_banner_svg__st25'
          d='M364.83 299.24a.49.49 0 01-.49-.49l-.12-43.57c0-.18.1-.34.25-.43l5.92-3.32a.53.53 0 01.49 0c.15.09.24.25.24.42l.01 3.38a.49.49 0 01-.98 0l-.01-2.55-4.94 2.77.12 43.29c0 .28-.22.5-.49.5z'
        />
        <path
          className='dataMigr_banner_svg__st25'
          d='M364.73 260.37c-.08 0-.17-.02-.24-.06l-6.28-3.55a.488.488 0 01-.18-.67.48.48 0 01.67-.18l6.28 3.55c.23.13.32.43.18.67a.52.52 0 01-.43.24zM364.75 267.13c-.08 0-.17-.02-.24-.06l-6.28-3.55a.488.488 0 01-.18-.67.48.48 0 01.67-.18l6.28 3.55c.23.13.32.43.18.67a.52.52 0 01-.43.24zM364.76 273.88c-.08 0-.17-.02-.24-.06l-6.28-3.55a.488.488 0 01-.18-.67c.13-.23.43-.32.67-.18l6.28 3.55c.23.13.32.43.18.67-.09.15-.26.24-.43.24zM364.78 280.64c-.08 0-.17-.02-.24-.06l-6.28-3.55a.488.488 0 01-.18-.67c.13-.23.43-.32.67-.18l6.28 3.55c.23.13.32.43.18.67-.09.15-.26.24-.43.24zM364.8 287.39c-.08 0-.17-.02-.24-.06l-6.28-3.55a.488.488 0 01-.18-.67.48.48 0 01.67-.18l6.28 3.55c.23.13.32.43.18.67-.09.15-.26.24-.43.24zM364.82 294.14c-.08 0-.17-.02-.24-.06l-6.28-3.55a.488.488 0 01-.18-.67.48.48 0 01.67-.18l6.28 3.55c.23.13.32.43.18.67-.09.15-.26.24-.43.24z'
        />
      </g>
    </g>
    <g>
      <linearGradient
        id='dataMigr_banner_svg__SVGID_50_'
        gradientUnits='userSpaceOnUse'
        x1={299.166}
        y1={100.785}
        x2={320.231}
        y2={100.785}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0} stopColor='#00dcf3' stopOpacity={0} />
        <stop offset={0.13} stopColor='#08c2f2' stopOpacity={0.104} />
        <stop offset={0.423} stopColor='#188bef' stopOpacity={0.338} />
        <stop offset={0.676} stopColor='#2463ed' stopOpacity={0.541} />
        <stop offset={0.877} stopColor='#2b4beb' stopOpacity={0.702} />
        <stop offset={1} stopColor='#2e42eb' stopOpacity={0.8} />
      </linearGradient>
      <path
        d='M318.23 294.76l-20 11.7c-.35.2-.34.7 0 .9.16.09.36.09.52 0l20-11.7c.34-.2.34-.69 0-.9-.16-.1-.36-.1-.52 0z'
        fill='url(#dataMigr_banner_svg__SVGID_50_)'
      />
      <image
        width={76}
        height={75}
        xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABLCAYAAADakmGTAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAASNJREFUeNrs2NGKwzAMRNE4zXb/ /3sbW1uDtUzdtK8S+B4wIXkyg6Q42TYAAAAAAAAAAAAAAAAAMUqWjZhZudiX/T8oxQjsNax5aWDN 76ODK0nC2qelgfVVx7VFh3Ykqawe0m3s5yahtRFWvz+l4tYMbPCq6nu5j+shrdiDemi19aCjqiw6 MK8wr66f5/qVfXl1eVs2b8vlKmwa9PsU2jGe++w6pU1LdDtkOuLsct0/vDlDHYkCM2m5KkNf29Ai 2zE0sD60OwmqjuHuQRV5VqU9l64wPWedIySfWfNbskYP/Cwt2WSGmbwZN2nHUyos9OCa5aRfvpz0 dYa15T+NPnxLXrWtZfgAT/O34uKPxdtLYgMAAAAAAAAAAAAAAACwsD8BBgD9p3cGs09wQwAAAABJ RU5ErkJggg=='
        transform='translate(280 258)'
        overflow='visible'
      />
      <path
        className='dataMigr_banner_svg__st26'
        d='M319.38 295.24c0 .67-.54 1.22-1.22 1.23-.67 0-1.22-.54-1.23-1.22 0-.67.54-1.22 1.22-1.23.68 0 1.23.55 1.23 1.22z'
      />
    </g>
    <g>
      <g className='dataMigr_banner_svg__st1'>
        <linearGradient
          id='dataMigr_banner_svg__SVGID_51_'
          gradientUnits='userSpaceOnUse'
          x1={521.864}
          y1={109.213}
          x2={547.694}
          y2={109.213}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
          <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_51_)' d='M546.46 291.98l-12.85 7.52-12.98-7.45 12.85-7.51z' />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_52_'
          gradientUnits='userSpaceOnUse'
          x1={541.148}
          y1={23.324}
          x2={541.148}
          y2={109.218}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
          <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_52_)' d='M546.46 291.98l-.01 78.41-12.85 7.52.01-78.41z' />
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_53_'
            gradientUnits='userSpaceOnUse'
            x1={528.233}
            y1={23.324}
            x2={528.233}
            y2={109.218}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
            <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_53_)' d='M533.61 299.5l-.01 78.41-12.98-7.45.01-78.41z' />
        </g>
      </g>
      <g className='dataMigr_banner_svg__st1'>
        <linearGradient
          id='dataMigr_banner_svg__SVGID_54_'
          gradientUnits='userSpaceOnUse'
          x1={478.732}
          y1={108.595}
          x2={504.562}
          y2={108.595}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
          <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_54_)' d='M503.33 292.72l-12.86 7.52-12.97-7.45 12.85-7.52z' />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_55_'
          gradientUnits='userSpaceOnUse'
          x1={498.016}
          y1={22.7}
          x2={498.016}
          y2={108.595}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
          <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_55_)' d='M503.33 292.72l-.01 78.41-12.85 7.52v-78.41z' />
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_56_'
            gradientUnits='userSpaceOnUse'
            x1={485.096}
            y1={22.7}
            x2={485.096}
            y2={108.595}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
            <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_56_)' d='M490.47 300.24v78.41l-12.98-7.45.01-78.41z' />
        </g>
      </g>
      <g className='dataMigr_banner_svg__st1'>
        <linearGradient
          id='dataMigr_banner_svg__SVGID_57_'
          gradientUnits='userSpaceOnUse'
          x1={502.779}
          y1={151.972}
          x2={534.559}
          y2={151.972}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
          <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_57_)' d='M533.21 249.26l-15.81 9.25-15.97-9.16 15.82-9.25z' />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_58_'
          gradientUnits='userSpaceOnUse'
          x1={526.506}
          y1={46.297}
          x2={526.506}
          y2={151.974}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
          <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_58_)' d='M533.21 249.26l-.01 96.47-15.81 9.25.01-96.47z' />
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_59_'
            gradientUnits='userSpaceOnUse'
            x1={510.616}
            y1={46.297}
            x2={510.616}
            y2={151.97}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0} stopColor='#f0eeff' stopOpacity={0} />
            <stop offset={0.5} stopColor='#e9e8fd' stopOpacity={0.5} />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_59_)' d='M517.4 258.51l-.01 96.47-15.97-9.16.01-96.47z' />
        </g>
      </g>
    </g>
    <g>
      <image
        width={228}
        height={163}
        xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOQAAACjCAYAAACaCrJZAAAACXBIWXMAAAsSAAALEgHS3X78AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAVpNJREFUeNrsfduO3FaS7b6QzKys KpWktmxoRjgQDgQcQK9+Om/6CX9PT//O+CNGH2A9joABjIHQR9OCW7ZudclMknvvEysiNi9ZWaUq u0ouSaSbTWYqMyuT5GKsiFgRYcy0TMu0TMu0TMu0TMu0TMu0TMu0TMu0TMu0TMu0TMu0TMu0TMu0 TMu0TMu0TMu0TMu0TMu0TMu0TMu0TMu0TMu0TMu0TMu0TMu0TMu0TMu0TMu0TMvNXux0CD6nJfH5 SukCJ7Y7szZNx20C5LRcAfjSNUBJgDqBdALktPxhEP7tb3K+/vrXj38Svdboa9P5AJ3AOQFyWj4K wvPA9+OPHz9vP/xwGojngXSynBMgJyCm0yAcAjADj8DVLU+fPqXnnlzg85+aJ0+epMFnnQIqALod nBMwp+WrAmK//tu/JUfbbv33f0+etrz+x3+kAivtFz/99FP500+JV3rM63/+Z6o21/xv+bV4H94/ +Cz+bP073d/V7zH6btO5+vSLmw7BpwbiiJJ2FlGtob13T7bPnj1z+/vGfvvtc/f8uXE7O9/bg4Of 3cGBcT//bNzTpy/8YmHc5orn8e94HVa8D+/H5+Dznj3jc979Haw//vhj/h42U2X+xhMwJ0B+TUDM IMwAySB8/vy5AtC4qnpsAbT371/6+fyRm8+xb/z/+T8P3WxmTq14Hv+O18lrXzJw8TkCUMMAffJE /p787R8UmGYC5gTILxiKIyD+7RQQ4Rs+fSpWCwDJIFwsFmztAKjdXeM/fPjF/+///cB9+PDaE+j8 3t6v9JzxZWn88fGbIq94jOf39gy/Dvvyvl88PgefJ5b0BVtZsZ5iOYdW8zxg5lzotExBnc85YGOF lv5IIPxBgzPGAgiwWI8fG0MAsUUhq/fGOmfsb79h/1danXXvrTV37hg8f3j4noB7wJ9zdPShO4d7 e7f4r74nE7m/f5BiRMDmrYkxpRDu0mrSX/5i+Hnst62sjx6ZRFbTLJcmff+9SfTdDN0gEgJBOQi0 GQCaorITID87IG5ETe3HgPjmzS+uKBwB8F4HSqwnJx+cc5b3jdknUB5ZAgTt7235DkdkyfYSWcR0 eHhoAD4BZKLnDmIGowDyl9Q0MdV1SPfvt/S4pf1H6XLAnEA5AfIGHsc0QOIQiKB/mZoKEJ8TEB93 QPztt1euLO/zflW9IeDd7UB4cHDLLpdHDuBzbo9ByPsrY5f032KxY1arZXcO5/OddHKyNDs7O2wF 6SvxKvtHaWdnL+Lx27fvO3CSoY0CWoD0JYPyNDAlhTIEJu4+owMwAXPyIW+Onzi+Nod+Yg7WiI8I 0D22L14g2PKKfbz/9b/uk0/3Bv6dr6q7vq4Pi7Y9KmezW0XTHJchOFp9GeOyinHFa5itqlmy1XK5 nqXkqopWbPF4NrMVWT96XV6XFfmT/DlNY0p85s6OL+i5oqrgg74ryJDSd/mVfNIHbjZ76F6/nrOf iaguAkD7+0/0tzy1g5v45F9OgLxp9LS/AHP0NF+sOUAiVvF7iyBKDtQMgfg///OuABABkLo2BJT9 oiz3ilkAiHbLqlqUAF9i0M1ptTNerZvRx88qWlNFW1rxmF5H65pXYwSwACi2DGYGuGNgNs1RWde+ mM8/0N/9xmdgIhCUgUmgtWQlNfjzxMLSnxX4wX1pAuZEWW8cPTWcR8wWcRysefsWKQihpvSco+fc anXk12tL+9bt+YWr/coTbXVta71taOuIsdJjoqtMX+l5l+lrib+G/2v4fwBFKmitoQYoTCwTUdIC tDSBroKexoLgTpYzElBjVe0EbLHSDSO2rawh/Jpu3/4mvnzJgSA8RzTWJGLbiSy+OTz8Pl3AvzxF badlAuSV0tNtx2/sJz4ji/I9/xv8xNevX7qHDx8QEF87BGvK0jgG4olxS9oW9bH3+7uurpe+aaxf LCwB0XiAEdYU+3RhOwKMgrR1lS0sgdDaFv8bnsNGAFkUUf1HASBt1wRIAn8oiorAuMbzQYC5IlCm cHiYaLsIAswPBMBbDEz4mK9emdQ0rwiY9ztgnhf4mfzLibLeOHqa/UTJA/7q58uCc4PwEUFN6xno 6UkZZq48Pl4xpSTaWZGlZEpalnZW13ZOHzsPod0prZ3bNuw4Z8nuWpi1RXDtIsawsLTylp63+m82 hB153O4QeOeVDXN6TJ/X4DOV3oLS2ur42JKf6UrxNU/K9fpWId/zQwEfE9QaFBv5zJzLRL5U/Esz +ZeThbz59BQpjPv3v7Pv34tF7OnpMYHS+qKwbBGxJcvnia56sk4FAc6T9SrwXFi3RXTy7zYSfS28 sxG0FRazZdoa6O97+hK0pQ+RqCo9IHwbpqjO+ZBSi/1gbdF6nwKsI722JRoLi0j79AJ6rm1TIAvO W6GyR3E+32OrCWt565aJ//zn63Tnzr3IaZOfX6T2wSAie0h/e8pfToC8CfT06dMX7tEjQpcXelpV vvMTV6tDAtw+0dMT35SWweeJkrYEQL8jQIzR0toUVVV62W8LlyxnJQk3RbTGF/SQLKGHL0mPWfZG AKV/EUQSCHGhJ6dg7AFpaAUQQ6DHLf07AbAJLhRtoH0AcghM72f8OIQl0dhIAN2l9TA2TYy7u/TO 5k68fZvoMPmXL+qX6d69B/ER0djn5rlZLpfpYv7lBMyJsv4BegqVzXn0dH+fOF/5gCOo83nhq6X3 oKZkNWndLwKiprNFWZY7JWjiGpSxtBw1Jb+QaGQ7L0tH9BQ00+wQ4hYEukWwEVSU12jDbnJ2N1q7 a5PdJcDuWuxH2ZJ17R/zv5tdwiFBKNDz+XPCQigtUd/SKo21HY0lqky0maO0oNCadjkpEf1FuqSq 7jD15ojs3q9+d/cBU/MXqpfFMTlfive3jYjstEwW8kwgmiujp4icer+HfQDTt+2qAD0lwBUeFpHM HdFGUNMi1aF0HpGYQGA1JQGuIJNHbqMnK0mvTZEtJQHVw1KmFD2CrslGsoVGbGXk2ytTVnooFpKY rWPrSH+VDHJybAFb+hxaU0Ovoa0nu9fStmicY0vZkk1tA1Fa57LFxPOgsztkZY/JQsJifoiLBd55 WwM/v6S7d7+LWY63PfDzI1nMH6bAz2QhP05PzxOBS3IfQYznnCz/5z9fcD4R1RUQfC8WJVsMBEEQ DCnXhnOJsIp0cZawNvQxbA3ZElWwRGYmAZuwE5ylKz2QBSQLVtgdAilZsmJBwCNrmHYdrJ41uwTM PXoOkh2yfIm2fpdwSvt2r9vafku43LPO7FqynIRSspR2t8DfSPT5ZIELU+z0waB2B9+HtnOy3LMy W0zOgUoe9ORkVZXlbiEWkxh47VlcgN+OYwB2gGPSB35+3gj83JsCPxMgL05PDVvFv5rt9FRUNkXx yAo9NT09rcjr4qS+Y3racFJfgEhAr0ADsQolFCC2bdjJkVAysjsAoo2RbE4kyklrikw7CTxMUQWA QknpM/foWzM4GaAQr/JWVwuqGve8vi8BuKCwDgCnfyOQA+xNApUVYBpTMlUuTMk3iQY0thVwatS3 2t+f0+9acUQW6qGqckXz7qicMTX3dCze5ioUvllBWICb1yQsmAB5ISBu1igaXCA/9ndyqU2UEH+v svmFUwCwCvCl4FPBUtQsRdsrKgLicUIaY80gTKmeqWVk64OLnawSA5H+Iu2Tb0gWMTYEQOsXWOn1 BBqzmwEIS5d4BQgtA5B+A22trNbt2s4qWgKg3eMtgJsGwCULmQLeZ9gXLdQ3bVKzi9RJCHERBhaT uDCB0ojVpN+wWtUz+r5sMbN/Wd3Z49/Ox6Auis6/VMUPbl7wscW/NDbXYZ5X6vU1+5df24++lAgc V13xkpy9Rw9HKpujI0dbR/6hJUvpvHO7ZCroQlQ/ET5iQJICa4QPSNbSh5L8sdL7gmhsoHdb+Itk NSPte9kPsSKKWRpQRDJZdEmW1iRij64gy1fQawp6jvxH4xI8x2hR/9GfwyRRVujJkRkhixeQBEnw GVNqCZQtvbWhxw2BsqFPqRO2xtUESDKKtPWG9g35lamJeB35mjaYhnzYJriG/Mqiod/Xtq5PlZDl bI+OTlhgMJ/vdmmSobDg7l3zEf9yEhZ8VYBMoEHpYmkMsopd0Gb2m3HugbHv3hkC31uURznvDzho U9fO7+8vXHO4KloFItIYcdWUwVcEoLZ0rkTwRkFoOMKKLf1ptjSyjbx1ACK/hvYNv5bIXySAOvom ACQR22Q8QREJDkc/RyR0egXbDpAGlZCRfjGB0raJTLJ1DiBsowEYE4OS/oYCMtWE75qOSE0vbawn YNI+gAhg0q+q6Ts3YU2ARPBnRvshtchlhmUKBbYFcpopNA1ymAjkHhIAU6zpE/f2Im3vRpR7nR34 6ZpyfdVpkq8AkOfXKAKIdIc226Onxt2/b7roKfKJsIqS2Hec1PdkGf3u3LdtjSBOB0JsAShYQp+K Etcpg44AB+CFGMnLMvyczcCEtSSjS7iib+FKsoq0T6C0pqBLk9ZE38I6+j2ci9TzRzeaTO/ok6yU U1kGoyMLGQNEdvR+sZCWgEmgpH2ykFYBaWqsZIhqsZYKzMLx8wAl/dRaLCYB2QkgY2y4Wsv7knOZ kr9cXVhY8PPPL9IDFhbUBMzHiajuV5+//JIBeSUicFjEkxPQ01tkIXuVjW8Q17QERKKnQegpGR4F o2V6akxvFbdYQo68ki2bJRtlH+AEICOAyZS2pAsQWnGirtazbhxghNScLCTT1YSrM7L1t1bcL6sW kp6AZqcHJFFXY4Su0m2KLKSrGZjGKiAJfLCW1nTAFEC2BE5P+2QpaT8QfQUoQWeRRkGqpEuZeC6n ZAVQQVazamNoq+3Cgj8oXE8TID+jNMa237lVZUP09OdqLAL/1t+zH8qh3E3oaZlVNl6ACEUN5xKD ZYtIHJF8RbaAJbFMAlSoMjX12A4sYjRx5vCcFWDSF6wM+5Ro5UhAFOpKoEZbR1MQUKHH8UbzkCj8 QMqR/q/LQ1qbKStBiQwl/QP8R2h4glhI8iUdFOhWrWRSKxnFj0xJgAkQWt0HKK1SWn4eQPT0fEs+ JvmXkr9sAMYMzJzHLJTGisVcdBZzWFGyXn8TJ+H6Fxtl/R0i8IWKwHd7EfjRQAQuRcIeebeSACkq m3UzM3WrAm07a6F2seXcFMWcI5RIYyBaiXwfRzLNgv4y5xVtTLtkETmtQd+V1+F+6l5L25QW9H3p 88xOt00Jnz8nMCJNMaczOKfneWs61U1CTpGjuHT5yr6xIkzHdzJpQQZ0V/4O8pyOnouSDqGV0Mxp EkR7iZAvJPorEdnEOUz6bUUh4vUQdpDCwd/VlE63IiILZVJVIU2yLJGbbd4dlyyur1GDWaAj3iRc /wIt5LWKwEX4bUXwHYSael9Bb8p+oucoqkRN4TNmqwgLCD8xhThjSop9oqh01OnfrFpHspjwGem9 MSWirIiyGo6skpUDVSXKCtpKVDWxhcRNFH6k4xhr6s8hW8gktFVspom0EyyvRFtBWWEpDahrUitp ugAPqCusZUJAx9i1Vd8yMYVN4lta1/mbiMbiebaaiMyqxcxUdkhjRSs7a+nYh8PDE9bIkvUki7kf zvcvRbj+tfiXnz0g/6gI/NtviZ5+6IM2myLwDMRMTwFC70vQ1VICOERN21CBonryGdlf9IYFAcQa yT8UYBI6ZkxLreXnGbRW/UaUGDMYLQI6AHQHRGsk1WGSrh0gia6CsLn+GDB92wCkkUKQyNHWJNSV rtnWIv1hIvuUAKUl6mqwzcC0AkaCtPqWGvghWiv7A18TAM5pkkD0VdMlSJE4UFknEdkCVBb+ZVdR crZwHf5lrcL1r6kwuvhSo6dKT82AnrJFFJXNffvu3a9uPi/cq1fv6fGBW0TjYrXvUShsZ84ntoTw 16ArNQWZrCI2bVnMkM4gwATyDz2CN7FyBVlFur6iEbCRFRTriMfJzBJHV8ki4t/IGjrLeUbyJQ1b xGjEMvIYAOK+COTouWHLyNFVw9Dz7GZYvuScpHI4kmMH/hWviLYa1bTyNtJnILhj+LMAzkKDPAR6 xxFc9Sn5JkCPOQca1WLzPt0onHeFp89C8UnU7xkjdLdiORERxvcv6f61btsC/mVFzD/QsVzR6iuy 0JHuXBV8TudCOHGz2X4oiiOymgdB2lwau7cH//JBJHfCwr+k85foPHZnnM5vZkAZjDn7Y5Qt2c/R v/wcfcgLdQL/uMrmG1bZ5IZPTThhuVtVSTWGrp2mk32zUoqFyeZ0KhvIzaALFR9Q/DLxtSzL1OA/ ZqkafYb8G54z7CvuEKgW8PMS/DwH/8/wSv8OK6prTovAmgL8ALsjkEiKBGBmqstgZkCXyaiVNkqL mR4n/jx6nv8GfFEHNY6NO/A74fvCx6Tfot8P39fR0SMfk3xJT/tERcnPtKyxFd837mb/Er81SlUJ a3PLsphDiidSQVSz5MJoW4niB0XZCz7u7F82k3/5WX3Zq6pRXK0+cD6R6WlhfINcood/uOZc4s6O 9asV+YZe8oqgp0juS16RL/xKIqi2kiS++ofJs4V0TsDDAEjiR/a5Romk0sUORQ7TU8OW0QwsI1sx iarK2ltHRFeZrnLSw3bOk96hej8STziiqklEAobrQoKFcseIgsdYqfxIOQJLNJOVPPAvYS0tUVdp 1dPlKOl95F8KbaXPkshrpq9RqSxobGFqOpZg/nVg+mpY8bMOTUtgE2EB6Kz6l1nxs82/jPENesfG r6Ew+jOxkFdbo5hF4OEMEThaZ2QRuEQP7ZysIEcV2SpGsoIpW4Vef8qCcC+RSwMLQjd1tjBJopMc odSIKaKl9DpYJrFWtrOIatV4klXFgOVeVqCVlukgA5fBi9ykCgaMPk5Mc7EPYDPoWVzAljXJDcFm i2lww5jR1TojGs2/F9/J4nup9XaI7iLia8QCIjorkeGkUdm46+k4ePy7d11ElrzWBXHqRbCijeWq Ftvu4FgSNC8kXBdraYrl0vP564Tr+4OOeJhV8u1zd3F97M22mPbmA9FcWfT0rBpFT/5iIGuI5H6s ETEVtc1Q7iYWcpBTzEEZVdxYiZLShe36iz5bQ/wbqCXTTDMI3DB4SlbhSOCm0Pp/LxbRcQAHqhxE VbknQKfOIRg5e4o1WHkq9f4kPUJfgWwleY3IWiLYE6S1B3xJ9i/REQSdslr6IKh5YEHZUrKYIKt6 8HgjAgvrOBIW4DFZSvrAurASieWIbNSAT0AgyTfRNfQ3SpXijesvrzJ/+Te6eP7617/eeGHBjQXk 2CL+jcuiTtPTXgT+8mVhH3Ui8NP09IDo6WoLPRUBOAGR6SnE39tF4D0tNQpCKyDkfQffrgNhimmW /Tj13+gzs6/nEDzp5XCW/y6sHkdRLSf+BYx2EFFVqGUxOYd1umNkT8UUk4gEQCySApNsvDUjYNJL mL5CZpeBGROnSVoGpk2yTQIipq8aie3BKRQ1agRWKKxQXPJP1yIyECkeKG9hWXTQZGBuCtezuGDY SgR9fq6jMPom0lj3OdDT66pRpOtOAjZKTwm42kIDFCsuCKxIvmuQRgIYOYiRuD2GQYHwwnX/nnYj 6JwjuidJd1A9paZI5tMamaJKcEUpKqymTUJNAVbLOUjDg1ojIpoWQCWQIvMo58zFlH1KEZp3+90K zWsa+qGeI6tGKK9Y51Tmm4XkTpOkZvh70feMOcCUJOgEwYPR38bHBRTcMUXvhAW07/Mxg8ggaW2n Ulm0JaGb2IJrQNFGpCg4WEYeLFPZHPiR0jXDZWzxJDd4PuGO7ldVGH0Taaz9XOgpomlP6Hb3e+ip rwelUWQRs2WEJfyoCNxIzlBkbn5AUS1R1DgTq2hV9ibWUCirZZAxJWVfzoysIltCM7SK1msqQ4Em FhHJf6GrxqopxGOrcRzbxXT03m+7mhab+meHK2R1qRcOJM5RhiGNzQGfwRatmZnKkumFZewqRthK bstfpiQSPNXIIp+Jfe/dmoXr9gzhOllM5C2zgD13x/OD4A8HfT6kOK/2Qli8J+s4aLxFHODFi5dE adv05MnD+Pw5Gm9dVLj+5+cv7U2jp2dHT6+jRtEqPTWS3OekfujKokQE7piuQnsqFDUJIFl7OqCx gwS/1DEaiaJK5FT1qMjfDUTi7C86tmSZnnYWj6kpQ81lAErKp98fU68u0NrtWn45ozaNc5Q2CpUd glNACXAqfZVaSsNrCxqLrWPfkoBJVJb9SwCT1iwsSEPRQOxBCvoqPudAI6vUVvxLLyJ2FRRAYHCe f4lqEqKo7F+izCtHZPuO62P/8jxhwU2ise6m0dNt0dMnG/QUUbaenr5lenrv3m0PeooIHfq+gOac oHOasSN6inwYt6copJ8NXX9MTyPTqci9ZnL01HD0NO2moe7Um4VD9JRW5BxZG6qaU9aMOie5PfwN J9TU9lHNikurQFEdaKkT+uiQ4hikOTpwShDH2t5K5hECXXBHQarW0o5fo+kRwxGMDvByA8A4goSo bP67ReffCnXW75qqTGMt02yJCjvoaFMU3a5xXf4yU3xjNH9J+3R3WSAa22l5uVeQPGZKG0UfS7fZ nT4iC32sm1vtWJD7++T8JZpL08nlrgU473BPiLJ2M0okf9kPqc0Dajc74p1NY/8cY2VvglXcFrQ5 O3p60RpFVGTYi9UosrWLZA0hc3MVAjYmxBlXZ3QBHCeAGuhPIyzjQH+qtYugqpKWUIqqgZqRVTTw 7wa6VDeipmOwZYs4pKmDu/lAOpeVKqMznPT+n/TOP6KyCPRwptL21hL9l5NGY3VfI7KJC54Ngj6Z ypKlzBI8WEjD1g5RWFjGpJTWKn1V64j8pROLaZXahmwto2kKvNYltppCXZvWhcsVRs/nt4LkL+/G O3dM7AfU/jwatYdjcJOs5Z9hIc8I2pzu8IbmSItRhzc48W/88f+8K6TDmwRt9C5ZVtFyRUasbLVa SY4Ld9eiKGfSf7SUagxrcAdeSHe3iLu35s9cZxEj59sMByOMyc+nXbpGd1GFkaSSY4ecvLnJFpHV L6hvVMuYxvlEtkBGpHh0tsUycX0jg9L3FiynOcYWcYOuqmVMA2XK2FJq9DXvy3u61Im1+nfo76ss T61lUtme6GklRSPfn1VAnbXk4I9N/Nu5/46VHCsHsywrkIRBGK10AcOA9YQVzUEyDfwMA2boMWS0 YgaqKItKmrLrHztvGs5hSm/bJBUlkr9clgjgscXkHkd3eczfZuMt3OBxo8/H6QLW8ku1kGeN+j47 aPPbb8Y96FponFOjiE7g/vfVKMJCBuQQc3UGV2RYTWGIQDwHbDhpj6ik7G/xE3nf92qbHOl0mk/E Y/ENFYDqK+aLIg2p5zhwk06fr43XbIyq7A98zr3JC2Sb6ycHlrML/OAFQz1sDvxk/xLVI1pJ0krP nlxFIrWWsJTwLZEqIbxzFcko8KOqnhwEgo/Z+ZfWdAEfzm0i8AMrmv3LrjC6bl2L2suqK4wuirlW lBxzj59N/xL5y239fTaDPn9WQbT7M8CYe58OfcX9/X2b+56Otaem6/AmNYpHxfv3W2oUze+vUUwx ieaUUxl21xpJYxhW3Egf006xkuhzyE+0ahXJtqg2lHOPvXaU1TFJioxZoM7i7QFt7S2igDP1+cYt dPU0Ve1fM7SQQzCPcNvnLXFtDa1u9/cH38c7bRWCmwq92MuNhn1e8TH1d0IMoQJ6sBBOlyRWIRk5 5hZpn8ja2L7WUxQ+yYrix3MaRfxLWE60wkwtt8FkVRRxe2I07NvvGPiXIddfVjODcbR6zkXKuGb/ 8uBgNzOnotPHLgtmWMM0SbaW6IaH4wF3KSt9TutivxgLORaDZyH4OIIqVnFUua+lUTm5X5JFdPu7 rm3pyKKFRiFWsW+hgZza5WoUoTslJ2kmJVKah9PoqYKrHFbyczqjV9kUeTtW2YjSBtPHoafpLnqu YWQz1fmKKatutvuJ9ixreIkznIaB/KEVHexLzNVuicayLHYQjc2tQQbCAqMRWdHF2k4fmxU/7F/C n1QxAaymWEGr2tgN/9KIj5n9S7aWies3a7QS4Wgs0iNcfylWUzoW1O18zlFZtBBpCy71yv5lDNzf 58372HKZV4i3ofbprOXP2tunn02CY/CpLaX9M8HIf58o6nMCIxrqQmkzzCkul++JkjoCIoHv1h7d 6ow/DKtit9hGTwmMXlrxuyTU9NI1iq4HbRrmFLMI3IrFs2ZQHpWQuBd/cKiyyWJwLiS2HUVlj5As shMEXoye/i4gjs1j2uSyZwEz09dMaTtQcuCH0yMDxY+kSTAM1uYOd0m3OVXCwvW0VbguBdEAWhrI 8EBf7dqcUxiNwI/XwuhO8aPF0Wi8hW2uvzzuaOwJ0dYFgZJs7NsPEYP89vZuBxRFL5f34rC3z3L5 7E8Dpf3UYEQj4qfqLxoeavqzQyrjt99eka94v/MVO6tYuq5yH1HTYXK/j56KRcSNUHKK0mqxaySl EVOn1q9TyOQaxVzB3/W1UTByRUYESKUSIyf3TfYTZWs5EGK11w3X8Q+ip2OLOKajI1CeBbwrO0fb fMyN59JF/MuLCgvEz0xBIrFJKkpMEv8SvqXRrnfSoSDXU9bpnMLoLCzIhdHsX5LVRGVJ33hrkL/U /j45f5mtJbbZtyQQciQWgoJcED30K0+BUkpt0mcGyLHPmCOpOXgDf5GT/AxG5IhEf1oUdzWdYQiE x7Tu+qZZFVK5P/Mx1iW0p9zhbVYWRD2qMT0tpNvboNUiRztd7vBmqrPoKd5vRVlD4HTSpPgjIvBs FS0S/KdUNqfBmK6Tnv4BYJ4O/GynsZvCgnEhdC8sMCIoEBobM51lq9lk4Trdreo+8ENAjBmcw/Ku JPR1oPbJKh/6FoPGW5oyUXAKKHs6y20qG2KmhQR/EPBpmqigfBv39+9o4Mckuvbi0FK+fm3SZqDn ulIi1wbI7AQPwZhpqoDxsTQiJsiI2kYiqCUBcVUeERD3PPuKfoeF4N7PigzG6A3XKBIjqjh6Cs0j cou5+TDR0xByV7ezahQdATVtr1FUpc1IBJ59RjuWu11MZaMJQ5OunZ7+EWBexr/MOUztAStVJMhp EtLQ7W5TuG4Gip9hRcnQv0xKZRmcuTWlgrKX4PVqH6/qn6hgNINeP/A1VYbHiiJYS3QvoGuMAAl9 yBLTvKASCc3cMBib5te4Xod4924TVytYyufqUx4SKJ9sAeVnA8hReoOjqT8IGu2QpgKMBYHxPcGj In9xNUMaw/miZvl/EUoZ3UY0tQhR+pQSKZSADXzDXBqVQYXEPoEtcItF38nd2AJmyVtO8GtZVK8/ lVyh0FPLLSwyPR0BUekpXX8ERJfzhW6cxjiDntrUNaW6bnp62RN2Uf9yTGc3hAXsW+JOLMICul7V v1Qqy2BUYHJvH5HhbfUvrfqXVkq7MOaAjDCDU1IkQ4uJ5/zail/JQR+IChicKPMqBZyO/s6SrOXO TtW07aotSzQyOGZ9bF3DWt4KAOWtW9+E9Vp8ykeP+GajAoKuauTarOR1XABdB7iBQNzmaCrSGgxG 8hnf7hRkGe/RSmBcAYz7RE+XBMAdoqbrUucolhxBrYlmerWKXT4R/mEg/7DIgnCJnjqvwRtW0qgA 3HF5lBl2eRvVKIoIvEuG8xwNDdikIT09LQKnE+8+rrIZ1S5+Mnp6Vf5l3ueYqx34lhzFPcO/NOpf pvOF65KzvJx/yfpYx/5kbra11twl7YeaqOuabgt1QMeC0GrngqZxbWpaV3IvWfIj0TuW1tjOZrtt 0ximr6vVnQCfEqB8+NDEZ8/O9iev2kraT0FVJc8oqY3F4oX77bcZ+YwKxs4yChjL0rK/CEpaRLKI BEiiGSXd68iqtRURRPIZJQDDltDlCgzH5UOj6CnTU1d1fqTRivlL1CgmLX86TwRube8rbgZrxvR0 XFB8E4D4+/zL05ZyY43nCde7ViK/w79MaiE7oXqMDEalsWv8m3bFE78TllMspUj0XI1obO1aQ8AU UO7tzZsPH45DUey28/l7spYHtL6Oy2UbDw/X8dtvH0bxJ3vqel1W0l6XddykqtlvRDIWUVSobY6O WNLk6/q4QPCmPVqVaFcGehoLLo0i8JUI2EjKgqyhJ1pKvGfmpPHTLEp51Mzm0ihEUJ3tLCS0qefS U0f0NCoYB9rTiHSGKmw+Tk9t5x+qVbyIyuZmt5I45V/2qZOr8C/pn6LTNMlF/EujRdE5L+mcXZMJ ZhoraRIAMYKmrtVargFK+g7ka9Jz3q/JUgqNJUBiS5SULWW2lmUZ26oSS0nWkdZf4vFxExF5ff/e xE9hJYsrto4bYvEfTE9Vq25uBlowluU3HMiBBK5qnW/SqoglEklqEbXzW+64BjBCkUFnkqwf2ina 3JENviH5ihGUdCbRUxmOajnYkyR6qmPeTNejJpV0QWh1AxfrFnRifYSiJm6KwLnY9xwReF+jOFDA 5Ep+u3FhfxazDzdaS44E7MMbzUiBwN1CdJwBvYZAg/aTVn80+shG9qT5n9AFgPOxDEgrNziUpnkB pgjyrUlZV4upX5pu4t5B9LrIN9Dk1Kfnf/Nyw4zGWWmd6TDchK4f1e8WjHMQY7i+Jd3v4SvSNZfq mq6ieJRmsz3avk13w3fp79Urum5fELt7SO9/RtfzoXn9+jWB8Ye0cXNNNw6Q/SKOo0ZVebybMY8M ACntNe7ZXERMrN4TXHwMyDGKFtQjgEOgNG1J1pCAGMyMECIV9g5A9DO6/86xb7vqewUo2meYJFUZ 2WfkaKore/2pWMSkzaGkcRR9h0xPbaaniZU2ncrGjsGYpWoZiBehp2eJTW+0sRxYxw3d7IABdGA0 fQUKwAgLmUQvxMk7Piawno6nc5nopOcsuwCgrwApz790XQCNGAskfBztTlxPKpFvYjdOJYgpScE3 AZMcfBct0k4MezICTvCIYICH1SYQEhtGsB7d7ZDqIKYWZ3ERG3/s/Ilxx2uX4s6bVLb306tXL9nt Wi6/H508NTxaPWNvmoXsL76sxsm+I7oyvngh1tF7ASMoKyr6QWHpDsUWKZAvzjpJtZAoFkbUlO6r opXkNhiGwRjRUxQicNaSprmFv2i5t40EcVIuHE5IcUj1flJtqVJT9hOdkZpAVtxkemr6iyTTU3ta BG7tWGWj9G0MvC1W8nNbNqzjmcDcYimNUnsJ/gwoPpiG3NRcZFDaYXsSFlgowKSzgmWmIqBzYi15 Pqb68Q43UcfwTzDDrFmEuA8NlKCjM2xacZ8NHD0Vv6+NZAU4h+rbma/9KhZ+N57QC+/cOYh1/ZZZ XVV5+/LlC0u+pNWSrZHhyef9hvmQkuoYRlY3fccPH157BHIg9L1b3fLvwwkxBleU5bxcreqqKGzV NO2sKMqKDuKcjiVZRzs3PrdkNCLohnW0hkBp5s7YWd9UWBoBZ+0pZixiQrHkFqUt4jbtaSd5S/YS NYofV9l8LvT0agM/v8O/7PSxxFGM5VkkOU3S6WIlIotaS5BNbQGSWAtL710nbrCVENRZkS9J/qNd 0ftpTSt67TLv5y2dbuwj4LNumrquqmItPiUZSR/pGfiT+232JW/d+i6cnJgoCp6niWhrGqdA7M2i rNsswLNnz9An1WTf0dOlXxy9czv3bttlTRYS00MbgGKN6gKijKbw2v2NpW+tlUr7QFbPa43hAIzS 09RqJXtfnZ/Yj3TSot+oDhU0R6On/LsH7RZj5IqGTvKW6emgTGoLPU0jlc1Ggv1zpaeX8i83gGkv 6l+KpFe7i+T/+IYO5Q/eGTvZYcS56M5JjmbbvhMC53YTzCsnQntfTttfRn6axfDEg8FOA/0LPQ48 pg8mk65Luv9bugZTcLV1a8ddCu2bkw9kTG7F7777zjTNS7KUDywAacyT67vZXTWtMdqoNtPVnHfM xcVot4GuYbCMKI9BeoNbMxQSNW3bMCcawRYRZTaEFAJf3LEoBI5ph8euSWkPnke7DARyuJNbl+rQ 8qekhbV58Ck3FB4JwZFj3KzcH8rd7Kg+8SapbG4aRi+ev8x0MXUyPFRZDq0lvTQOWlNm0bpEYa1t 6OUt5ylN1OnPdk1HfU3vXSdYvWwJrV3SJ67oDJKFtEu6yS/py7C1JN9x5Zyn/YasabGyZBMNWUnn ZnVRE/7q43ZdiJVcrUxYLl/Fg4P7Aeqdx48fxw2rf2UNsj5BPaQEc4ritX3/nmB1dMC+13qNthtM C7lwl9x7tpIOs1xiKFIbYCVF0M2gijxdmCOu2oHbcvMp0aSOwej6nqhcpaGAtDpIBsl/rVHsLKWO CU+D9oo5snpWsn8DfPYrBePgehxZ0Fx1P4o+S6QzjVpWss+e1Jfnlpe4aTqkmsSX1MJv7dJeOtnn tBUPArI678RqO015XOaiALrI5P0cN6BrQKPomGrmXOlCaD0h3LkWjI3s4y7QyzW69OQ7Yna/2n/5 l/sG0VZjHptxYCef86thQ9cCSERXYdTRJQ6Pf/nlFW3vmTt37pgjd0ju9x479RAK4GQsQ+MDUXci EXSgAohttmA8YUmjoDIvEQccKQwby/4EjE+C9Bu1uVZR/EaJ0HF6w3Sdwa0Eb3JgYIv0baOplNne 1+arBeIpEJ4ujB792xZZoYDTSkHaqEjaaJTVagrE6JgEPpcchIOaygrQ6LxaVlcp8Gw3yo8eR16l vy19lmPQO7rx800YRgGFDggH8vleQcCya46P8R1v09f4Rn/Ow4tRhD8fkFmdM7gwmWY/5rsK7i64 y+Bu43iY2rFe6HPbto0cjLK0EvL2fKCiHjxZvU/dwZYTYHGnywc+5SCN8yp1k+p8CY9rsXBO8uda xRxqTxmMgyT/CIybvuJkFT8CzE1rOWhTqd0K7Ki7QQfMzm/XVcGactS7v2l6nplp+HJyYlUdXsdD bXmwLVqmuKEVBgCjJ+soOUo952Qd+95FjWxXehN27sgeHr63f/mLMa9f/2KHsZFhRuEqEfkJKGu+ q+Aug7vNvlkuWW1m63rdWSAcGKwERj5YOHC8IqcUYydZQ8DbsYxNKA7C4RIhRag8ieWz+YDLSeRm Tp3cbdwmw5y6a6dRAOes8qjJKv4+UOZmz10BzKi/lAD21LmRl/Njm2+WEimSticp8ppGoxYA8jhy ORDeQUqEtXxBXlMYJLxLchpZMMtp7fV61X2hg4MD8+7dm+7xY2as31/bsbs2QA7vInnB3YZo+dD5 Z9evbY2oAorC5AOXDyyB0fXqlwRwOhzonH3Se5nG6rSmIuUJw8Mzbk8BcHDyRxfH+OI5nWOyExSv IvjXPR4/Z89975eYRvrEFvJiS9u2sJL2vG940S+rrSfSGdGH3JeUbqof8wbShVM803LxczM8vnKu BuL12AcvJcuRg68qyRtEN7c9px2EkkR1XS6g7l7npA9mgmKHh2h6lJg0nBeT163NbDbvvuP79+/N 7XA33bv3HT/3/DnZx4E4AJrWzwKQ33///anLdn//AGUs3VJVM30NotcFHyBwThGqsffXHVw3OPA4 0Hzwopb+dP+lrSfMDFpQyAnPpUM2h967l6b8yoGCP6XNC+n042nZnvYYPhaA5Tud7Z4bpRC4YTM4 0kY6hJtqmVwxIo+tNthicTpyixYVJLyyyCD27wWyXeGCqFylw4H3PhrWsbJaB/I5AamuMe4lXLO/ Xew3f24W8tdMXM3ODk9JS+v1Wkb98tLyCUETFp+QxJWDhhUOQlI1B/SP3Fwp2ZyjCiiENfx8V3On vV6wnyIx2u4k0nWgd82cHRv2i5G7tVxA+GI2DbuBD0G4DaQTEHODrE2mmUE5Hv7TtwLp85GS0Kdz p716RHwu55pnWHbzLKVnD30w5ye7ladC265PrOXJ0I5X5DU5txm5C3uEjI4sAFRDESUFfDliVgKt JyfHZneX/tq7d+buXdr+A1/9xZZffbUm8ooAac/4cs/hH6Z//OMV/ahvUKbKqzQB7+9ERVHS3aqI PioI6WWtAqrQA2n0YNIHAHzoZBaCPMeNekVaFXO9nbS7530+YdrcFwNJCbhcMNsX0XLFu9x9NxO+ Yn9NBumYx+bHEzCNinHSJoMYyenysewZi6hpuOtA1yxLuthJe8nUza3M8rmUayetjDBA7SSXbBkp bMZgWRlp4GSmZcL0rCjviTy2na8n5wp63gfH4BRQFgTKspzF4+46pe2t2+ipY8J3aBX5kIf2YO4k GipLlPWvg2ljV4ekq3TWO6UOms9iyEnWscrcxjue7kSFtH3H9KmuzEpKqUw7l7b/FvMJd6DSIWpB +3Yn2bhDh27HGD9XxY7K53LFRxYJyBhvOvhlzG0bJS/VVXRI+c5lOsR9vMbxS9WuXo6ebq+bzEXN gxuY3vxspp9KLXGzHPXk4Zuv0ZYfRruiGyleRjeBtUzcEqUO/ZkVvb/TrRJMloStFZ3cJbGuZTBZ oZNWIbTrohBNa9smrpGs66R61kVTVaataxP2901ompfcZyfXRebGV+aKtazXSlmfPdOd//fS/KW9 l6Icbjq+qDnbEaqg9NJj1FhMfOfiO1lMXEFurW/QtIgYaiONjJxM7dUGuylJW4d8cghj69yPBQWt jvt/yl2TwNkS6KRdBFvVvkBWpFpJhM5braWN26zlmMamK8xIfYb0dGwlOwZkutHqPfC0x2t37MFm yDAGHa0Oz4XPv0xqlh47Rs+3lb6t/ZpkdZYF5VyYnP8NnQSc69p7yLWUMFFSrCVG3On8yYDr8dat eZjN6DKNh3ytBmlAQu94wD1b8cOkSPnHzynK+qN+aToK9CPa+w9SvIcfd1dpK52n4+M0i3MGJR8M PiBNiDWtdKCcLdC6ofHoKJZCg0ZHDm0ZWKuo1eBGT0Li57qTwaEyKyeFqwC0Gza3gkgyGNRor1Ar Y7uF3moXbvE3Ux9M6HzO8UU2BuboDvml09jt9HRQ3TE4RjFbwcFKl3kPRroIuGOAU+opq+UeOkYG wtY9AOn8RqnmsF1Fx7CSw67oooZF5BXvQd+dqH1eiRt1PVxzi0gBJblHhYASNZKLxX5EkTKr0XVy lgQrZYtKj6uOsF4LZT1dfiXzE4S26jzHlfdrjBpvQeQdplV1HQKKgpsbY17GzIQwJ2IJOjonT0PK r6zWQgpN5WqPUfmVzcNUcxMrGYjDEjq7veO46aR0Lis4+vb/H+skZ9KNb2D1Z9HTDM4ueJNy9/Nx k2WrviJHSwdBG10bbrRsjbaKjF0bD4jKk/RxlZsw99SxK75RE0B5mwiUnsAaDNp40FZu6nQFoNxK W3qkumkS0dR5U9THba2i8r09E/7xDym9AiDPpqs30Ic83fpxWPGBMWAv3e5u6f5l9p070sE5DMgK VR+2G5rDoGRheOi6AAQT5x5dAgDOEOfJeS7DSlqcbLjsyrG4HILzFNOMvk0eeFOJntX2TY+tyu5y 5bkdg/JUMyszHgXQjXjrW3dcwL/8fIH5xxsrA3yn508OgajzQTRy2s8F6So7rICxnwcSpcqDO89F aXDllLJGYU/eOwYgngtKYwtuF0k+owJx2FcHgGwa+I0fwnweArrPocrjL39Zx5OTh/HxYzN0Y8xV +49XTFnHXwp3EKGtz5i23r/fpoYO7z+Zk79NGBP2oU1MD8pSKAPoAw5MQCdqU9T0Uh7kyQfWo2Qm 4MCuiFSskrMoo4EI7wQr9ulELOnT++dQdmNZuL8USkN3zZSdfyPBgEyLkB82ueMZUya5ODjHlcTf STxgpk+ZXMq/NJ+rf3kqp9j9DnuKwm9S0yhWL9PT7B9Ky0dt88jR0exWwMVARiwXGFs9dwT7pePz anhNvO9O6GLi801g7K8B2pKFXBLch3SWwJjWwTZ1UAB2Hc194h6tGGGHhsmLBYbx3KH9X3Qs+kMe LYDoanYdr4OuXpsPOfyyaMWOH4MfVdch4Ufix+JHo5171fAMv5APDM/844NVS5NcvbMRcNccKaPV OK4Ax4mig06gTHSSUqKTRCfKOD5hdCmgFm6ZsBqphwM4rWUgr8iKrtUHyVG63M0M/oZcMBgWw34m qFPiuzh8DKsFrxf3L81n51+OgGdGvuHQZxxQUpOGUVMNjmnlvxQC53SFkWPbAZEppBXKaR3XMa4S zhFX+yc+fxFrwrnGjZbASOecPvPEOntM75N9Wh1AippHvk64/nEVAMbCE7iLtW03LeOsKRs0TDY6 8+M9AfB2vH3bxLt3v+sG8MB35PmRJqc7hnT1BvqQZ9FWlGI9e/aM57v3viRaeXi3XHo/056sZbMs mnKnQIPkqJ3nuNlV6vuxSitIK6PGh93JB+MCuCerdJeTf0MHOu06F3V2B+rniOagvpLr67J/mXvs CJ01pyZabfqXw36s5jNtkHw5enqB8XUxbRmPPp75sdks2Qo4W8klJhn4ygXIOrYuqvW00pM1cm9W BOwwtg5BG3lsvaMbNxiVtH/kG3qQWSGWGyUTCNt61Ch53JPVBKQ5MHyHjAhPxOrbdpgzZnx8No2S h9OuumZX9sUL42a/Gfd2x7j58q0v7t3heR7r9pj9SUy4QrNkIg2l9xUmXBEQS+5U7r10LOdGyXl+ BxolGwEoD9vhomUdJ+5sF+Axg/EB3CS5C/gYzVkOplttGapzIf+yqyJJl+y9c2OAmc4BZzqvQfLZ lf99TtEMxgmocKPvWo7+q9ZhypXM+NAoa54dORwfABBaGS9A4Aw84yPw8J3Acz5kQhZALT1YA9m9 qkJzZB0lQGBsQVPJMn5oj8MdAiPP93j9Nu7v3Amtdi3fHCVw2ne8umDOtQFy00oOtjrXg4fqyFyP AtORCZTFHYfJyAWPnXO+IUAWwRbLiDECpigSWTQvFrOBtUwybo4HrqK7nJEJVnnADgMxiYXEa3iM APq26vxHqTBP0nmAB7Ai4BO7uR4AZ+TKdCu9QcVK8vRjmSws065yaVduE2mctNvRTgOXGrJzfefj 90RPz5rtMQAliuPS9hHopzqVsx+Z1IeU6GkSmRtR1r4hsh00Q84zO9g6Io8I35KbIjuxft6u0bUc YAUAYQkx1wPvQVojjw6gb9AEumxkElbVFOhlNRi2g6bI87kZTcDKYBy26+hHnf+tU+d8NsN2to8T eMpjy3d2dix3oXv90vmHD+yHD78SZcUYujs8gg6dzGW+B8+EJIvJg1nLfkIyg7Qkb7MftuM9W06n VDVIN/PK6qg5sZwyKzIN5nvEbvyctH/oBrNy31bbtX2g4y5V6qcG7hg37MkjBWXcEPjCY+hu0vSr 8+gpVyVupafDIa4pdgEwYzZmRZp+iKusrLbRnHAOrkmPHLZ+ZN0AxG6gDqKnYi1hEaMNg5F0ni1j gVEBMri1BiUl+DcRU6/mMv0KMYq2hb94Mh5HN7CMwxmRiKo+ffrUbJ98dfXW8RrvyNunJksahDvR iT/52hAojR1aytXq0G8Oac3zPjxPTW4JkGWRgdkSMJ0C00n/HYym03mPscoWM09PzqCUKcmn/Use WZ50+I42VLbS4fyj+cs8agBg/IgM7xQw/wT/8hroKfTCdoOecpc3jlxLoyrbKE1teLiOWsWP0dPY +Y9CTQ0Pc+2nKluepiyTlAl8DQa2zrDPgUJEU2e0XZ47sLW3jOdPUb4uMF4zRdoyPXkwBQv9dABK 5CcfkqUczogUUBLnqB1vyTp6ABJTk2EpxVo23fRkojADcMq8SPRjJf+y7OdECkidDmYd+5faNMs6 AmbsAj8mDadi9e1CeDydtL1nGrttGM+pUeY3xL+8LD01G+VrZjBIpy+FihpRtRxRNTldlCWKEk1t eU6Hyhjp6NQdGHVCMiwiR7x5P1tEAE5GnAOYIVPZwXjzc4e0CiCDjJ5Dau0ozusYfqV3PnhwG6m2 +PKlSf1Ic6GpSHF8ajBeu88yFFqfBmVvKeFT5inK3357zx69fOcLwOnOLZ2kfELgXJC1XBW7sJqn Rpq30tyKVlhLWMpgbGc5GYgYTa4jzm0O8qCHa0oz2w3icXkQjwR+UsqUlgDpCmme1U3G6idkJTOy mBCtp2Hn840pWVvAeO3C9UvRUzNs2ajqmmg6esoqG1hEk0eZqx6YR5j3g3OGE604kqqicJHDaeAG +86uoU2O3Pg4KlXV59k6Kj1Fc2RETYs8oNXXPMacLOI6NG2FMeaOR5cTEE+PMZ/P9xiA8BebJpBF /CbevStAxNi5/HtBU58QTTUbNPW6/MZPGkT4OCjhU8pocwDzzRvjZjMM4yG/8phAefeAZ4DAWu7v L1xzuCraAlaTraVfrSQam+ksQOkBTo9mywX7mnS1VIW1QmeztZRJWZ1Piegst460GZD0GTFJB/Tc 2W4AzNFk5QGNVcspNHZjjuS2Mecb3drOB6aOJfijQLwcPT2ny/i4b2o/7zGXxGVaqhR1+3RkpDOi 0lMn0VOffccoPiIBMWqeWII1bUdPLeYzsWUsGk9WMXgZWV4U87YiX7GtFhy0ESC+i5CV1/Vdpqgh vEwyKdlwrlx1qoMAzqcF4yeL6m0D5XDEuXlm7HOlsMhTosu5UNg3rjhy7gQjWotbBNJj9i339hbk c6448JNpLPmUhYBUgkBsPQHMTf9SRguwtWT/UmdNygxJWw1BatRaJp4jKePOZZxdPD1T0uTJTLnN 5LZRdukiZV5bgHn5uZIXHcB6IXpqpVpfalVjHLT6Z3q60e6/HWlPh1ORTT98VUBoZPCqsewbum7O owAxZKt4Jj0FNa3b+bxslkuIS8RXxISmtpLo6bt3GFX+Pu7uxlNWsfcX+4GsfyYYP2mY/TxQbvqV 0lhZrOX9+8a+f9/7lgRCB1Du7++i0TLTWAEmxp/XmLhcwGKiybL4ly1bzEjW0mAMemvYz5TgT56O NRASdAN68rAe9TUBxAxMK+PVrfZ/RYokzwyx6l+aXHM5EBaYobW8AuH6JjiH3Q0uAsRNenpaBM6+ 4qB4eGAVmZ5KwGbTT+wKha0k9wVQffQ0aSQVMx4FkJLst0hjDPxDE3QsuYIw01NUAQVnhJrSGrzp rCJkmOIrHkbIMzGm/NYtE//5z9fpzp17m1FUpai9v5iVZp/KZ/zTACm34tSJxgb0taOwdFB4H+Pr hgEfZPzoTseDXvPkLNBYTM+q6yVHY72fEyjXHI11PNFK/EuxnjJOAFayTaEHJHKTRnKTw2isU2pr NBA0mr4s1LXiSKxVwbqmSVJMHxEWmIF/mUZTmPVcjPzLlBvz8fwKYy9LW88D4u+hp5AOdkNWBxbR aDnb0E+0g4BNnnwMmRxxdrGCml+0KXR0VNIZ2T/cTk8ByuwjYtvR0yoD8SjCV0T0FOvBgYmvXv2S sgyubX8mq/hoK0XdjD5/ajBem5b1bPRzj5qhFrA7CJAl8eOnQiFwB7t3b8Wh6KZB4agJmLFQ128w 3ZbuhHtNXR/Sidlp1mt6SbNk7esMNZNNqsuyWGVBOV0mK7pGIFBfOkz/a9PSRdU/WneMNWGbEq90 UaFnteyHeEKW8wRtVgxrZkVHGVVLC9Ez/aglay+t6DCNlAINhOtafykUru8Hk6scsnCd/bFeGyst RIeaUd0b9f+xI1o16OI2At5pEbjdKgLnfjQqApcK/cg5Q2h8rcjZutrEJGtXixhTXPExsXJ8RFuM Y2z5GNP70R0Dx4+OcTqmP0nnwPA5oM8/JkKPx3SO6FhDp+xpTX5Jd1vaFqumqXlaFd0n102DVMes 3rXzmsBJ18JRW9F1US1DW9dveQIyKv3//vdXXD5F1w7L4N6/f8RVG6Co+ThmijoGo02fGozGXNvA 1nNhmaSJbV8IodZSniArefhUCkGfPXs0orEEyvTmzd2kNDZV1T4m37pFWMSVPyYaYiP5l+HkcBWL hmc3BLqkAtk0cukTkR7y78iOkq0KLXcPcK1YTYCELjznG6dV6gTCNiJ/Zrl4me78lqmS+qC5qZLO EEl5HHfLwgLHBbg8/k6PcVRdbCH0L3q4kklSB7l7Ooq30dY+9fMvRv1K02BOo5o6Y/OA4yEHHVpE BaLpm3d1+7Hr19cpbLSZmJHmUmQu0SCMNafJjGoUW3q+kdZH0JtKhwZsEajhTg0ut9awdUSRONFR rtyHtYyS4mAai3xiEpoKSyg+YtsAZGT9RDjQ0N90OEdFC/0prCOBET5joD9CbqTQU0s+YyxCqleB gzZ0IyffcA1LyDe2Z8+ecbGDGoAhAFNma3+GVfzTLOQoSWk/bi1xF0OCFnpC3N1wl4OlxF0Pd7/1 +lfc+dp1Res6tjLXzzS7u3O6e+ICSHWjFSO4wxIc6Q5O2OW7buJJSC3KeuiOTBfLCfHFE7rC1BIa umsnvpPbbC1xV2eLyrMQjulK5tdyZUlCqReXf6GSRMp+ElnNpNak61rADbK53MvBAqWUgaxtRCy3 EtFR3wMLlkalXsOGURlsQxq6aRGH+/x3oipqbJ+ywPeQ0jMpjSLQCdCS0RpEK6Vrhrs0oHfNkkvc UIXBZVGWy6Loqj7GcaE7zAl9JTl+HQuxxw77Wq1h1CriXMiWmccqNX5V8PlCVU5iyyja1FlNzzNg m+aonc0MFxNX1a0W18TJSUM+4z1YSL5evv32YSQc8m///vvvY762bpJVvAmAHFjLcSNrHKRcjY2D h4P4tKOxzzlfRHe9+N///ZLA+U0QYKJ0pqWTEpi21G+PFJzsezAwseKkAphks+iEx1WRCgYm0yOU bxGddXyBKJWNuIBwIeEiAiiJaqUgFDZFAiNtLb3WW9BcBqY1Woe50VZC2o7YDphS/S5UFtZZKa2U eRnt72M2QZmB2fX7ieM+oh0I43YgWm2ZYWIHxI/UKPb9ayxRUgYF39RwzOivcTkUvZaOhd6cTHdc lKLi5ibHUChq4OMrK4GS3Ac6B1wylZtPyTni0iuhp1aAaJWelqVp1heip+ZcejoM3HyqKOqNCupc QpS+Jejz1D558gSNs5TG/tzlLodpEufu2hyR9R4RWVX7NNZr/tJ7qH4kj1ms120582XBA+eh+Em2 bLiyBHpZTZOYoSa2T4108jsryqAsQtAqkkpSJFbH6UlElsu9dDJTnyZhEfvZwvVRRcmopMt+RBqX RdAMZAnY9KVRW0XgbC2VmuY0BrdczO0VU5OT+rmVRoLVR9W+lbYaLIHLQRsk9VWDyhRVS6GwRfBG pG5SmyhpDNPO52mUxhClTR89zZK3GN+gxjYieoqc4s8/t+nJk4cjejpMZWyXDNobVZvqbs5XsR+h sa87Gou7HpzzTGNBT0BlQVdwp0RNG6yl0NgFj6h2i7neZWcdjSV/ZF2Wnu/GxH/IYgp18t7xnZsg 0FlACf4YpbBJ92k1EgiySmU901nDxdIxifUFlc2F0Uaq4LvC6CwLc0wPtX9Mr3LRAEuf9xMqm05V 5muXvNMrW0T4hrnZsBQKS8AmZcssYNNkvXTw084KHKwB/RaryJRSujGIhTOJ2YJSeKGqTFH7oI3j oA1oKtwCWfFZYCdgKeQ3YruSYnQ+L/VsNlszPa1PTtHT3JpxTE8fXJae3jgw3jBAjoE5prF/M3me +9C/FGAO/cvvmLbQYzpJbYBfgd6aZbnLJ1SicSdN9i/tAJhFIVHZ1jQEznblib4yjUruJPs7mcrC F3LkCwGIZMuOAyhaCPQt4klgKkuvA1Uz0nJC/SL4Wctkev8SwBQKK1RWorDiw2l08xQwpfv2sJt3 3yq/A2Eyo2qLDogi9hahd4ySOzTD1IREUK3SbKan3AIF9NSKr8gUVP0/o9SejgUDLwkQ+d80espA HUZPcSy8ITAWS0S/NRK+btRPzE2n6nrJQCzphgp6uuzo6a9XRU9vZNeGwtzQRedtMI3N9WfDaKxG yYzMCkED2B3zqH6c2oP7CfnLe82D5B5w/pJ7+CwJWmV56IpiP3qOyLpI1Da62hBhNRjzE+jKDHSn DrEwbRObki/8JPTNQQ7mHIpnQU/bNklU1YUkbeqRGlBal5zVqnd+jFKvVkXsrfhusVSVSyEBFW68 FZyARoTrVset82QFjr06yWFuyu46TWx3Q9O4xLhFP0YosAaVf1NwbkRTNWo8sJqdBjV1lfu5RjGh HpF7nSaOkNIXY6UNROEoGoY8jv3PBLUN0dPQNq7wRFHbxviC5XRti8L9omlQHiVtUtB9DuLw4Nd0 HKoFMZ3D6Iiekm8Qv/nmoEvuN81LuiG3l4qe3kR6esN9yN/nX3YSvKfGPtsf+JcvC1s8eqj+pYjW P3zoFT/Zv4Q+FoofiArgX/ZlXrZT+wxleCLBs10t5lnC9ZjHq3fdCiz7lBcRrmdBgc2DSaUGU/1K iAqis4xPnWWp8/q6Ps2cT5HhQznn2IvBk6ptJMGfZW9Wy6PgHxK95OhqV6OoLTSyyiZL3TyAGNUv 9G5QndGnMQBkKRI2TV+JUbcoj4L4G83NsggcSX7UKc7nu6o9PSu530vetiX3t8jejPlMGox9Zm0J Lxv4GcrwfnH373+nMrx37uRE9bH1sXf7u65pllzmBcVP265FGxtMEbwd6WM3hevIQ7pLCtdTVxgN 4TqkeGksXB+UeHXAFH2sqHsYjVLSJVYydlec5dm0/eyMxDNKEytukOpAXjEDkfCstFiaemEeRjLk b2vBsFJoBtxHaxT136zRukaXpBojmg6M6Bbu2poF4N6XXWmUADHSdpdWCdrE396mZi/E2+tv4svm lXZ/GwPxPMnbTcgpflGU9RxRQaftHBx8K3TlSUdjRVjQA5P8jUR+hyvL+2k2a1NVfQPK6orFblQZ HtHYE3puSZQWNK/3w9AIAt3Vi8LTHR0XNF1CEG25gvZDyyJzroInP4+uK7KWmJPd0Lcl+ioCa7pY ewG2CLIRgcV7K6v9ZaIVKovBvrYTrUsbEZXgbTbaGlaMDGdfppweyT1RrQwekkbESsPR81QkaU5k b5rcT5rgt53aiPORUrXPiXzRobJQPGbfM8lrEUElasqfRVQVUdnCFE10olAyVdHOCtOVReXSqLLc IxpNpt/txz2ytf/cadOdW/fif6v29CG8z8dfFj39TII6F/MvP5a/3CYsODi4D6FxODrq85cIFCBg sF4fSkR2LflLXo3kLvvoH7eyX0HKZVjOlZaElpNgBhHZQiOKCP44K3lMjjxazsvhseXEOUvItH8s 5/IQMJHV5j6ymhh3nRwvB3+0ckIsk6wiNjApA0SUMnYwA8PqyAWW+HGLRWmNiYBTVMkbt9A0EiU2 fXtFlhKmIL8DAa2QNKfIogpZNZ/Lx4aPURFXqShWjR6/2SytiQzXTYNjHDn67TloQwhu3rEsEvLI hs5Rjp5mIfiz5ecdPf1CKevv8y/H1SQ/25fkXz46w7/8mHA9hAbVJcU24Tr6+qROuA7/MlxYuB5V sC6Wk/3UbmqX0S7rSestM3W1OqJ9o2ZSpgdr2RSnSNKwgBgDbRzL3gznF1kxhECNttHQHjZJCoSN 5hT9761R9KYtiqoNx6sQSqGnbRvZV5RqDMkpip9o0rbSqC+Vnn6hgLwa/7IovrMQFhwdOVdx/aUl cO4TKE+6NiK+tb5F/eXOoA5zbcroc58fwyVejvzNFr7jMPAzaCMCH5MFB7YTEmj7kNT5lqCt0i/W 5gZbhRmVc5mumRb3JjBWZamWgzlRIqzQ8MakVRoYatNN/+oqM4zOyrCD1IdMF/u9NYoeza7nZROW KaA0ioh9KPfRGfwk9pX777lYGE2z0ZQ4viQT+pe+p83jxxdM7std6YsZbPTFzTLc0ubCblpLlHlt B+a4/rK3mKcLo52b+SLWrPjhmstIgPSBrWXfSkT6yJphYbQWQ7u83wGVGzeXRmsu2UraVBKypGes FX+SLj0MmNaOBKLi4d/sVFiXaxtVPKDKG0yX7ju/DeRxPDcDMzMGYOwCOKKmGfWwuWyN4n4xb1se FXEc0eUNVpHoatzbG1buk0X8+UVqH7Q8oHG5fHyqYPhzj55+0T7kBfzLdFn/8kzh+vos4frqHOG6 V+F6u4Q+Fv6l0zIv3kITuyFcR3IdwgL4l9GIuAC+JxQxRgXv9O8QFoiQ3UT2+wicy2TFd8NWBAjw S90JxO+srUXJmNHPyv5hSt3fEsWR5e8AHzcaEUG45I678rTkTmL0J15+z5LQRr+3WaFVP7TBg8T+ Gr73AqVRdKxqVdlAnJFF4P/6r7dbUdmYTgR+8u1DLY16HA8Pn6Ynrz/f5P4EyDOBKftZhvfJhOt0 kYpwncXSrPZBVQkrVrBGAkPMdZhSfymrFZCy4iUHgVJXXZLrClFNQUaRQA7Bth2ogvAeIwoaVQux lM1kUOP1fc1nrv/kCoyssrGpByGCNalX2bCk8II1ivWwRrG6nAicZZI4T2cC0X6xsze/WED2aZLz gQlahDsy7szQQUIPebow+k6oiaChzKu8jcLoOCiMJmCueb5gjYtSo7IrIq5SGN2MC6OJAp64Ui52 yO1gkbIMj4GYFJgAjcllS+Y4cgWF5a3I0gzrRumnMUD5MayfERlbFIsoFthoQTA0p0Y+n+VufBPQ mwIKhDvNaeiqMRBB9kkH2Jh2RZRTi77zpOJCgWgYjCJ3M1w8Dmax5rHgGO3WskXEMcVNTyr3n3f9 bIbsRYahgp/erNKoyYf8ZP7lj+Rf/vAR//IMYUF5TP4khAXGi9JnzS1EctOtzr9MgQUF7F/Cz3Ti Z6ZgeMwBUdtS/EjyHSM3c+aGzSY31NKZlrlXD/l93A7EaKS1/5FkB7nNvzSkEi2rIwMdA0dVhwEd Cd405I4yoLT6gjuB29g2kRP6npsQc+uMdd26qpQWGpsd3i7cQuOyKpsvI3o6WcgL+5fXK1zv/MtC /cvI1FV8PlSUWBFhwyqxj5mc0laItMm6eXeUuA6TRdvIX0p7EeeO6LfIagYrPTb8elhGd2ScPRIa Ss/n99Fnen6v5ktDX6OI1iZkCcn/zUXDDVtEUFNTFGfWKIKe/p4aRboZmvP9xK8HjFgK8xUu1yNc h+VcjIXrDrNKZmQt6hBjEehoF2TY0GxC1D6O83Q8r4TMZwMFWcs5zQSBekmWriDLRhbSc5TVmiiN mWPi1pLQtEpbSW5XbLllFhc9OohdpR2HVQsZY5B+PtI9nCw22S+ygB7W0dFjqUls8VzCNOGiG2pK YORWi+RJ0/46DFtoQPlT17nDG+2PWmh8XAT+g/QC/SJUNhNlveb85UWF65h1ua0wGsL1nCYZFkb3 wvXNzusGY0yE3hqD6VsFA9RhhAHA6HygLeHcgbIi80FbB0Ry+xtCEDR/Iih3BMggkjknoGQtKSR6 MbQsl2NKSuC0XrWmbQvxd9adZhF4FoDn+RgVkvvV4hro6ZeXxpgAeQ3ANL9XuN75l6eF692ckkgA 5VklAGdB26BVHwxQBq6N+PdAgPQ+QmwO/5HsYRRtqzXRdHlIWEmbHLp0JMxmRJ8ANPMCqAjFLb1f QGllJiOAN5yH4WLvJ/ZAHIvA5+1ueNeOGxDfvv1NfPny6xGBT5T1k0Rkr1i4XpwvXIcPyjNKGJwQ rgOAviHiiFIvBFLUmiZPsOItoZDssowpACht7ukau2+bWCxHtNVqX1UbHYExML1E7SGL3wmIsZX9 0hAYk4q/iwIARXc3paZDEXiuUTRfVY3iFNT58wM/Zhz4uZhw/fj4ZTxXuN7lL2fcogLpgixcl+ZO mirxaG+BjgVegy2ObK4/Jgt5HLWNCAsLUjqOUfeHj+nfnXbJI5jR+1v5HCeNvMhDXRoEl3yXK+0q 93MLDURgF4tZnUXgt+n7z7qcogRs/vGPX+KX1kJjoqyfuX/5R4XrSJeIFK8rjkazK9bK6nPows7B HHIpiYsGpqs20s3Uy3VNr+VJPzC7XltAel+IAXQsZIuetrDM0SEQ0wSiqEJjXdJtRdt1INIcUBol 4m/xE4ci8BB+TV9bjeIEyC/Sv3xDoHTqX/bCdelYsNoEJm8VmN6F1tuqcIG2zpXOhtYF8RoVkLYH pE8dIE2L9KOJzhfcVpLBWJPb6BMBsGzpFSHQPgApQJzTuox9sbCJi4UEbJDQD2E8H+NRPa5R/Nw6 vE2U9bP2L/uL6XRHvCcXyF/eDbu7t1vJX+63s9mHVmoBDSt+dneTTgKerXsaWzKNrZOHMgb9SiU3 KPWGJ5In5H6m2lPWn/hYnODfuDYx+mUq/LKhz2iS1ECiPrFMJecTkUtEfSIoNKg08oneh0Z0p4bz rLlG8daoRnH1VdUoToC82f7lpYXruTD67383A+G6CAvQ2lCAudM4N+duaxAXAJhNs2aNbFmKFK9S P5PAsyIvTwFaLAsCJVk43jacxDfy7wUDloFYylZ0p7NKu7vF2u8isX/MQMxyt+b1u9C3Wrw7FoFf YD7G1yACnwB544A5tpYXEa4fHJgwFq5LRYkA80Mrw4OCBn9OFJhckcQ62VoBJQCNK2wZcKUGZZI8 ZvCV3Ed1PTOVAHEW0ed0vWbd7ZIr9p3bqWGhYREBxArzTcmC73I1RlbZmE5lgxsMbjSb2tNB9DRl R+hrVNlMgLwBNPYywvV+oteLeBqYtziCialeAIi0t4hsNdmSecNbY7iBsK6RqS0Bdm1rLnvixzbF vhTKruT9a1jfk2axCPR4p8ZnI/qLm8FrsogZiPsnYskBRFh23EiyCBw3mAvR0wmIU1DnTw/7fLQw etsohMKKjEdmYGKFuADb4+P37s6dA76+l8sjZ+0e/7u4Y/La5XJpF4sds1otu789n++kk5Ol2Uk7 Kc6Hcz+OeLuzsxfT+w/pbUhpd/eA2/Ef1Hfjq9YkTIv6i1btkzVMz58bM5wubH6kPzCJwCcL+WX4 l0+2jEJ4SH5ZbzEl+PMLB1Gq6qDNBdKSy/zA+UzQWrJqHAwCvcUWFi+v3fP+qKnWuQxKfMOi2OMu 4CsOLOHzX3M7/vUtCdqAUotFZOFDevxPI8XCT0QE/rXWKE6A/ML9y23A/L//90GQ4M93GtGUoEoG pxRJtwSqfW2t/17pLcD5oc0rHuN5BnFl+PXVsbwXYgV8Hj43R01zJcY2IJon/Y3ka65RnAD5FfiX m8AUH/N56gcIvYhEFztwwpLt7t6B1aStYQtH/94uFqYDK1Y8xvNV1bR4Hb/+wZ2uZQZWfC4+fxis ORuIw+jpX2/c+LYJkNNyaWDmRx8H5uPYp0sedrnM42PDlkwCQSLLOzoyuQKfAHq3zSse596zeB32 5X3fBXxOBuHJyQnnS/H3EKw5H4gTPZ0A+QX7l9uB+WOXZAdAYDURUAFosuU8OHjAgMIKf++//usF txrZXPE8/l1e+zO/D+/H52QQSjOpPmr65MmTOAFxWr7KBRHZ4fpv/5YwqLVb//3fE/dexfof/5EK rBgn8NNPP5U//ZR4xfgCrP/5n6naXPO/5dfifXj/4LP4s/XvdH9Xv0f3vcZTtablk9y8p0Pw5wJz 87kNnSynTbCVwnpZkEIxxC8/vjw1ZPnS4LOMflYa/L1R+iJbxMkaToD8mqE5Eq8PwakU99SSgXre MgTeEIAD2mwmIE6AnJZLWs2LgvQy4JtAOAFyWq7Icv7hkz6BcALktFwdSMWSXhR4E/imZVqmZVqm ZVqmZVqmZVqmZVqmZVqmZVqmZVqmZVqmZVqmZVqmZVqmZVqmZVqmZVqmZVqmZVqmZVqmZVqmZVqm ZVqmZVqmZVqmZVqmZVqmZVqmZVqm5eqW/y/AABNhXURpEOGvAAAAAElFTkSuQmCC'
        transform='translate(397 104)'
        overflow='visible'
      />
      <linearGradient
        id='dataMigr_banner_svg__SVGID_60_'
        gradientUnits='userSpaceOnUse'
        x1={423.195}
        y1={228.382}
        x2={598.805}
        y2={228.382}
        gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
      >
        <stop offset={0} stopColor='#00dcf3' stopOpacity={0} />
        <stop offset={0.13} stopColor='#08c2f2' stopOpacity={0.104} />
        <stop offset={0.423} stopColor='#188bef' stopOpacity={0.338} />
        <stop offset={0.676} stopColor='#2463ed' stopOpacity={0.541} />
        <stop offset={0.877} stopColor='#2b4beb' stopOpacity={0.702} />
        <stop offset={1} stopColor='#2e42eb' stopOpacity={0.8} />
      </linearGradient>
      <path
        d='M509.86 224.01c-2.58.01-5.16-.55-7.13-1.69l-77.94-44.72c-2.02-1.16-3.14-2.74-3.15-4.46-.01-1.7 1.09-3.28 3.08-4.45l77.19-45.14c3.91-2.29 10.31-2.31 14.25-.04l77.94 44.72c2.02 1.16 3.14 2.74 3.15 4.45.01 1.7-1.09 3.28-3.08 4.45l-77.19 45.14c-1.96 1.15-4.54 1.73-7.12 1.74zm-.84-101.07c-2.38.01-4.75.54-6.55 1.59l-77.19 45.14c-1.63.95-2.53 2.19-2.52 3.47.01 1.29.92 2.53 2.59 3.49l77.94 44.72c3.64 2.09 9.52 2.07 13.12-.04l77.19-45.14c1.63-.96 2.53-2.19 2.53-3.47-.01-1.29-.92-2.53-2.58-3.48l-77.94-44.72c-1.83-1.05-4.21-1.57-6.59-1.56z'
        fill='url(#dataMigr_banner_svg__SVGID_60_)'
      />
      <g className='dataMigr_banner_svg__st1'>
        <linearGradient
          id='dataMigr_banner_svg__SVGID_61_'
          gradientUnits='userSpaceOnUse'
          x1={435.012}
          y1={237.234}
          x2={586.976}
          y2={237.234}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path
          d='M582.9 160.42c3.31 1.9 3.33 4.99.05 6.9l-67.22 39.31c-3.27 1.91-8.61 1.93-11.92.03l-67.88-38.94c-3.31-1.9-3.33-4.99-.06-6.91l67.22-39.31c3.28-1.92 8.61-1.93 11.92-.03l67.89 38.95z'
          fill='url(#dataMigr_banner_svg__SVGID_61_)'
        />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_62_'
          gradientUnits='userSpaceOnUse'
          x1={586.972}
          y1={210.654}
          x2={434.995}
          y2={210.654}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path
          d='M585.38 164.14c-.01.09-.01.18-.03.27-.01.07-.03.14-.05.22-.02.08-.04.17-.07.25-.02.07-.06.14-.09.21-.04.09-.08.18-.12.26-.03.06-.07.13-.11.19-.06.1-.13.2-.2.29s-.14.19-.22.28c-.02.02-.04.04-.06.07-.11.12-.23.24-.35.35-.08.07-.17.14-.26.21-.08.06-.15.13-.24.19-.1.07-.2.14-.3.2-.11.07-.21.14-.32.21l-67.22 39.31c-.25.15-.52.28-.79.4-.08.04-.16.07-.24.1-.21.09-.44.17-.66.25-.08.03-.16.06-.24.08-.14.05-.29.08-.43.12l-.33.09c-.15.04-.31.07-.47.1-.11.02-.21.05-.32.07-.32.06-.64.1-.96.14l-.3.03c-.19.02-.38.03-.57.04-.12.01-.24.01-.36.01h-.46c-.13 0-.26 0-.39-.01-.14-.01-.29-.01-.43-.02l-.39-.03c-.14-.01-.28-.03-.42-.05-.13-.02-.25-.03-.38-.05-.15-.02-.3-.05-.45-.08-.12-.02-.23-.04-.35-.07-.18-.04-.35-.08-.52-.13-.1-.03-.19-.05-.29-.08-.31-.09-.61-.19-.9-.3-.15-.06-.29-.12-.43-.18-.07-.03-.15-.06-.22-.09-.21-.1-.42-.21-.62-.32l-67.88-38.94c-1.66-.96-2.5-2.21-2.5-3.47v9.16c0 1.26.83 2.51 2.5 3.47l67.88 38.94c.2.11.41.22.62.32.07.03.15.06.22.09.13.06.25.11.38.16.02.01.03.01.05.02.29.11.59.21.9.3.02.01.05.02.07.02.07.02.14.03.22.05.17.05.35.09.52.13l.14.03c.07.01.14.02.21.04.15.03.3.05.45.08l.18.03c.07.01.13.01.2.02.14.02.28.03.42.05.07.01.13.02.2.02.06.01.13.01.19.01.14.01.28.02.43.02.07 0 .14.01.21.01h.86c.05 0 .09-.01.14-.01.19-.01.38-.02.57-.04.08-.01.15-.01.23-.02.02 0 .05-.01.07-.01.32-.03.64-.08.96-.14.02 0 .03 0 .05-.01l.27-.06c.16-.03.31-.06.47-.1l.33-.09c.15-.04.29-.08.43-.13l.09-.03.15-.06c.23-.08.45-.16.66-.25.08-.03.16-.07.24-.1.27-.12.54-.26.79-.4l67.22-39.31c.03-.02.07-.04.1-.06.08-.05.14-.1.22-.15.1-.07.21-.13.3-.2.08-.06.16-.12.23-.19.09-.07.18-.14.26-.22.02-.01.04-.03.05-.04.11-.1.21-.2.3-.31l.06-.06c.06-.06.11-.13.16-.19l.06-.09c.07-.1.14-.2.2-.29.03-.04.06-.08.08-.12l.03-.06c.05-.09.08-.18.12-.26.02-.05.05-.1.07-.15.01-.02.01-.04.01-.05.03-.08.05-.17.07-.25.01-.06.04-.11.05-.17 0-.02 0-.03.01-.05.02-.09.02-.18.03-.27.01-.06.02-.12.02-.17v-9.23c.01.08-.01.17-.01.25z'
          fill='url(#dataMigr_banner_svg__SVGID_62_)'
        />
      </g>
      <g>
        <linearGradient
          id='dataMigr_banner_svg__SVGID_63_'
          gradientUnits='userSpaceOnUse'
          x1={480.286}
          y1={284.118}
          x2={480.286}
          y2={250.702}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_63_)' d='M471.95 117.28V143l13.35 7.66v-25.72z' />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_64_'
          gradientUnits='userSpaceOnUse'
          x1={490.801}
          y1={250.702}
          x2={490.801}
          y2={280.902}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_64_)' d='M485.3 150.66l7.69-4.5v-25.72l-7.69 4.5z' />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_65_'
          gradientUnits='userSpaceOnUse'
          x1={494.687}
          y1={282.51}
          x2={473.656}
          y2={282.51}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_65_)' d='M485.3 124.94l7.69-4.5-13.35-7.66-7.69 4.5z' />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_66_'
          gradientUnits='userSpaceOnUse'
          x1={476.617}
          y1={275.396}
          x2={483.808}
          y2={275.396}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_66_)' d='M474.93 124.31l7.2 4.13v-.77l-7-4.02-.2-.12z' />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_67_'
          gradientUnits='userSpaceOnUse'
          x1={476.613}
          y1={274.031}
          x2={483.804}
          y2={274.031}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_67_)' d='M474.93 125.67l7.2 4.13v-.77l-7-4.02-.2-.11z' />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_68_'
          gradientUnits='userSpaceOnUse'
          x1={476.62}
          y1={276.761}
          x2={483.811}
          y2={276.761}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_68_)' d='M474.93 122.94l7.2 4.13v-.77l-7-4.02-.2-.11z' />
        <path
          className='dataMigr_banner_svg__st25'
          d='M475.13 124.2l7 4.02v-.55l-7-4.02zM475.13 125.56l7 4.02v-.55l-7-4.02zM475.13 122.83l7 4.02v-.55l-7-4.02z'
        />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_69_'
          gradientUnits='userSpaceOnUse'
          x1={476.622}
          y1={270.016}
          x2={483.813}
          y2={270.016}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_69_)' d='M474.95 129.68l7.2 4.14v-.78l-7.01-4.02-.19-.11z' />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_70_'
          gradientUnits='userSpaceOnUse'
          x1={476.619}
          y1={268.651}
          x2={483.81}
          y2={268.651}
          gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_70_)' d='M474.95 131.05l7.2 4.13v-.77l-7.01-4.02-.19-.11z' />
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_71_'
            gradientUnits='userSpaceOnUse'
            x1={476.626}
            y1={271.381}
            x2={483.817}
            y2={271.381}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_71_)' d='M474.95 128.32l7.2 4.13v-.77l-7.01-4.02-.19-.11z' />
        </g>
        <g>
          <path
            className='dataMigr_banner_svg__st25'
            d='M475.14 129.58l7.01 4.02v-.56l-7.01-4.02zM475.14 130.94l7.01 4.02v-.55l-7.01-4.02zM475.14 128.21l7.01 4.02v-.55l-7.01-4.02z'
          />
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_72_'
            gradientUnits='userSpaceOnUse'
            x1={476.618}
            y1={264.641}
            x2={483.809}
            y2={264.641}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_72_)' d='M474.96 135.06l7.2 4.13v-.77l-7-4.02-.2-.11z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_73_'
            gradientUnits='userSpaceOnUse'
            x1={476.614}
            y1={263.271}
            x2={483.805}
            y2={263.271}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_73_)' d='M474.96 136.43l7.2 4.13v-.77l-7-4.02-.2-.11z' />
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_74_'
              gradientUnits='userSpaceOnUse'
              x1={476.622}
              y1={266.006}
              x2={483.812}
              y2={266.006}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_74_)' d='M474.96 133.7l7.2 4.13v-.77l-7-4.02-.2-.12z' />
          </g>
        </g>
        <g>
          <path
            className='dataMigr_banner_svg__st25'
            d='M475.16 134.96l7 4.01v-.55l-7-4.02zM475.16 136.32l7 4.02v-.55l-7-4.02zM475.16 133.59l7 4.02v-.55l-7-4.02z'
          />
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_75_'
            gradientUnits='userSpaceOnUse'
            x1={476.623}
            y1={259.261}
            x2={483.814}
            y2={259.261}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_75_)' d='M474.98 140.44l7.2 4.13v-.77l-7.01-4.02-.19-.11z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_76_'
            gradientUnits='userSpaceOnUse'
            x1={476.62}
            y1={257.896}
            x2={483.81}
            y2={257.896}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_76_)' d='M474.98 141.81l7.2 4.13v-.77l-7.01-4.02-.19-.12z' />
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_77_'
              gradientUnits='userSpaceOnUse'
              x1={476.627}
              y1={260.626}
              x2={483.818}
              y2={260.626}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_77_)' d='M474.98 139.08l7.2 4.13v-.78l-7.01-4.01-.19-.12z' />
          </g>
        </g>
        <g>
          <path
            className='dataMigr_banner_svg__st25'
            d='M475.17 140.33l7.01 4.02v-.55l-7.01-4.02zM475.17 141.7l7.01 4.02v-.55l-7.01-4.02zM475.17 138.97l7.01 4.02v-.56l-7.01-4.01z'
          />
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_78_'
            gradientUnits='userSpaceOnUse'
            x1={489.054}
            y1={273.912}
            x2={492.762}
            y2={273.912}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_78_)' d='M487.38 128.12v.79l3.7-2.16v-.78l-.11.07-.06.03z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_79_'
            gradientUnits='userSpaceOnUse'
            x1={489.055}
            y1={272.532}
            x2={492.767}
            y2={272.532}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_79_)' d='M487.38 129.51v.78l3.71-2.15v-.79l-.17.1z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_80_'
            gradientUnits='userSpaceOnUse'
            x1={489.055}
            y1={275.297}
            x2={492.76}
            y2={275.297}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_80_)' d='M487.37 126.73l.01.79 3.7-2.15-.01-.78-.17.1z' />
        </g>
        <g>
          <path
            className='dataMigr_banner_svg__st25'
            d='M487.38 128.12v.58l3.53-2.05v-.58zM487.38 129.51v.58l3.54-2.05v-.59zM487.37 126.73l.01.59 3.52-2.05v-.58z'
          />
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_81_'
            gradientUnits='userSpaceOnUse'
            x1={489.052}
            y1={268.462}
            x2={492.761}
            y2={268.462}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_81_)' d='M487.39 133.57l.01.79 3.7-2.15-.01-.79-.11.07-.06.03z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_82_'
            gradientUnits='userSpaceOnUse'
            x1={489.056}
            y1={267.077}
            x2={492.772}
            y2={267.077}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_82_)' d='M487.4 134.96v.78l3.71-2.15-.01-.78-.17.1z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_83_'
            gradientUnits='userSpaceOnUse'
            x1={489.053}
            y1={269.847}
            x2={492.761}
            y2={269.847}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_83_)' d='M487.39 132.19v.78l3.7-2.15v-.78l-.18.1z' />
        </g>
        <g>
          <path
            className='dataMigr_banner_svg__st25'
            d='M487.39 133.57v.58l3.54-2.05-.01-.58zM487.4 134.96v.58l3.53-2.05v-.58zM487.39 132.19v.58l3.53-2.05-.01-.58z'
          />
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_84_'
            gradientUnits='userSpaceOnUse'
            x1={489.055}
            y1={263.012}
            x2={492.763}
            y2={263.012}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_84_)' d='M487.41 139.02v.79l3.7-2.15v-.79l-.11.07-.06.03z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_85_'
            gradientUnits='userSpaceOnUse'
            x1={489.055}
            y1={261.622}
            x2={492.768}
            y2={261.622}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_85_)' d='M487.41 140.41v.79l3.71-2.16v-.78l-.17.1z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_86_'
            gradientUnits='userSpaceOnUse'
            x1={489.055}
            y1={264.397}
            x2={492.76}
            y2={264.397}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_86_)' d='M487.4 137.64l.01.78 3.7-2.15-.01-.78-.17.1z' />
        </g>
        <g>
          <path
            className='dataMigr_banner_svg__st25'
            d='M487.41 139.02v.58l3.53-2.05v-.58zM487.41 140.41v.58l3.54-2.05v-.58zM487.4 137.64l.01.58 3.52-2.05v-.58z'
          />
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_87_'
            gradientUnits='userSpaceOnUse'
            x1={489.052}
            y1={257.557}
            x2={492.761}
            y2={257.557}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_87_)' d='M487.42 144.48l.01.78 3.7-2.15-.01-.78-.11.06-.06.04z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_88_'
            gradientUnits='userSpaceOnUse'
            x1={489.056}
            y1={256.172}
            x2={492.772}
            y2={256.172}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_88_)' d='M487.43 145.86v.79l3.71-2.16-.01-.78-.17.1z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_89_'
            gradientUnits='userSpaceOnUse'
            x1={489.054}
            y1={258.947}
            x2={492.762}
            y2={258.947}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_89_)' d='M487.42 143.09v.78l3.7-2.15v-.78l-.18.1z' />
        </g>
        <g>
          <path
            className='dataMigr_banner_svg__st25'
            d='M487.42 144.48v.58l3.54-2.06-.01-.57zM487.43 145.86v.58l3.53-2.05v-.58zM487.42 143.09v.58l3.53-2.05-.01-.58z'
          />
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_90_'
            gradientUnits='userSpaceOnUse'
            x1={-4236.455}
            y1={-4245.275}
            x2={-4231.614}
            y2={-4245.275}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M476.84 115.38c1.33-.77 3.5-.77 4.82 0 1.33.77 1.32 2.02-.01 2.79s-3.5.77-4.82 0c-1.33-.76-1.32-2.02.01-2.79'
            fill='url(#dataMigr_banner_svg__SVGID_90_)'
          />
          <path
            className='dataMigr_banner_svg__st25'
            d='M477.34 115.67c1.06-.61 2.77-.61 3.82 0 1.05.61 1.04 1.6-.01 2.21s-2.77.61-3.82 0c-1.05-.6-1.04-1.6.01-2.21'
          />
          <g className='dataMigr_banner_svg__st1'>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_91_'
              gradientUnits='userSpaceOnUse'
              x1={-4235.872}
              y1={-4245.316}
              x2={-4231.611}
              y2={-4245.316}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M481.11 115.12c.03.01.06.02.09.04.01.01.03.01.04.02h.01c.06.03.13.06.19.09.01.01.03.01.04.02.06.03.12.06.18.1.33.19.58.41.74.65.04.06.08.12.11.18s.06.12.08.18c.04.12.06.25.06.37v.15c0-.5-.33-1-.99-1.39-.06-.03-.12-.07-.18-.1-.01-.01-.03-.01-.04-.02-.06-.03-.12-.06-.19-.09-.02-.01-.04-.01-.05-.02-.03-.01-.06-.02-.09-.04-.02-.01-.04-.02-.06-.02l-.09-.03c-.02-.01-.03-.01-.05-.02-.08-.03-.16-.05-.24-.07-.01 0-.03-.01-.04-.01-.07-.02-.14-.03-.21-.05h-.02c-.07-.01-.14-.03-.21-.04-.02 0-.04-.01-.05-.01-.06-.01-.12-.02-.18-.02h-.03c-.07-.01-.14-.01-.2-.02h-.05c-.05 0-.11-.01-.16-.01h-.53c-.07 0-.15.01-.22.01h-.03l-.23.03h-.03c-.09.01-.19.03-.28.05-.01 0-.02 0-.03.01-.12.02-.23.05-.35.08-.01 0-.02.01-.04.01-.07.02-.15.04-.22.07-.01 0-.01 0-.02.01-.07.02-.14.05-.21.08-.01.01-.03.01-.04.02-.07.03-.14.06-.2.09-.01.01-.02.01-.03.02-.07.03-.13.07-.2.11l-.15.09c-.01.01-.03.02-.04.03-.04.02-.07.05-.1.07-.01.01-.02.02-.04.03-.03.02-.06.05-.09.07-.01.01-.02.01-.02.02-.04.03-.07.06-.1.09l-.06.06-.02.02c-.03.03-.05.06-.07.08l-.01.01c-.02.02-.04.05-.06.07-.01.01-.01.02-.02.03-.01.02-.02.03-.03.05-.03.04-.05.08-.07.12 0 .01-.01.01-.01.02-.02.03-.03.07-.04.1 0 .01-.01.02-.01.03-.01.04-.03.08-.04.12-.01.04-.02.08-.02.12v.03c0 .03-.01.07-.01.1v.03-.15-.01-.02c0-.03 0-.07.01-.1v-.03c.01-.04.01-.08.02-.12.01-.04.02-.08.04-.12v-.01c0-.01.01-.01.01-.02.01-.03.03-.07.04-.1 0-.01 0-.01.01-.02v-.01c.02-.04.04-.08.07-.12 0 0 0-.01.01-.01.01-.01.02-.02.03-.04.01-.01.01-.02.02-.03.02-.03.04-.05.06-.07 0 0 0-.01.01-.01.02-.03.05-.06.07-.08l.02-.02c.02-.02.03-.04.05-.05.03-.03.07-.06.1-.09.01-.01.02-.01.02-.02.03-.02.06-.05.09-.07l.01-.01c.01-.01.02-.01.02-.02l.1-.07c.01-.01.03-.02.04-.03l.15-.09c.06-.04.13-.07.2-.11.01-.01.02-.01.03-.02.07-.03.13-.06.2-.09.01-.01.03-.01.04-.02.07-.03.14-.06.21-.08.01 0 .01 0 .02-.01.07-.02.14-.05.22-.07.01 0 .01 0 .02-.01h.01c.06-.02.11-.03.17-.04.06-.01.12-.03.17-.04h.03c.09-.02.18-.03.28-.05h.02l.23-.03h.03c.08-.01.15-.01.22-.02h.53c.05 0 .11.01.16.01h.05c.07.01.14.01.2.02h.03c.06.01.12.02.18.02h.05c.07.01.14.02.21.04h.01c.07.01.14.03.21.05.01 0 .02 0 .03.01h.01c.08.02.16.04.24.07.01 0 .01 0 .02.01.01 0 .02.01.03.01l.09.03c.06.02.09.03.11.04z'
              fill='url(#dataMigr_banner_svg__SVGID_91_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_92_'
              gradientUnits='userSpaceOnUse'
              x1={-4236.709}
              y1={-4245.123}
              x2={-4232.23}
              y2={-4245.123}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M476.94 118.37c.07.03.13.06.2.09.02.01.04.02.06.02.03.01.06.03.1.04.02.01.04.02.07.02.03.01.06.02.1.03.02.01.04.01.05.02.08.03.17.05.25.07.01 0 .03.01.04.01.07.02.15.04.22.05h.02c.07.01.15.03.22.04.02 0 .04.01.06.01l.19.03h.03c.07.01.14.01.21.02h.06c.06 0 .12.01.17.01h.56c.08 0 .15-.01.23-.02h.04l.24-.03h.03c.1-.01.2-.03.29-.05.01 0 .02 0 .04-.01.06-.01.12-.03.18-.04.06-.01.12-.03.18-.05.01 0 .03-.01.04-.01.08-.02.15-.04.23-.07.01 0 .01 0 .02-.01.08-.03.15-.05.23-.08.01-.01.03-.01.04-.02l.21-.09c.01-.01.02-.01.04-.02.07-.04.14-.07.21-.11.05-.03.11-.06.16-.1.01-.01.03-.02.04-.03l.11-.08c.01-.01.03-.02.04-.03.03-.02.06-.05.09-.07.01-.01.02-.01.03-.02.04-.03.07-.06.11-.1l.06-.06.02-.02c.03-.03.05-.06.08-.09 0 0 0-.01.01-.01.02-.03.04-.05.06-.08.01-.01.01-.02.02-.03.01-.02.02-.03.03-.05.03-.04.05-.09.07-.13 0-.01.01-.01.01-.02.02-.04.03-.07.05-.11 0-.01.01-.02.01-.03.01-.04.03-.08.04-.13.01-.04.02-.08.02-.12v-.04c0-.03.01-.07.01-.1v-.03V116.93c0 .03 0 .07-.01.1v.04c-.01.04-.01.08-.02.12-.01.04-.02.08-.04.13v.01c0 .01-.01.01-.01.02-.01.04-.03.07-.05.11 0 .01 0 .01-.01.02v.01c-.02.04-.05.09-.07.13 0 0 0 .01-.01.01-.01.01-.02.03-.03.04s-.01.02-.02.03c-.02.03-.04.05-.06.08 0 0 0 .01-.01.01-.02.03-.05.06-.08.09l-.02.02c-.02.02-.04.04-.05.06-.03.03-.07.07-.11.1-.01.01-.02.01-.03.02a.55.55 0 01-.09.07l-.01.01c-.01.01-.02.01-.03.02-.03.03-.07.05-.11.08-.01.01-.03.02-.04.03-.05.03-.1.06-.16.1-.07.04-.14.08-.21.11-.01.01-.02.01-.04.02l-.21.09c-.01.01-.03.01-.04.02-.07.03-.15.06-.23.08-.01 0-.01 0-.02.01-.07.03-.15.05-.23.07-.01 0-.02 0-.02.01h-.02c-.06.02-.12.03-.18.05-.06.01-.12.03-.18.04h-.04c-.1.02-.19.03-.29.05h-.03l-.24.03h-.03c-.08.01-.16.01-.24.02H479c-.06 0-.12-.01-.17-.01h-.06c-.07-.01-.14-.01-.21-.02h-.03l-.19-.03h-.05c-.07-.01-.15-.03-.22-.04h-.02c-.07-.02-.15-.03-.22-.05-.01 0-.02 0-.03-.01h-.01c-.09-.02-.17-.05-.25-.07-.01 0-.02 0-.02-.01-.01 0-.02-.01-.03-.01-.03-.01-.06-.02-.1-.03a.145.145 0 00-.07-.02c-.03-.01-.06-.03-.1-.04-.02-.01-.03-.01-.05-.02h-.01c-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.13-.07-.19-.1-.48-.28-.79-.61-.94-.97-.03-.06-.05-.13-.07-.2a.355.355 0 01-.02-.1c-.01-.07-.02-.13-.02-.2v-.15c0 .53.35 1.06 1.04 1.46.06.04.13.07.19.1 0 0 .01.01.03.01z'
              fill='url(#dataMigr_banner_svg__SVGID_92_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_93_'
              gradientUnits='userSpaceOnUse'
              x1={-4236.582}
              y1={-4245.269}
              x2={-4231.487}
              y2={-4245.269}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M476.7 118.25c-1.4-.81-1.39-2.13.02-2.94 1.4-.81 3.68-.81 5.08 0s1.39 2.13-.02 2.94-3.68.81-5.08 0zm.14-2.87c-1.33.77-1.34 2.02-.01 2.79s3.49.77 4.82 0 1.34-2.02.01-2.79c-1.32-.77-3.48-.77-4.82 0'
              fill='url(#dataMigr_banner_svg__SVGID_93_)'
            />
          </g>
          <g className='dataMigr_banner_svg__st1'>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_94_'
              gradientUnits='userSpaceOnUse'
              x1={-4232.624}
              y1={-4244.704}
              x2={-4233.575}
              y2={-4246.342}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M480.34 116.22c.01-.03.03-.06.04-.09.35-.74-1.03-1.06-1.1-1.07l-.44.93-.3.64c.04-.04.08-.07.13-.1.15-.09.35-.13.56-.14l1.11-.17z'
              fill='url(#dataMigr_banner_svg__SVGID_94_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_95_'
              gradientUnits='userSpaceOnUse'
              x1={-4232.526}
              y1={-4242.99}
              x2={-4233.9}
              y2={-4245.358}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M481.52 116.86c.57-.33.44-.86.44-.89l-1.61.25-1.11.17c.21 0 .42.04.57.14.31.18.31.47 0 .65a.75.75 0 01-.18.08c.07-.01.15-.02.24-.04.25-.04.58-.09.86-.13.05-.01.11-.02.16-.02.28-.05.48-.13.63-.21z'
              fill='url(#dataMigr_banner_svg__SVGID_95_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_96_'
                gradientUnits='userSpaceOnUse'
                x1={-4234.102}
                y1={-4244.507}
                x2={-4234.102}
                y2={-4245.964}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0} stopColor='#7f64ff' />
                <stop offset={0.484} stopColor='#7d62ff' />
                <stop offset={0.752} stopColor='#775aff' />
                <stop offset={0.967} stopColor='#6d4cff' />
                <stop offset={1} stopColor='#6b49ff' />
              </linearGradient>
              <path
                d='M479.81 117.18c.31-.18.31-.47 0-.65-.16-.09-.37-.14-.57-.14s-.4.05-.56.14c-.05.03-.1.06-.13.1-.14.14-.14.32.01.46.03.03.07.06.12.09.16.09.37.14.57.13.13 0 .26-.02.38-.06.07-.02.13-.04.18-.07z'
                fill='url(#dataMigr_banner_svg__SVGID_96_)'
              />
            </g>
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_97_'
                gradientUnits='userSpaceOnUse'
                x1={-4233.375}
                y1={-4242.571}
                x2={-4234.517}
                y2={-4244.539}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M481.92 117.77l-1.18-.68c-.29.04-.61.1-.86.13l-.23.5c.04.02.08.05.12.07.92.54 2.09 0 2.15-.02z'
                fill='url(#dataMigr_banner_svg__SVGID_97_)'
              />
            </g>
          </g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_98_'
            gradientUnits='userSpaceOnUse'
            x1={-4233.889}
            y1={-4245.813}
            x2={-4235.031}
            y2={-4247.78}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M478.56 117.09c-.14-.14-.15-.32-.01-.46l.3-.64c-.04-.02-.08-.05-.12-.07-.93-.54-2.1-.01-2.16.02l1.18.68.81.47z'
            fill='url(#dataMigr_banner_svg__SVGID_98_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_99_'
            gradientUnits='userSpaceOnUse'
            x1={-4234.37}
            y1={-4245.072}
            x2={-4235.744}
            y2={-4247.438}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M479.25 117.31c-.21 0-.41-.04-.57-.13a.623.623 0 01-.12-.09l-.8-.47c-.05.01-.11.02-.16.02-.27.04-.47.11-.62.2-.57.33-.44.86-.44.89l1.61-.25 1.1-.17z'
            fill='url(#dataMigr_banner_svg__SVGID_99_)'
          />
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_100_'
              gradientUnits='userSpaceOnUse'
              x1={-4234.72}
              y1={-4244.148}
              x2={-4235.638}
              y2={-4245.729}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M479.21 118.65l.44-.93.23-.5c-.09.01-.17.03-.24.04-.12.04-.25.06-.38.06l-1.1.17c-.01.03-.03.06-.04.09-.36.74 1.01 1.05 1.09 1.07z'
              fill='url(#dataMigr_banner_svg__SVGID_100_)'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_101_'
              gradientUnits='userSpaceOnUse'
              x1={-4234.772}
              y1={-4246.134}
              x2={-4230.185}
              y2={-4246.134}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
              <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
              <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
              <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
            </linearGradient>
            <path
              d='M477.02 113.67c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.17-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.1-.19.15-.38.15-.57z'
              fill='url(#dataMigr_banner_svg__SVGID_101_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_102_'
              gradientUnits='userSpaceOnUse'
              x1={-4233.372}
              y1={-4246.899}
              x2={-4228.785}
              y2={-4246.899}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0} stopColor='#2afadf' stopOpacity={0} />
              <stop offset={0.275} stopColor='#36d1ea' stopOpacity={0.165} />
              <stop offset={0.596} stopColor='#42a7f5' stopOpacity={0.358} />
              <stop offset={0.849} stopColor='#498dfc' stopOpacity={0.51} />
              <stop offset={1} stopColor='#4c83ff' stopOpacity={0.6} />
            </linearGradient>
            <path
              d='M477.06 112.07c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.16-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0l-.02-.04.02.04c-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.09-.19.15-.38.15-.57z'
              fill='url(#dataMigr_banner_svg__SVGID_102_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_103_'
                gradientUnits='userSpaceOnUse'
                x1={-4231.978}
                y1={-4247.645}
                x2={-4227.391}
                y2={-4247.645}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
              </linearGradient>
              <path
                d='M477.11 110.49c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.17-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0l-.02-.04.02.04c-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.1-.18.15-.37.15-.57z'
                fill='url(#dataMigr_banner_svg__SVGID_103_)'
              />
            </g>
          </g>
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_104_'
            gradientUnits='userSpaceOnUse'
            x1={-4236.289}
            y1={-4238.299}
            x2={-4231.449}
            y2={-4238.299}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M482.97 118.72c1.33-.77 3.5-.77 4.82 0 1.33.77 1.32 2.02-.01 2.79s-3.5.77-4.82 0c-1.34-.76-1.33-2.02.01-2.79'
            fill='url(#dataMigr_banner_svg__SVGID_104_)'
          />
          <path
            className='dataMigr_banner_svg__st25'
            d='M483.47 119.01c1.06-.61 2.77-.61 3.82 0 1.05.61 1.04 1.6-.01 2.21-1.06.61-2.77.61-3.82 0-1.05-.6-1.05-1.6.01-2.21'
          />
          <g className='dataMigr_banner_svg__st1'>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_105_'
              gradientUnits='userSpaceOnUse'
              x1={-4235.708}
              y1={-4238.349}
              x2={-4231.447}
              y2={-4238.349}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M487.23 118.46c.03.01.06.02.09.04.01.01.03.01.04.02h.01c.06.03.13.06.19.09.01.01.03.01.04.02.06.03.13.06.18.1.33.19.58.41.74.65.04.06.08.12.11.18s.06.12.08.18c.04.12.06.25.06.37v.15c0-.5-.33-1-.99-1.39-.06-.03-.12-.07-.18-.1-.01-.01-.03-.01-.04-.02-.06-.03-.13-.06-.19-.09-.02-.01-.04-.01-.05-.02-.03-.01-.06-.02-.09-.04-.02-.01-.04-.02-.06-.02l-.09-.03c-.02-.01-.03-.01-.05-.02-.08-.03-.16-.05-.24-.07-.01 0-.03-.01-.04-.01-.07-.02-.14-.03-.21-.05h-.02c-.07-.01-.14-.03-.21-.04-.02 0-.04-.01-.05-.01-.06-.01-.12-.02-.18-.02h-.03c-.07-.01-.14-.01-.2-.02h-.05c-.05 0-.11-.01-.16-.01h-.53c-.07 0-.15.01-.22.01h-.03l-.23.03h-.03c-.09.01-.19.03-.28.05-.01 0-.02 0-.03.01-.12.02-.23.05-.35.08-.01 0-.02.01-.04.01-.07.02-.15.04-.22.07-.01 0-.01 0-.02.01-.07.02-.14.05-.21.08-.01.01-.03.01-.04.02-.07.03-.14.06-.2.09-.01.01-.02.01-.03.02-.07.03-.13.07-.2.11l-.15.09c-.01.01-.03.02-.04.03-.04.02-.07.05-.1.07-.01.01-.02.02-.04.03-.03.02-.06.05-.09.07-.01.01-.02.01-.02.02-.03.03-.07.06-.1.09l-.06.06-.02.02c-.03.03-.05.06-.07.08 0 0 0 .01-.01.01-.02.02-.04.05-.06.07-.01.01-.01.02-.02.03-.01.02-.02.03-.03.05-.03.04-.05.08-.07.12 0 .01-.01.01-.01.02-.02.03-.03.07-.04.1 0 .01-.01.02-.01.03-.01.04-.03.08-.04.12-.01.04-.02.08-.02.12v.03c0 .03-.01.07-.01.1v.03-.15-.02-.02c0-.03 0-.07.01-.1v-.03c.01-.04.01-.08.02-.12.01-.04.02-.08.04-.12v-.01c0-.01.01-.01.01-.02.01-.03.03-.07.04-.1 0-.01 0-.01.01-.02v-.01c.02-.04.04-.08.07-.12 0 0 0-.01.01-.01.01-.01.02-.02.03-.04.01-.01.01-.02.02-.03.02-.03.04-.05.06-.07 0 0 0-.01.01-.01.02-.03.05-.06.07-.08l.02-.02c.02-.02.03-.04.05-.05.03-.03.06-.06.1-.09.01-.01.02-.01.02-.02.03-.02.06-.05.09-.07l.01-.01c.01-.01.02-.01.02-.02l.1-.07c.01-.01.03-.02.04-.03l.15-.09c.06-.04.13-.07.2-.11.01-.01.02-.01.03-.02.07-.03.13-.06.2-.09.01-.01.03-.01.04-.02.07-.03.14-.06.21-.08.01 0 .01 0 .02-.01.07-.02.14-.05.22-.07.01 0 .01 0 .02-.01h.01c.06-.02.11-.03.17-.04.06-.01.12-.03.18-.04h.03c.09-.02.18-.03.28-.05h.02l.23-.03h.03c.07-.01.15-.01.22-.01h.53c.05 0 .11.01.16.01h.05c.07.01.14.01.2.02h.03c.06.01.12.02.18.02h.05c.07.01.14.02.21.04h.02c.07.01.14.03.21.05.01 0 .02 0 .03.01h.01c.08.02.16.04.24.07.01 0 .01 0 .02.01.01 0 .02.01.03.01l.09.03c.05.02.07.03.09.04z'
              fill='url(#dataMigr_banner_svg__SVGID_105_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_106_'
              gradientUnits='userSpaceOnUse'
              x1={-4236.544}
              y1={-4238.15}
              x2={-4232.065}
              y2={-4238.15}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M483.06 121.72c.07.03.13.06.2.09.02.01.04.02.06.02.03.01.06.03.1.04.02.01.04.02.07.02.03.01.06.02.1.03.02.01.04.01.05.02.08.03.17.05.25.07.01 0 .03.01.04.01.07.02.15.04.22.05h.02c.07.01.15.03.22.04.02 0 .04.01.06.01l.19.03h.03c.07.01.14.01.21.02h.06c.06 0 .12.01.17.01h.56c.08 0 .15-.01.23-.02h.04l.24-.03h.03c.1-.01.2-.03.29-.05.01 0 .02 0 .04-.01.06-.01.12-.03.18-.04.06-.01.12-.03.18-.05.01 0 .03-.01.04-.01.08-.02.15-.04.23-.07.01 0 .01 0 .02-.01.08-.03.15-.05.23-.08.01-.01.03-.01.04-.02l.21-.09c.01-.01.02-.01.04-.02.07-.04.14-.07.21-.11.05-.03.11-.06.16-.1.01-.01.03-.02.04-.03l.11-.08c.01-.01.03-.02.04-.03.03-.02.06-.05.09-.07.01-.01.02-.01.03-.02.04-.03.07-.06.11-.1l.06-.06.02-.02c.03-.03.05-.06.08-.09 0 0 0-.01.01-.01.02-.03.04-.05.06-.08.01-.01.01-.02.02-.03.01-.02.02-.03.03-.05.03-.04.05-.09.07-.13 0-.01.01-.01.01-.02.02-.04.03-.07.05-.11 0-.01.01-.02.01-.03.01-.04.03-.08.04-.13.01-.04.02-.08.02-.12v-.04c0-.03.01-.07.01-.1v-.03V120.28c0 .03 0 .07-.01.1v.04c-.01.04-.01.08-.02.12-.01.04-.02.08-.04.13v.01c0 .01-.01.01-.01.02-.01.04-.03.07-.05.11 0 .01 0 .01-.01.02v.01c-.02.04-.05.09-.07.13 0 0 0 .01-.01.01-.01.01-.02.03-.03.04s-.01.02-.02.03c-.02.03-.04.05-.06.08 0 0 0 .01-.01.01-.02.03-.05.06-.08.09l-.02.02c-.02.02-.04.04-.05.06-.03.03-.07.07-.11.1-.01.01-.02.01-.03.02-.03.02-.06.05-.09.07l-.01.01c-.01.01-.02.01-.03.02-.03.03-.07.05-.11.08-.01.01-.03.02-.04.03-.05.03-.1.06-.16.1-.07.04-.14.08-.21.11-.01.01-.02.01-.04.02l-.21.09c-.01.01-.03.01-.04.02-.07.03-.15.06-.23.08-.01 0-.01 0-.02.01-.07.03-.15.05-.23.07-.01 0-.02 0-.02.01h-.02c-.06.02-.12.03-.18.05-.06.01-.12.03-.18.04h-.04c-.1.02-.19.03-.29.05h-.03l-.24.03h-.03c-.08.01-.15.01-.23.02h-.56c-.06 0-.12-.01-.17-.01h-.06c-.07-.01-.14-.01-.21-.02h-.03l-.19-.03h-.05c-.07-.01-.15-.03-.22-.04h-.02c-.07-.02-.15-.03-.22-.05-.01 0-.02 0-.03-.01h-.01c-.09-.02-.17-.05-.25-.07-.01 0-.02 0-.02-.01-.01 0-.02-.01-.03-.01-.03-.01-.06-.02-.1-.03a.145.145 0 00-.07-.02c-.03-.01-.06-.03-.1-.04-.02-.01-.03-.01-.05-.02 0 0-.01 0-.01-.01-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.13-.07-.19-.1-.48-.28-.79-.61-.94-.97-.03-.06-.05-.13-.07-.2a.355.355 0 01-.02-.1c-.01-.07-.02-.13-.02-.2v-.15c0 .53.35 1.06 1.04 1.46.06.04.13.07.19.1 0 0 .02.01.03.02z'
              fill='url(#dataMigr_banner_svg__SVGID_106_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_107_'
              gradientUnits='userSpaceOnUse'
              x1={-4236.417}
              y1={-4238.298}
              x2={-4231.322}
              y2={-4238.298}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M482.82 121.59c-1.4-.81-1.39-2.13.02-2.94 1.4-.81 3.68-.81 5.08 0s1.39 2.13-.02 2.94c-1.4.81-3.68.81-5.08 0zm.15-2.87c-1.33.77-1.34 2.02-.01 2.79s3.49.77 4.82 0 1.34-2.02.01-2.79-3.49-.77-4.82 0'
              fill='url(#dataMigr_banner_svg__SVGID_107_)'
            />
          </g>
          <g className='dataMigr_banner_svg__st1'>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_108_'
              gradientUnits='userSpaceOnUse'
              x1={-4232.458}
              y1={-4237.731}
              x2={-4233.409}
              y2={-4239.369}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M486.47 119.56c.01-.03.03-.06.04-.09.35-.74-1.03-1.06-1.1-1.07l-.44.93-.3.64c.04-.04.08-.07.13-.1.15-.09.35-.13.55-.14l1.12-.17z'
              fill='url(#dataMigr_banner_svg__SVGID_108_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_109_'
              gradientUnits='userSpaceOnUse'
              x1={-4232.358}
              y1={-4236.014}
              x2={-4233.732}
              y2={-4238.382}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M487.65 120.2c.57-.33.44-.86.44-.89l-1.61.25-1.11.17c.21 0 .42.04.57.14.31.18.31.47 0 .65a.75.75 0 01-.18.08c.07-.01.15-.02.24-.04.25-.04.58-.09.86-.13.05-.01.11-.02.16-.02.27-.05.47-.12.63-.21z'
              fill='url(#dataMigr_banner_svg__SVGID_109_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_110_'
                gradientUnits='userSpaceOnUse'
                x1={-4233.935}
                y1={-4237.533}
                x2={-4233.935}
                y2={-4238.989}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0} stopColor='#7f64ff' />
                <stop offset={0.484} stopColor='#7d62ff' />
                <stop offset={0.752} stopColor='#775aff' />
                <stop offset={0.967} stopColor='#6d4cff' />
                <stop offset={1} stopColor='#6b49ff' />
              </linearGradient>
              <path
                d='M485.93 120.52c.31-.18.31-.47 0-.65-.16-.09-.37-.14-.57-.14s-.4.05-.55.14c-.05.03-.1.06-.13.1-.14.14-.14.32.01.46.03.03.07.06.12.09.16.09.37.14.57.13.13 0 .26-.02.38-.06a.51.51 0 00.17-.07z'
                fill='url(#dataMigr_banner_svg__SVGID_110_)'
              />
            </g>
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_111_'
                gradientUnits='userSpaceOnUse'
                x1={-4233.209}
                y1={-4235.598}
                x2={-4234.351}
                y2={-4237.565}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M488.04 121.11l-1.18-.68c-.29.04-.61.1-.86.13l-.23.5c.04.02.08.05.12.07.93.54 2.09 0 2.15-.02z'
                fill='url(#dataMigr_banner_svg__SVGID_111_)'
              />
            </g>
          </g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_112_'
            gradientUnits='userSpaceOnUse'
            x1={-4233.722}
            y1={-4238.838}
            x2={-4234.864}
            y2={-4240.805}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M484.68 120.43c-.14-.14-.15-.32-.01-.46l.3-.64c-.04-.02-.08-.05-.12-.07-.93-.54-2.1-.01-2.16.02l1.18.68.81.47z'
            fill='url(#dataMigr_banner_svg__SVGID_112_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_113_'
            gradientUnits='userSpaceOnUse'
            x1={-4234.203}
            y1={-4238.096}
            x2={-4235.576}
            y2={-4240.462}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M485.38 120.65c-.21 0-.41-.04-.57-.13a.623.623 0 01-.12-.09l-.8-.47c-.05.01-.11.02-.16.02-.27.04-.47.11-.62.2-.57.33-.44.86-.44.89l1.61-.25 1.1-.17z'
            fill='url(#dataMigr_banner_svg__SVGID_113_)'
          />
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_114_'
              gradientUnits='userSpaceOnUse'
              x1={-4234.554}
              y1={-4237.174}
              x2={-4235.471}
              y2={-4238.755}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M485.33 121.99l.44-.93.23-.5c-.09.01-.17.03-.24.04-.12.04-.25.06-.38.06l-1.1.17c-.01.03-.03.06-.04.09-.36.74 1.02 1.06 1.09 1.07z'
              fill='url(#dataMigr_banner_svg__SVGID_114_)'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_115_'
              gradientUnits='userSpaceOnUse'
              x1={-4234.608}
              y1={-4239.155}
              x2={-4230.021}
              y2={-4239.155}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
              <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
              <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
              <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
            </linearGradient>
            <path
              d='M483.15 117.01c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.16-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.09-.19.15-.38.15-.57z'
              fill='url(#dataMigr_banner_svg__SVGID_115_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_116_'
              gradientUnits='userSpaceOnUse'
              x1={-4233.207}
              y1={-4239.928}
              x2={-4228.621}
              y2={-4239.928}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0} stopColor='#2afadf' stopOpacity={0} />
              <stop offset={0.275} stopColor='#36d1ea' stopOpacity={0.165} />
              <stop offset={0.596} stopColor='#42a7f5' stopOpacity={0.358} />
              <stop offset={0.849} stopColor='#498dfc' stopOpacity={0.51} />
              <stop offset={1} stopColor='#4c83ff' stopOpacity={0.6} />
            </linearGradient>
            <path
              d='M483.18 115.41c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.16-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0l-.02-.04.02.04c-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.1-.18.15-.37.15-.57z'
              fill='url(#dataMigr_banner_svg__SVGID_116_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_117_'
                gradientUnits='userSpaceOnUse'
                x1={-4231.809}
                y1={-4240.666}
                x2={-4227.222}
                y2={-4240.666}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
              </linearGradient>
              <path
                d='M483.24 113.83c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.16-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0l-.02-.04.02.04c-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.09-.18.15-.37.15-.57z'
                fill='url(#dataMigr_banner_svg__SVGID_117_)'
              />
            </g>
          </g>
        </g>
        <g>
          <g className='dataMigr_banner_svg__st1'>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_118_'
              gradientUnits='userSpaceOnUse'
              x1={469.133}
              y1={277.678}
              x2={469.133}
              y2={244.263}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_118_)' d='M460.81 123.75v25.72l13.35 7.66.01-25.72z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_119_'
              gradientUnits='userSpaceOnUse'
              x1={479.649}
              y1={244.263}
              x2={479.649}
              y2={274.462}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_119_)' d='M474.16 157.13l7.69-4.5.01-25.72-7.69 4.5z' />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_120_'
                gradientUnits='userSpaceOnUse'
                x1={483.54}
                y1={276.07}
                x2={462.498}
                y2={276.07}
                gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path fill='url(#dataMigr_banner_svg__SVGID_120_)' d='M474.17 131.41l7.69-4.5-13.36-7.66-7.69 4.5z' />
            </g>
          </g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_121_'
            gradientUnits='userSpaceOnUse'
            x1={465.459}
            y1={268.961}
            x2={472.652}
            y2={268.961}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_121_)' d='M463.79 130.77l7.21 4.13v-.77l-7.01-4.02-.2-.11z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_122_'
            gradientUnits='userSpaceOnUse'
            x1={465.456}
            y1={267.591}
            x2={472.649}
            y2={267.591}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_122_)' d='M463.79 132.14l7.21 4.13v-.77l-7.01-4.02-.2-.11z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_123_'
            gradientUnits='userSpaceOnUse'
            x1={465.465}
            y1={270.326}
            x2={472.664}
            y2={270.326}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_123_)' d='M463.8 129.41l7.2 4.13v-.77l-7.01-4.02-.2-.12z' />
          <path
            className='dataMigr_banner_svg__st25'
            d='M463.99 130.67l7.01 4.01v-.55l-7.01-4.02zM463.99 132.03l7.01 4.02v-.55l-7.01-4.02zM463.99 129.3l7.01 4.02v-.55l-7.01-4.02z'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_124_'
            gradientUnits='userSpaceOnUse'
            x1={465.465}
            y1={263.581}
            x2={472.656}
            y2={263.581}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_124_)' d='M463.81 136.15l7.2 4.13v-.77l-7-4.02-.2-.11z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_125_'
            gradientUnits='userSpaceOnUse'
            x1={465.461}
            y1={262.216}
            x2={472.652}
            y2={262.216}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_125_)' d='M463.81 137.52l7.2 4.13v-.77l-7-4.02-.2-.12z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_126_'
            gradientUnits='userSpaceOnUse'
            x1={465.469}
            y1={264.946}
            x2={472.659}
            y2={264.946}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_126_)' d='M463.81 134.79l7.2 4.13v-.78l-7-4.01-.2-.12z' />
          <path
            className='dataMigr_banner_svg__st25'
            d='M464.01 136.04l7 4.02v-.55l-7-4.02zM464.01 137.41l7 4.02v-.55l-7-4.02zM464.01 134.68l7 4.02v-.56l-7-4.01z'
          />
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_127_'
              gradientUnits='userSpaceOnUse'
              x1={465.46}
              y1={258.201}
              x2={472.653}
              y2={258.201}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_127_)' d='M463.82 141.53l7.21 4.13v-.77l-7.01-4.02-.2-.11z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_128_'
              gradientUnits='userSpaceOnUse'
              x1={465.457}
              y1={256.836}
              x2={472.649}
              y2={256.836}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_128_)' d='M463.82 142.9l7.21 4.13v-.78l-7.01-4.01-.2-.12z' />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_129_'
                gradientUnits='userSpaceOnUse'
                x1={465.464}
                y1={259.571}
                x2={472.657}
                y2={259.571}
                gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path fill='url(#dataMigr_banner_svg__SVGID_129_)' d='M463.82 140.16l7.21 4.13v-.77l-7.01-4.02-.2-.11z' />
            </g>
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M464.02 141.42l7.01 4.02v-.55l-7.01-4.02zM464.02 142.79l7.01 4.02v-.56l-7.01-4.01zM464.02 140.06l7.01 4.01v-.55l-7.01-4.02z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_130_'
              gradientUnits='userSpaceOnUse'
              x1={465.466}
              y1={252.826}
              x2={472.657}
              y2={252.826}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_130_)' d='M463.84 146.91l7.2 4.13v-.77l-7-4.02-.2-.12z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_131_'
              gradientUnits='userSpaceOnUse'
              x1={465.462}
              y1={251.456}
              x2={472.653}
              y2={251.456}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_131_)' d='M463.84 148.27l7.2 4.14v-.78l-7-4.02-.2-.11z' />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_132_'
                gradientUnits='userSpaceOnUse'
                x1={465.47}
                y1={254.191}
                x2={472.661}
                y2={254.191}
                gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path fill='url(#dataMigr_banner_svg__SVGID_132_)' d='M463.84 145.54l7.2 4.13v-.77l-7-4.02-.2-.11z' />
            </g>
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M464.04 146.8l7 4.02v-.55l-7-4.02zM464.04 148.17l7 4.01v-.55l-7-4.02zM464.04 145.43l7 4.02v-.55l-7-4.02z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_133_'
              gradientUnits='userSpaceOnUse'
              x1={477.901}
              y1={267.477}
              x2={481.61}
              y2={267.477}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              fill='url(#dataMigr_banner_svg__SVGID_133_)'
              d='M476.24 134.59v.78l3.71-2.15-.01-.78-.11.06-.06.04z'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_134_'
              gradientUnits='userSpaceOnUse'
              x1={477.903}
              y1={266.092}
              x2={481.619}
              y2={266.092}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_134_)' d='M476.25 135.97v.79l3.71-2.15-.01-.79-.17.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_135_'
              gradientUnits='userSpaceOnUse'
              x1={477.901}
              y1={268.862}
              x2={481.609}
              y2={268.862}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_135_)' d='M476.24 133.2v.79l3.7-2.15v-.79l-.18.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M476.24 134.59v.58l3.53-2.05v-.58zM476.25 135.97v.59l3.53-2.06v-.58zM476.24 133.2v.58l3.53-2.05-.01-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_136_'
              gradientUnits='userSpaceOnUse'
              x1={477.902}
              y1={262.027}
              x2={481.61}
              y2={262.027}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_136_)' d='M476.26 140.04v.78l3.7-2.15v-.78l-.11.06-.06.04z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_137_'
              gradientUnits='userSpaceOnUse'
              x1={477.899}
              y1={260.642}
              x2={481.611}
              y2={260.642}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_137_)' d='M476.26 141.43v.78l3.71-2.15v-.79l-.18.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_138_'
              gradientUnits='userSpaceOnUse'
              x1={477.898}
              y1={263.412}
              x2={481.604}
              y2={263.412}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_138_)' d='M476.25 138.65l.01.79 3.69-2.15v-.79l-.17.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M476.26 140.04v.58l3.53-2.05v-.58zM476.26 141.43v.58l3.54-2.06-.01-.58zM476.25 138.65v.58l3.53-2.05v-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_139_'
              gradientUnits='userSpaceOnUse'
              x1={477.901}
              y1={256.572}
              x2={481.611}
              y2={256.572}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              fill='url(#dataMigr_banner_svg__SVGID_139_)'
              d='M476.27 145.49v.79l3.71-2.16-.01-.78-.11.07-.06.03z'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_140_'
              gradientUnits='userSpaceOnUse'
              x1={477.904}
              y1={255.192}
              x2={481.617}
              y2={255.192}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_140_)' d='M476.28 146.88v.78l3.7-2.15v-.79l-.17.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_141_'
              gradientUnits='userSpaceOnUse'
              x1={477.901}
              y1={257.957}
              x2={481.609}
              y2={257.957}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_141_)' d='M476.27 144.1v.79l3.7-2.15v-.78l-.18.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M476.27 145.49v.58l3.53-2.05v-.58zM476.28 146.88v.58l3.53-2.05v-.59zM476.27 144.1v.59l3.53-2.05-.01-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_142_'
              gradientUnits='userSpaceOnUse'
              x1={477.903}
              y1={251.122}
              x2={481.611}
              y2={251.122}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_142_)' d='M476.29 150.94v.79l3.7-2.16v-.78l-.11.07-.06.03z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_143_'
              gradientUnits='userSpaceOnUse'
              x1={477.899}
              y1={249.737}
              x2={481.612}
              y2={249.737}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_143_)' d='M476.29 152.33v.78l3.71-2.15v-.78l-.18.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_144_'
              gradientUnits='userSpaceOnUse'
              x1={477.899}
              y1={252.507}
              x2={481.604}
              y2={252.507}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_144_)' d='M476.28 149.56l.01.78 3.69-2.15v-.78l-.17.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M476.29 150.94v.58l3.53-2.05v-.58zM476.29 152.33v.58l3.54-2.05-.01-.58zM476.28 149.56v.58l3.53-2.05v-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_145_'
              gradientUnits='userSpaceOnUse'
              x1={-4247.621}
              y1={-4251.688}
              x2={-4242.78}
              y2={-4251.688}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M465.71 121.85c1.33-.77 3.5-.77 4.82 0 1.33.77 1.32 2.02-.01 2.79s-3.5.77-4.82 0c-1.34-.77-1.33-2.02.01-2.79'
              fill='url(#dataMigr_banner_svg__SVGID_145_)'
            />
            <path
              className='dataMigr_banner_svg__st25'
              d='M466.21 122.14c1.06-.61 2.77-.61 3.82 0 1.05.61 1.04 1.6-.01 2.21-1.06.61-2.77.61-3.82 0-1.05-.61-1.05-1.6.01-2.21'
            />
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_146_'
                gradientUnits='userSpaceOnUse'
                x1={-4247.041}
                y1={-4251.742}
                x2={-4242.78}
                y2={-4251.742}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M469.97 121.58c.03.01.06.02.09.04.01.01.03.01.04.02h.01c.06.03.13.06.19.09.01.01.03.01.04.02.06.03.12.06.18.1.33.19.58.41.74.65.04.06.08.12.11.18s.06.12.08.18c.04.12.06.25.06.37v.15c0-.5-.33-1-.99-1.39-.06-.03-.12-.07-.18-.1-.01-.01-.03-.01-.04-.02-.06-.03-.12-.06-.19-.09-.02-.01-.04-.01-.05-.02-.03-.01-.06-.02-.09-.04-.02-.01-.04-.02-.06-.02l-.09-.03c-.02-.01-.03-.01-.05-.02-.08-.03-.16-.05-.24-.07-.01 0-.03-.01-.04-.01-.07-.02-.14-.03-.21-.05h-.02c-.07-.01-.14-.03-.21-.04-.02 0-.04-.01-.05-.01-.06-.01-.12-.02-.18-.02h-.03c-.07-.01-.14-.01-.2-.02h-.05c-.05 0-.11-.01-.16-.01h-.53c-.07 0-.15.01-.22.01h-.03l-.23.03h-.03c-.09.01-.19.03-.28.05-.01 0-.02 0-.03.01-.12.02-.23.05-.35.08-.01 0-.02.01-.04.01-.07.02-.15.04-.22.07-.01 0-.01 0-.02.01-.07.02-.14.05-.21.08-.01.01-.03.01-.04.02-.07.03-.14.06-.2.09-.01.01-.02.01-.03.02-.07.03-.13.07-.2.11l-.15.09c-.01.01-.03.02-.04.03-.04.02-.07.05-.1.07-.01.01-.02.02-.04.03-.03.02-.06.05-.09.07-.01.01-.02.01-.02.02-.03.03-.07.06-.1.09l-.06.06-.02.02c-.03.03-.05.06-.07.08 0 0 0 .01-.01.01-.02.02-.04.05-.06.07-.01.01-.01.02-.02.03-.01.02-.02.03-.03.05-.03.04-.05.08-.07.12 0 .01-.01.01-.01.02-.02.03-.03.07-.04.1 0 .01-.01.02-.01.03-.01.04-.03.08-.04.12-.01.04-.02.08-.02.12v.03c0 .03-.01.07-.01.1v.03-.15-.02-.02c0-.03 0-.07.01-.1v-.03c.01-.04.01-.08.02-.12.01-.04.02-.08.04-.12v-.01c0-.01.01-.01.01-.02.01-.03.03-.07.04-.1 0-.01 0-.01.01-.02v-.01c.02-.04.04-.08.07-.12 0 0 0-.01.01-.01.01-.01.02-.02.03-.04.01-.01.01-.02.02-.03.02-.03.04-.05.06-.07 0 0 0-.01.01-.01.02-.03.05-.06.07-.08l.02-.02c.02-.02.03-.04.05-.05.03-.03.07-.06.1-.09.01-.01.02-.01.02-.02.03-.02.06-.05.09-.07l.01-.01c.01-.01.02-.01.02-.02l.1-.07c.01-.01.03-.02.04-.03l.15-.09c.06-.04.13-.07.2-.11.01-.01.02-.01.03-.02.07-.03.13-.06.2-.09.01-.01.03-.01.04-.02.07-.03.14-.06.21-.08.01 0 .01 0 .02-.01.07-.02.14-.05.22-.07.01 0 .01 0 .02-.01h.01c.06-.02.11-.03.17-.04.06-.01.12-.03.18-.04h.03c.09-.02.18-.03.28-.05h.03l.23-.03h.03c.07-.01.15-.01.22-.01h.53c.05 0 .11.01.16.01h.05c.07.01.14.01.2.02h.03c.06.01.12.02.18.02h.05c.07.01.14.02.21.04h.01c.07.01.14.03.21.05.01 0 .02 0 .03.01h.01c.08.02.16.04.24.07.01 0 .01 0 .02.01.01 0 .02.01.03.01l.09.03c.05.03.07.04.09.04z'
                fill='url(#dataMigr_banner_svg__SVGID_146_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_147_'
                gradientUnits='userSpaceOnUse'
                x1={-4247.876}
                y1={-4251.547}
                x2={-4243.396}
                y2={-4251.547}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M465.8 124.84c.07.03.13.06.2.09.02.01.04.02.06.02.03.01.06.03.1.04.02.01.04.02.07.02.03.01.06.02.1.03.02.01.04.01.05.02.08.03.17.05.25.07.01 0 .03.01.04.01.07.02.15.04.22.05h.02c.07.01.15.03.22.04.02 0 .04.01.06.01l.19.03h.03c.07.01.14.01.21.02h.06c.06 0 .12.01.17.01h.56c.08 0 .15-.01.23-.02h.04l.24-.03h.03c.1-.01.2-.03.29-.05.01 0 .02 0 .04-.01.06-.01.12-.03.18-.04.06-.01.12-.03.18-.05.01 0 .03-.01.04-.01.08-.02.15-.04.23-.07.01 0 .01 0 .02-.01.08-.03.15-.05.23-.08.01-.01.03-.01.04-.02l.21-.09c.01-.01.02-.01.04-.02.07-.04.14-.07.21-.11.05-.03.11-.06.16-.1.01-.01.03-.02.04-.03l.11-.08c.01-.01.03-.02.04-.03.03-.02.06-.05.09-.07.01-.01.02-.01.03-.02.04-.03.07-.06.11-.1l.06-.06.02-.02c.03-.03.05-.06.08-.09 0 0 0-.01.01-.01.02-.03.04-.05.06-.08.01-.01.01-.02.02-.03.01-.02.02-.03.03-.05.03-.04.05-.09.07-.13 0-.01.01-.01.01-.02.02-.04.03-.07.05-.11 0-.01.01-.02.01-.03.01-.04.03-.08.04-.13.01-.04.02-.08.02-.12v-.04c0-.03.01-.07.01-.1v-.03V123.4c0 .03 0 .07-.01.1v.04c-.01.04-.01.08-.02.12-.01.04-.02.08-.04.13v.01c0 .01-.01.01-.01.02-.01.04-.03.07-.05.11 0 .01 0 .01-.01.02v.01c-.02.04-.05.09-.07.13 0 0 0 .01-.01.01-.01.01-.02.03-.03.04s-.01.02-.02.03c-.02.03-.04.05-.06.08 0 0 0 .01-.01.01-.02.03-.05.06-.08.09l-.02.02c-.02.02-.04.04-.05.06-.03.03-.07.07-.11.1-.01.01-.02.01-.03.02-.03.02-.06.05-.09.07l-.01.01c-.01.01-.02.01-.03.02-.03.03-.07.05-.11.08-.01.01-.03.02-.04.03-.05.03-.1.06-.16.1-.07.04-.14.08-.21.11-.01.01-.02.01-.04.02l-.21.09c-.01.01-.03.01-.04.02-.07.03-.15.06-.23.08-.01 0-.01 0-.02.01-.07.03-.15.05-.23.07-.01 0-.02 0-.02.01h-.02c-.06.02-.12.03-.18.05-.06.01-.12.03-.18.04h-.04c-.1.02-.19.03-.29.05h-.03l-.24.03h-.03c-.08.01-.16.01-.24.02h-.56c-.06 0-.12-.01-.17-.01h-.06c-.07-.01-.14-.01-.21-.02h-.03l-.19-.03h-.05c-.07-.01-.15-.03-.22-.04h-.02c-.07-.02-.15-.03-.22-.05-.01 0-.02 0-.03-.01h-.01c-.09-.02-.17-.05-.25-.07-.01 0-.02 0-.02-.01-.01 0-.02-.01-.03-.01-.03-.01-.06-.02-.1-.03a.145.145 0 00-.07-.02c-.03-.01-.06-.03-.1-.04-.02-.01-.03-.01-.05-.02 0 0-.01 0-.01-.01-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.13-.07-.19-.1-.48-.28-.79-.61-.94-.97-.03-.06-.05-.13-.07-.2a.355.355 0 01-.02-.1c-.01-.07-.02-.13-.02-.2v-.15c0 .53.35 1.06 1.04 1.46.06.04.13.07.19.1.01.01.02.01.04.02z'
                fill='url(#dataMigr_banner_svg__SVGID_147_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_148_'
                gradientUnits='userSpaceOnUse'
                x1={-4247.753}
                y1={-4251.686}
                x2={-4242.658}
                y2={-4251.686}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M465.56 124.72c-1.4-.81-1.39-2.13.02-2.94 1.4-.81 3.68-.81 5.08 0s1.39 2.13-.02 2.94c-1.4.81-3.68.81-5.08 0zm.15-2.87c-1.33.77-1.34 2.02-.01 2.79s3.49.77 4.82 0 1.34-2.02.01-2.79-3.49-.77-4.82 0'
                fill='url(#dataMigr_banner_svg__SVGID_148_)'
              />
            </g>
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_149_'
                gradientUnits='userSpaceOnUse'
                x1={-4243.785}
                y1={-4251.124}
                x2={-4244.736}
                y2={-4252.762}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M469.21 122.68c.01-.03.03-.06.04-.09.35-.74-1.03-1.06-1.1-1.07l-.44.93-.3.64c.04-.04.08-.07.13-.1.15-.09.35-.13.56-.14l1.11-.17z'
                fill='url(#dataMigr_banner_svg__SVGID_149_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_150_'
                gradientUnits='userSpaceOnUse'
                x1={-4243.686}
                y1={-4249.41}
                x2={-4245.06}
                y2={-4251.777}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M470.39 123.32c.57-.33.44-.86.44-.89l-1.61.25-1.11.17c.21 0 .42.04.57.14.31.18.31.47 0 .65a.75.75 0 01-.18.08c.07-.01.15-.02.24-.04.25-.04.58-.09.86-.13.05-.01.11-.02.16-.02.27-.05.47-.12.63-.21z'
                fill='url(#dataMigr_banner_svg__SVGID_150_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_151_'
                  gradientUnits='userSpaceOnUse'
                  x1={-4245.264}
                  y1={-4250.924}
                  x2={-4245.264}
                  y2={-4252.381}
                  gradientTransform='rotate(-60.025 1898.378 -6144.042)'
                >
                  <stop offset={0} stopColor='#7f64ff' />
                  <stop offset={0.484} stopColor='#7d62ff' />
                  <stop offset={0.752} stopColor='#775aff' />
                  <stop offset={0.967} stopColor='#6d4cff' />
                  <stop offset={1} stopColor='#6b49ff' />
                </linearGradient>
                <path
                  d='M468.67 123.64c.31-.18.31-.47 0-.65-.16-.09-.37-.14-.57-.14s-.4.05-.56.14c-.05.03-.1.06-.13.1-.14.14-.14.32.01.46.03.03.07.06.12.09.16.09.37.14.57.13.13 0 .26-.02.38-.06a.36.36 0 00.18-.07z'
                  fill='url(#dataMigr_banner_svg__SVGID_151_)'
                />
              </g>
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_152_'
                  gradientUnits='userSpaceOnUse'
                  x1={-4244.537}
                  y1={-4248.991}
                  x2={-4245.678}
                  y2={-4250.958}
                  gradientTransform='rotate(-60.025 1898.378 -6144.042)'
                >
                  <stop offset={0.117} stopColor='#dddcf9' />
                  <stop offset={0.562} stopColor='#fff' />
                  <stop offset={0.708} stopColor='#f9f8fe' />
                  <stop offset={0.915} stopColor='#e6e6fb' />
                  <stop offset={1} stopColor='#dddcf9' />
                </linearGradient>
                <path
                  d='M470.78 124.23l-1.18-.68c-.29.04-.61.1-.86.13l-.23.5c.04.02.08.05.12.07.93.54 2.09.01 2.15-.02z'
                  fill='url(#dataMigr_banner_svg__SVGID_152_)'
                />
              </g>
            </g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_153_'
              gradientUnits='userSpaceOnUse'
              x1={-4245.049}
              y1={-4252.231}
              x2={-4246.19}
              y2={-4254.198}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M467.42 123.55c-.14-.14-.15-.32-.01-.46l.3-.64c-.04-.02-.08-.05-.12-.07-.93-.54-2.1-.01-2.16.02l1.18.68.81.47z'
              fill='url(#dataMigr_banner_svg__SVGID_153_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_154_'
              gradientUnits='userSpaceOnUse'
              x1={-4245.539}
              y1={-4251.486}
              x2={-4246.913}
              y2={-4253.852}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M468.12 123.78c-.21 0-.41-.04-.57-.13a.623.623 0 01-.12-.09l-.8-.47c-.05.01-.11.02-.16.02-.27.04-.47.11-.62.2-.57.33-.44.86-.44.89l1.61-.25 1.1-.17z'
              fill='url(#dataMigr_banner_svg__SVGID_154_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_155_'
                gradientUnits='userSpaceOnUse'
                x1={-4245.889}
                y1={-4250.563}
                x2={-4246.807}
                y2={-4252.143}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M468.07 125.12l.44-.93.23-.5c-.09.01-.17.03-.24.04-.12.04-.25.06-.38.06l-1.1.17c-.01.03-.03.06-.04.09-.36.74 1.02 1.05 1.09 1.07z'
                fill='url(#dataMigr_banner_svg__SVGID_155_)'
              />
            </g>
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_156_'
                gradientUnits='userSpaceOnUse'
                x1={-4245.935}
                y1={-4252.548}
                x2={-4241.348}
                y2={-4252.548}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
              </linearGradient>
              <path
                d='M465.89 120.13c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.16-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.09-.18.15-.37.15-.57z'
                fill='url(#dataMigr_banner_svg__SVGID_156_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_157_'
                gradientUnits='userSpaceOnUse'
                x1={-4244.542}
                y1={-4253.316}
                x2={-4239.956}
                y2={-4253.316}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0} stopColor='#2afadf' stopOpacity={0} />
                <stop offset={0.275} stopColor='#36d1ea' stopOpacity={0.165} />
                <stop offset={0.596} stopColor='#42a7f5' stopOpacity={0.358} />
                <stop offset={0.849} stopColor='#498dfc' stopOpacity={0.51} />
                <stop offset={1} stopColor='#4c83ff' stopOpacity={0.6} />
              </linearGradient>
              <path
                d='M465.92 118.54c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.16-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0l-.02-.04.02.04c-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.1-.19.15-.38.15-.57z'
                fill='url(#dataMigr_banner_svg__SVGID_157_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_158_'
                  gradientUnits='userSpaceOnUse'
                  x1={-4243.144}
                  y1={-4254.054}
                  x2={-4238.557}
                  y2={-4254.054}
                  gradientTransform='rotate(-60.025 1898.378 -6144.042)'
                >
                  <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                  <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                  <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                  <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
                </linearGradient>
                <path
                  d='M465.98 116.96c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.16-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0l-.02-.04.02.04c-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.09-.19.15-.38.15-.57z'
                  fill='url(#dataMigr_banner_svg__SVGID_158_)'
                />
              </g>
            </g>
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_159_'
              gradientUnits='userSpaceOnUse'
              x1={-4247.455}
              y1={-4244.714}
              x2={-4242.615}
              y2={-4244.714}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M471.83 125.19c1.33-.77 3.5-.77 4.82 0 1.33.77 1.32 2.02-.01 2.79s-3.5.77-4.82 0c-1.33-.77-1.32-2.02.01-2.79'
              fill='url(#dataMigr_banner_svg__SVGID_159_)'
            />
            <path
              className='dataMigr_banner_svg__st25'
              d='M472.33 125.48c1.06-.61 2.77-.61 3.82 0 1.05.61 1.04 1.6-.01 2.21-1.06.61-2.77.61-3.82 0-1.05-.61-1.04-1.6.01-2.21'
            />
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_160_'
                gradientUnits='userSpaceOnUse'
                x1={-4246.878}
                y1={-4244.766}
                x2={-4242.618}
                y2={-4244.766}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M476.09 124.93c.03.01.06.02.09.04.01.01.03.01.04.02h.01c.06.03.13.06.19.09.01.01.03.01.04.02.06.03.13.06.18.1.33.19.58.41.74.65.04.06.08.12.11.18s.06.12.08.18c.04.12.06.25.06.37v.15c0-.5-.33-1-.99-1.39-.06-.03-.12-.07-.18-.1-.01-.01-.03-.01-.04-.02-.06-.03-.13-.06-.19-.09-.02-.01-.04-.01-.05-.02-.03-.01-.06-.02-.09-.04-.02-.01-.04-.02-.06-.02l-.09-.03c-.02-.01-.03-.01-.05-.02-.08-.03-.16-.05-.24-.07-.01 0-.03-.01-.04-.01-.07-.02-.14-.03-.21-.05h-.02c-.07-.01-.14-.03-.21-.04-.02 0-.04-.01-.05-.01-.06-.01-.12-.02-.18-.02h-.03c-.07-.01-.14-.01-.2-.02h-.05c-.05 0-.11-.01-.16-.01h-.53c-.07 0-.15.01-.22.01h-.03l-.23.03h-.03c-.09.01-.19.03-.28.05-.01 0-.02 0-.03.01-.12.02-.23.05-.35.08-.01 0-.02.01-.04.01-.07.02-.15.04-.22.07-.01 0-.01 0-.02.01-.07.02-.14.05-.21.08-.01.01-.03.01-.04.02-.07.03-.14.06-.2.09-.01.01-.02.01-.03.02-.07.03-.13.07-.2.11l-.15.09c-.01.01-.03.02-.04.03-.04.02-.07.05-.1.07-.01.01-.02.02-.04.03-.03.02-.06.05-.09.07-.01.01-.02.01-.02.02-.03.03-.07.06-.1.09l-.06.06-.02.02c-.03.03-.05.06-.07.08 0 0 0 .01-.01.01-.02.02-.04.05-.06.07-.01.01-.01.02-.02.03-.01.02-.02.03-.03.05-.03.04-.05.08-.07.12 0 .01-.01.01-.01.02-.02.03-.03.07-.04.1 0 .01-.01.02-.01.03-.01.04-.03.08-.04.12-.01.04-.02.08-.02.12v.03c0 .03-.01.07-.01.1v.03-.15-.02-.02c0-.03 0-.07.01-.1v-.03c.01-.04.01-.08.02-.12.01-.04.02-.08.04-.12v-.01c0-.01.01-.01.01-.02.01-.03.03-.07.04-.1 0-.01 0-.01.01-.02v-.01c.02-.04.04-.08.07-.12 0 0 0-.01.01-.01.01-.01.02-.02.02-.04.01-.01.01-.02.02-.03.02-.03.04-.05.06-.07 0 0 0-.01.01-.01.02-.03.05-.06.07-.08l.02-.02c.02-.02.03-.04.05-.05.03-.03.06-.06.1-.09.01-.01.02-.01.02-.02.03-.02.06-.05.09-.07l.01-.01c.01-.01.02-.01.02-.02l.1-.07c.01-.01.03-.02.04-.03l.15-.09c.06-.04.13-.07.2-.11.01-.01.02-.01.03-.02.07-.03.13-.06.2-.09.01-.01.03-.01.04-.02.07-.03.14-.06.21-.08.01 0 .01 0 .02-.01.07-.02.14-.05.22-.07.01 0 .01 0 .02-.01h.01c.06-.02.11-.03.17-.04.06-.01.12-.03.17-.04h.03c.09-.02.18-.03.28-.05h.02l.23-.03h.03c.07-.01.15-.01.22-.01h.53c.05 0 .11.01.16.01h.05c.07.01.14.01.2.02h.03c.06.01.12.02.18.02h.05c.07.01.14.02.21.04h.02c.07.01.14.03.21.05.01 0 .02 0 .03.01h.01c.08.02.16.04.24.07.01 0 .01 0 .02.01.01 0 .02.01.03.01l.09.03c.07.02.09.03.11.04z'
                fill='url(#dataMigr_banner_svg__SVGID_160_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_161_'
                gradientUnits='userSpaceOnUse'
                x1={-4247.71}
                y1={-4244.577}
                x2={-4243.231}
                y2={-4244.577}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M471.92 128.18c.07.03.13.06.2.09.02.01.04.02.06.02.03.01.06.03.1.04.02.01.04.02.07.02.03.01.06.02.1.03.02.01.04.01.05.02.08.03.17.05.25.07.01 0 .03.01.04.01.07.02.15.04.22.05h.02c.07.01.15.03.22.04.02 0 .04.01.06.01l.19.03h.03c.07.01.14.01.21.02h.06c.06 0 .12.01.17.01h.56c.08 0 .15-.01.23-.02h.04l.24-.03h.03c.1-.01.2-.03.29-.05.01 0 .02 0 .04-.01.06-.01.12-.03.18-.04.06-.01.12-.03.18-.05.01 0 .03-.01.04-.01.08-.02.15-.04.23-.07.01 0 .01 0 .02-.01.08-.03.15-.05.23-.08.01-.01.03-.01.04-.02l.21-.09c.01-.01.02-.01.04-.02.07-.04.14-.07.21-.11.05-.03.11-.06.16-.1.01-.01.03-.02.04-.03l.11-.08c.01-.01.03-.02.04-.03.03-.02.06-.05.09-.07.01-.01.02-.01.03-.02.04-.03.07-.06.11-.1l.06-.06.02-.02c.03-.03.05-.06.08-.09 0 0 0-.01.01-.01.02-.03.04-.05.06-.08.01-.01.01-.02.02-.03.01-.02.02-.03.03-.05.03-.04.05-.09.07-.13 0-.01.01-.01.01-.02.02-.04.03-.07.05-.11 0-.01.01-.02.01-.03.01-.04.03-.08.04-.13.01-.04.02-.08.02-.12v-.04c0-.03.01-.07.01-.1v-.03.18c0 .03 0 .07-.01.1v.04c-.01.04-.01.08-.02.12-.01.04-.02.08-.04.13v.01c0 .01-.01.01-.01.02-.01.04-.03.07-.05.11 0 .01 0 .01-.01.02v.01c-.02.04-.05.09-.07.13 0 0 0 .01-.01.01-.01.01-.02.03-.03.04s-.01.02-.02.03c-.02.03-.04.05-.06.08 0 0 0 .01-.01.01-.02.03-.05.06-.08.09l-.02.02c-.02.02-.04.04-.05.06-.03.03-.07.07-.11.1-.01.01-.02.01-.03.02-.03.02-.06.05-.09.07l-.01.01c-.01.01-.02.01-.03.02-.03.03-.07.05-.11.08-.01.01-.03.02-.04.03-.05.03-.1.06-.16.1-.07.04-.14.08-.21.11-.01.01-.02.01-.04.02l-.21.09c-.01.01-.03.01-.04.02-.07.03-.15.06-.23.08-.01 0-.01 0-.02.01-.07.02-.15.05-.23.07-.01 0-.02 0-.02.01h-.02c-.06.02-.12.03-.18.05-.06.01-.12.03-.18.04h-.04c-.1.02-.19.03-.29.05h-.03l-.24.03h-.03c-.08.01-.15.01-.23.02h-.56c-.06 0-.12-.01-.17-.01h-.06c-.07-.01-.14-.01-.21-.02h-.03l-.19-.03h-.05c-.07-.01-.15-.03-.22-.04h-.02c-.07-.02-.15-.03-.22-.05-.01 0-.02 0-.03-.01h-.01c-.09-.02-.17-.05-.25-.07-.01 0-.02 0-.02-.01-.01 0-.02-.01-.03-.01-.03-.01-.06-.02-.1-.03a.145.145 0 00-.07-.02c-.03-.01-.06-.03-.1-.04-.02-.01-.03-.01-.05-.02 0 0-.01 0-.01-.01-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.13-.07-.19-.1-.48-.28-.79-.61-.94-.97-.03-.06-.05-.13-.07-.2a.355.355 0 01-.02-.1c-.01-.07-.02-.13-.02-.2v-.15c0 .53.35 1.06 1.04 1.46.06.04.13.07.19.1.01.02.02.03.03.03z'
                fill='url(#dataMigr_banner_svg__SVGID_161_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_162_'
                gradientUnits='userSpaceOnUse'
                x1={-4247.583}
                y1={-4244.708}
                x2={-4242.488}
                y2={-4244.708}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M471.69 128.06c-1.4-.81-1.39-2.13.02-2.94 1.4-.81 3.68-.81 5.08 0s1.39 2.13-.02 2.94-3.69.81-5.08 0zm.14-2.87c-1.33.77-1.34 2.02-.01 2.79s3.49.77 4.82 0 1.34-2.02.01-2.79c-1.32-.77-3.49-.77-4.82 0'
                fill='url(#dataMigr_banner_svg__SVGID_162_)'
              />
            </g>
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_163_'
                gradientUnits='userSpaceOnUse'
                x1={-4243.618}
                y1={-4244.149}
                x2={-4244.568}
                y2={-4245.787}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M475.33 126.02c.01-.03.03-.06.04-.09.35-.74-1.03-1.06-1.1-1.07l-.44.93-.3.64c.04-.04.08-.07.13-.1.15-.09.35-.13.55-.14l1.12-.17z'
                fill='url(#dataMigr_banner_svg__SVGID_163_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_164_'
                gradientUnits='userSpaceOnUse'
                x1={-4243.52}
                y1={-4242.436}
                x2={-4244.895}
                y2={-4244.805}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M476.51 126.66c.57-.33.44-.86.44-.89l-1.61.25-1.11.17c.21 0 .42.04.57.14.31.18.31.47 0 .65a.75.75 0 01-.18.08c.07-.01.15-.02.24-.04.25-.04.58-.09.86-.13.05-.01.11-.02.16-.02.28-.05.48-.12.63-.21z'
                fill='url(#dataMigr_banner_svg__SVGID_164_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_165_'
                  gradientUnits='userSpaceOnUse'
                  x1={-4245.101}
                  y1={-4243.949}
                  x2={-4245.101}
                  y2={-4245.405}
                  gradientTransform='rotate(-60.025 1898.378 -6144.042)'
                >
                  <stop offset={0} stopColor='#7f64ff' />
                  <stop offset={0.484} stopColor='#7d62ff' />
                  <stop offset={0.752} stopColor='#775aff' />
                  <stop offset={0.967} stopColor='#6d4cff' />
                  <stop offset={1} stopColor='#6b49ff' />
                </linearGradient>
                <path
                  d='M474.8 126.99c.31-.18.31-.47 0-.65-.16-.09-.37-.14-.57-.14s-.4.05-.55.14c-.05.03-.1.06-.13.1-.14.14-.14.32.01.46.03.03.07.06.12.09.16.09.37.14.57.13.13 0 .26-.02.38-.06.05-.02.11-.04.17-.07z'
                  fill='url(#dataMigr_banner_svg__SVGID_165_)'
                />
              </g>
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_166_'
                  gradientUnits='userSpaceOnUse'
                  x1={-4244.37}
                  y1={-4242.016}
                  x2={-4245.511}
                  y2={-4243.983}
                  gradientTransform='rotate(-60.025 1898.378 -6144.042)'
                >
                  <stop offset={0.117} stopColor='#dddcf9' />
                  <stop offset={0.562} stopColor='#fff' />
                  <stop offset={0.708} stopColor='#f9f8fe' />
                  <stop offset={0.915} stopColor='#e6e6fb' />
                  <stop offset={1} stopColor='#dddcf9' />
                </linearGradient>
                <path
                  d='M476.9 127.57l-1.18-.68c-.29.04-.61.1-.86.13l-.23.5c.04.02.08.05.12.07.93.54 2.09.01 2.15-.02z'
                  fill='url(#dataMigr_banner_svg__SVGID_166_)'
                />
              </g>
            </g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_167_'
              gradientUnits='userSpaceOnUse'
              x1={-4244.882}
              y1={-4245.257}
              x2={-4246.024}
              y2={-4247.224}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M473.55 126.89c-.14-.14-.15-.32-.01-.46l.3-.64c-.04-.02-.08-.05-.12-.07-.93-.54-2.1-.01-2.16.02l1.18.68.81.47z'
              fill='url(#dataMigr_banner_svg__SVGID_167_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_168_'
              gradientUnits='userSpaceOnUse'
              x1={-4245.373}
              y1={-4244.513}
              x2={-4246.747}
              y2={-4246.879}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M474.24 127.12c-.21 0-.41-.04-.57-.13a.623.623 0 01-.12-.09l-.8-.47c-.05.01-.11.02-.16.02-.27.04-.47.11-.62.2-.57.33-.44.86-.44.89l1.61-.25 1.1-.17z'
              fill='url(#dataMigr_banner_svg__SVGID_168_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_169_'
                gradientUnits='userSpaceOnUse'
                x1={-4245.723}
                y1={-4243.588}
                x2={-4246.64}
                y2={-4245.169}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M474.19 128.46l.44-.93.23-.5c-.09.01-.17.03-.24.04-.12.04-.25.06-.38.06l-1.1.17c-.01.03-.03.06-.04.09-.35.74 1.02 1.05 1.09 1.07z'
                fill='url(#dataMigr_banner_svg__SVGID_169_)'
              />
            </g>
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_170_'
                gradientUnits='userSpaceOnUse'
                x1={-4245.77}
                y1={-4245.578}
                x2={-4241.184}
                y2={-4245.578}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
              </linearGradient>
              <path
                d='M472.01 123.47c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.16-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.1-.18.15-.37.15-.57z'
                fill='url(#dataMigr_banner_svg__SVGID_170_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_171_'
                gradientUnits='userSpaceOnUse'
                x1={-4244.373}
                y1={-4246.337}
                x2={-4239.787}
                y2={-4246.337}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0} stopColor='#2afadf' stopOpacity={0} />
                <stop offset={0.275} stopColor='#36d1ea' stopOpacity={0.165} />
                <stop offset={0.596} stopColor='#42a7f5' stopOpacity={0.358} />
                <stop offset={0.849} stopColor='#498dfc' stopOpacity={0.51} />
                <stop offset={1} stopColor='#4c83ff' stopOpacity={0.6} />
              </linearGradient>
              <path
                d='M472.05 121.88c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.16-.27.42-.52.79-.73zm5.38 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0l-.02-.04.02.04c-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.1-.19.15-.38.15-.57z'
                fill='url(#dataMigr_banner_svg__SVGID_171_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_172_'
                  gradientUnits='userSpaceOnUse'
                  x1={-4242.98}
                  y1={-4247.083}
                  x2={-4238.393}
                  y2={-4247.083}
                  gradientTransform='rotate(-60.025 1898.378 -6144.042)'
                >
                  <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                  <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                  <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                  <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
                </linearGradient>
                <path
                  d='M472.1 120.3c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.16-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0l-.02-.04.02.04c-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.1-.19.15-.38.15-.57z'
                  fill='url(#dataMigr_banner_svg__SVGID_172_)'
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g className='dataMigr_banner_svg__st1'>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_173_'
              gradientUnits='userSpaceOnUse'
              x1={457.976}
              y1={271.229}
              x2={457.976}
              y2={237.813}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_173_)' d='M449.67 130.23v25.72l13.36 7.66v-25.72z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_174_'
              gradientUnits='userSpaceOnUse'
              x1={468.497}
              y1={237.813}
              x2={468.497}
              y2={268.012}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_174_)' d='M463.03 163.61l7.69-4.5v-25.72l-7.69 4.5z' />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_175_'
                gradientUnits='userSpaceOnUse'
                x1={472.382}
                y1={269.62}
                x2={451.341}
                y2={269.62}
                gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path fill='url(#dataMigr_banner_svg__SVGID_175_)' d='M463.03 137.89l7.69-4.5-13.36-7.66-7.69 4.5z' />
            </g>
          </g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_176_'
            gradientUnits='userSpaceOnUse'
            x1={454.312}
            y1={262.511}
            x2={461.503}
            y2={262.511}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_176_)' d='M452.66 137.25l7.2 4.13v-.77l-7.01-4.02-.19-.11z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_177_'
            gradientUnits='userSpaceOnUse'
            x1={454.308}
            y1={261.146}
            x2={461.499}
            y2={261.146}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_177_)' d='M452.66 138.62l7.2 4.13v-.77l-7.01-4.02-.19-.12z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_178_'
            gradientUnits='userSpaceOnUse'
            x1={454.316}
            y1={263.876}
            x2={461.507}
            y2={263.876}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_178_)' d='M452.66 135.89l7.2 4.13v-.78l-7.01-4.01-.19-.12z' />
          <path
            className='dataMigr_banner_svg__st25'
            d='M452.85 137.14l7.01 4.02v-.55l-7.01-4.02zM452.85 138.51l7.01 4.02v-.55l-7.01-4.02zM452.85 135.78l7.01 4.02v-.56l-7.01-4.01z'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_179_'
            gradientUnits='userSpaceOnUse'
            x1={454.308}
            y1={257.131}
            x2={461.498}
            y2={257.131}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_179_)' d='M452.67 142.63l7.2 4.13v-.77l-7-4.02-.2-.11z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_180_'
            gradientUnits='userSpaceOnUse'
            x1={454.304}
            y1={255.766}
            x2={461.495}
            y2={255.766}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_180_)' d='M452.67 144l7.2 4.13v-.78l-7-4.01-.2-.12z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_181_'
            gradientUnits='userSpaceOnUse'
            x1={454.311}
            y1={258.496}
            x2={461.502}
            y2={258.496}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_181_)' d='M452.67 141.26l7.2 4.14v-.78l-7-4.02-.2-.11z' />
          <path
            className='dataMigr_banner_svg__st25'
            d='M452.87 142.52l7 4.02v-.55l-7-4.02zM452.87 143.89l7 4.02v-.56l-7-4.01zM452.87 141.16l7 4.02v-.56l-7-4.02z'
          />
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_182_'
              gradientUnits='userSpaceOnUse'
              x1={454.313}
              y1={251.751}
              x2={461.504}
              y2={251.751}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_182_)' d='M452.69 148.01l7.2 4.13v-.77l-7.01-4.02-.19-.11z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_183_'
              gradientUnits='userSpaceOnUse'
              x1={454.309}
              y1={250.386}
              x2={461.5}
              y2={250.386}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_183_)' d='M452.69 149.37l7.2 4.14v-.78l-7.01-4.02-.19-.11z' />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_184_'
                gradientUnits='userSpaceOnUse'
                x1={454.317}
                y1={253.121}
                x2={461.508}
                y2={253.121}
                gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path fill='url(#dataMigr_banner_svg__SVGID_184_)' d='M452.69 146.64l7.2 4.13V150l-7.01-4.02-.19-.11z' />
            </g>
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M452.88 147.9l7.01 4.02v-.55l-7.01-4.02zM452.88 149.27l7.01 4.01v-.55l-7.01-4.02zM452.88 146.53l7.01 4.02V150l-7.01-4.02z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_185_'
              gradientUnits='userSpaceOnUse'
              x1={454.308}
              y1={246.376}
              x2={461.499}
              y2={246.376}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_185_)' d='M452.7 153.39l7.2 4.13v-.77l-7-4.02-.2-.12z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_186_'
              gradientUnits='userSpaceOnUse'
              x1={454.305}
              y1={245.011}
              x2={461.496}
              y2={245.011}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_186_)' d='M452.7 154.75l7.2 4.13v-.77l-7-4.02-.2-.11z' />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_187_'
                gradientUnits='userSpaceOnUse'
                x1={454.312}
                y1={247.741}
                x2={461.503}
                y2={247.741}
                gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path fill='url(#dataMigr_banner_svg__SVGID_187_)' d='M452.7 152.02l7.2 4.13v-.77l-7-4.02-.2-.11z' />
            </g>
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M452.9 153.28l7 4.02v-.55l-7-4.02zM452.9 154.65l7 4.01v-.55l-7-4.02zM452.9 151.91l7 4.02v-.55l-7-4.02z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_188_'
              gradientUnits='userSpaceOnUse'
              x1={466.746}
              y1={261.027}
              x2={470.455}
              y2={261.027}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_188_)' d='M465.1 141.07l.01.78 3.7-2.15v-.78l-.12.06-.06.04z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_189_'
              gradientUnits='userSpaceOnUse'
              x1={466.746}
              y1={259.642}
              x2={470.462}
              y2={259.642}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_189_)' d='M465.11 142.45v.79l3.71-2.16-.01-.78-.17.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_190_'
              gradientUnits='userSpaceOnUse'
              x1={466.743}
              y1={262.417}
              x2={470.451}
              y2={262.417}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_190_)' d='M465.1 139.68v.78l3.7-2.15v-.78l-.17.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M465.1 141.07l.01.58 3.53-2.05-.01-.58zM465.11 142.45v.59l3.53-2.06v-.58zM465.1 139.68v.58l3.53-2.05v-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_191_'
              gradientUnits='userSpaceOnUse'
              x1={466.745}
              y1={255.577}
              x2={470.453}
              y2={255.577}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_191_)' d='M465.12 146.52v.78l3.7-2.15v-.78l-.11.06-.06.04z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_192_'
              gradientUnits='userSpaceOnUse'
              x1={466.743}
              y1={254.192}
              x2={470.459}
              y2={254.192}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_192_)' d='M465.12 147.9l.01.79 3.7-2.15v-.79l-.17.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_193_'
              gradientUnits='userSpaceOnUse'
              x1={466.748}
              y1={256.962}
              x2={470.454}
              y2={256.962}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_193_)' d='M465.12 145.13v.79l3.7-2.15-.01-.79-.17.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M465.12 146.52v.58l3.53-2.05v-.58zM465.12 147.9v.59l3.54-2.06v-.58zM465.12 145.13v.58l3.52-2.05v-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_194_'
              gradientUnits='userSpaceOnUse'
              x1={466.746}
              y1={250.127}
              x2={470.455}
              y2={250.127}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              fill='url(#dataMigr_banner_svg__SVGID_194_)'
              d='M465.13 151.97l.01.78 3.7-2.15v-.78l-.12.06-.06.04z'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_195_'
              gradientUnits='userSpaceOnUse'
              x1={466.746}
              y1={248.742}
              x2={470.462}
              y2={248.742}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_195_)' d='M465.14 153.36v.78l3.71-2.15-.01-.79-.17.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_196_'
              gradientUnits='userSpaceOnUse'
              x1={466.744}
              y1={251.512}
              x2={470.452}
              y2={251.512}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_196_)' d='M465.13 150.58v.79l3.7-2.15v-.79l-.17.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M465.13 151.97l.01.58 3.53-2.05-.01-.58zM465.14 153.36v.58l3.53-2.06v-.58zM465.13 150.58v.58l3.53-2.05v-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_197_'
              gradientUnits='userSpaceOnUse'
              x1={466.745}
              y1={244.672}
              x2={470.453}
              y2={244.672}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_197_)' d='M465.15 157.42v.79l3.7-2.16v-.78l-.11.07-.06.03z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_198_'
              gradientUnits='userSpaceOnUse'
              x1={466.744}
              y1={243.292}
              x2={470.459}
              y2={243.292}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_198_)' d='M465.15 158.81l.01.78 3.7-2.15v-.79l-.17.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_199_'
              gradientUnits='userSpaceOnUse'
              x1={466.749}
              y1={246.057}
              x2={470.455}
              y2={246.057}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_199_)' d='M465.15 156.03v.79l3.7-2.15-.01-.78-.17.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M465.15 157.42v.58l3.53-2.05v-.58zM465.15 158.81v.58l3.54-2.05v-.59zM465.15 156.03v.59l3.52-2.05v-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_200_'
              gradientUnits='userSpaceOnUse'
              x1={-4258.798}
              y1={-4258.099}
              x2={-4253.958}
              y2={-4258.099}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M454.57 128.33c1.33-.77 3.5-.77 4.82 0 1.33.77 1.32 2.02-.01 2.79s-3.5.77-4.82 0c-1.33-.77-1.33-2.02.01-2.79'
              fill='url(#dataMigr_banner_svg__SVGID_200_)'
            />
            <path
              className='dataMigr_banner_svg__st25'
              d='M455.07 128.62c1.06-.61 2.77-.61 3.82 0 1.05.61 1.04 1.6-.01 2.21-1.06.61-2.77.61-3.82 0-1.05-.61-1.05-1.6.01-2.21'
            />
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_201_'
                gradientUnits='userSpaceOnUse'
                x1={-4258.218}
                y1={-4258.154}
                x2={-4253.958}
                y2={-4258.154}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M458.83 128.06c.03.01.06.02.09.04.01.01.03.01.04.02h.01c.06.03.13.06.19.09.01.01.03.01.04.02.06.03.13.06.18.1.33.19.58.41.74.65.04.06.08.12.11.18s.06.12.08.18c.04.12.06.25.06.37v.15c0-.5-.33-1-.99-1.39-.06-.03-.12-.07-.18-.1-.01-.01-.03-.01-.04-.02-.06-.03-.12-.06-.19-.09-.02-.01-.04-.01-.05-.02-.03-.01-.06-.02-.09-.04-.02-.01-.04-.02-.06-.02l-.09-.03c-.02-.01-.03-.01-.05-.02-.08-.03-.16-.05-.24-.07-.01 0-.03-.01-.04-.01-.07-.02-.14-.03-.21-.05h-.02c-.07-.01-.14-.03-.21-.04-.02 0-.04-.01-.05-.01-.06-.01-.12-.02-.18-.02h-.03c-.07-.01-.14-.01-.2-.02h-.05c-.05 0-.11-.01-.16-.01h-.53c-.07 0-.15.01-.22.01h-.03l-.23.03h-.03c-.09.01-.19.03-.28.05-.01 0-.02 0-.03.01-.12.02-.23.05-.35.08-.01 0-.02.01-.04.01-.07.02-.15.04-.22.07-.01 0-.01 0-.02.01-.07.02-.14.05-.21.08-.01.01-.03.01-.04.02-.07.03-.14.06-.2.09-.01.01-.02.01-.03.02-.07.03-.13.07-.2.11l-.15.09c-.01.01-.03.02-.04.03-.04.02-.07.05-.1.07-.01.01-.02.02-.04.03-.03.02-.06.05-.09.07-.01.01-.02.01-.02.02-.03.03-.07.06-.1.09l-.06.06-.02.02c-.03.03-.05.06-.07.08 0 0 0 .01-.01.01-.02.02-.04.05-.06.07-.01.01-.01.02-.02.03-.01.02-.02.03-.03.05-.03.04-.05.08-.07.12 0 .01-.01.01-.01.02-.02.03-.03.07-.04.1 0 .01-.01.02-.01.03-.01.04-.03.08-.04.12-.01.04-.02.08-.02.12v.03c0 .03-.01.07-.01.1v.03-.15-.02-.02c0-.03 0-.07.01-.1v-.03c.01-.04.01-.08.02-.12.01-.04.02-.08.04-.12v-.01c0-.01.01-.01.01-.02.01-.03.03-.07.04-.1 0-.01 0-.01.01-.02v-.01c.02-.04.04-.08.07-.12 0 0 0-.01.01-.01.01-.01.02-.02.03-.04.01-.01.01-.02.02-.03.02-.03.04-.05.06-.07 0 0 0-.01.01-.01.02-.03.05-.06.07-.08l.02-.02c.02-.02.03-.04.05-.05.03-.03.07-.06.1-.09.01-.01.02-.01.02-.02.03-.02.06-.05.09-.07l.01-.01c.01-.01.02-.01.02-.02l.1-.07c.01-.01.03-.02.04-.03l.15-.09c.06-.04.13-.07.2-.11.01-.01.02-.01.03-.02.07-.03.13-.06.2-.09.01-.01.03-.01.04-.02.07-.03.14-.06.21-.08.01 0 .01 0 .02-.01.07-.02.14-.05.22-.07.01 0 .01 0 .02-.01h.01c.06-.02.11-.03.17-.04.06-.01.12-.03.18-.04h.03c.09-.02.18-.03.28-.05h.02l.23-.03h.03c.07-.01.15-.01.22-.01h.53c.05 0 .11.01.16.01h.05c.07.01.14.01.2.02h.03c.06.01.12.02.18.02h.05c.07.01.14.02.21.04h.01c.07.01.14.03.21.05.01 0 .02 0 .03.01h.01c.08.02.16.04.24.07.01 0 .01 0 .02.01.01 0 .02.01.03.01l.09.03c.06.03.08.04.1.04z'
                fill='url(#dataMigr_banner_svg__SVGID_201_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_202_'
                gradientUnits='userSpaceOnUse'
                x1={-4259.053}
                y1={-4257.96}
                x2={-4254.574}
                y2={-4257.96}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M454.66 131.32c.07.03.13.06.2.09.02.01.04.02.06.02.03.01.06.03.1.04.02.01.04.02.07.02.03.01.06.02.1.03.02.01.04.01.05.02.08.03.17.05.25.07.01 0 .03.01.04.01.07.02.15.04.22.05h.02c.07.01.15.03.22.04.02 0 .04.01.06.01l.19.03h.03c.07.01.14.01.21.02h.06c.06 0 .12.01.17.01h.56c.08 0 .15-.01.23-.02h.04l.24-.03h.03c.1-.01.2-.03.29-.05.01 0 .02 0 .04-.01.06-.01.12-.03.18-.04.06-.01.12-.03.18-.05.01 0 .03-.01.04-.01.08-.02.15-.04.23-.07.01 0 .01 0 .02-.01.08-.03.15-.05.23-.08.01-.01.03-.01.04-.02l.21-.09c.01-.01.02-.01.04-.02.07-.04.14-.07.21-.11.05-.03.11-.06.16-.1.01-.01.03-.02.04-.03l.11-.08c.01-.01.03-.02.04-.03.03-.02.06-.05.09-.07.01-.01.02-.01.03-.02.04-.03.07-.06.11-.1l.06-.06.02-.02c.03-.03.05-.06.08-.09 0 0 0-.01.01-.01.02-.03.04-.05.06-.08.01-.01.01-.02.02-.03.01-.02.02-.03.03-.05.03-.04.05-.09.07-.13 0-.01.01-.01.01-.02.02-.04.03-.07.05-.11 0-.01.01-.02.01-.03.01-.04.03-.08.04-.13.01-.04.02-.08.02-.12v-.04c0-.03.01-.07.01-.1v-.03V129.88c0 .03 0 .07-.01.1v.04c-.01.04-.01.08-.02.12-.01.04-.02.08-.04.13v.01c0 .01-.01.01-.01.02-.01.04-.03.07-.05.11 0 .01 0 .01-.01.02v.01c-.02.04-.05.09-.07.13 0 0 0 .01-.01.01-.01.01-.02.03-.03.04s-.01.02-.02.03c-.02.03-.04.05-.06.08 0 0 0 .01-.01.01-.02.03-.05.06-.08.09l-.02.02c-.02.02-.04.04-.05.06-.03.03-.07.07-.11.1-.01.01-.02.01-.03.02-.03.02-.06.05-.09.07l-.01.01c-.01.01-.02.01-.03.02-.03.03-.07.05-.11.08-.01.01-.03.02-.04.03-.05.03-.1.06-.16.1-.07.04-.14.08-.21.11-.01.01-.02.01-.04.02l-.21.09c-.01.01-.03.01-.04.02-.07.03-.15.06-.23.08-.01 0-.01 0-.02.01-.07.03-.15.05-.23.07-.01 0-.02 0-.02.01h-.02c-.06.02-.12.03-.18.05-.06.01-.12.03-.18.04h-.04c-.1.02-.19.03-.29.05h-.03l-.24.03h-.03c-.08.01-.16.01-.24.02h-.56c-.06 0-.12-.01-.17-.01h-.06c-.07-.01-.14-.01-.21-.02h-.03l-.19-.03H456c-.07-.01-.15-.03-.22-.04h-.02c-.07-.02-.15-.03-.22-.05-.01 0-.02 0-.03-.01h-.01c-.09-.02-.17-.05-.25-.07-.01 0-.02 0-.02-.01-.01 0-.02-.01-.03-.01-.03-.01-.06-.02-.1-.03a.145.145 0 00-.07-.02c-.03-.01-.06-.03-.1-.04-.02-.01-.03-.01-.05-.02 0 0-.01 0-.01-.01-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.13-.07-.19-.1-.48-.28-.79-.61-.94-.97-.03-.06-.05-.13-.07-.2a.355.355 0 01-.02-.1c-.01-.07-.02-.13-.02-.2v-.15c0 .53.35 1.06 1.04 1.46.06.04.13.07.19.1.01.01.03.01.04.02z'
                fill='url(#dataMigr_banner_svg__SVGID_202_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_203_'
                gradientUnits='userSpaceOnUse'
                x1={-4258.928}
                y1={-4258.091}
                x2={-4253.833}
                y2={-4258.091}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M454.43 131.2c-1.4-.81-1.39-2.13.02-2.94 1.4-.81 3.68-.81 5.08 0s1.39 2.13-.02 2.94-3.69.81-5.08 0zm.14-2.87c-1.33.77-1.34 2.02-.01 2.79s3.49.77 4.82 0 1.34-2.02.01-2.79c-1.32-.77-3.49-.77-4.82 0'
                fill='url(#dataMigr_banner_svg__SVGID_203_)'
              />
            </g>
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_204_'
                gradientUnits='userSpaceOnUse'
                x1={-4254.963}
                y1={-4257.534}
                x2={-4255.914}
                y2={-4259.171}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M458.07 129.16c.01-.03.03-.06.04-.09.35-.74-1.03-1.06-1.1-1.07l-.44.93-.3.64c.04-.04.08-.07.13-.1.15-.09.35-.13.56-.14l1.11-.17z'
                fill='url(#dataMigr_banner_svg__SVGID_204_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_205_'
                gradientUnits='userSpaceOnUse'
                x1={-4254.864}
                y1={-4255.82}
                x2={-4256.239}
                y2={-4258.188}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M459.25 129.8c.57-.33.44-.86.44-.89l-1.61.25-1.11.17c.21 0 .42.04.57.14.31.18.31.47 0 .65a.75.75 0 01-.18.08c.07-.01.15-.02.24-.04.25-.04.58-.09.86-.13.05-.01.11-.02.16-.02.27-.05.48-.12.63-.21z'
                fill='url(#dataMigr_banner_svg__SVGID_205_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_206_'
                  gradientUnits='userSpaceOnUse'
                  x1={-4256.439}
                  y1={-4257.334}
                  x2={-4256.439}
                  y2={-4258.791}
                  gradientTransform='rotate(-60.025 1898.378 -6144.042)'
                >
                  <stop offset={0} stopColor='#7f64ff' />
                  <stop offset={0.484} stopColor='#7d62ff' />
                  <stop offset={0.752} stopColor='#775aff' />
                  <stop offset={0.967} stopColor='#6d4cff' />
                  <stop offset={1} stopColor='#6b49ff' />
                </linearGradient>
                <path
                  d='M457.54 130.12c.31-.18.31-.47 0-.65-.16-.09-.37-.14-.57-.14s-.4.05-.56.14c-.05.03-.1.06-.13.1-.14.14-.14.32.01.46.03.03.07.06.12.09.16.09.37.14.57.13.13 0 .26-.02.38-.06.06-.01.12-.04.18-.07z'
                  fill='url(#dataMigr_banner_svg__SVGID_206_)'
                />
              </g>
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_207_'
                  gradientUnits='userSpaceOnUse'
                  x1={-4255.714}
                  y1={-4255.4}
                  x2={-4256.856}
                  y2={-4257.368}
                  gradientTransform='rotate(-60.025 1898.378 -6144.042)'
                >
                  <stop offset={0.117} stopColor='#dddcf9' />
                  <stop offset={0.562} stopColor='#fff' />
                  <stop offset={0.708} stopColor='#f9f8fe' />
                  <stop offset={0.915} stopColor='#e6e6fb' />
                  <stop offset={1} stopColor='#dddcf9' />
                </linearGradient>
                <path
                  d='M459.64 130.71l-1.18-.68c-.29.04-.61.1-.86.13l-.23.5c.04.02.08.05.12.07.93.54 2.09.01 2.15-.02z'
                  fill='url(#dataMigr_banner_svg__SVGID_207_)'
                />
              </g>
            </g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_208_'
              gradientUnits='userSpaceOnUse'
              x1={-4256.227}
              y1={-4258.642}
              x2={-4257.369}
              y2={-4260.609}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M456.28 130.03c-.14-.14-.15-.32-.01-.46l.3-.64c-.04-.02-.08-.05-.12-.07-.93-.54-2.1-.01-2.16.02l1.18.68.81.47z'
              fill='url(#dataMigr_banner_svg__SVGID_208_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_209_'
              gradientUnits='userSpaceOnUse'
              x1={-4256.717}
              y1={-4257.896}
              x2={-4258.091}
              y2={-4260.263}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M456.98 130.26c-.21 0-.41-.04-.57-.13a.623.623 0 01-.12-.09l-.8-.47c-.05.01-.11.02-.16.02-.27.04-.47.11-.62.2-.57.33-.44.86-.44.89l1.61-.25 1.1-.17z'
              fill='url(#dataMigr_banner_svg__SVGID_209_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_210_'
                gradientUnits='userSpaceOnUse'
                x1={-4257.068}
                y1={-4256.973}
                x2={-4257.985}
                y2={-4258.554}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M456.93 131.6l.44-.93.23-.5c-.09.01-.17.03-.24.04-.12.04-.25.06-.38.06l-1.1.17c-.01.03-.03.06-.04.09-.35.73 1.02 1.05 1.09 1.07z'
                fill='url(#dataMigr_banner_svg__SVGID_210_)'
              />
            </g>
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_211_'
                gradientUnits='userSpaceOnUse'
                x1={-4257.114}
                y1={-4258.961}
                x2={-4252.528}
                y2={-4258.961}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
              </linearGradient>
              <path
                d='M454.75 126.61c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.16-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.1-.18.15-.37.15-.57z'
                fill='url(#dataMigr_banner_svg__SVGID_211_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_212_'
                gradientUnits='userSpaceOnUse'
                x1={-4255.716}
                y1={-4259.73}
                x2={-4251.129}
                y2={-4259.73}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0} stopColor='#2afadf' stopOpacity={0} />
                <stop offset={0.275} stopColor='#36d1ea' stopOpacity={0.165} />
                <stop offset={0.596} stopColor='#42a7f5' stopOpacity={0.358} />
                <stop offset={0.849} stopColor='#498dfc' stopOpacity={0.51} />
                <stop offset={1} stopColor='#4c83ff' stopOpacity={0.6} />
              </linearGradient>
              <path
                d='M454.78 125.02c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.16-.27.43-.53.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0l-.02-.04.02.04c-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.1-.19.15-.38.15-.57z'
                fill='url(#dataMigr_banner_svg__SVGID_212_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_213_'
                  gradientUnits='userSpaceOnUse'
                  x1={-4254.323}
                  y1={-4260.467}
                  x2={-4249.737}
                  y2={-4260.467}
                  gradientTransform='rotate(-60.025 1898.378 -6144.042)'
                >
                  <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                  <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                  <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                  <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
                </linearGradient>
                <path
                  d='M454.84 123.44c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.16-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0l-.02-.04.02.04c-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.1-.19.15-.38.15-.57z'
                  fill='url(#dataMigr_banner_svg__SVGID_213_)'
                />
              </g>
            </g>
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_214_'
              gradientUnits='userSpaceOnUse'
              x1={-4258.629}
              y1={-4251.127}
              x2={-4253.789}
              y2={-4251.127}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M460.69 131.67c1.33-.77 3.5-.77 4.82 0 1.33.77 1.32 2.02-.01 2.79s-3.5.77-4.82 0c-1.33-.77-1.32-2.02.01-2.79'
              fill='url(#dataMigr_banner_svg__SVGID_214_)'
            />
            <path
              className='dataMigr_banner_svg__st25'
              d='M461.19 131.96c1.06-.61 2.77-.61 3.82 0 1.05.61 1.04 1.6-.01 2.21-1.06.61-2.77.61-3.82 0-1.05-.61-1.04-1.6.01-2.21'
            />
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_215_'
                gradientUnits='userSpaceOnUse'
                x1={-4258.053}
                y1={-4251.17}
                x2={-4253.794}
                y2={-4251.17}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M464.96 131.4c.03.01.06.02.09.04.01.01.03.01.04.02h.01c.06.03.13.06.19.09.01.01.03.01.04.02.06.03.13.06.18.1.33.19.58.41.74.65.04.06.08.12.11.18s.06.12.08.18c.04.12.06.25.06.38v.15c0-.5-.33-1-.99-1.39-.06-.03-.12-.07-.18-.1-.01-.01-.03-.01-.04-.02-.06-.03-.13-.06-.19-.09-.02-.01-.04-.01-.05-.02-.03-.01-.06-.02-.09-.04-.02-.01-.04-.02-.06-.02l-.09-.03c-.02-.01-.03-.01-.05-.02-.08-.03-.16-.05-.24-.07-.01 0-.03-.01-.04-.01-.07-.02-.14-.03-.21-.05h-.02c-.07-.01-.14-.03-.21-.04-.02 0-.04-.01-.05-.01-.06-.01-.12-.02-.18-.02h-.03c-.07-.01-.14-.01-.2-.02h-.05c-.05 0-.11-.01-.16-.01h-.53c-.07 0-.15.01-.22.01h-.03l-.23.03h-.03c-.09.01-.19.03-.28.05-.01 0-.02 0-.03.01-.12.02-.23.05-.35.08-.01 0-.02.01-.04.01-.07.02-.15.04-.22.07-.01 0-.01 0-.02.01-.07.02-.14.05-.21.08-.01.01-.03.01-.04.02-.07.03-.14.06-.2.09-.01.01-.02.01-.03.02-.07.03-.13.07-.2.11l-.15.09c-.01.01-.03.02-.04.03-.04.02-.07.05-.1.07-.01.01-.02.02-.04.03-.03.02-.06.05-.09.07-.01.01-.02.01-.02.02-.03.03-.07.06-.1.09l-.06.06-.02.02c-.03.03-.05.06-.07.08 0 0 0 .01-.01.01-.02.02-.04.05-.06.07-.01.01-.01.02-.02.03-.01.02-.02.03-.03.05-.03.04-.05.08-.07.12 0 .01-.01.01-.01.02-.02.03-.03.07-.04.1 0 .01-.01.02-.01.03-.01.04-.03.08-.04.12-.01.04-.02.08-.02.12v.03c0 .03-.01.07-.01.1v.03-.15-.02-.02c0-.03 0-.07.01-.1v-.03c.01-.04.01-.08.02-.12.01-.04.02-.08.04-.12v-.01c0-.01.01-.01.01-.02.01-.03.03-.07.04-.1 0-.01 0-.01.01-.02v-.01c.02-.04.04-.08.07-.12 0 0 0-.01.01-.01.01-.01.02-.02.02-.04.01-.01.01-.02.02-.03.02-.03.04-.05.06-.07 0 0 0-.01.01-.01.02-.03.05-.06.07-.08l.02-.02c.02-.02.03-.04.05-.05.03-.03.06-.06.1-.09.01-.01.02-.01.02-.02.03-.02.06-.05.09-.07l.01-.01c.01-.01.02-.01.02-.02l.1-.07c.01-.01.03-.02.04-.03l.15-.09c.06-.04.13-.07.2-.11.01-.01.02-.01.03-.02.07-.03.13-.06.2-.09.01-.01.03-.01.04-.02.07-.03.14-.06.21-.08.01 0 .01 0 .02-.01.07-.02.14-.05.22-.07.01 0 .01 0 .02-.01h.01c.06-.02.11-.03.17-.04.06-.01.12-.03.17-.04h.03c.09-.02.18-.03.28-.05h.03l.23-.03h.03c.07-.01.15-.01.22-.01h.53c.05 0 .11.01.16.01h.05c.07.01.14.01.2.02h.03c.06.01.12.02.18.02h.05c.07.01.14.02.21.04h.02c.07.01.14.03.21.05.01 0 .02 0 .03.01h.01c.08.02.16.04.24.07.01 0 .01 0 .02.01.01 0 .02.01.03.01l.09.03c.05.02.08.03.1.03z'
                fill='url(#dataMigr_banner_svg__SVGID_215_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_216_'
                gradientUnits='userSpaceOnUse'
                x1={-4258.887}
                y1={-4250.977}
                x2={-4254.407}
                y2={-4250.977}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M460.79 134.66c.07.03.13.06.2.09.02.01.04.02.06.02.03.01.06.03.1.04.02.01.04.02.07.02.03.01.06.02.1.03.02.01.04.01.05.02.08.03.17.05.25.07.01 0 .03.01.04.01.07.02.15.04.22.05h.02c.07.01.15.03.22.04.02 0 .04.01.06.01l.19.03h.03c.07.01.14.01.21.02h.06c.06 0 .12.01.17.01h.56c.08 0 .15-.01.23-.02h.04l.24-.03h.03c.1-.01.2-.03.29-.05.01 0 .02 0 .04-.01.06-.01.12-.03.18-.04.06-.01.12-.03.18-.05.01 0 .03-.01.04-.01.08-.02.15-.04.23-.07.01 0 .01 0 .02-.01.08-.03.15-.05.23-.08.01-.01.03-.01.04-.02l.21-.09c.01-.01.02-.01.04-.02.07-.04.14-.07.21-.11.05-.03.11-.06.16-.1.01-.01.03-.02.04-.03l.11-.08c.01-.01.03-.02.04-.03.03-.02.06-.05.09-.07.01-.01.02-.01.03-.02.04-.03.07-.06.11-.1l.06-.06.02-.02c.03-.03.05-.06.08-.09 0 0 0-.01.01-.01.02-.03.04-.05.06-.08.01-.01.01-.02.02-.03.01-.02.02-.03.03-.05.03-.04.05-.09.07-.13 0-.01.01-.01.01-.02.02-.04.03-.07.05-.11 0-.01.01-.02.01-.03.01-.04.03-.08.04-.13.01-.04.02-.08.02-.12v-.04c0-.03.01-.07.01-.1v-.03V133.22c0 .03 0 .07-.01.1v.04c-.01.04-.01.08-.02.12-.01.04-.02.08-.04.13v.01c0 .01-.01.01-.01.02-.01.04-.03.07-.05.11 0 .01 0 .01-.01.02v.01c-.02.04-.05.09-.07.13 0 0 0 .01-.01.01-.01.01-.02.03-.03.04s-.01.02-.02.03c-.02.03-.04.05-.06.08 0 0 0 .01-.01.01-.02.03-.05.06-.08.09l-.02.02c-.02.02-.04.04-.05.06-.03.03-.07.07-.11.1-.01.01-.02.01-.03.02-.03.02-.06.05-.09.07l-.01.01c-.01.01-.02.01-.03.02-.03.03-.07.05-.11.08-.01.01-.03.02-.04.03-.05.03-.1.06-.16.1-.07.04-.14.08-.21.11-.01.01-.02.01-.04.02l-.21.09c-.01.01-.03.01-.04.02-.07.03-.15.06-.23.08-.01 0-.01 0-.02.01-.07.02-.15.05-.23.07-.01 0-.02.01-.02.01h-.02c-.06.02-.12.03-.18.05-.06.01-.12.03-.18.04h-.04c-.1.02-.19.03-.29.05h-.03l-.24.03h-.03c-.08.01-.15.01-.23.02h-.56c-.06 0-.12-.01-.17-.01h-.05c-.08-.01-.15-.01-.22-.02h-.03l-.19-.03h-.05c-.07-.01-.15-.03-.22-.04h-.02c-.07-.02-.15-.03-.22-.05-.01 0-.02 0-.03-.01h-.01c-.09-.02-.17-.05-.25-.07-.01 0-.02 0-.02-.01-.01 0-.02-.01-.03-.01-.03-.01-.06-.02-.1-.03a.145.145 0 00-.07-.02c-.03-.01-.06-.03-.1-.04-.02-.01-.03-.01-.05-.02 0 0-.01 0-.01-.01-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.13-.07-.19-.1-.48-.28-.79-.61-.94-.97-.03-.06-.05-.13-.07-.2a.355.355 0 01-.02-.1c-.01-.07-.02-.13-.02-.2v-.15c0 .53.35 1.06 1.04 1.46.06.04.13.07.19.1 0 .01.01.01.03.02z'
                fill='url(#dataMigr_banner_svg__SVGID_216_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_217_'
                gradientUnits='userSpaceOnUse'
                x1={-4258.763}
                y1={-4251.12}
                x2={-4253.668}
                y2={-4251.12}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M460.55 134.54c-1.4-.81-1.39-2.13.02-2.94 1.4-.81 3.68-.81 5.08 0s1.39 2.13-.02 2.94-3.68.81-5.08 0zm.14-2.87c-1.33.77-1.34 2.02-.01 2.79s3.49.77 4.82 0 1.34-2.02.01-2.79c-1.32-.77-3.48-.77-4.82 0'
                fill='url(#dataMigr_banner_svg__SVGID_217_)'
              />
            </g>
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_218_'
                gradientUnits='userSpaceOnUse'
                x1={-4254.796}
                y1={-4250.56}
                x2={-4255.747}
                y2={-4252.198}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M464.2 132.5c.01-.03.03-.06.04-.09.35-.74-1.03-1.06-1.1-1.07l-.44.93-.3.64c.04-.04.08-.07.13-.1.15-.09.35-.13.55-.14l1.12-.17z'
                fill='url(#dataMigr_banner_svg__SVGID_218_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_219_'
                gradientUnits='userSpaceOnUse'
                x1={-4254.698}
                y1={-4248.846}
                x2={-4256.072}
                y2={-4251.214}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M465.37 133.14c.57-.33.44-.86.44-.89l-1.61.25-1.11.17c.21 0 .42.04.57.14.31.18.31.47 0 .65a.75.75 0 01-.18.08c.07-.01.15-.02.24-.04.25-.04.58-.09.86-.13.05-.01.11-.02.16-.02.28-.05.48-.12.63-.21z'
                fill='url(#dataMigr_banner_svg__SVGID_219_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_220_'
                  gradientUnits='userSpaceOnUse'
                  x1={-4256.272}
                  y1={-4250.36}
                  x2={-4256.272}
                  y2={-4251.817}
                  gradientTransform='rotate(-60.025 1898.378 -6144.042)'
                >
                  <stop offset={0} stopColor='#7f64ff' />
                  <stop offset={0.484} stopColor='#7d62ff' />
                  <stop offset={0.752} stopColor='#775aff' />
                  <stop offset={0.967} stopColor='#6d4cff' />
                  <stop offset={1} stopColor='#6b49ff' />
                </linearGradient>
                <path
                  d='M463.66 133.46c.31-.18.31-.47 0-.65-.16-.09-.37-.14-.57-.14s-.4.05-.55.14c-.05.03-.1.06-.13.1-.14.14-.14.32.01.46.03.03.07.06.12.09.16.09.37.14.57.13.13 0 .26-.02.38-.06.06-.01.12-.03.17-.07z'
                  fill='url(#dataMigr_banner_svg__SVGID_220_)'
                />
              </g>
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_221_'
                  gradientUnits='userSpaceOnUse'
                  x1={-4255.548}
                  y1={-4248.427}
                  x2={-4256.69}
                  y2={-4250.394}
                  gradientTransform='rotate(-60.025 1898.378 -6144.042)'
                >
                  <stop offset={0.117} stopColor='#dddcf9' />
                  <stop offset={0.562} stopColor='#fff' />
                  <stop offset={0.708} stopColor='#f9f8fe' />
                  <stop offset={0.915} stopColor='#e6e6fb' />
                  <stop offset={1} stopColor='#dddcf9' />
                </linearGradient>
                <path
                  d='M465.77 134.05l-1.18-.68c-.29.04-.61.1-.86.13l-.23.5c.04.02.08.05.12.07.92.54 2.09.01 2.15-.02z'
                  fill='url(#dataMigr_banner_svg__SVGID_221_)'
                />
              </g>
            </g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_222_'
              gradientUnits='userSpaceOnUse'
              x1={-4256.061}
              y1={-4251.669}
              x2={-4257.203}
              y2={-4253.636}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M462.41 133.37c-.14-.14-.15-.32-.01-.46l.3-.64c-.04-.02-.08-.05-.12-.07-.93-.54-2.1-.01-2.16.02l1.18.68.81.47z'
              fill='url(#dataMigr_banner_svg__SVGID_222_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_223_'
              gradientUnits='userSpaceOnUse'
              x1={-4256.551}
              y1={-4250.923}
              x2={-4257.924}
              y2={-4253.289}
              gradientTransform='rotate(-60.025 1898.378 -6144.042)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M463.1 133.6c-.21 0-.41-.04-.57-.13a.623.623 0 01-.12-.09l-.8-.47c-.05.01-.11.02-.16.02-.27.04-.47.11-.62.2-.57.33-.44.86-.44.89l1.61-.25 1.1-.17z'
              fill='url(#dataMigr_banner_svg__SVGID_223_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_224_'
                gradientUnits='userSpaceOnUse'
                x1={-4256.901}
                y1={-4249.998}
                x2={-4257.818}
                y2={-4251.58}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M463.06 134.94l.44-.93.23-.5c-.09.01-.17.03-.24.04-.12.04-.25.06-.38.06l-1.1.17c-.01.03-.03.06-.04.09-.36.74 1.01 1.05 1.09 1.07z'
                fill='url(#dataMigr_banner_svg__SVGID_224_)'
              />
            </g>
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_225_'
                gradientUnits='userSpaceOnUse'
                x1={-4256.95}
                y1={-4251.99}
                x2={-4252.363}
                y2={-4251.99}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
              </linearGradient>
              <path
                d='M460.87 129.95c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.17-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.1-.18.15-.37.15-.57z'
                fill='url(#dataMigr_banner_svg__SVGID_225_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_226_'
                gradientUnits='userSpaceOnUse'
                x1={-4255.553}
                y1={-4252.75}
                x2={-4250.966}
                y2={-4252.75}
                gradientTransform='rotate(-60.025 1898.378 -6144.042)'
              >
                <stop offset={0} stopColor='#2afadf' stopOpacity={0} />
                <stop offset={0.275} stopColor='#36d1ea' stopOpacity={0.165} />
                <stop offset={0.596} stopColor='#42a7f5' stopOpacity={0.358} />
                <stop offset={0.849} stopColor='#498dfc' stopOpacity={0.51} />
                <stop offset={1} stopColor='#4c83ff' stopOpacity={0.6} />
              </linearGradient>
              <path
                d='M460.91 128.36c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.16-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0l-.02-.04.02.04c-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.09-.19.15-.38.15-.57z'
                fill='url(#dataMigr_banner_svg__SVGID_226_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_227_'
                  gradientUnits='userSpaceOnUse'
                  x1={-4254.154}
                  y1={-4253.496}
                  x2={-4249.568}
                  y2={-4253.496}
                  gradientTransform='rotate(-60.025 1898.378 -6144.042)'
                >
                  <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                  <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                  <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                  <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
                </linearGradient>
                <path
                  d='M460.96 126.78c1.25-.72 3.29-.72 4.53 0 .61.35.94.83.94 1.33 0 .51-.34.99-.96 1.34-1.25.72-3.29.73-4.53 0-.61-.35-.94-.83-.94-1.33 0-.21.06-.41.17-.61.17-.27.43-.52.79-.73zm5.39 1.33c0-.47-.32-.92-.9-1.26-1.22-.71-3.22-.71-4.45 0l-.02-.04.02.04c-.59.34-.91.79-.91 1.27 0 .47.32.92.9 1.26 1.22.71 3.22.71 4.45 0 .35-.2.61-.44.76-.7.1-.19.15-.38.15-.57z'
                  fill='url(#dataMigr_banner_svg__SVGID_227_)'
                />
              </g>
            </g>
          </g>
        </g>
        <g className='dataMigr_banner_svg__st233'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_228_'
            gradientUnits='userSpaceOnUse'
            x1={-4234.022}
            y1={-4245.293}
            x2={-4226.107}
            y2={-4249.888}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M481.07 107.92c.03.01.06.02.09.04.01.01.03.01.04.02h.01c.06.03.13.06.19.09.01.01.03.01.04.02.06.03.12.06.18.1.66.38.99.88.99 1.39l.02 7.17c0-.5-.33-1-.99-1.39-.06-.03-.12-.07-.18-.1-.01-.01-.03-.01-.04-.02-.06-.03-.12-.06-.19-.09-.02-.01-.04-.01-.05-.02-.03-.01-.06-.02-.09-.04-.02-.01-.04-.02-.06-.02l-.09-.03c-.02-.01-.03-.01-.05-.02-.08-.03-.16-.05-.24-.07-.01 0-.03-.01-.04-.01-.07-.02-.14-.03-.21-.05h-.02c-.07-.01-.14-.03-.21-.04-.02 0-.04-.01-.05-.01-.06-.01-.12-.02-.18-.02h-.03c-.07-.01-.14-.01-.2-.02h-.05c-.05 0-.11-.01-.16-.01h-.53c-.07 0-.15.01-.22.01h-.03l-.23.03h-.03c-.09.01-.19.03-.28.05-.01 0-.02 0-.03.01-.06.01-.12.02-.17.04-.06.01-.11.03-.17.04-.01 0-.02.01-.04.01-.07.02-.15.04-.22.07-.01 0-.01 0-.02.01-.07.02-.14.05-.21.08-.01.01-.03.01-.04.02-.07.03-.14.06-.2.09-.01.01-.02.01-.03.02-.07.03-.13.07-.2.11l-.15.09c-.01.01-.03.02-.04.03-.04.02-.07.05-.1.07-.01.01-.02.02-.04.03-.03.02-.06.05-.09.07-.01.01-.02.01-.02.02-.03.03-.07.06-.1.09l-.06.06-.02.02c-.03.03-.05.06-.07.08l-.01.01c-.02.02-.04.05-.06.08-.01.01-.01.02-.02.03-.01.02-.02.03-.03.05-.03.04-.05.08-.07.12 0 .01-.01.01-.01.02-.02.03-.03.07-.04.1 0 .01-.01.02-.01.03-.01.04-.03.08-.04.12-.01.04-.02.08-.02.12v.03c0 .03-.01.07-.01.1v.03l-.02-7.17v-.02-.02c0-.03 0-.07.01-.1v-.03c.01-.04.01-.08.02-.12.01-.04.02-.08.04-.12v-.01c0-.01.01-.01.01-.02.01-.03.03-.07.04-.1 0-.01 0-.01.01-.02v-.01c.02-.04.04-.08.07-.12 0 0 0-.01.01-.01.01-.01.02-.02.02-.04.01-.01.01-.02.02-.03.02-.03.04-.05.06-.08l.01-.01c.02-.03.05-.06.07-.08l.02-.02c.02-.02.03-.04.05-.05.03-.03.06-.06.1-.09.01-.01.02-.01.02-.02.03-.02.06-.05.09-.07l.01-.01c.01-.01.02-.01.02-.02l.1-.07c.01-.01.03-.02.04-.03l.15-.09c.06-.04.13-.07.2-.11.01-.01.02-.01.03-.02.07-.03.13-.06.2-.09.01-.01.03-.01.04-.02.07-.03.14-.05.21-.08.01 0 .01 0 .02-.01.07-.02.14-.05.22-.07.01 0 .01 0 .02-.01h.01c.06-.02.11-.03.17-.04.06-.01.12-.03.17-.04h.03c.09-.02.18-.03.28-.05h.03l.23-.03h.03c.07-.01.15-.01.22-.01h.53c.05 0 .11.01.16.01h.05c.07.01.14.01.2.02h.03c.06.01.12.02.18.02h.05c.07.01.14.02.21.04h.02c.07.01.14.03.21.05.01 0 .02 0 .03.01h.01c.08.02.16.04.24.07.01 0 .01 0 .02.01.01 0 .02.01.03.01l.09.03c.05.02.07.03.09.03z'
            fill='url(#dataMigr_banner_svg__SVGID_228_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_229_'
            gradientUnits='userSpaceOnUse'
            x1={-4235.728}
            y1={-4244.28}
            x2={-4227.804}
            y2={-4248.879}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M481.92 110.79c.01-.01.02-.02.04-.03.03-.02.06-.05.09-.07.01-.01.02-.01.02-.02.04-.03.07-.06.1-.09l.06-.06.02-.02a.55.55 0 00.07-.09l.01-.01c.02-.02.04-.05.06-.08.01-.01.01-.02.02-.03.01-.02.02-.03.03-.05.03-.04.05-.08.07-.12 0-.01.01-.01.01-.02.02-.03.03-.07.04-.1 0-.01.01-.02.01-.03.01-.04.03-.08.04-.12.01-.04.02-.08.02-.12v-.03c0-.03.01-.07.01-.1v-.03l.02 7.17v.04c0 .03 0 .07-.01.1v.03c-.01.04-.01.08-.02.12-.01.04-.02.08-.04.12v.01c0 .01-.01.01-.01.02-.01.03-.03.07-.04.1 0 .01 0 .01-.01.02v.01c-.02.04-.04.08-.07.12 0 0 0 .01-.01.01-.01.01-.02.02-.03.04-.01.01-.01.02-.02.03-.02.03-.04.05-.06.08l-.01.01c-.02.03-.05.06-.07.08l-.02.02c-.02.02-.03.04-.05.05-.03.03-.07.06-.1.09-.01.01-.02.01-.02.02-.03.02-.06.05-.09.07l-.01.01c-.01.01-.02.01-.02.02l-.1.07c-.01.01-.03.02-.04.03l-.15.09c-.06.04-.13.07-.2.11-.01.01-.02.01-.03.02-.07.03-.13.06-.2.09-.01.01-.03.01-.04.02-.07.03-.14.06-.22.08-.01 0-.01 0-.02.01-.07.02-.14.05-.22.07-.01 0-.01 0-.02.01h-.01c-.06.02-.11.03-.17.04-.06.01-.12.03-.18.04h-.04c-.09.02-.19.03-.28.05H480l-.23.03h-.03c-.07.01-.15.01-.22.01h-.48-.05c-.05 0-.11-.01-.16-.01h-.05c-.07-.01-.14-.01-.2-.02h-.03c-.06-.01-.12-.02-.18-.02h-.05c-.07-.01-.14-.02-.21-.04h-.01c-.07-.01-.14-.03-.21-.05-.01 0-.02 0-.03-.01h-.01c-.08-.02-.16-.04-.24-.07-.01 0-.01 0-.02-.01-.01 0-.02-.01-.03-.01l-.09-.03c-.02-.01-.04-.02-.06-.02-.03-.01-.06-.02-.09-.04-.01-.01-.03-.01-.04-.02h-.01c-.06-.03-.13-.06-.19-.09-.01-.01-.03-.01-.04-.02-.06-.03-.13-.06-.19-.1-.66-.38-.99-.89-1-1.39l-.02-7.17c0 .51.33 1.01 1 1.39.06.03.12.07.19.1.01.01.03.01.04.02.06.03.13.06.19.09.02.01.04.01.05.02.03.01.06.02.09.04.02.01.04.02.06.02l.09.03c.02.01.03.01.05.02.08.03.16.05.24.07.01 0 .03.01.04.01.07.02.14.03.21.05h.02c.07.01.14.03.21.04.02 0 .04.01.05.01.06.01.12.02.18.02h.03c.07.01.14.01.2.02h.05c.05 0 .11.01.16.01h.53c.07 0 .15-.01.22-.01h.03l.23-.03h.03c.09-.01.19-.03.28-.05.01 0 .02 0 .04-.01.06-.01.12-.02.17-.04.06-.01.12-.03.17-.04.01 0 .02-.01.04-.01.07-.02.15-.04.22-.07.01 0 .01 0 .02-.01.07-.02.14-.05.22-.08.01-.01.03-.01.04-.02.07-.03.14-.06.2-.09.01-.01.02-.01.03-.02.07-.03.13-.07.2-.11l.15-.09c.01-.01.03-.02.04-.03.01-.02.05-.04.08-.07z'
            fill='url(#dataMigr_banner_svg__SVGID_229_)'
          />
        </g>
        <g className='dataMigr_banner_svg__st233'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_230_'
            gradientUnits='userSpaceOnUse'
            x1={-4233.859}
            y1={-4238.322}
            x2={-4225.952}
            y2={-4242.912}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M487.19 111.26c.03.01.06.02.09.04.01.01.03.01.04.02h.01c.06.03.13.06.19.09.01.01.03.01.04.02.06.03.12.06.18.1.66.38.99.88.99 1.39l.02 7.17c0-.5-.33-1-.99-1.39-.06-.03-.12-.07-.18-.1-.01-.01-.03-.01-.04-.02-.06-.03-.12-.06-.19-.09-.02-.01-.04-.01-.05-.02-.03-.01-.06-.02-.09-.04-.02-.01-.04-.02-.06-.02l-.09-.03c-.02-.01-.03-.01-.05-.02-.08-.03-.16-.05-.24-.07-.01 0-.03-.01-.04-.01-.07-.02-.14-.03-.21-.05h-.02c-.07-.01-.14-.03-.21-.04-.02 0-.04-.01-.05-.01-.06-.01-.12-.02-.18-.02h-.03c-.07-.01-.14-.01-.2-.02h-.05c-.05 0-.11-.01-.16-.01h-.53c-.07 0-.15.01-.22.01h-.03l-.23.03h-.03c-.09.01-.19.03-.28.05-.01 0-.02 0-.03.01-.06.01-.12.02-.17.04-.06.01-.11.03-.17.04-.01 0-.02.01-.04.01-.07.02-.15.04-.22.07-.01 0-.01 0-.02.01-.07.02-.14.05-.21.08-.01.01-.03.01-.04.02-.07.03-.14.06-.2.09-.01.01-.02.01-.03.02-.07.03-.13.07-.2.11l-.15.09c-.01.01-.03.02-.04.03-.04.02-.07.05-.1.07-.01.01-.02.02-.04.03-.03.02-.06.05-.09.07-.01.01-.02.01-.02.02-.03.03-.07.06-.1.09l-.06.06-.02.02c-.03.03-.05.06-.07.08l-.01.01c-.02.02-.04.05-.06.08-.01.01-.01.02-.02.03-.01.02-.02.03-.03.05-.03.04-.05.08-.07.12 0 .01-.01.01-.01.02-.02.03-.03.07-.04.1 0 .01-.01.02-.01.03-.01.04-.03.08-.04.12-.01.04-.02.08-.02.12v.03c0 .03-.01.07-.01.1v.03l-.02-7.17v-.01-.02c0-.03 0-.07.01-.1v-.03c.01-.04.01-.08.02-.12.01-.04.02-.08.04-.12v-.01c0-.01.01-.01.01-.02.01-.03.03-.07.04-.1 0-.01 0-.01.01-.02v-.01c.02-.04.04-.08.07-.12 0 0 0-.01.01-.01.01-.01.02-.02.02-.04.01-.01.01-.02.02-.03.02-.03.04-.05.06-.08l.01-.01c.02-.03.05-.06.07-.08l.02-.02c.02-.02.03-.04.05-.05.03-.03.06-.06.1-.09.01-.01.02-.01.02-.02.03-.02.06-.05.09-.07l.01-.01c.01-.01.02-.01.02-.02l.1-.07c.01-.01.03-.02.04-.03l.15-.09c.06-.04.13-.07.2-.11.01-.01.02-.01.03-.02.07-.03.13-.06.2-.09.01-.01.03-.01.04-.02.07-.03.14-.06.21-.08.01 0 .01 0 .02-.01.07-.02.14-.05.22-.07.01 0 .01 0 .02-.01h.01c.06-.02.11-.03.17-.04.06-.01.12-.03.17-.04h.03c.09-.02.18-.03.28-.05h.03l.23-.03h.03c.07-.01.15-.01.22-.01h.53c.05 0 .11.01.16.01h.05c.07.01.14.01.2.02h.03c.06.01.12.02.18.02h.05c.07.01.14.02.21.04h.02c.07.01.14.03.21.05.01 0 .02 0 .03.01h.01c.08.02.16.04.24.07.01 0 .01 0 .02.01.01 0 .02.01.03.01l.09.03c.05.01.07.02.09.02z'
            fill='url(#dataMigr_banner_svg__SVGID_230_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_231_'
            gradientUnits='userSpaceOnUse'
            x1={-4235.562}
            y1={-4237.305}
            x2={-4227.638}
            y2={-4241.904}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M488.04 114.13c.01-.01.02-.02.04-.03.03-.02.06-.05.09-.07.01-.01.02-.01.02-.02.04-.03.07-.06.1-.09l.06-.06.02-.02a.55.55 0 00.07-.09l.01-.01c.02-.02.04-.05.06-.08.01-.01.01-.02.02-.03.01-.02.02-.03.03-.05.03-.04.05-.08.07-.12 0-.01.01-.01.01-.02.02-.03.03-.07.04-.1 0-.01.01-.02.01-.03.01-.04.03-.08.04-.12.01-.04.02-.08.02-.12v-.03c0-.03.01-.07.01-.1v-.03l.02 7.17v.04c0 .03 0 .07-.01.1v.03c-.01.04-.01.08-.02.12-.01.04-.02.08-.04.12v.01c0 .01-.01.01-.01.02-.01.03-.03.07-.04.1 0 .01 0 .01-.01.02v.01c-.02.04-.04.08-.07.12 0 0 0 .01-.01.01-.01.01-.02.02-.03.04-.01.01-.01.02-.02.03-.02.03-.04.05-.06.08l-.01.01c-.02.03-.05.06-.07.08l-.02.02c-.02.02-.03.04-.05.05-.03.03-.07.06-.1.09-.01.01-.02.01-.02.02-.03.02-.06.05-.09.07l-.01.01c-.01.01-.02.01-.02.02l-.1.07c-.01.01-.03.02-.04.03l-.15.09c-.06.04-.13.07-.2.11-.01.01-.02.01-.03.02-.07.03-.13.06-.2.09-.01.01-.03.01-.04.02-.07.03-.14.06-.22.08-.01 0-.01 0-.02.01-.07.02-.14.05-.22.07-.01 0-.01 0-.02.01h-.01c-.06.02-.11.03-.17.04-.06.01-.12.03-.18.04h-.04c-.09.02-.19.03-.28.05h-.03l-.23.03h-.03c-.07.01-.15.01-.22.01h-.53c-.05 0-.11-.01-.16-.01h-.05c-.07-.01-.14-.01-.2-.02h-.02c-.06-.01-.12-.02-.18-.02h-.05c-.07-.01-.14-.02-.21-.04h-.01c-.07-.01-.14-.03-.21-.05-.01 0-.02 0-.03-.01h-.01c-.08-.02-.16-.04-.24-.07-.01 0-.01 0-.02-.01-.01 0-.02-.01-.03-.01l-.09-.03c-.02-.01-.04-.02-.06-.02-.03-.01-.06-.02-.09-.04-.01-.01-.03-.01-.04-.02h-.01c-.06-.03-.13-.06-.19-.09-.01-.01-.03-.01-.04-.02-.06-.03-.13-.06-.19-.1-.66-.38-.99-.89-1-1.39l-.02-7.17c0 .51.33 1.01 1 1.39.06.03.12.07.19.1.01.01.03.01.04.02.06.03.13.06.19.09.02.01.04.01.05.02.03.01.06.02.09.04.02.01.04.02.06.02l.09.03c.02.01.03.01.05.02.08.03.16.05.24.07.01 0 .03.01.04.01.07.02.14.03.21.05h.02c.07.01.14.03.21.04.02 0 .04.01.05.01.06.01.12.02.18.02h.03c.07.01.14.01.2.02h.05c.05 0 .11.01.16.01h.53c.07 0 .15-.01.22-.01h.03l.23-.03h.03c.09-.01.19-.03.28-.05.01 0 .02 0 .04-.01.06-.01.12-.02.17-.04.06-.01.12-.03.17-.04.01 0 .02-.01.04-.01.07-.02.15-.04.22-.07.01 0 .01 0 .02-.01.07-.02.14-.05.22-.08.01-.01.03-.01.04-.02.07-.03.14-.06.2-.09.01-.01.02-.01.03-.02.07-.03.13-.07.2-.11l.15-.09c.01-.01.03-.02.04-.03.01-.02.04-.04.07-.07z'
            fill='url(#dataMigr_banner_svg__SVGID_231_)'
          />
        </g>
        <g className='dataMigr_banner_svg__st233'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_232_'
            gradientUnits='userSpaceOnUse'
            x1={-4245.19}
            y1={-4251.713}
            x2={-4237.277}
            y2={-4256.306}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M469.93 114.39c.03.01.06.02.09.04.01.01.03.01.04.02h.01c.06.03.13.06.19.09.01.01.03.01.04.02.06.03.12.06.18.1.66.38.99.88.99 1.39l.02 7.17c0-.5-.33-1-.99-1.39-.06-.03-.12-.07-.18-.1-.01-.01-.03-.01-.04-.02-.06-.03-.12-.06-.19-.09-.02-.01-.04-.01-.05-.02-.03-.01-.06-.02-.09-.04-.02-.01-.04-.02-.06-.02l-.09-.03c-.02-.01-.03-.01-.05-.02-.08-.03-.16-.05-.24-.07-.01 0-.03-.01-.04-.01-.07-.02-.14-.03-.21-.05h-.02c-.07-.01-.14-.03-.21-.04-.02 0-.04-.01-.05-.01-.06-.01-.12-.02-.18-.02h-.03c-.07-.01-.14-.01-.2-.02h-.05c-.05 0-.11-.01-.16-.01h-.53c-.07 0-.15.01-.22.01h-.03l-.23.03h-.03c-.09.01-.19.03-.28.05-.01 0-.02 0-.03.01-.06.01-.12.02-.17.04-.06.01-.11.03-.17.04-.01 0-.02.01-.04.01-.07.02-.15.04-.22.07-.01 0-.01 0-.02.01-.07.02-.14.05-.21.08-.01.01-.03.01-.04.02-.07.03-.14.06-.2.09-.01.01-.02.01-.03.02-.07.03-.13.07-.2.11l-.15.09c-.01.01-.03.02-.04.03-.04.02-.07.05-.1.07-.01.01-.02.02-.04.03-.03.02-.06.05-.09.07-.01.01-.02.01-.02.02-.03.03-.07.06-.1.09l-.06.06-.02.02c-.03.03-.05.06-.07.08l-.01.01c-.02.02-.04.05-.06.08-.01.01-.01.02-.02.03-.01.02-.02.03-.03.05-.03.04-.05.08-.07.12 0 .01-.01.01-.01.02-.02.03-.03.07-.04.1 0 .01-.01.02-.01.03-.01.04-.03.08-.04.12-.01.04-.02.08-.02.12v.03c0 .03-.01.07-.01.1v.03l-.02-7.17v-.02-.02c0-.03 0-.07.01-.1v-.03c.01-.04.01-.08.02-.12.01-.04.02-.08.04-.12v-.01c0-.01.01-.01.01-.02.01-.03.03-.07.04-.1 0-.01 0-.01.01-.02v-.01c.02-.04.04-.08.07-.12 0 0 0-.01.01-.01.01-.01.02-.02.02-.04.01-.01.01-.02.02-.03.02-.03.04-.05.06-.08l.01-.01c.02-.03.05-.06.07-.08l.02-.02c.02-.02.03-.04.05-.05.03-.03.06-.06.1-.09.01-.01.02-.01.02-.02.03-.02.06-.05.09-.07l.01-.01c.01-.01.02-.01.02-.02l.1-.07c.01-.01.03-.02.04-.03l.15-.09c.06-.04.13-.07.2-.11.01-.01.02-.01.03-.02.07-.03.13-.06.2-.09.01-.01.03-.01.04-.02.07-.03.14-.06.21-.08.01 0 .01 0 .02-.01.07-.02.14-.05.22-.07.01 0 .01 0 .02-.01h.01c.06-.02.11-.03.17-.04.06-.01.12-.03.17-.04h.03c.09-.02.18-.03.28-.05h.03l.23-.03h.03c.08-.01.15-.01.22-.02h.53c.05 0 .11.01.16.01h.04c.07.01.14.01.21.02h.02c.06.01.12.02.18.02h.05c.07.01.14.02.21.04h.01c.07.01.14.03.21.05.01 0 .02 0 .03.01h.01c.08.02.16.04.24.07.01 0 .01 0 .02.01.01 0 .02.01.03.01l.09.03c.07.02.09.03.11.04z'
            fill='url(#dataMigr_banner_svg__SVGID_232_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_233_'
            gradientUnits='userSpaceOnUse'
            x1={-4246.896}
            y1={-4250.694}
            x2={-4238.972}
            y2={-4255.293}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M470.78 117.26c.01-.01.02-.02.04-.03.03-.02.06-.05.09-.07.01-.01.02-.01.02-.02.04-.03.07-.06.1-.09l.06-.06.02-.02a.55.55 0 00.07-.09l.01-.01c.02-.02.04-.05.06-.08.01-.01.01-.02.02-.03.01-.02.02-.03.03-.05.03-.04.05-.08.07-.12 0-.01.01-.01.01-.02.02-.03.03-.07.04-.1 0-.01.01-.02.01-.03.01-.04.03-.08.04-.12.01-.04.02-.08.02-.12v-.03c0-.03.01-.07.01-.1v-.03l.02 7.17v.04c0 .03 0 .07-.01.1v.03c-.01.04-.01.08-.02.12-.01.04-.02.08-.04.12v.01c0 .01-.01.01-.01.02-.01.03-.03.07-.04.1 0 .01 0 .01-.01.02v.01c-.02.04-.04.08-.07.12 0 0 0 .01-.01.01-.01.01-.02.02-.03.04-.01.01-.01.02-.02.03-.02.03-.04.05-.06.08l-.01.01c-.02.03-.05.06-.07.08l-.02.02c-.02.02-.03.04-.05.05-.03.03-.07.06-.1.09-.01.01-.02.01-.02.02-.03.02-.06.05-.09.07l-.01.01c-.01.01-.02.01-.02.02l-.1.07c-.01.01-.03.02-.04.03l-.15.09c-.06.04-.13.07-.2.11-.01.01-.02.01-.03.02-.07.03-.13.06-.2.09-.01.01-.03.01-.04.02-.07.03-.14.06-.22.08-.01 0-.01 0-.02.01-.07.02-.14.05-.22.07-.01 0-.01 0-.02.01h-.01c-.06.02-.11.03-.17.04-.06.01-.12.03-.18.04h-.04c-.09.02-.19.03-.28.05h-.03l-.23.03h-.03c-.08.01-.15.01-.22.02h-.53c-.05 0-.11-.01-.16-.01h-.05c-.07-.01-.14-.01-.2-.02h-.02c-.06-.01-.12-.02-.18-.02h-.05c-.07-.01-.14-.02-.21-.04h-.01c-.07-.01-.14-.03-.21-.05-.01 0-.02 0-.03-.01h-.01c-.08-.02-.16-.04-.24-.07-.01 0-.01 0-.02-.01-.01 0-.02-.01-.03-.01l-.09-.03c-.02-.01-.04-.02-.06-.02-.03-.01-.06-.02-.09-.04-.01-.01-.03-.01-.04-.02h-.01c-.06-.03-.13-.06-.19-.09-.01-.01-.03-.01-.04-.02-.06-.03-.13-.06-.19-.1-.66-.38-.99-.89-1-1.39l-.02-7.17c0 .51.33 1.01 1 1.39.06.03.12.07.19.1.01.01.03.01.04.02.06.03.13.06.19.09.02.01.04.01.05.02.03.01.06.02.09.04.02.01.04.02.06.02l.09.03c.02.01.03.01.05.02.08.03.16.05.24.07.01 0 .03.01.04.01.07.02.14.03.21.05h.02c.07.01.14.03.21.04.02 0 .04.01.05.01.06.01.12.02.18.02h.03c.07.01.14.01.2.02h.05c.05 0 .11.01.16.01h.53c.07 0 .15-.01.22-.01h.03l.23-.03h.03c.09-.01.19-.03.28-.05.01 0 .02 0 .04-.01.06-.01.12-.02.17-.04.06-.01.12-.03.17-.04.01 0 .02-.01.04-.01.07-.02.15-.04.22-.07.01 0 .01 0 .02-.01.07-.02.14-.05.22-.08.01-.01.03-.01.04-.02.07-.03.14-.06.2-.09.01-.01.02-.01.03-.02.07-.03.13-.07.2-.11l.15-.09c.01-.01.03-.02.04-.03.01-.03.04-.06.07-.08z'
            fill='url(#dataMigr_banner_svg__SVGID_233_)'
          />
        </g>
        <g className='dataMigr_banner_svg__st233'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_234_'
            gradientUnits='userSpaceOnUse'
            x1={-4245.021}
            y1={-4244.733}
            x2={-4237.109}
            y2={-4249.326}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M476.06 117.73c.03.01.06.02.09.04.01.01.03.01.04.02h.01c.06.03.13.06.19.09.01.01.03.01.04.02.06.03.12.06.18.1.66.38.99.88.99 1.39l.02 7.17c0-.5-.33-1-.99-1.39-.06-.03-.12-.07-.18-.1-.01-.01-.03-.01-.04-.02-.06-.03-.12-.06-.19-.09-.02-.01-.04-.01-.05-.02-.03-.01-.06-.02-.09-.04-.02-.01-.04-.02-.06-.02l-.09-.03c-.02-.01-.03-.01-.05-.02-.08-.03-.16-.05-.24-.07-.01 0-.03-.01-.04-.01-.07-.02-.14-.03-.21-.05h-.02c-.07-.01-.14-.03-.21-.04-.02 0-.04-.01-.05-.01-.06-.01-.12-.02-.18-.02h-.03c-.07-.01-.14-.01-.2-.02h-.05c-.05 0-.11-.01-.16-.01h-.53c-.07 0-.15.01-.22.01h-.03l-.23.03h-.03c-.09.01-.19.03-.28.05-.01 0-.02 0-.03.01-.06.01-.12.02-.17.04-.06.01-.11.03-.17.04-.01 0-.02.01-.04.01-.07.02-.15.04-.22.07-.01 0-.01 0-.02.01-.07.02-.14.05-.21.08-.01.01-.03.01-.04.02-.07.03-.14.06-.2.09-.01.01-.02.01-.03.02-.07.03-.13.07-.2.11l-.15.09c-.01.01-.03.02-.04.03-.04.02-.07.05-.1.07-.01.01-.02.02-.04.03-.03.02-.06.05-.09.07-.01.01-.02.01-.02.02-.03.03-.07.06-.1.09l-.06.06-.02.02c-.03.03-.05.06-.07.08l-.01.01c-.02.02-.04.05-.06.08-.01.01-.01.02-.02.03-.01.02-.02.03-.03.05-.03.04-.05.08-.07.12 0 .01-.01.01-.01.02-.02.03-.03.07-.04.1 0 .01-.01.02-.01.03-.01.04-.03.08-.04.12-.01.04-.02.08-.02.12v.03c0 .03-.01.07-.01.1v.03l-.02-7.17v-.02-.02c0-.03 0-.07.01-.1v-.03c.01-.04.01-.08.02-.12.01-.04.02-.08.04-.12V119c0-.01.01-.01.01-.02.01-.03.03-.07.04-.1 0-.01 0-.01.01-.02v-.01c.02-.04.04-.08.07-.12 0 0 0-.01.01-.01.01-.01.02-.02.02-.04.01-.01.01-.02.02-.03.02-.03.04-.05.06-.08l.01-.01c.02-.03.05-.06.07-.08l.02-.02c.02-.02.03-.04.05-.05.03-.03.06-.06.1-.09.01-.01.02-.01.02-.02.03-.02.06-.05.09-.07l.01-.01c.01-.01.02-.01.02-.02l.1-.07c.01-.01.03-.02.04-.03l.15-.09c.06-.04.13-.07.2-.11.01-.01.02-.01.03-.02.07-.03.13-.06.2-.09.01-.01.03-.01.04-.02.07-.03.14-.06.21-.08.01 0 .01 0 .02-.01.07-.02.14-.05.22-.07.01 0 .01 0 .02-.01h.01c.06-.02.11-.03.17-.04.06-.01.12-.03.17-.04h.03c.09-.02.18-.03.28-.05h.02l.23-.03h.03c.08-.01.15-.01.22-.02h.53c.05 0 .11.01.16.01h.05c.07.01.14.01.2.02h.03c.06.01.12.02.18.02h.05c.07.01.14.02.21.04h.01c.07.01.14.03.21.05.01 0 .02 0 .03.01h.01c.08.02.16.04.24.07.01 0 .01 0 .02.01.01 0 .02.01.03.01l.09.03c.06.03.08.03.11.04z'
            fill='url(#dataMigr_banner_svg__SVGID_234_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_235_'
            gradientUnits='userSpaceOnUse'
            x1={-4246.718}
            y1={-4243.719}
            x2={-4238.794}
            y2={-4248.319}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M476.91 120.6c.01-.01.02-.02.04-.03.03-.02.06-.05.09-.07.01-.01.02-.01.02-.02.04-.03.07-.06.1-.09l.06-.06.02-.02a.55.55 0 00.07-.09l.01-.01c.02-.02.04-.05.06-.08.01-.01.01-.02.02-.03.01-.02.02-.03.03-.05.03-.04.05-.08.07-.12 0-.01.01-.01.01-.02.02-.03.03-.07.04-.1 0-.01.01-.02.01-.03.01-.04.03-.08.04-.12.01-.04.02-.08.02-.12v-.03c0-.03.01-.07.01-.1v-.03l.02 7.17v.04c0 .03 0 .07-.01.1v.03c-.01.04-.01.08-.02.12-.01.04-.02.08-.04.12v.01c0 .01-.01.01-.01.02-.01.03-.03.07-.04.1 0 .01 0 .01-.01.02v.01c-.02.04-.04.08-.07.12 0 0 0 .01-.01.01-.01.01-.02.02-.03.04-.01.01-.01.02-.02.03-.02.03-.04.05-.06.08l-.01.01c-.02.03-.05.06-.07.08l-.02.02c-.02.02-.03.04-.05.05-.03.03-.07.06-.1.09-.01.01-.02.01-.02.02-.03.02-.06.05-.09.07l-.01.01c-.01.01-.02.01-.02.02l-.1.07c-.01.01-.03.02-.04.03l-.15.09c-.06.04-.13.07-.2.11-.01.01-.02.01-.03.02-.07.03-.13.06-.2.09-.01.01-.03.01-.04.02-.07.03-.14.06-.22.08-.01 0-.01 0-.02.01-.07.02-.14.05-.22.07-.01 0-.01 0-.02.01h-.01c-.06.02-.11.03-.17.04-.06.01-.12.03-.18.04h-.04c-.09.02-.19.03-.28.05h-.03l-.23.03h-.03c-.07.01-.15.01-.22.01h-.53c-.05 0-.11-.01-.16-.01h-.05c-.07-.01-.14-.01-.2-.02h-.02c-.06-.01-.12-.02-.18-.02h-.05c-.07-.01-.14-.02-.21-.04h-.01c-.07-.01-.14-.03-.21-.05-.01 0-.02 0-.03-.01h-.01c-.08-.02-.16-.04-.24-.07-.01 0-.01 0-.02-.01-.01 0-.02-.01-.03-.01l-.09-.03c-.02-.01-.04-.02-.06-.02-.03-.01-.06-.02-.09-.04-.01-.01-.03-.01-.04-.02h-.01c-.06-.03-.13-.06-.19-.09-.01-.01-.03-.01-.04-.02-.06-.03-.13-.06-.19-.1-.66-.38-.99-.89-1-1.39l-.02-7.17c0 .51.33 1.01 1 1.39.06.03.12.07.19.1.01.01.03.01.04.02.06.03.13.06.19.09.02.01.04.01.05.02.03.01.06.02.09.04.02.01.04.02.06.02l.09.03c.02.01.03.01.05.02.08.03.16.05.24.07.01 0 .03.01.04.01.07.02.14.03.21.05h.02c.07.01.14.03.21.04.02 0 .04.01.05.01.06.01.12.02.18.02h.03c.07.01.14.01.21.02h.05c.05 0 .11.01.16.01h.53c.07 0 .15-.01.22-.01h.03l.23-.03h.03c.09-.01.19-.03.28-.05.01 0 .02 0 .04-.01.06-.01.12-.02.17-.04.06-.01.12-.03.17-.04.01 0 .02-.01.04-.01.07-.02.15-.04.22-.07.01 0 .01 0 .02-.01.07-.02.14-.05.22-.08.01-.01.03-.01.04-.02.07-.03.14-.06.2-.09.01-.01.02-.01.03-.02.07-.03.13-.07.2-.11l.15-.09c.01-.01.03-.02.04-.03-.01-.02.02-.04.06-.07z'
            fill='url(#dataMigr_banner_svg__SVGID_235_)'
          />
        </g>
        <g className='dataMigr_banner_svg__st233'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_236_'
            gradientUnits='userSpaceOnUse'
            x1={-4256.369}
            y1={-4258.127}
            x2={-4248.454}
            y2={-4262.721}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M458.79 120.87c.03.01.06.02.09.04.01.01.03.01.04.02h.01c.06.03.13.06.19.09.01.01.03.01.04.02.06.03.12.06.18.1.66.38.99.88.99 1.39l.02 7.17c0-.5-.33-1-.99-1.39-.06-.03-.12-.07-.18-.1-.01-.01-.03-.01-.04-.02-.06-.03-.12-.06-.19-.09-.02-.01-.04-.01-.05-.02-.03-.01-.06-.02-.09-.04-.02-.01-.04-.02-.06-.02l-.09-.03c-.02-.01-.03-.01-.05-.02-.08-.03-.16-.05-.24-.07-.01 0-.03-.01-.04-.01-.07-.02-.14-.03-.21-.05h-.02c-.07-.01-.14-.03-.21-.04-.02 0-.04-.01-.05-.01-.06-.01-.12-.02-.18-.02h-.03c-.07-.01-.14-.01-.2-.02h-.05c-.05 0-.11-.01-.16-.01h-.53c-.07 0-.15.01-.22.01h-.03l-.23.03h-.03c-.09.01-.19.03-.28.05-.01 0-.02 0-.03.01-.06.01-.12.02-.17.04-.06.01-.11.03-.17.04-.01 0-.02.01-.04.01-.07.02-.15.04-.22.07-.01 0-.01 0-.02.01-.07.02-.14.05-.21.08-.01.01-.03.01-.04.02-.07.03-.14.06-.2.09-.01.01-.02.01-.03.02-.07.03-.13.07-.2.11l-.15.09c-.01.01-.03.02-.04.03-.04.02-.07.05-.1.07-.01.01-.02.02-.04.03-.03.02-.06.05-.09.07-.01.01-.02.01-.02.02-.03.03-.07.06-.1.09l-.06.06-.02.02c-.03.03-.05.06-.07.08l-.01.01c-.02.02-.04.05-.06.08-.01.01-.01.02-.02.03-.01.02-.02.03-.03.05-.03.04-.05.08-.07.12 0 .01-.01.01-.01.02-.02.03-.03.07-.04.1 0 .01-.01.02-.01.03-.01.04-.03.08-.04.12-.01.04-.02.08-.02.12v.03c0 .03-.01.07-.01.1v.03l-.02-7.17v-.02-.02c0-.03 0-.07.01-.1v-.03c.01-.04.01-.08.02-.12.01-.04.02-.08.04-.12v-.01c0-.01.01-.01.01-.02.01-.03.03-.07.04-.1 0-.01 0-.01.01-.02v-.01c.02-.04.04-.08.07-.12 0 0 0-.01.01-.01.01-.01.02-.02.02-.04.01-.01.01-.02.02-.03.02-.03.04-.05.06-.08l.01-.01c.02-.03.05-.06.07-.08l.02-.02c.02-.02.03-.04.05-.05.03-.03.06-.06.1-.09.01-.01.02-.01.02-.02.03-.02.06-.05.09-.07l.01-.01c.01-.01.02-.01.02-.02l.1-.07c.01-.01.03-.02.04-.03l.15-.09c.06-.04.13-.07.2-.11.01-.01.02-.01.03-.02.07-.03.13-.06.2-.09.01-.01.03-.01.04-.02.07-.03.14-.06.21-.08.01 0 .01 0 .02-.01.07-.02.14-.05.22-.07.01 0 .01 0 .02-.01h.01c.06-.02.11-.03.17-.04.06-.01.12-.03.17-.04h.03c.09-.02.18-.03.28-.05h.03l.23-.03h.03c.07-.01.15-.01.22-.01h.53c.05 0 .11.01.16.01h.05c.07.01.14.01.2.02h.03c.06.01.12.02.18.02h.05c.07.01.14.02.21.04h.01c.07.01.14.03.21.05.01 0 .02 0 .03.01h.01c.08.02.16.04.24.07.01 0 .01 0 .02.01.01 0 .02.01.03.01l.09.03c.06.01.08.02.1.03z'
            fill='url(#dataMigr_banner_svg__SVGID_236_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_237_'
            gradientUnits='userSpaceOnUse'
            x1={-4258.063}
            y1={-4257.103}
            x2={-4250.138}
            y2={-4261.702}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M459.65 123.74c.01-.01.02-.02.04-.03.03-.02.06-.05.09-.07.01-.01.02-.01.02-.02.04-.03.07-.06.1-.09l.06-.06.02-.02a.55.55 0 00.07-.09l.01-.01c.02-.02.04-.05.06-.08.01-.01.01-.02.02-.03.01-.02.02-.03.03-.05.03-.04.05-.08.07-.12 0-.01.01-.01.01-.02.02-.03.03-.07.04-.1 0-.01.01-.02.01-.03.01-.04.03-.08.04-.12.01-.04.02-.08.02-.12v-.03c0-.03.01-.07.01-.1v-.03l.02 7.17v.04c0 .03 0 .07-.01.1v.03c-.01.04-.01.08-.02.12-.01.04-.02.08-.04.12v.01c0 .01-.01.01-.01.02-.01.03-.03.07-.04.1 0 .01 0 .01-.01.02v.01c-.02.04-.04.08-.07.12 0 0 0 .01-.01.01-.01.01-.02.02-.03.04-.01.01-.01.02-.02.03-.02.03-.04.05-.06.08l-.01.01c-.02.03-.05.06-.07.08l-.02.02c-.02.02-.03.04-.05.05-.03.03-.07.06-.1.09-.01.01-.02.01-.02.02-.03.02-.06.05-.09.07l-.01.01c-.01.01-.02.01-.02.02l-.1.07c-.01.01-.03.02-.04.03l-.15.09c-.06.04-.13.07-.2.11-.01.01-.02.01-.03.02-.07.03-.13.06-.2.09-.01.01-.03.01-.04.02-.07.03-.14.06-.22.08-.01 0-.01 0-.02.01-.07.02-.14.05-.22.07-.01 0-.01 0-.02.01h-.01c-.06.02-.11.03-.17.04-.06.01-.12.03-.18.04h-.04c-.09.02-.19.03-.28.05h-.03l-.23.03h-.03c-.07.01-.15.01-.22.01h-.53c-.05 0-.11-.01-.16-.01h-.05c-.07-.01-.14-.01-.2-.02h-.02c-.06-.01-.12-.02-.18-.02h-.05c-.07-.01-.14-.02-.21-.04h-.01c-.07-.01-.14-.03-.21-.05-.01 0-.02 0-.03-.01h-.01c-.08-.02-.16-.04-.24-.07-.01 0-.01 0-.02-.01-.01 0-.02-.01-.03-.01l-.09-.03c-.02-.01-.04-.02-.06-.02-.03-.01-.06-.02-.09-.04-.01-.01-.03-.01-.04-.02h-.01c-.06-.03-.13-.06-.19-.09-.01-.01-.03-.01-.04-.02-.06-.03-.13-.06-.19-.1-.66-.38-.99-.89-1-1.39l-.02-7.17c0 .51.33 1.01 1 1.39.06.03.12.07.19.1.01.01.03.01.04.02.06.03.13.06.19.09.02.01.04.01.05.02.03.01.06.02.09.04.02.01.04.02.06.02l.09.03c.02.01.03.01.05.02.08.03.16.05.24.07.01 0 .03.01.04.01.07.02.14.03.21.05h.02c.07.01.14.03.21.04.02 0 .04.01.05.01.06.01.12.02.18.02h.03c.07.01.14.01.2.02h.05c.05 0 .11.01.16.01h.53c.07 0 .15-.01.22-.01h.03l.23-.03h.03c.09-.01.19-.03.28-.05.01 0 .02 0 .04-.01.06-.01.12-.02.17-.04.06-.01.12-.03.17-.04.01 0 .02-.01.04-.01.07-.02.15-.04.22-.07.01 0 .01 0 .02-.01.07-.02.14-.05.22-.08.01-.01.03-.01.04-.02.07-.03.14-.06.2-.09.01-.01.02-.01.03-.02.07-.03.13-.07.2-.11l.15-.09c.01-.01.03-.02.04-.03 0-.02.03-.05.07-.07z'
            fill='url(#dataMigr_banner_svg__SVGID_237_)'
          />
        </g>
        <g className='dataMigr_banner_svg__st233'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_238_'
            gradientUnits='userSpaceOnUse'
            x1={-4256.201}
            y1={-4251.146}
            x2={-4248.288}
            y2={-4255.739}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M464.92 124.21c.03.01.06.02.09.04.01.01.03.01.04.02h.01c.06.03.13.06.19.09.01.01.03.01.04.02.06.03.12.06.18.1.66.38.99.88.99 1.39l.02 7.17c0-.5-.33-1-.99-1.39-.06-.03-.12-.07-.18-.1-.01-.01-.03-.01-.04-.02-.06-.03-.12-.06-.19-.09-.02-.01-.04-.01-.05-.02-.03-.01-.06-.02-.09-.04-.02-.01-.04-.02-.06-.02l-.09-.03c-.02-.01-.03-.01-.05-.02-.08-.03-.16-.05-.24-.07-.01 0-.03-.01-.04-.01-.07-.02-.14-.03-.21-.05h-.02c-.07-.01-.14-.03-.21-.04-.02 0-.04-.01-.05-.01-.06-.01-.12-.02-.18-.02h-.03c-.07-.01-.14-.01-.2-.02h-.05c-.05 0-.11-.01-.16-.01h-.53c-.07 0-.15.01-.22.01h-.03l-.23.03h-.03c-.09.01-.19.03-.28.05-.01 0-.02 0-.03.01-.06.01-.12.02-.17.04-.06.01-.11.03-.17.04-.01 0-.02.01-.04.01-.07.02-.15.04-.22.07-.01 0-.01 0-.02.01-.07.02-.14.05-.21.08-.01.01-.03.01-.04.02-.07.03-.14.06-.2.09-.01.01-.02.01-.03.02-.07.03-.13.07-.2.11l-.15.09c-.01.01-.03.02-.04.03-.04.02-.07.05-.1.07-.01.01-.02.02-.04.03-.03.02-.06.05-.09.07-.01.01-.02.01-.02.02-.03.03-.07.06-.1.09l-.06.06-.02.02c-.03.03-.05.06-.07.08l-.01.01c-.02.02-.04.05-.06.08-.01.01-.01.02-.02.03-.01.02-.02.03-.03.05-.03.04-.05.08-.07.12 0 .01-.01.01-.01.02-.02.03-.03.07-.04.1 0 .01-.01.02-.01.03-.01.04-.03.08-.04.12-.01.04-.02.08-.02.12v.03c0 .03-.01.07-.01.1v.03l-.02-7.17v-.02-.02c0-.03 0-.07.01-.1v-.03c.01-.04.01-.08.02-.12.01-.04.02-.08.04-.12v-.01c0-.01.01-.01.01-.02.01-.03.03-.07.04-.1 0-.01 0-.01.01-.02v-.01c.02-.04.04-.08.07-.12 0 0 0-.01.01-.01.01-.01.02-.02.02-.04.01-.01.01-.02.02-.03.02-.03.04-.05.06-.08l.01-.01c.02-.03.05-.06.07-.08l.02-.02c.02-.02.03-.04.05-.05.03-.03.06-.06.1-.09.01-.01.02-.01.02-.02.03-.02.06-.05.09-.07l.01-.01c.01-.01.02-.01.02-.02l.1-.07c.01-.01.03-.02.04-.03l.15-.09c.06-.04.13-.07.2-.11.01-.01.02-.01.03-.02.07-.03.13-.06.2-.09.01-.01.03-.01.04-.02.07-.03.14-.06.21-.08.01 0 .01 0 .02-.01.07-.02.14-.05.22-.07.01 0 .01 0 .02-.01h.01c.06-.02.11-.03.17-.04.06-.01.12-.03.17-.04h.03c.09-.02.18-.03.28-.05h.03l.23-.03h.03c.08-.01.15-.01.22-.02h.53c.05 0 .11.01.16.01h.05c.07.01.14.01.2.02h.03c.06.01.12.02.18.02h.05c.07.01.14.02.21.04h.01c.07.01.14.03.21.05.01 0 .02 0 .03.01h.01c.08.02.16.04.24.07.01 0 .01 0 .02.01.01 0 .02.01.03.01l.09.03c.06.02.08.03.1.04z'
            fill='url(#dataMigr_banner_svg__SVGID_238_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_239_'
            gradientUnits='userSpaceOnUse'
            x1={-4257.898}
            y1={-4250.132}
            x2={-4249.974}
            y2={-4254.731}
            gradientTransform='rotate(-60.025 1898.378 -6144.042)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M465.77 127.08c.01-.01.02-.02.04-.03.03-.02.06-.05.09-.07.01-.01.02-.01.02-.02.04-.03.07-.06.1-.09l.06-.06.02-.02a.55.55 0 00.07-.09l.01-.01c.02-.02.04-.05.06-.08.01-.01.01-.02.02-.03.01-.02.02-.03.03-.05.03-.04.05-.08.07-.12 0-.01.01-.01.01-.02.02-.03.03-.07.04-.1 0-.01.01-.02.01-.03.01-.04.03-.08.04-.12.01-.04.02-.08.02-.12v-.03c0-.03.01-.07.01-.1v-.03l.02 7.17v.04c0 .03 0 .07-.01.1v.03c-.01.04-.01.08-.02.12-.01.04-.02.08-.04.12v.01c0 .01-.01.01-.01.02-.01.03-.03.07-.04.1 0 .01 0 .01-.01.02v.01c-.02.04-.04.08-.07.12 0 0 0 .01-.01.01-.01.01-.02.02-.03.04-.01.01-.01.02-.02.03-.02.03-.04.05-.06.08l-.01.01c-.02.03-.05.06-.07.08l-.02.02c-.02.02-.03.04-.05.05-.03.03-.07.06-.1.09-.01.01-.02.01-.02.02-.03.02-.06.05-.09.07l-.01.01c-.01.01-.02.01-.02.02l-.1.07c-.01.01-.03.02-.04.03l-.15.09c-.06.04-.13.07-.2.11-.01.01-.02.01-.03.02-.07.03-.13.06-.2.09-.01.01-.03.01-.04.02-.07.03-.14.06-.22.08-.01 0-.01 0-.02.01-.07.02-.14.05-.22.07-.01 0-.01 0-.02.01h-.01c-.06.02-.11.03-.17.04-.06.01-.12.03-.18.04h-.04c-.09.02-.19.03-.28.05h-.03l-.23.03h-.03c-.07.01-.15.01-.22.01h-.53c-.05 0-.11-.01-.16-.01h-.05c-.07-.01-.14-.01-.2-.02h-.02c-.06-.01-.12-.02-.18-.02h-.05c-.07-.01-.14-.02-.21-.04h-.01c-.07-.01-.14-.03-.21-.05-.01 0-.02 0-.03-.01h-.01c-.08-.02-.16-.04-.24-.07-.01 0-.01 0-.02-.01-.01 0-.02-.01-.03-.01l-.09-.03c-.02-.01-.04-.02-.06-.02-.03-.01-.06-.02-.09-.04-.01-.01-.03-.01-.04-.02h-.01c-.06-.03-.13-.06-.19-.09-.01-.01-.03-.01-.04-.02-.06-.03-.13-.06-.19-.1-.66-.38-.99-.89-1-1.39l-.02-7.17c0 .51.33 1.01 1 1.39.06.03.12.07.19.1.01.01.03.01.04.02.06.03.13.06.19.09.02.01.04.01.05.02.03.01.06.02.09.04.02.01.04.02.06.02l.09.03c.02.01.03.01.05.02.08.03.16.05.24.07.01 0 .03.01.04.01.07.02.14.03.21.05h.02c.07.01.14.03.21.04.02 0 .04.01.05.01.06.01.12.02.18.02h.03c.07.01.14.01.2.02h.05c.05 0 .11.01.16.01h.53c.07 0 .15-.01.22-.01h.03l.23-.03h.03c.09-.01.19-.03.28-.05.01 0 .02 0 .04-.01.06-.01.12-.02.17-.04.06-.01.12-.03.17-.04.01 0 .02-.01.04-.01.07-.02.15-.04.22-.07.01 0 .01 0 .02-.01.07-.02.14-.05.22-.08.01-.01.03-.01.04-.02.07-.03.14-.06.2-.09.01-.01.02-.01.03-.02.07-.03.13-.07.2-.11l.15-.09c.01-.01.03-.02.04-.03 0-.02.04-.05.07-.07z'
            fill='url(#dataMigr_banner_svg__SVGID_239_)'
          />
        </g>
      </g>
      <g>
        <linearGradient
          id='dataMigr_banner_svg__SVGID_240_'
          gradientUnits='userSpaceOnUse'
          x1={2818.893}
          y1={283.17}
          x2={2818.893}
          y2={249.745}
          gradientTransform='rotate(180 1679.786 198.591)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_240_)' d='M547.08 117.07l.14 25.72-13.31 7.74-.14-25.72z' />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_241_'
          gradientUnits='userSpaceOnUse'
          x1={2829.412}
          y1={249.745}
          x2={2829.412}
          y2={279.947}
          gradientTransform='rotate(180 1679.786 198.591)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_241_)' d='M533.91 150.53l-7.71-4.46-.15-25.72 7.72 4.46z' />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_242_'
          gradientUnits='userSpaceOnUse'
          x1={2812.263}
          y1={281.553}
          x2={2833.302}
          y2={281.553}
          gradientTransform='rotate(180 1679.786 198.591)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_242_)' d='M533.77 124.81l-7.72-4.46 13.32-7.73 7.71 4.45z' />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_243_'
          gradientUnits='userSpaceOnUse'
          x1={2815.222}
          y1={274.442}
          x2={2822.415}
          y2={274.442}
          gradientTransform='rotate(180 1679.786 198.591)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path
          fill='url(#dataMigr_banner_svg__SVGID_243_)'
          d='M544.14 124.12l-7.18 4.17-.01-.22v-.55l6.99-4.06.19-.12z'
        />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_244_'
          gradientUnits='userSpaceOnUse'
          x1={2815.223}
          y1={273.077}
          x2={2822.417}
          y2={273.077}
          gradientTransform='rotate(180 1679.786 198.591)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_244_)' d='M544.14 125.48l-7.18 4.17v-.77l6.98-4.06.2-.11z' />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_245_'
          gradientUnits='userSpaceOnUse'
          x1={2815.228}
          y1={275.807}
          x2={2822.427}
          y2={275.807}
          gradientTransform='rotate(180 1679.786 198.591)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path
          fill='url(#dataMigr_banner_svg__SVGID_245_)'
          d='M544.13 122.75l-7.18 4.17v-.22l-.01-.55 6.99-4.06.19-.11z'
        />
        <path
          className='dataMigr_banner_svg__st25'
          d='M543.94 124.01l-6.99 4.06v-.55l6.99-4.06zM543.95 125.38l-6.99 4.05v-.55l6.98-4.06zM543.93 122.64l-6.98 4.06-.01-.55 6.99-4.06z'
        />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_246_'
          gradientUnits='userSpaceOnUse'
          x1={2815.224}
          y1={269.062}
          x2={2822.418}
          y2={269.062}
          gradientTransform='rotate(180 1679.786 198.591)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path fill='url(#dataMigr_banner_svg__SVGID_246_)' d='M544.15 129.5l-7.18 4.17v-.78l6.98-4.05.2-.12z' />
        <linearGradient
          id='dataMigr_banner_svg__SVGID_247_'
          gradientUnits='userSpaceOnUse'
          x1={2815.22}
          y1={267.697}
          x2={2822.419}
          y2={267.697}
          gradientTransform='rotate(180 1679.786 198.591)'
        >
          <stop offset={0.117} stopColor='#dddcf9' />
          <stop offset={0.562} stopColor='#fff' />
          <stop offset={0.708} stopColor='#f9f8fe' />
          <stop offset={0.915} stopColor='#e6e6fb' />
          <stop offset={1} stopColor='#dddcf9' />
        </linearGradient>
        <path
          fill='url(#dataMigr_banner_svg__SVGID_247_)'
          d='M544.16 130.86l-7.18 4.17v-.22l-.01-.55 6.99-4.06.19-.11z'
        />
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_248_'
            gradientUnits='userSpaceOnUse'
            x1={2815.231}
            y1={270.427}
            x2={2822.424}
            y2={270.427}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_248_)' d='M544.14 128.13l-7.18 4.17v-.77l6.98-4.06.2-.11z' />
        </g>
        <g>
          <path
            className='dataMigr_banner_svg__st25'
            d='M543.95 129.39l-6.98 4.06v-.56l6.98-4.05zM543.96 130.75l-6.98 4.06-.01-.55 6.99-4.06zM543.95 128.02l-6.99 4.06v-.55l6.98-4.06z'
          />
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_249_'
            gradientUnits='userSpaceOnUse'
            x1={2815.221}
            y1={263.687}
            x2={2822.414}
            y2={263.687}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            fill='url(#dataMigr_banner_svg__SVGID_249_)'
            d='M544.17 134.87l-7.18 4.17-.01-.22v-.55l6.98-4.06.2-.11z'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_250_'
            gradientUnits='userSpaceOnUse'
            x1={2815.223}
            y1={262.317}
            x2={2822.416}
            y2={262.317}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_250_)' d='M544.17 136.24l-7.18 4.17v-.77l6.98-4.06.2-.11z' />
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_251_'
              gradientUnits='userSpaceOnUse'
              x1={2815.227}
              y1={265.052}
              x2={2822.427}
              y2={265.052}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              fill='url(#dataMigr_banner_svg__SVGID_251_)'
              d='M544.16 133.51l-7.18 4.17v-.22l-.01-.55 6.99-4.06.19-.12z'
            />
          </g>
        </g>
        <g>
          <path
            className='dataMigr_banner_svg__st25'
            d='M543.97 134.77l-6.99 4.05v-.55l6.98-4.06zM543.97 136.13l-6.98 4.06v-.55l6.98-4.06zM543.96 133.4l-6.98 4.06-.01-.55 6.99-4.06z'
          />
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_252_'
            gradientUnits='userSpaceOnUse'
            x1={2815.223}
            y1={258.307}
            x2={2822.417}
            y2={258.307}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_252_)' d='M544.18 140.25l-7.18 4.17v-.77l6.98-4.06.2-.11z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_253_'
            gradientUnits='userSpaceOnUse'
            x1={2815.219}
            y1={256.942}
            x2={2822.418}
            y2={256.942}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            fill='url(#dataMigr_banner_svg__SVGID_253_)'
            d='M544.19 141.62l-7.18 4.17v-.22l-.01-.55 6.99-4.06.19-.12z'
          />
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_254_'
              gradientUnits='userSpaceOnUse'
              x1={2815.23}
              y1={259.672}
              x2={2822.423}
              y2={259.672}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_254_)' d='M544.17 138.89l-7.18 4.17v-.78l6.98-4.05.2-.12z' />
          </g>
        </g>
        <g>
          <path
            className='dataMigr_banner_svg__st25'
            d='M543.98 140.15L537 144.2v-.55l6.98-4.06zM543.99 141.51l-6.98 4.06-.01-.55 6.99-4.06zM543.97 138.78l-6.98 4.06v-.56l6.98-4.05z'
          />
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_255_'
            gradientUnits='userSpaceOnUse'
            x1={2827.662}
            y1={272.961}
            x2={2831.369}
            y2={272.961}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_255_)' d='M531.71 128v.78l-3.71-2.13v-.78l.11.06.06.04z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_256_'
            gradientUnits='userSpaceOnUse'
            x1={2827.662}
            y1={271.576}
            x2={2831.376}
            y2={271.576}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_256_)' d='M531.71 129.39l.01.78-3.72-2.13v-.79l.17.1z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_257_'
            gradientUnits='userSpaceOnUse'
            x1={2827.662}
            y1={274.346}
            x2={2831.369}
            y2={274.346}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_257_)' d='M531.71 126.61v.79l-3.71-2.13v-.79l.17.1z' />
        </g>
        <g>
          <path
            className='dataMigr_banner_svg__st25'
            d='M531.71 128v.58l-3.54-2.03v-.58zM531.71 129.39l.01.58-3.55-2.04v-.58zM531.71 126.61v.59l-3.54-2.04v-.58z'
          />
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_258_'
            gradientUnits='userSpaceOnUse'
            x1={2827.659}
            y1={267.506}
            x2={2831.368}
            y2={267.506}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_258_)' d='M531.72 133.45l.01.79-3.72-2.14v-.78l.11.07.06.03z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_259_'
            gradientUnits='userSpaceOnUse'
            x1={2827.661}
            y1={266.121}
            x2={2831.377}
            y2={266.121}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_259_)' d='M531.73 134.84v.78l-3.72-2.13v-.78l.17.09z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_260_'
            gradientUnits='userSpaceOnUse'
            x1={2827.663}
            y1={268.891}
            x2={2831.37}
            y2={268.891}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_260_)' d='M531.72 132.07v.78l-3.71-2.13v-.78l.17.1z' />
        </g>
        <g>
          <path
            className='dataMigr_banner_svg__st25'
            d='M531.72 133.45l.01.58-3.55-2.03v-.58zM531.73 134.84v.58l-3.55-2.03v-.59zM531.72 132.07v.58l-3.54-2.03v-.58z'
          />
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_261_'
            gradientUnits='userSpaceOnUse'
            x1={2827.662}
            y1={262.056}
            x2={2831.368}
            y2={262.056}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_261_)' d='M531.74 138.9v.79l-3.71-2.13v-.79l.11.07.06.03z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_262_'
            gradientUnits='userSpaceOnUse'
            x1={2827.662}
            y1={260.671}
            x2={2831.376}
            y2={260.671}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_262_)' d='M531.74 140.29l.01.78-3.72-2.13v-.78l.17.1z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_263_'
            gradientUnits='userSpaceOnUse'
            x1={2827.662}
            y1={263.441}
            x2={2831.368}
            y2={263.441}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_263_)' d='M531.74 137.52v.78l-3.71-2.13v-.78l.17.1z' />
        </g>
        <g>
          <path
            className='dataMigr_banner_svg__st25'
            d='M531.74 138.9v.58l-3.54-2.03v-.58zM531.74 140.29l.01.58-3.55-2.03v-.58zM531.74 137.52v.58l-3.54-2.03v-.58z'
          />
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_264_'
            gradientUnits='userSpaceOnUse'
            x1={2827.658}
            y1={256.606}
            x2={2831.368}
            y2={256.606}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_264_)' d='M531.75 144.35l.01.79-3.72-2.13v-.79l.11.07.06.03z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_265_'
            gradientUnits='userSpaceOnUse'
            x1={2827.66}
            y1={255.216}
            x2={2831.376}
            y2={255.216}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_265_)' d='M531.76 145.74v.79l-3.72-2.14v-.78l.17.1z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_266_'
            gradientUnits='userSpaceOnUse'
            x1={2827.663}
            y1={257.991}
            x2={2831.369}
            y2={257.991}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_266_)' d='M531.75 142.97v.78l-3.71-2.13v-.78l.17.1z' />
        </g>
        <g>
          <path
            className='dataMigr_banner_svg__st25'
            d='M531.75 144.35l.01.58-3.55-2.03v-.58zM531.76 145.74v.58l-3.55-2.03v-.58zM531.75 142.97v.58l-3.54-2.03v-.58z'
          />
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_267_'
            gradientUnits='userSpaceOnUse'
            x1={-3062.683}
            y1={-2221.297}
            x2={-3057.845}
            y2={-2221.297}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M542.18 115.2c-1.34-.76-3.5-.75-4.82.02-1.32.78-1.31 2.03.03 2.79s3.5.75 4.82-.02 1.3-2.02-.03-2.79'
            fill='url(#dataMigr_banner_svg__SVGID_267_)'
          />
          <path
            className='dataMigr_banner_svg__st25'
            d='M541.68 115.5c-1.06-.6-2.77-.6-3.82.02-1.05.61-1.04 1.61.02 2.21s2.77.6 3.82-.02c1.05-.62 1.03-1.61-.02-2.21'
          />
          <g className='dataMigr_banner_svg__st1'>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_268_'
              gradientUnits='userSpaceOnUse'
              x1={-3062.108}
              y1={-2221.337}
              x2={-3057.848}
              y2={-2221.337}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M537.91 114.96c-.03.01-.06.02-.09.04-.01.01-.03.01-.04.02h-.01c-.06.03-.13.06-.19.09-.01.01-.03.01-.04.02-.06.03-.12.06-.18.1-.33.19-.57.42-.74.65-.04.06-.08.12-.11.18s-.06.12-.08.18c-.04.12-.06.25-.06.38v.15c0-.5.33-1.01.98-1.39.06-.04.12-.07.18-.1.01-.01.03-.01.04-.02.06-.03.12-.06.19-.09.02-.01.04-.01.05-.02.03-.01.06-.02.09-.04.02-.01.04-.02.06-.02l.09-.03c.02-.01.03-.01.05-.02.08-.03.16-.05.24-.07.01 0 .03-.01.04-.01.07-.02.14-.03.21-.05h.02c.07-.01.14-.03.21-.04.02 0 .04-.01.05-.01l.18-.03h.03c.07-.01.14-.01.2-.02h.05c.05 0 .11-.01.16-.01h.53c.07 0 .15.01.22.01h.03c.08.01.15.01.23.02h.03c.09.01.19.03.28.04.01 0 .02 0 .03.01.12.02.23.05.35.08.01 0 .02.01.04.01.07.02.15.04.22.07.01 0 .01 0 .02.01.07.02.14.05.22.08.01.01.03.01.04.02.07.03.14.06.2.09.01.01.02.01.03.02.07.03.13.07.2.1l.15.09c.01.01.03.02.04.03.04.02.07.05.1.07.01.01.02.02.04.03.03.02.06.05.09.07.01.01.02.01.02.02.04.03.07.06.1.09l.06.06.02.02c.03.03.05.06.07.08l.01.01c.02.02.04.05.06.07.01.01.01.02.02.03.01.02.02.03.03.05.03.04.05.08.07.12 0 .01.01.01.01.02.02.03.03.07.04.1 0 .01.01.02.01.03.01.04.03.08.04.12.01.04.02.08.02.12v.03c0 .03.01.07.01.1v.03-.15-.02-.02c0-.03 0-.07-.01-.1v-.03c-.01-.04-.01-.08-.02-.12a.564.564 0 00-.04-.12v-.01c0-.01-.01-.01-.01-.02-.01-.03-.03-.07-.04-.1 0-.01 0-.01-.01-.02v-.01a.746.746 0 00-.07-.12s0-.01-.01-.01a.138.138 0 01-.03-.04c-.01-.01-.01-.02-.02-.03-.02-.02-.04-.05-.06-.07 0 0 0-.01-.01-.01-.02-.03-.05-.06-.07-.08l-.02-.02c-.02-.02-.03-.04-.05-.05-.03-.03-.07-.06-.1-.09-.01-.01-.02-.01-.02-.02-.03-.02-.06-.05-.09-.07l-.01-.01c-.01-.01-.02-.01-.02-.02l-.1-.07c-.01-.01-.03-.02-.04-.03l-.15-.09c-.06-.04-.13-.07-.2-.1-.01-.01-.02-.01-.03-.02-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.14-.05-.22-.08-.01 0-.01 0-.02-.01-.07-.02-.14-.04-.22-.06-.01 0-.01 0-.02-.01h-.02c-.06-.01-.11-.03-.17-.04-.06-.01-.12-.03-.18-.04h-.03c-.09-.02-.18-.03-.28-.04h-.03c-.08-.01-.15-.02-.23-.02h-.03c-.08-.01-.15-.01-.22-.01h-.53c-.05 0-.11.01-.16.01h-.05c-.07.01-.14.01-.2.02h-.02l-.18.03h-.05c-.07.01-.14.02-.21.04h-.02c-.07.02-.14.03-.21.05-.01 0-.02 0-.03.01h-.01c-.08.02-.16.05-.24.07-.01 0-.01 0-.02.01-.01 0-.02.01-.03.01l-.09.03c-.03.01-.05.01-.07.02z'
              fill='url(#dataMigr_banner_svg__SVGID_268_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_269_'
              gradientUnits='userSpaceOnUse'
              x1={-3062.941}
              y1={-2221.137}
              x2={-3058.462}
              y2={-2221.137}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M542.1 118.2c-.06.03-.13.06-.2.09-.02.01-.04.02-.06.02-.03.01-.06.03-.1.04-.02.01-.04.02-.07.02-.03.01-.06.02-.1.03-.02.01-.04.01-.05.02-.08.03-.17.05-.25.07-.01 0-.03.01-.04.01-.07.02-.15.04-.22.05h-.02c-.07.02-.15.03-.22.04-.02 0-.04.01-.06.01l-.19.03h-.03c-.07.01-.14.02-.21.02h-.06c-.06 0-.11.01-.17.01h-.56c-.08 0-.15-.01-.23-.01h-.04l-.24-.03h-.03a2.5 2.5 0 01-.29-.05c-.01 0-.02 0-.04-.01-.06-.01-.12-.02-.18-.04-.06-.01-.12-.03-.18-.04-.01 0-.03-.01-.04-.01-.08-.02-.15-.04-.23-.07-.01 0-.01 0-.02-.01-.08-.03-.15-.05-.23-.08-.01-.01-.03-.01-.04-.02l-.21-.09c-.01-.01-.02-.01-.04-.02-.07-.03-.14-.07-.21-.11-.05-.03-.11-.06-.16-.1-.01-.01-.03-.02-.04-.03-.04-.02-.07-.05-.11-.08-.01-.01-.03-.02-.04-.03-.03-.02-.06-.05-.09-.07-.01-.01-.02-.01-.03-.02-.04-.03-.07-.06-.11-.1l-.06-.06-.02-.02c-.03-.03-.05-.06-.08-.09 0 0 0-.01-.01-.01-.02-.03-.04-.05-.06-.08-.01-.01-.01-.02-.02-.03-.01-.02-.02-.03-.03-.05-.03-.04-.05-.09-.07-.13 0-.01-.01-.01-.01-.02-.02-.04-.03-.07-.05-.11 0-.01-.01-.02-.01-.03-.01-.04-.03-.08-.04-.12-.01-.04-.02-.08-.02-.12v-.04c0-.03-.01-.07-.01-.1v-.03V116.79c0 .03 0 .07.01.1v.04c.01.04.01.08.02.12.01.04.02.08.04.13v.01c0 .01.01.01.01.02.01.04.03.07.05.11v.02c.02.04.05.09.07.13 0 0 0 .01.01.01.01.01.02.03.03.04s.01.02.02.03c.02.03.04.05.06.08 0 0 0 .01.01.01.02.03.05.06.08.09l.02.02c.02.02.04.04.05.06.04.03.07.07.11.1.01.01.02.01.03.02.03.02.06.05.09.07l.01.01c.01.01.02.01.03.02.03.03.07.05.11.08.01.01.03.02.04.03.05.03.1.06.16.1.07.04.14.07.21.11.01.01.02.01.04.02l.21.09c.01.01.03.01.04.02.07.03.15.06.23.08.01 0 .01 0 .02.01.07.02.15.05.23.07.01 0 .02 0 .02.01h.02c.06.02.12.03.18.04.06.01.12.03.18.04h.04c.1.02.19.03.29.05h.03l.24.03h.03c.08.01.15.01.23.01h.56c.06 0 .12-.01.17-.01h.06c.07-.01.14-.01.21-.02h.03l.19-.03h.05c.07-.01.15-.03.22-.04h.02c.07-.02.15-.03.22-.05.01 0 .02 0 .03-.01h.01c.09-.02.17-.05.25-.07.01 0 .02 0 .02-.01.01 0 .02-.01.03-.01.03-.01.06-.02.1-.03.02-.01.04-.02.07-.02.03-.01.06-.03.1-.04.02-.01.03-.01.05-.02 0 0 .01 0 .01-.01.07-.03.13-.06.2-.09.01-.01.03-.01.04-.02.07-.03.13-.07.19-.11.48-.28.79-.62.93-.97.03-.06.05-.13.06-.2.01-.03.01-.07.02-.1.01-.07.02-.13.02-.2v-.15c0 .53-.34 1.06-1.03 1.47-.06.04-.13.07-.19.11.02-.01 0 0-.01.01z'
              fill='url(#dataMigr_banner_svg__SVGID_269_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_270_'
              gradientUnits='userSpaceOnUse'
              x1={-3062.813}
              y1={-2221.287}
              x2={-3057.717}
              y2={-2221.287}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M537.25 118.1c-1.41-.8-1.42-2.12-.03-2.94 1.39-.82 3.67-.83 5.08-.03 1.41.8 1.42 2.12.03 2.94-1.39.82-3.67.83-5.08.03zm4.93-2.9c-1.34-.76-3.5-.75-4.82.02-1.32.78-1.31 2.03.03 2.79s3.5.75 4.82-.02 1.3-2.02-.03-2.79'
              fill='url(#dataMigr_banner_svg__SVGID_270_)'
            />
          </g>
          <g className='dataMigr_banner_svg__st1'>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_271_'
              gradientUnits='userSpaceOnUse'
              x1={-3059.806}
              y1={-2222.362}
              x2={-3058.856}
              y2={-2220.725}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M538.68 116.06c-.01-.03-.03-.06-.04-.09-.35-.74 1.02-1.06 1.09-1.08l.44.93.3.64a.642.642 0 00-.13-.1c-.15-.09-.35-.13-.56-.13l-1.1-.17z'
              fill='url(#dataMigr_banner_svg__SVGID_271_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_272_'
              gradientUnits='userSpaceOnUse'
              x1={-3060.127}
              y1={-2221.381}
              x2={-3058.752}
              y2={-2219.013}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M537.5 116.7c-.58-.33-.45-.86-.44-.89l1.61.24 1.11.17c-.21 0-.42.05-.57.14-.31.18-.31.47.01.65.05.03.11.06.18.08-.07-.01-.15-.02-.24-.04-.25-.04-.58-.09-.86-.13a.875.875 0 00-.16-.02c-.28-.04-.48-.11-.64-.2z'
              fill='url(#dataMigr_banner_svg__SVGID_272_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_273_'
                gradientUnits='userSpaceOnUse'
                x1={-3060.335}
                y1={-2220.527}
                x2={-3060.335}
                y2={-2221.983}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0} stopColor='#7f64ff' />
                <stop offset={0.484} stopColor='#7d62ff' />
                <stop offset={0.752} stopColor='#775aff' />
                <stop offset={0.967} stopColor='#6d4cff' />
                <stop offset={1} stopColor='#6b49ff' />
              </linearGradient>
              <path
                d='M539.22 117.02c-.31-.18-.32-.47-.01-.65.16-.09.37-.14.57-.14s.4.04.56.13c.05.03.1.06.13.1.14.14.14.32 0 .46-.03.03-.07.06-.12.09-.16.09-.36.14-.57.14-.13 0-.26-.02-.38-.06a.751.751 0 01-.18-.07z'
                fill='url(#dataMigr_banner_svg__SVGID_273_)'
              />
            </g>
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_274_'
                gradientUnits='userSpaceOnUse'
                x1={-3060.743}
                y1={-2220.561}
                x2={-3059.601}
                y2={-2218.595}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M537.11 117.61l1.17-.69c.29.04.61.09.86.13l.24.5c-.04.02-.08.05-.12.07-.92.55-2.08.02-2.15-.01z'
                fill='url(#dataMigr_banner_svg__SVGID_274_)'
              />
            </g>
          </g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_275_'
            gradientUnits='userSpaceOnUse'
            x1={-3061.262}
            y1={-2223.799}
            x2={-3060.12}
            y2={-2221.832}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M540.47 116.92c.14-.14.14-.32 0-.46l-.3-.64c.04-.02.08-.05.12-.07.93-.55 2.1-.02 2.16.01l-1.17.69-.81.47z'
            fill='url(#dataMigr_banner_svg__SVGID_275_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_276_'
            gradientUnits='userSpaceOnUse'
            x1={-3061.983}
            y1={-2223.454}
            x2={-3060.61}
            y2={-2221.088}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M539.78 117.15c.21 0 .41-.05.57-.14.05-.03.09-.06.12-.09l.8-.47c.05.01.11.02.16.02.27.04.47.11.62.2.58.33.45.86.44.89l-1.61-.24-1.1-.17z'
            fill='url(#dataMigr_banner_svg__SVGID_276_)'
          />
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_277_'
              gradientUnits='userSpaceOnUse'
              x1={-3061.866}
              y1={-2221.751}
              x2={-3060.948}
              y2={-2220.17}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M539.83 118.48l-.44-.93-.24-.5c.09.01.17.03.24.04.12.04.25.06.38.06l1.1.17c.02.03.03.06.04.09.36.74-1.01 1.06-1.08 1.07z'
              fill='url(#dataMigr_banner_svg__SVGID_277_)'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_278_'
              gradientUnits='userSpaceOnUse'
              x1={-3061.005}
              y1={-2222.148}
              x2={-3056.414}
              y2={-2222.148}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
              <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
              <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
              <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
            </linearGradient>
            <path
              d='M542.78 114.22c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.36.21.63.46.79.73zm-6.02 1.19c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.06.38.16.56z'
              fill='url(#dataMigr_banner_svg__SVGID_278_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_279_'
              gradientUnits='userSpaceOnUse'
              x1={-3059.604}
              y1={-2222.912}
              x2={-3055.012}
              y2={-2222.912}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0} stopColor='#2afadf' stopOpacity={0} />
              <stop offset={0.275} stopColor='#36d1ea' stopOpacity={0.165} />
              <stop offset={0.596} stopColor='#42a7f5' stopOpacity={0.358} />
              <stop offset={0.849} stopColor='#498dfc' stopOpacity={0.51} />
              <stop offset={1} stopColor='#4c83ff' stopOpacity={0.6} />
            </linearGradient>
            <path
              d='M542.73 112.62c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.37.21.63.46.79.73zm-6.01 1.2c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26l.02-.04-.02.04c-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.06.38.16.56z'
              fill='url(#dataMigr_banner_svg__SVGID_279_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_280_'
                gradientUnits='userSpaceOnUse'
                x1={-3058.21}
                y1={-2223.657}
                x2={-3053.618}
                y2={-2223.657}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
              </linearGradient>
              <path
                d='M542.67 111.04c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.36.21.63.46.79.73zm-6.01 1.2c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26l.02-.04-.02.04c-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.05.38.16.56z'
                fill='url(#dataMigr_banner_svg__SVGID_280_)'
              />
            </g>
          </g>
        </g>
        <g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_281_'
            gradientUnits='userSpaceOnUse'
            x1={-3062.52}
            y1={-2214.32}
            x2={-3057.682}
            y2={-2214.32}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M536.07 118.58c-1.34-.76-3.5-.75-4.82.02-1.32.78-1.31 2.03.03 2.79s3.5.75 4.82-.02c1.32-.77 1.31-2.03-.03-2.79'
            fill='url(#dataMigr_banner_svg__SVGID_281_)'
          />
          <path
            className='dataMigr_banner_svg__st25'
            d='M535.57 118.87c-1.06-.6-2.77-.6-3.82.02s-1.04 1.61.02 2.21 2.77.6 3.82-.02c1.05-.61 1.04-1.6-.02-2.21'
          />
          <g className='dataMigr_banner_svg__st1'>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_282_'
              gradientUnits='userSpaceOnUse'
              x1={-3061.943}
              y1={-2214.354}
              x2={-3057.682}
              y2={-2214.354}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M531.8 118.34c-.03.01-.06.02-.09.04-.01.01-.03.01-.04.02h-.01c-.06.03-.13.06-.19.09-.01.01-.03.01-.04.02-.06.03-.12.06-.18.1-.33.19-.57.42-.74.65-.04.06-.08.12-.11.18s-.06.12-.08.18c-.04.12-.06.25-.06.38v.15c0-.5.33-1.01.98-1.39.06-.04.12-.07.18-.1.01-.01.03-.01.04-.02.06-.03.12-.06.19-.09.02-.01.04-.01.05-.02.03-.01.06-.02.09-.04.02-.01.04-.02.06-.02l.09-.03c.02-.01.03-.01.05-.02.08-.03.16-.05.24-.07.01 0 .03-.01.04-.01.07-.02.14-.03.21-.05h.02c.07-.01.14-.03.21-.04.02 0 .04-.01.05-.01l.18-.03h.03c.07-.01.14-.01.2-.02h.05c.05 0 .11-.01.16-.01h.53c.07 0 .15.01.22.01h.03c.08.01.15.01.23.02h.03c.09.01.19.03.28.04.01 0 .02 0 .03.01.12.02.23.05.35.08.01 0 .02.01.04.01.07.02.15.04.22.07.01 0 .01 0 .02.01.07.02.14.05.22.08.01.01.03.01.04.02.07.03.14.06.2.09.01.01.02.01.03.02.07.03.13.07.2.1l.15.09c.01.01.03.02.04.03.04.02.07.05.1.07.01.01.02.02.04.03.03.02.06.05.09.07.01.01.02.01.02.02.04.03.07.06.1.09l.06.06.02.02c.03.03.05.06.07.08 0 0 0 .01.01.01.02.02.04.05.06.07.01.01.01.02.02.03.01.02.02.03.03.05.03.04.05.08.07.12 0 .01.01.01.01.02.02.03.03.07.04.1 0 .01.01.02.01.03.01.04.03.08.04.12.01.04.02.08.02.12v.03c0 .03.01.07.01.1v.03-.15-.02-.02c0-.03 0-.07-.01-.1v-.03c-.01-.04-.01-.08-.02-.12a.564.564 0 00-.04-.12v-.01c0-.01-.01-.02-.01-.02-.01-.03-.03-.07-.04-.1 0-.01 0-.01-.01-.02-.02-.04-.05-.08-.07-.12 0 0 0-.01-.01-.01a.138.138 0 01-.03-.04c-.01-.01-.01-.02-.02-.03-.02-.02-.04-.05-.06-.07v-.01c-.02-.03-.05-.06-.07-.08l-.02-.02c-.02-.02-.03-.04-.05-.05-.03-.03-.07-.06-.1-.09-.01-.01-.02-.01-.02-.02-.03-.02-.06-.05-.09-.07l-.01-.01c-.01-.01-.02-.01-.02-.02l-.1-.07c-.01-.01-.03-.02-.04-.03l-.15-.09c-.06-.04-.13-.07-.2-.1-.01-.01-.02-.01-.03-.02-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.14-.05-.22-.08-.01 0-.01 0-.02-.01-.07-.02-.14-.04-.22-.06-.01 0-.01 0-.02-.01h-.01c-.06-.01-.11-.03-.17-.04-.06-.01-.12-.03-.17-.04h-.03c-.09-.02-.18-.03-.28-.04h-.02c-.08-.01-.15-.02-.23-.02h-.03c-.08-.01-.15-.01-.22-.01h-.53c-.05 0-.11.01-.16.01h-.05c-.07.01-.14.01-.2.02H533l-.18.03h-.05c-.07.01-.14.02-.21.04h-.01c-.08.02-.15.03-.22.05-.01 0-.02 0-.03.01h-.01c-.08.02-.16.05-.24.07-.01 0-.01 0-.02.01-.01 0-.02.01-.03.01l-.09.03c-.06-.01-.08 0-.11.01z'
              fill='url(#dataMigr_banner_svg__SVGID_282_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_283_'
              gradientUnits='userSpaceOnUse'
              x1={-3062.777}
              y1={-2214.181}
              x2={-3058.298}
              y2={-2214.181}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M535.99 121.57c-.06.03-.13.06-.2.09-.02.01-.04.02-.06.02-.03.01-.06.03-.1.04-.02.01-.04.02-.07.02-.03.01-.06.02-.1.03-.02.01-.04.01-.05.02-.08.03-.17.05-.25.07-.01 0-.03.01-.04.01-.07.02-.15.04-.22.05h-.02c-.07.02-.15.03-.22.04-.02 0-.04.01-.06.01l-.19.03h-.03c-.07.01-.14.02-.21.02h-.06c-.06 0-.11.01-.17.01h-.56c-.08 0-.15-.01-.23-.01h-.04l-.24-.03h-.03a2.5 2.5 0 01-.29-.05c-.01 0-.02 0-.04-.01-.06-.01-.12-.02-.18-.04-.06-.01-.12-.03-.18-.04-.01 0-.03-.01-.04-.01-.08-.02-.15-.04-.23-.07-.01 0-.01 0-.02-.01-.08-.03-.15-.05-.23-.08-.01-.01-.03-.01-.04-.02l-.21-.09c-.01-.01-.02-.01-.04-.02-.07-.03-.14-.07-.21-.11-.05-.03-.11-.06-.16-.1-.01-.01-.03-.02-.04-.03-.04-.02-.07-.05-.11-.08-.01-.01-.03-.02-.04-.03-.03-.02-.06-.05-.09-.07-.01-.01-.02-.01-.03-.02-.04-.03-.07-.06-.11-.1l-.06-.06-.02-.02c-.03-.03-.05-.06-.08-.09v-.01c-.02-.03-.04-.05-.06-.08-.01-.01-.01-.02-.02-.03-.01-.02-.02-.03-.03-.05-.03-.04-.05-.09-.07-.13 0-.01-.01-.01-.01-.02-.02-.04-.03-.07-.05-.11 0-.01-.01-.02-.01-.03-.01-.04-.03-.08-.04-.12-.01-.04-.02-.08-.02-.12v-.04c0-.03-.01-.07-.01-.1v-.03V120.16c0 .03 0 .07.01.1v.03c.01.05.01.09.02.13.01.04.02.08.04.12v.01c0 .01.01.01.01.02.01.04.03.07.05.11 0 .01 0 .01.01.02v.01c.02.04.05.09.07.13 0 0 0 .01.01.01.01.01.02.03.03.04s.01.02.02.03c.02.03.04.05.06.08 0 0 0 .01.01.01.02.03.05.06.08.09l.02.02c.02.02.04.04.05.06.03.03.07.07.11.1.01.01.02.01.03.02.03.02.06.05.09.07l.01.01c.01.01.02.01.03.02.03.03.07.05.11.08.01.01.03.02.04.03.05.03.1.06.16.1.07.04.14.07.21.11.01.01.02.01.04.02l.21.09c.01.01.03.01.04.02.07.03.15.06.23.08.01 0 .01 0 .02.01.07.02.15.05.23.07.01 0 .02 0 .02.01h.02c.06.02.12.03.18.04.06.01.12.03.18.04h.04c.1.02.19.03.29.05h.03l.24.03h.03c.08.01.16.01.24.01h.56c.06 0 .12-.01.17-.01h.06c.07-.01.14-.01.21-.02h.03l.19-.03h.05c.07-.01.15-.03.22-.04h.02c.07-.02.15-.03.22-.05.01 0 .02 0 .03-.01h.01c.09-.02.17-.05.25-.07.01 0 .02 0 .02-.01.01 0 .02-.01.03-.01.03-.01.06-.02.1-.03.02-.01.04-.02.07-.02.03-.01.06-.03.1-.04.02-.01.03-.01.05-.02h.01c.07-.03.14-.06.2-.09.01-.01.03-.01.04-.02.07-.03.13-.07.19-.11.48-.28.79-.62.93-.97.03-.06.05-.13.06-.2.01-.03.01-.07.02-.1.01-.07.02-.13.02-.2v-.15c0 .53-.34 1.06-1.03 1.47-.06.04-.13.07-.19.11-.01-.01-.02-.01-.04 0z'
              fill='url(#dataMigr_banner_svg__SVGID_283_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_284_'
              gradientUnits='userSpaceOnUse'
              x1={-3062.646}
              y1={-2214.32}
              x2={-3057.55}
              y2={-2214.32}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M531.15 121.47c-1.41-.8-1.42-2.12-.03-2.94 1.39-.82 3.67-.83 5.08-.03 1.41.8 1.42 2.12.03 2.94-1.39.82-3.67.84-5.08.03zm4.92-2.89c-1.34-.76-3.5-.75-4.82.02-1.32.78-1.31 2.03.03 2.79s3.5.75 4.82-.02c1.32-.77 1.31-2.03-.03-2.79'
              fill='url(#dataMigr_banner_svg__SVGID_284_)'
            />
          </g>
          <g className='dataMigr_banner_svg__st1'>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_285_'
              gradientUnits='userSpaceOnUse'
              x1={-3059.636}
              y1={-2215.39}
              x2={-3058.686}
              y2={-2213.753}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M532.57 119.43c-.01-.03-.03-.06-.04-.09-.35-.74 1.02-1.06 1.09-1.08l.44.93.3.64a.642.642 0 00-.13-.1c-.15-.09-.35-.13-.56-.13l-1.1-.17z'
              fill='url(#dataMigr_banner_svg__SVGID_285_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_286_'
              gradientUnits='userSpaceOnUse'
              x1={-3059.966}
              y1={-2214.405}
              x2={-3058.592}
              y2={-2212.037}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M531.4 120.08c-.58-.33-.45-.86-.44-.89l1.61.24 1.11.17c-.21 0-.42.05-.57.14-.31.18-.31.47.01.65.05.03.11.06.18.08-.07-.01-.15-.02-.24-.04-.25-.04-.58-.09-.86-.13a.875.875 0 00-.16-.02c-.29-.04-.49-.12-.64-.2z'
              fill='url(#dataMigr_banner_svg__SVGID_286_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_287_'
                gradientUnits='userSpaceOnUse'
                x1={-3060.163}
                y1={-2213.553}
                x2={-3060.163}
                y2={-2215.009}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0} stopColor='#7f64ff' />
                <stop offset={0.484} stopColor='#7d62ff' />
                <stop offset={0.752} stopColor='#775aff' />
                <stop offset={0.967} stopColor='#6d4cff' />
                <stop offset={1} stopColor='#6b49ff' />
              </linearGradient>
              <path
                d='M533.11 120.39c-.31-.18-.32-.47-.01-.65.16-.09.37-.14.57-.14s.4.04.56.13c.05.03.1.06.13.1.14.14.14.32 0 .46-.03.03-.07.06-.12.09-.16.09-.36.14-.57.14-.13 0-.26-.02-.38-.06a.67.67 0 01-.18-.07z'
                fill='url(#dataMigr_banner_svg__SVGID_287_)'
              />
            </g>
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_288_'
                gradientUnits='userSpaceOnUse'
                x1={-3060.58}
                y1={-2213.586}
                x2={-3059.438}
                y2={-2211.619}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M531.01 120.99l1.17-.69c.29.04.61.09.86.13l.24.5c-.04.02-.08.05-.12.07-.92.54-2.09.02-2.15-.01z'
                fill='url(#dataMigr_banner_svg__SVGID_288_)'
              />
            </g>
          </g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_289_'
            gradientUnits='userSpaceOnUse'
            x1={-3061.093}
            y1={-2216.829}
            x2={-3059.951}
            y2={-2214.862}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M534.36 120.29c.14-.14.14-.32 0-.46l-.3-.64c.04-.02.08-.05.12-.07.93-.55 2.1-.02 2.16.01l-1.17.69-.81.47z'
            fill='url(#dataMigr_banner_svg__SVGID_289_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_290_'
            gradientUnits='userSpaceOnUse'
            x1={-3061.813}
            y1={-2216.482}
            x2={-3060.44}
            y2={-2214.116}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M533.67 120.52c.21 0 .41-.05.57-.14.05-.03.09-.06.12-.09l.8-.47c.05.01.11.02.16.02.27.04.47.11.62.2.58.33.45.86.44.89l-1.61-.24-1.1-.17z'
            fill='url(#dataMigr_banner_svg__SVGID_290_)'
          />
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_291_'
              gradientUnits='userSpaceOnUse'
              x1={-3061.705}
              y1={-2214.774}
              x2={-3060.787}
              y2={-2213.194}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M533.72 121.86l-.44-.93-.24-.5c.09.01.17.03.24.04.12.04.25.06.38.06l1.1.17c.02.03.03.06.04.09.37.73-1 1.05-1.08 1.07z'
              fill='url(#dataMigr_banner_svg__SVGID_291_)'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_292_'
              gradientUnits='userSpaceOnUse'
              x1={-3060.839}
              y1={-2215.172}
              x2={-3056.247}
              y2={-2215.172}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
              <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
              <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
              <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
            </linearGradient>
            <path
              d='M536.67 117.59c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.36.21.63.46.79.73zm-6.01 1.2c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.05.38.16.56z'
              fill='url(#dataMigr_banner_svg__SVGID_292_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_293_'
              gradientUnits='userSpaceOnUse'
              x1={-3059.44}
              y1={-2215.94}
              x2={-3054.849}
              y2={-2215.94}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0} stopColor='#2afadf' stopOpacity={0} />
              <stop offset={0.275} stopColor='#36d1ea' stopOpacity={0.165} />
              <stop offset={0.596} stopColor='#42a7f5' stopOpacity={0.358} />
              <stop offset={0.849} stopColor='#498dfc' stopOpacity={0.51} />
              <stop offset={1} stopColor='#4c83ff' stopOpacity={0.6} />
            </linearGradient>
            <path
              d='M536.63 116c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.36.2.63.45.79.73zm-6.01 1.19c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26l.02-.04-.02.04c-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.05.38.16.56z'
              fill='url(#dataMigr_banner_svg__SVGID_293_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_294_'
                gradientUnits='userSpaceOnUse'
                x1={-3058.046}
                y1={-2216.676}
                x2={-3053.455}
                y2={-2216.676}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
              </linearGradient>
              <path
                d='M536.56 114.42c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.36.21.63.46.79.73zm-6.01 1.19c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26l.02-.04-.02.04c-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.06.38.16.56z'
                fill='url(#dataMigr_banner_svg__SVGID_294_)'
              />
            </g>
          </g>
        </g>
        <g>
          <g className='dataMigr_banner_svg__st1'>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_295_'
              gradientUnits='userSpaceOnUse'
              x1={2807.74}
              y1={276.73}
              x2={2807.74}
              y2={243.315}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_295_)' d='M558.25 123.48l.14 25.72-13.31 7.73-.14-25.72z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_296_'
              gradientUnits='userSpaceOnUse'
              x1={2818.255}
              y1={243.315}
              x2={2818.255}
              y2={273.506}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_296_)' d='M545.08 156.93l-7.71-4.45-.14-25.72 7.71 4.45z' />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_297_'
                gradientUnits='userSpaceOnUse'
                x1={2801.11}
                y1={275.118}
                x2={2822.139}
                y2={275.118}
                gradientTransform='rotate(180 1679.786 198.591)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path fill='url(#dataMigr_banner_svg__SVGID_297_)' d='M544.94 131.21l-7.71-4.45 13.31-7.73 7.71 4.45z' />
            </g>
          </g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_298_'
            gradientUnits='userSpaceOnUse'
            x1={2804.069}
            y1={268.007}
            x2={2811.268}
            y2={268.007}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            fill='url(#dataMigr_banner_svg__SVGID_298_)'
            d='M555.31 130.52l-7.18 4.17v-.22l-.01-.55 6.99-4.06.19-.11z'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_299_'
            gradientUnits='userSpaceOnUse'
            x1={2804.071}
            y1={266.637}
            x2={2811.264}
            y2={266.637}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            fill='url(#dataMigr_banner_svg__SVGID_299_)'
            d='M555.31 131.89l-7.17 4.17-.01-.22v-.55l6.98-4.06.2-.11z'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_300_'
            gradientUnits='userSpaceOnUse'
            x1={2804.073}
            y1={269.372}
            x2={2811.267}
            y2={269.372}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_300_)' d='M555.3 129.16l-7.18 4.17v-.78l6.98-4.05.2-.12z' />
          <path
            className='dataMigr_banner_svg__st25'
            d='M555.11 130.42l-6.98 4.05-.01-.55 6.99-4.06zM555.12 131.78l-6.99 4.06v-.55l6.98-4.06zM555.1 129.05l-6.98 4.06v-.56l6.98-4.05z'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_301_'
            gradientUnits='userSpaceOnUse'
            x1={2804.072}
            y1={262.627}
            x2={2811.265}
            y2={262.627}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_301_)' d='M555.32 135.9l-7.18 4.17v-.77l6.98-4.06.2-.11z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_302_'
            gradientUnits='userSpaceOnUse'
            x1={2804.065}
            y1={261.262}
            x2={2811.259}
            y2={261.262}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_302_)' d='M555.33 137.27l-7.18 4.17v-.78l6.98-4.05.2-.12z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_303_'
            gradientUnits='userSpaceOnUse'
            x1={2804.078}
            y1={263.992}
            x2={2811.271}
            y2={263.992}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            fill='url(#dataMigr_banner_svg__SVGID_303_)'
            d='M555.31 134.54l-7.17 4.17-.01-.22v-.56l6.98-4.05.2-.12z'
          />
          <path
            className='dataMigr_banner_svg__st25'
            d='M555.12 135.79l-6.98 4.06v-.55l6.98-4.06zM555.13 137.16l-6.98 4.06v-.56l6.98-4.05zM555.12 134.43l-6.99 4.06v-.56l6.98-4.05z'
          />
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_304_'
              gradientUnits='userSpaceOnUse'
              x1={2804.068}
              y1={257.247}
              x2={2811.267}
              y2={257.247}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              fill='url(#dataMigr_banner_svg__SVGID_304_)'
              d='M555.34 141.28l-7.18 4.17v-.22l-.01-.55 6.99-4.06.19-.11z'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_305_'
              gradientUnits='userSpaceOnUse'
              x1={2804.07}
              y1={255.882}
              x2={2811.263}
              y2={255.882}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              fill='url(#dataMigr_banner_svg__SVGID_305_)'
              d='M555.34 142.64l-7.17 4.18-.01-.23v-.55l6.98-4.05.2-.12z'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_306_'
                gradientUnits='userSpaceOnUse'
                x1={2804.073}
                y1={258.617}
                x2={2811.266}
                y2={258.617}
                gradientTransform='rotate(180 1679.786 198.591)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path fill='url(#dataMigr_banner_svg__SVGID_306_)' d='M555.33 139.91l-7.18 4.17v-.77l6.98-4.06.2-.11z' />
            </g>
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M555.14 141.17l-6.98 4.06-.01-.55 6.99-4.06zM555.15 142.54l-6.99 4.05v-.55l6.98-4.05zM555.13 139.81l-6.98 4.05v-.55l6.98-4.06z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_307_'
              gradientUnits='userSpaceOnUse'
              x1={2804.071}
              y1={251.872}
              x2={2811.264}
              y2={251.872}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_307_)' d='M555.35 146.66l-7.18 4.17v-.77l6.98-4.06.2-.12z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_308_'
              gradientUnits='userSpaceOnUse'
              x1={2804.064}
              y1={250.507}
              x2={2811.258}
              y2={250.507}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_308_)' d='M555.36 148.02l-7.18 4.17v-.77l6.98-4.06.2-.11z' />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_309_'
                gradientUnits='userSpaceOnUse'
                x1={2804.077}
                y1={253.237}
                x2={2811.271}
                y2={253.237}
                gradientTransform='rotate(180 1679.786 198.591)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path fill='url(#dataMigr_banner_svg__SVGID_309_)' d='M555.34 145.29l-7.18 4.17v-.77l6.98-4.06.2-.11z' />
            </g>
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M555.15 146.55l-6.98 4.06v-.55l6.98-4.06zM555.16 147.92l-6.98 4.05v-.55l6.98-4.06zM555.15 145.18l-6.99 4.06v-.55l6.98-4.06z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_310_'
              gradientUnits='userSpaceOnUse'
              x1={2816.51}
              y1={266.521}
              x2={2820.216}
              y2={266.521}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_310_)' d='M542.88 134.41v.78l-3.71-2.13v-.78l.11.06.06.03z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_311_'
              gradientUnits='userSpaceOnUse'
              x1={2816.508}
              y1={265.136}
              x2={2820.225}
              y2={265.136}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_311_)' d='M542.89 135.79v.79l-3.72-2.14v-.78l.17.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_312_'
              gradientUnits='userSpaceOnUse'
              x1={2816.506}
              y1={267.911}
              x2={2820.212}
              y2={267.911}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_312_)' d='M542.88 133.02v.78l-3.71-2.13v-.78l.17.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M542.88 134.41v.58l-3.54-2.04v-.58zM542.89 135.79v.58l-3.55-2.03v-.58zM542.88 133.02v.58l-3.54-2.03v-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_313_'
              gradientUnits='userSpaceOnUse'
              x1={2816.504}
              y1={261.071}
              x2={2820.214}
              y2={261.071}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_313_)' d='M542.9 139.86v.78l-3.72-2.13v-.78l.12.06.06.04z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_314_'
              gradientUnits='userSpaceOnUse'
              x1={2816.508}
              y1={259.686}
              x2={2820.225}
              y2={259.686}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_314_)' d='M542.9 141.24v.79l-3.72-2.13v-.79l.18.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_315_'
              gradientUnits='userSpaceOnUse'
              x1={2816.511}
              y1={262.456}
              x2={2820.217}
              y2={262.456}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_315_)' d='M542.89 138.47v.79l-3.71-2.13v-.79l.18.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M542.9 139.86v.58l-3.54-2.03v-.58zM542.9 141.24v.59l-3.54-2.04v-.58zM542.89 138.47v.58l-3.53-2.03v-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_316_'
              gradientUnits='userSpaceOnUse'
              x1={2816.509}
              y1={255.621}
              x2={2820.215}
              y2={255.621}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_316_)' d='M542.91 145.31v.78l-3.71-2.13v-.78l.11.06.06.04z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_317_'
              gradientUnits='userSpaceOnUse'
              x1={2816.508}
              y1={254.236}
              x2={2820.224}
              y2={254.236}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_317_)' d='M542.92 146.69v.79l-3.72-2.13v-.79l.17.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_318_'
              gradientUnits='userSpaceOnUse'
              x1={2816.505}
              y1={257.006}
              x2={2820.212}
              y2={257.006}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_318_)' d='M542.91 143.92v.79l-3.71-2.13v-.79l.17.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M542.91 145.31v.58l-3.54-2.03v-.58zM542.92 146.69v.59l-3.55-2.04v-.58zM542.91 143.92v.58l-3.54-2.03v-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_319_'
              gradientUnits='userSpaceOnUse'
              x1={2816.504}
              y1={250.171}
              x2={2820.213}
              y2={250.171}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_319_)' d='M542.93 150.76v.78l-3.72-2.13v-.78l.12.06.06.04z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_320_'
              gradientUnits='userSpaceOnUse'
              x1={2816.508}
              y1={248.786}
              x2={2820.224}
              y2={248.786}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_320_)' d='M542.93 152.15v.78l-3.72-2.13v-.79l.18.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_321_'
              gradientUnits='userSpaceOnUse'
              x1={2816.51}
              y1={251.556}
              x2={2820.216}
              y2={251.556}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_321_)' d='M542.92 149.37v.79l-3.71-2.13v-.79l.18.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M542.93 150.76v.58l-3.54-2.03v-.58zM542.93 152.15v.58l-3.54-2.04v-.58zM542.92 149.37v.58l-3.53-2.03v-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_322_'
              gradientUnits='userSpaceOnUse'
              x1={-3073.852}
              y1={-2227.712}
              x2={-3069.014}
              y2={-2227.712}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M553.35 121.61c-1.34-.76-3.5-.75-4.82.02-1.32.78-1.31 2.03.03 2.79s3.5.75 4.82-.02c1.32-.77 1.31-2.03-.03-2.79'
              fill='url(#dataMigr_banner_svg__SVGID_322_)'
            />
            <path
              className='dataMigr_banner_svg__st25'
              d='M552.85 121.9c-1.06-.6-2.77-.6-3.82.02-1.05.61-1.04 1.61.02 2.21s2.77.6 3.82-.02c1.05-.61 1.04-1.6-.02-2.21'
            />
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_323_'
                gradientUnits='userSpaceOnUse'
                x1={-3073.273}
                y1={-2227.749}
                x2={-3069.013}
                y2={-2227.749}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M549.08 121.37c-.03.01-.06.02-.09.04-.01.01-.03.01-.04.02h-.01c-.06.03-.13.06-.19.09-.01.01-.03.01-.04.02-.06.03-.12.06-.18.1-.33.19-.57.42-.74.65-.04.06-.08.12-.11.18s-.06.12-.08.18c-.04.12-.06.25-.06.38v.15c0-.5.33-1.01.98-1.39.06-.04.12-.07.18-.1.01-.01.03-.01.04-.02.06-.03.12-.06.19-.09.02-.01.04-.01.05-.02.03-.01.06-.02.09-.04.02-.01.04-.02.06-.02l.09-.03c.02-.01.03-.01.05-.02.08-.03.16-.05.24-.07.01 0 .03-.01.04-.01.07-.02.14-.03.21-.05h.02c.07-.01.14-.03.21-.04.02 0 .04-.01.05-.01l.18-.03h.03c.07-.01.14-.01.2-.02h.05c.05 0 .11-.01.16-.01h.53c.07 0 .15.01.22.01h.03c.08.01.15.01.23.02h.03c.09.01.19.03.28.04.01 0 .02 0 .03.01.12.02.23.05.35.08.01 0 .02.01.04.01.07.02.15.04.22.07.01 0 .01 0 .02.01.07.02.14.05.22.08.01.01.03.01.04.02.07.03.14.06.2.09.01.01.02.01.03.02.07.03.13.07.2.1l.15.09c.01.01.03.02.04.03.04.02.07.05.1.07.01.01.02.02.04.03.03.02.06.05.09.07.01.01.02.01.02.02.04.03.07.06.1.09l.06.06.02.02c.03.03.05.06.07.08 0 0 0 .01.01.01.02.02.04.05.06.07.01.01.01.02.02.03.01.02.02.03.03.05.03.04.05.08.07.12 0 .01.01.01.01.02.02.03.03.07.04.1 0 .01.01.02.01.03.01.04.03.08.04.12.01.04.02.08.02.12v.03c0 .03.01.07.01.1v.03-.15-.02-.02c0-.03 0-.07-.01-.1v-.03c-.01-.04-.01-.08-.02-.12a.564.564 0 00-.04-.12v-.01c0-.01-.01-.01-.01-.02-.01-.03-.03-.07-.04-.1 0-.01 0-.01-.01-.02v-.01a.746.746 0 00-.07-.12s0-.01-.01-.01a.138.138 0 01-.03-.04c-.01-.01-.01-.02-.02-.03-.02-.02-.04-.05-.06-.07 0 0 0-.01-.01-.01-.02-.03-.05-.06-.07-.08l-.02-.02c-.02-.02-.03-.04-.05-.05-.03-.03-.07-.06-.1-.09-.01-.01-.02-.01-.02-.02-.03-.02-.06-.05-.09-.07l-.01-.01c-.01-.01-.02-.01-.02-.02l-.1-.07c-.01-.01-.03-.02-.04-.03l-.15-.09c-.06-.04-.13-.07-.2-.1-.01-.01-.02-.01-.03-.02-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.14-.05-.22-.08-.01 0-.01 0-.02-.01-.07-.02-.14-.04-.22-.06-.01 0-.01 0-.02-.01h-.01c-.06-.01-.11-.03-.17-.04-.06-.01-.12-.03-.17-.04h-.03c-.09-.02-.18-.03-.28-.04h-.02c-.08-.01-.15-.02-.23-.02h-.03c-.08-.01-.15-.01-.22-.01h-.53c-.05 0-.11.01-.16.01h-.05c-.07.01-.14.01-.2.02h-.02l-.18.03h-.05c-.07.01-.14.02-.21.04h-.01c-.07.02-.14.03-.21.05-.01 0-.02 0-.03.01h-.01c-.08.02-.16.05-.24.07-.01 0-.01 0-.02.01-.01 0-.02.01-.03.01l-.09.03c-.07 0-.09.01-.11.02z'
                fill='url(#dataMigr_banner_svg__SVGID_323_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_324_'
                gradientUnits='userSpaceOnUse'
                x1={-3074.108}
                y1={-2227.569}
                x2={-3069.629}
                y2={-2227.569}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M553.27 124.6c-.07.03-.13.06-.2.09-.02.01-.04.02-.06.02-.03.01-.06.03-.1.04-.02.01-.04.02-.07.02-.03.01-.06.02-.1.03-.02.01-.04.01-.05.02-.08.03-.17.05-.25.07-.01 0-.03.01-.04.01-.07.02-.15.04-.22.05h-.02c-.07.02-.15.03-.22.04-.02 0-.04.01-.06.01l-.19.03h-.03c-.07.01-.14.02-.21.02h-.06c-.06 0-.11.01-.17.01h-.56c-.08 0-.15-.01-.23-.01h-.04l-.24-.03h-.03a2.5 2.5 0 01-.29-.05c-.01 0-.02 0-.04-.01-.06-.01-.12-.02-.18-.04-.06-.01-.12-.03-.18-.04-.01 0-.03-.01-.04-.01-.08-.02-.15-.04-.23-.07-.01 0-.01 0-.02-.01-.08-.03-.15-.05-.23-.08-.01-.01-.03-.01-.04-.02l-.21-.09c-.01-.01-.02-.01-.04-.02-.07-.03-.14-.07-.21-.11-.05-.03-.11-.06-.16-.1-.01-.01-.03-.02-.04-.03-.04-.02-.07-.05-.11-.08-.01-.01-.03-.02-.04-.03-.03-.02-.06-.05-.09-.07-.01-.01-.02-.01-.03-.02-.04-.03-.07-.06-.11-.1l-.06-.06-.02-.02c-.03-.03-.05-.06-.08-.09v-.01c-.02-.03-.04-.05-.06-.08-.01-.01-.01-.02-.02-.03-.01-.02-.02-.03-.03-.05-.03-.04-.05-.09-.07-.13 0-.01-.01-.01-.01-.02-.02-.04-.03-.07-.05-.11 0-.01-.01-.02-.01-.03-.01-.04-.03-.08-.04-.13-.01-.04-.02-.08-.02-.12v-.04c0-.03-.01-.07-.01-.1v-.03V123.18c0 .03 0 .07.01.1v.04c.01.04.01.08.02.12.01.04.02.08.04.13v.01c0 .01.01.02.01.02.01.04.03.07.05.11 0 .01 0 .01.01.02v.01c.02.04.05.09.07.13 0 0 0 .01.01.01.01.01.02.03.03.04s.01.02.02.03c.02.03.04.05.06.08 0 0 0 .01.01.01.02.03.05.06.08.09l.02.02c.02.02.04.04.05.06.04.03.07.07.11.1.01.01.02.01.03.02.03.02.06.05.09.07l.01.01c.01.01.02.01.03.02.03.03.07.05.11.08.01.01.03.02.04.03.05.03.1.06.16.1.07.04.14.07.21.11.01.01.02.01.04.02l.21.09c.01.01.03.01.04.02.07.03.15.06.23.08.01 0 .01 0 .02.01.07.02.15.05.23.07.01 0 .02 0 .02.01h.02c.06.02.12.03.18.04.06.01.12.03.18.04h.04c.1.02.19.03.29.05h.03l.24.03h.03c.08.01.15.01.23.01h.56c.06 0 .12-.01.17-.01h.06c.07-.01.14-.01.21-.02h.03l.19-.03h.05c.07-.01.15-.03.22-.04h.02c.07-.02.15-.03.22-.05.01 0 .02 0 .03-.01h.01c.09-.02.17-.05.25-.07.01 0 .02 0 .02-.01.01 0 .02-.01.03-.01.03-.01.06-.02.1-.03.02-.01.04-.02.07-.02.03-.01.06-.03.1-.04.02-.01.03-.01.05-.02h.01c.07-.03.14-.06.2-.09.01-.01.03-.01.04-.02.07-.03.13-.07.19-.11.48-.28.79-.62.93-.97.03-.06.05-.13.06-.2.01-.03.01-.07.02-.1.01-.07.02-.13.02-.2v-.15c0 .53-.34 1.06-1.03 1.47-.06.04-.13.07-.19.11 0-.01-.02 0-.03 0z'
                fill='url(#dataMigr_banner_svg__SVGID_324_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_325_'
                gradientUnits='userSpaceOnUse'
                x1={-3073.978}
                y1={-2227.713}
                x2={-3068.882}
                y2={-2227.713}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M548.43 124.5c-1.41-.8-1.42-2.12-.03-2.94 1.39-.82 3.67-.83 5.08-.03 1.41.8 1.42 2.12.03 2.94-1.4.82-3.67.84-5.08.03zm4.92-2.89c-1.34-.76-3.5-.75-4.82.02-1.32.78-1.31 2.03.03 2.79s3.5.75 4.82-.02c1.32-.77 1.31-2.03-.03-2.79'
                fill='url(#dataMigr_banner_svg__SVGID_325_)'
              />
            </g>
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_326_'
                gradientUnits='userSpaceOnUse'
                x1={-3070.967}
                y1={-2228.78}
                x2={-3070.016}
                y2={-2227.143}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M549.85 122.46c-.02-.03-.03-.06-.04-.09-.35-.74 1.02-1.06 1.09-1.08l.44.93.3.64a.642.642 0 00-.13-.1c-.15-.09-.35-.13-.56-.13l-1.1-.17z'
                fill='url(#dataMigr_banner_svg__SVGID_326_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_327_'
                gradientUnits='userSpaceOnUse'
                x1={-3071.296}
                y1={-2227.794}
                x2={-3069.922}
                y2={-2225.426}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M548.67 123.11c-.58-.33-.45-.86-.44-.89l1.61.24 1.11.17c-.21 0-.42.05-.57.14-.31.18-.31.47.01.65.05.03.11.06.18.08-.07-.01-.15-.02-.24-.04-.25-.04-.58-.09-.86-.13a.875.875 0 00-.16-.02c-.28-.04-.48-.11-.64-.2z'
                fill='url(#dataMigr_banner_svg__SVGID_327_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_328_'
                  gradientUnits='userSpaceOnUse'
                  x1={-3071.495}
                  y1={-2226.944}
                  x2={-3071.495}
                  y2={-2228.4}
                  gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
                >
                  <stop offset={0} stopColor='#7f64ff' />
                  <stop offset={0.484} stopColor='#7d62ff' />
                  <stop offset={0.752} stopColor='#775aff' />
                  <stop offset={0.967} stopColor='#6d4cff' />
                  <stop offset={1} stopColor='#6b49ff' />
                </linearGradient>
                <path
                  d='M550.39 123.42c-.31-.18-.32-.47-.01-.65.16-.09.37-.14.57-.14s.4.04.56.13c.05.03.1.06.13.1.14.14.14.32 0 .46-.03.03-.07.06-.12.09-.16.09-.36.14-.57.14-.13 0-.26-.02-.38-.06a.484.484 0 01-.18-.07z'
                  fill='url(#dataMigr_banner_svg__SVGID_328_)'
                />
              </g>
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_329_'
                  gradientUnits='userSpaceOnUse'
                  x1={-3071.91}
                  y1={-2226.976}
                  x2={-3070.769}
                  y2={-2225.009}
                  gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
                >
                  <stop offset={0.117} stopColor='#dddcf9' />
                  <stop offset={0.562} stopColor='#fff' />
                  <stop offset={0.708} stopColor='#f9f8fe' />
                  <stop offset={0.915} stopColor='#e6e6fb' />
                  <stop offset={1} stopColor='#dddcf9' />
                </linearGradient>
                <path
                  d='M548.29 124.02l1.17-.69c.29.04.61.09.86.13l.24.5c-.04.02-.08.05-.12.07-.93.54-2.09.02-2.15-.01z'
                  fill='url(#dataMigr_banner_svg__SVGID_329_)'
                />
              </g>
            </g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_330_'
              gradientUnits='userSpaceOnUse'
              x1={-3072.423}
              y1={-2230.217}
              x2={-3071.281}
              y2={-2228.25}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M551.64 123.32c.14-.14.14-.32 0-.46l-.3-.64c.04-.02.08-.05.12-.07.93-.55 2.1-.02 2.16.01l-1.17.69-.81.47z'
              fill='url(#dataMigr_banner_svg__SVGID_330_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_331_'
              gradientUnits='userSpaceOnUse'
              x1={-3073.144}
              y1={-2229.872}
              x2={-3071.771}
              y2={-2227.506}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M550.95 123.55c.21 0 .41-.05.57-.14.05-.03.09-.06.12-.09l.8-.47c.05.01.11.02.16.02.27.04.47.11.62.2.58.33.45.86.44.89l-1.61-.24-1.1-.17z'
              fill='url(#dataMigr_banner_svg__SVGID_331_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_332_'
                gradientUnits='userSpaceOnUse'
                x1={-3073.035}
                y1={-2228.164}
                x2={-3072.118}
                y2={-2226.584}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M551 124.89l-.44-.93-.24-.5c.09.01.17.03.24.04.12.04.25.06.38.06l1.1.17c.02.03.03.06.04.09.37.73-1.01 1.05-1.08 1.07z'
                fill='url(#dataMigr_banner_svg__SVGID_332_)'
              />
            </g>
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_333_'
                gradientUnits='userSpaceOnUse'
                x1={-3072.171}
                y1={-2228.565}
                x2={-3067.579}
                y2={-2228.565}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
              </linearGradient>
              <path
                d='M553.95 120.62c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.36.21.63.46.79.73zm-6.02 1.2c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.06.38.16.56z'
                fill='url(#dataMigr_banner_svg__SVGID_333_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_334_'
                gradientUnits='userSpaceOnUse'
                x1={-3070.771}
                y1={-2229.332}
                x2={-3066.179}
                y2={-2229.332}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0} stopColor='#2afadf' stopOpacity={0} />
                <stop offset={0.275} stopColor='#36d1ea' stopOpacity={0.165} />
                <stop offset={0.596} stopColor='#42a7f5' stopOpacity={0.358} />
                <stop offset={0.849} stopColor='#498dfc' stopOpacity={0.51} />
                <stop offset={1} stopColor='#4c83ff' stopOpacity={0.6} />
              </linearGradient>
              <path
                d='M553.91 119.03c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.36.21.63.45.79.73zm-6.02 1.19c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26l.02-.04-.02.04c-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.06.38.16.56z'
                fill='url(#dataMigr_banner_svg__SVGID_334_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_335_'
                  gradientUnits='userSpaceOnUse'
                  x1={-3069.378}
                  y1={-2230.069}
                  x2={-3064.787}
                  y2={-2230.069}
                  gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
                >
                  <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                  <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                  <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                  <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
                </linearGradient>
                <path
                  d='M553.84 117.45c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.36.21.63.46.79.73zm-6.01 1.19c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26l.02-.04-.02.04c-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.05.38.16.56z'
                  fill='url(#dataMigr_banner_svg__SVGID_335_)'
                />
              </g>
            </g>
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_336_'
              gradientUnits='userSpaceOnUse'
              x1={-3073.688}
              y1={-2220.736}
              x2={-3068.85}
              y2={-2220.736}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M547.24 124.98c-1.34-.76-3.5-.75-4.82.02-1.32.78-1.31 2.03.03 2.79s3.5.75 4.82-.02 1.31-2.02-.03-2.79'
              fill='url(#dataMigr_banner_svg__SVGID_336_)'
            />
            <path
              className='dataMigr_banner_svg__st25'
              d='M546.74 125.28c-1.06-.6-2.77-.6-3.82.02-1.05.61-1.04 1.61.02 2.21 1.06.6 2.77.6 3.82-.02 1.05-.62 1.04-1.61-.02-2.21'
            />
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_337_'
                gradientUnits='userSpaceOnUse'
                x1={-3073.108}
                y1={-2220.779}
                x2={-3068.847}
                y2={-2220.779}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M542.98 124.74c-.03.01-.06.02-.09.04-.01.01-.03.01-.04.02h-.01c-.07.03-.13.06-.19.09-.01.01-.03.01-.04.02-.06.03-.12.06-.18.1-.33.19-.57.42-.74.65-.04.06-.08.12-.11.18s-.06.12-.08.18c-.04.12-.06.25-.06.38v.15c0-.5.33-1.01.98-1.39.06-.04.12-.07.18-.1.01-.01.03-.01.04-.02.06-.03.12-.06.19-.09.02-.01.04-.01.05-.02.03-.01.06-.02.09-.04.02-.01.04-.02.06-.02l.09-.03c.02-.01.03-.01.05-.02.08-.03.16-.05.24-.07.01 0 .03-.01.04-.01.07-.02.14-.03.21-.05h.02c.07-.01.14-.03.21-.04.02 0 .04-.01.05-.01l.18-.03h.03c.07-.01.14-.01.2-.02h.05c.05 0 .11-.01.16-.01h.53c.07 0 .15.01.22.01h.03c.08.01.15.01.23.02h.03c.09.01.19.03.28.04.01 0 .02 0 .03.01.12.02.23.05.35.08.01 0 .02.01.04.01.07.02.15.04.22.07.01 0 .01 0 .02.01.07.02.14.05.22.08.01.01.03.01.04.02.07.03.14.06.2.09.01.01.02.01.03.02.07.03.13.07.2.1l.15.09c.01.01.03.02.04.03.04.02.07.05.1.07.01.01.02.02.04.03.03.02.06.05.09.07.01.01.02.01.02.02.04.03.07.06.1.09l.06.06.02.02c.03.03.05.06.07.08l.01.01c.02.02.04.05.06.07.01.01.01.02.02.03.01.02.02.03.03.05.03.04.05.08.07.12 0 .01.01.01.01.02.02.03.03.07.04.1 0 .01.01.02.01.03.01.04.03.08.04.12.01.04.02.08.02.12v.03c0 .03.01.07.01.1v.03-.15-.01-.02c0-.03 0-.07-.01-.1v-.03c-.01-.04-.01-.08-.02-.12a.564.564 0 00-.04-.12v-.01c0-.01-.01-.01-.01-.02-.01-.03-.03-.07-.04-.1 0-.01 0-.01-.01-.02v-.01a.746.746 0 00-.07-.12s0-.01-.01-.01a.138.138 0 01-.03-.04c-.01-.01-.01-.02-.02-.03-.02-.02-.04-.05-.06-.07 0 0 0-.01-.01-.01-.02-.03-.05-.06-.07-.08l-.02-.02c-.02-.02-.03-.04-.05-.05-.03-.03-.07-.06-.1-.09-.01-.01-.02-.01-.02-.02-.03-.02-.06-.05-.09-.07l-.01-.01c-.01-.01-.02-.01-.02-.02l-.1-.07c-.01-.01-.03-.02-.04-.03l-.15-.09c-.06-.04-.13-.07-.2-.1-.01-.01-.02-.01-.03-.02-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.14-.05-.22-.08-.01 0-.01 0-.02-.01-.07-.02-.14-.04-.22-.06-.01 0-.01 0-.02-.01h-.01c-.06-.01-.11-.03-.17-.04-.06-.01-.12-.03-.17-.04h-.03c-.09-.02-.18-.03-.28-.04h-.02c-.08-.01-.15-.02-.23-.02h-.03c-.08-.01-.15-.01-.22-.01h-.53c-.05 0-.11.01-.16.01h-.05c-.07.01-.14.01-.2.02h-.03l-.18.03h-.05c-.07.01-.14.02-.21.04h-.01c-.07.02-.14.03-.21.05-.01 0-.02 0-.03.01h-.01c-.08.02-.16.05-.24.07-.01 0-.01 0-.02.01-.01 0-.02.01-.03.01l-.09.03c-.06 0-.08 0-.1.01z'
                fill='url(#dataMigr_banner_svg__SVGID_337_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_338_'
                gradientUnits='userSpaceOnUse'
                x1={-3073.942}
                y1={-2220.591}
                x2={-3069.463}
                y2={-2220.591}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M547.16 127.98c-.06.03-.13.06-.2.09-.02.01-.04.02-.06.02-.03.01-.06.03-.1.04-.02.01-.04.02-.07.02-.03.01-.06.02-.1.03-.02.01-.04.01-.05.02-.08.03-.17.05-.25.07-.01 0-.03.01-.04.01-.07.02-.15.04-.22.05h-.02c-.07.02-.15.03-.22.04-.02 0-.04.01-.06.01l-.19.03h-.03c-.07.01-.14.02-.21.02h-.06c-.06 0-.11.01-.17.01h-.56c-.08 0-.15-.01-.23-.01h-.04l-.24-.03h-.03a2.5 2.5 0 01-.29-.05c-.01 0-.02 0-.04-.01-.06-.01-.12-.02-.18-.04-.06-.01-.12-.03-.18-.04-.01 0-.03-.01-.04-.01-.08-.02-.15-.04-.23-.07-.01 0-.01 0-.02-.01-.08-.03-.15-.05-.23-.08-.01-.01-.03-.01-.04-.02l-.21-.09c-.01-.01-.02-.01-.04-.02-.07-.03-.14-.07-.21-.11-.05-.03-.11-.06-.16-.1-.01-.01-.03-.02-.04-.03-.04-.02-.07-.05-.11-.08-.01-.01-.03-.02-.04-.03-.03-.02-.06-.05-.09-.07-.01-.01-.02-.01-.03-.02-.04-.03-.07-.06-.11-.1l-.06-.06-.02-.02c-.03-.03-.05-.06-.08-.09 0 0 0-.01-.01-.01-.02-.03-.04-.05-.06-.08-.01-.01-.01-.02-.02-.03-.01-.02-.02-.03-.03-.05-.03-.04-.05-.09-.07-.13 0-.01-.01-.01-.01-.02-.02-.04-.03-.07-.05-.11 0-.01-.01-.02-.01-.03-.01-.04-.03-.08-.04-.12-.01-.04-.02-.08-.02-.12v-.04c0-.03-.01-.07-.01-.1v-.03V126.57c0 .03 0 .07.01.1v.04c.01.04.01.08.02.12.01.04.02.08.04.13v.01c0 .01.01.01.01.02.01.04.03.07.05.11 0 .01 0 .01.01.02.02.04.05.09.07.13 0 0 0 .01.01.01.01.01.02.03.03.04s.01.02.02.03c.02.03.04.05.06.08 0 0 0 .01.01.01.02.03.05.06.08.09l.02.02c.02.02.04.04.05.06h.01c.03.03.07.07.11.1.01.01.02.01.03.02.03.02.06.05.09.07l.01.01c.01.01.02.01.03.02.03.03.07.05.11.08.01.01.03.02.04.03.05.03.1.06.16.1.07.04.14.07.21.11.01.01.02.01.04.02l.21.09c.01.01.03.01.04.02.07.03.15.06.23.08.01 0 .01 0 .02.01.07.02.15.05.23.07.01 0 .02 0 .02.01h.02c.06.02.12.03.18.04.06.01.12.03.18.04h.04c.1.02.19.03.29.05h.03l.24.03h.03c.08.01.16.01.24.01h.56c.06 0 .12-.01.17-.01h.06c.07-.01.14-.01.21-.02h.03l.19-.03h.05c.07-.01.15-.03.22-.04h.02c.07-.02.15-.03.22-.05.01 0 .02 0 .03-.01h.01c.09-.02.17-.05.25-.07.01 0 .02 0 .02-.01.01 0 .02-.01.03-.01.03-.01.06-.02.1-.03.02-.01.04-.02.07-.02.03-.01.06-.03.1-.04.02-.01.03-.01.05-.02 0 0 .01 0 .01-.01.07-.03.13-.06.2-.09.01-.01.03-.01.04-.02.07-.03.13-.07.19-.11.48-.28.79-.62.93-.97.03-.06.05-.13.06-.2.01-.03.01-.07.02-.1.01-.07.02-.13.02-.2v-.15c0 .53-.34 1.06-1.03 1.47-.06.04-.13.07-.19.11-.01-.01-.02 0-.04.01z'
                fill='url(#dataMigr_banner_svg__SVGID_338_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_339_'
                gradientUnits='userSpaceOnUse'
                x1={-3073.815}
                y1={-2220.732}
                x2={-3068.718}
                y2={-2220.732}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M542.32 127.88c-1.41-.8-1.42-2.12-.03-2.94 1.39-.82 3.67-.83 5.08-.03 1.41.8 1.42 2.12.03 2.94-1.39.82-3.67.83-5.08.03zm4.92-2.9c-1.34-.76-3.5-.75-4.82.02-1.32.78-1.31 2.03.03 2.79s3.5.75 4.82-.02 1.31-2.02-.03-2.79'
                fill='url(#dataMigr_banner_svg__SVGID_339_)'
              />
            </g>
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_340_'
                gradientUnits='userSpaceOnUse'
                x1={-3070.806}
                y1={-2221.803}
                x2={-3069.855}
                y2={-2220.166}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M543.74 125.84c-.01-.03-.03-.06-.04-.09-.35-.74 1.02-1.06 1.09-1.08l.44.93.3.64a.642.642 0 00-.13-.1c-.15-.09-.35-.13-.56-.13l-1.1-.17z'
                fill='url(#dataMigr_banner_svg__SVGID_340_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_341_'
                gradientUnits='userSpaceOnUse'
                x1={-3071.126}
                y1={-2220.822}
                x2={-3069.752}
                y2={-2218.454}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M542.57 126.48c-.58-.33-.45-.86-.44-.89l1.61.24 1.11.17c-.21 0-.42.05-.57.14-.31.18-.31.47.01.65.05.03.11.06.18.08-.07-.01-.15-.02-.24-.04-.25-.04-.58-.09-.86-.13a.875.875 0 00-.16-.02c-.29-.04-.49-.11-.64-.2z'
                fill='url(#dataMigr_banner_svg__SVGID_341_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_342_'
                  gradientUnits='userSpaceOnUse'
                  x1={-3071.332}
                  y1={-2219.968}
                  x2={-3071.332}
                  y2={-2221.425}
                  gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
                >
                  <stop offset={0} stopColor='#7f64ff' />
                  <stop offset={0.484} stopColor='#7d62ff' />
                  <stop offset={0.752} stopColor='#775aff' />
                  <stop offset={0.967} stopColor='#6d4cff' />
                  <stop offset={1} stopColor='#6b49ff' />
                </linearGradient>
                <path
                  d='M544.28 126.8c-.31-.18-.32-.47-.01-.65.16-.09.37-.14.57-.14s.4.04.56.13c.05.03.1.06.13.1.14.14.14.32 0 .46-.03.03-.07.06-.12.09-.16.09-.36.14-.57.14a1.336 1.336 0 01-.56-.13z'
                  fill='url(#dataMigr_banner_svg__SVGID_342_)'
                />
              </g>
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_343_'
                  gradientUnits='userSpaceOnUse'
                  x1={-3071.748}
                  y1={-2219.999}
                  x2={-3070.607}
                  y2={-2218.032}
                  gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
                >
                  <stop offset={0.117} stopColor='#dddcf9' />
                  <stop offset={0.562} stopColor='#fff' />
                  <stop offset={0.708} stopColor='#f9f8fe' />
                  <stop offset={0.915} stopColor='#e6e6fb' />
                  <stop offset={1} stopColor='#dddcf9' />
                </linearGradient>
                <path
                  d='M542.18 127.4l1.17-.69c.29.04.61.09.86.13l.24.5c-.04.02-.08.05-.12.07-.92.54-2.09.01-2.15-.01z'
                  fill='url(#dataMigr_banner_svg__SVGID_343_)'
                />
              </g>
            </g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_344_'
              gradientUnits='userSpaceOnUse'
              x1={-3072.262}
              y1={-2223.24}
              x2={-3071.12}
              y2={-2221.273}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M545.54 126.7c.14-.14.14-.32 0-.46l-.3-.64c.04-.02.08-.05.12-.07.93-.55 2.1-.02 2.16.01l-1.17.69-.81.47z'
              fill='url(#dataMigr_banner_svg__SVGID_344_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_345_'
              gradientUnits='userSpaceOnUse'
              x1={-3072.983}
              y1={-2222.895}
              x2={-3071.609}
              y2={-2220.529}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M544.84 126.93c.21 0 .41-.05.57-.14.05-.03.09-.06.12-.09l.8-.47c.05.01.11.02.16.02.27.04.47.11.62.2.58.33.45.86.44.89l-1.61-.24-1.1-.17z'
              fill='url(#dataMigr_banner_svg__SVGID_345_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_346_'
                gradientUnits='userSpaceOnUse'
                x1={-3072.874}
                y1={-2221.187}
                x2={-3071.957}
                y2={-2219.607}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M544.9 128.27l-.44-.93-.24-.5c.09.01.17.03.24.04.12.04.25.06.38.06l1.1.17c.02.03.03.06.04.09.36.73-1.01 1.05-1.08 1.07z'
                fill='url(#dataMigr_banner_svg__SVGID_346_)'
              />
            </g>
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_347_'
                gradientUnits='userSpaceOnUse'
                x1={-3072.008}
                y1={-2221.584}
                x2={-3067.416}
                y2={-2221.584}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
              </linearGradient>
              <path
                d='M547.84 124c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.36.21.63.46.79.73zm-6.01 1.19c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.05.38.16.56z'
                fill='url(#dataMigr_banner_svg__SVGID_347_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_348_'
                gradientUnits='userSpaceOnUse'
                x1={-3070.606}
                y1={-2222.357}
                x2={-3066.014}
                y2={-2222.357}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0} stopColor='#2afadf' stopOpacity={0} />
                <stop offset={0.275} stopColor='#36d1ea' stopOpacity={0.165} />
                <stop offset={0.596} stopColor='#42a7f5' stopOpacity={0.358} />
                <stop offset={0.849} stopColor='#498dfc' stopOpacity={0.51} />
                <stop offset={1} stopColor='#4c83ff' stopOpacity={0.6} />
              </linearGradient>
              <path
                d='M547.8 122.4c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.36.21.63.46.79.73zm-6.01 1.2c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26l.02-.04-.02.04c-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.05.38.16.56z'
                fill='url(#dataMigr_banner_svg__SVGID_348_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_349_'
                  gradientUnits='userSpaceOnUse'
                  x1={-3069.206}
                  y1={-2223.093}
                  x2={-3064.615}
                  y2={-2223.093}
                  gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
                >
                  <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                  <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                  <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                  <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
                </linearGradient>
                <path
                  d='M547.73 120.82c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.37.21.63.46.79.73zm-6.01 1.2c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26l.02-.04-.02.04c-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.06.38.16.56z'
                  fill='url(#dataMigr_banner_svg__SVGID_349_)'
                />
              </g>
            </g>
          </g>
        </g>
        <g>
          <g className='dataMigr_banner_svg__st1'>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_350_'
              gradientUnits='userSpaceOnUse'
              x1={2796.583}
              y1={270.279}
              x2={2796.583}
              y2={236.865}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_350_)' d='M569.42 129.9l.15 25.72-13.31 7.73-.15-25.72z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_351_'
              gradientUnits='userSpaceOnUse'
              x1={2807.097}
              y1={236.865}
              x2={2807.097}
              y2={267.056}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_351_)' d='M556.26 163.35l-7.72-4.45-.14-25.72 7.71 4.45z' />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_352_'
                gradientUnits='userSpaceOnUse'
                x1={2789.958}
                y1={268.673}
                x2={2810.986}
                y2={268.673}
                gradientTransform='rotate(180 1679.786 198.591)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path fill='url(#dataMigr_banner_svg__SVGID_352_)' d='M556.11 137.63l-7.71-4.45 13.31-7.74 7.71 4.46z' />
            </g>
          </g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_353_'
            gradientUnits='userSpaceOnUse'
            x1={2792.915}
            y1={261.557}
            x2={2800.108}
            y2={261.557}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_353_)' d='M566.48 136.94l-7.18 4.17v-.77l6.98-4.06.2-.11z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_354_'
            gradientUnits='userSpaceOnUse'
            x1={2792.91}
            y1={260.192}
            x2={2800.11}
            y2={260.192}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            fill='url(#dataMigr_banner_svg__SVGID_354_)'
            d='M566.49 138.31l-7.18 4.17v-.22l-.01-.56 6.99-4.05.19-.12z'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_355_'
            gradientUnits='userSpaceOnUse'
            x1={2792.921}
            y1={262.922}
            x2={2800.114}
            y2={262.922}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_355_)' d='M566.47 135.57l-7.18 4.18v-.78l6.98-4.05.2-.12z' />
          <path
            className='dataMigr_banner_svg__st25'
            d='M566.28 136.83l-6.98 4.06v-.55l6.98-4.06zM566.29 138.2l-6.98 4.06-.01-.56 6.99-4.05zM566.27 135.47l-6.98 4.05v-.55l6.98-4.05z'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_356_'
            gradientUnits='userSpaceOnUse'
            x1={2792.911}
            y1={256.177}
            x2={2800.104}
            y2={256.177}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            fill='url(#dataMigr_banner_svg__SVGID_356_)'
            d='M566.5 142.32l-7.18 4.17-.01-.22v-.55l6.98-4.06.2-.11z'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_357_'
            gradientUnits='userSpaceOnUse'
            x1={2792.913}
            y1={254.812}
            x2={2800.106}
            y2={254.812}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path fill='url(#dataMigr_banner_svg__SVGID_357_)' d='M566.5 143.68l-7.18 4.18v-.78l6.98-4.05.2-.12z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_358_'
            gradientUnits='userSpaceOnUse'
            x1={2792.918}
            y1={257.547}
            x2={2800.117}
            y2={257.547}
            gradientTransform='rotate(180 1679.786 198.591)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            fill='url(#dataMigr_banner_svg__SVGID_358_)'
            d='M566.49 140.95l-7.18 4.17v-.22l-.01-.55 6.99-4.06.19-.11z'
          />
          <path
            className='dataMigr_banner_svg__st25'
            d='M566.3 142.21l-6.99 4.06v-.55l6.98-4.06zM566.3 143.58l-6.98 4.05v-.55l6.98-4.05zM566.29 140.85l-6.98 4.05-.01-.55 6.99-4.06z'
          />
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_359_'
              gradientUnits='userSpaceOnUse'
              x1={2792.914}
              y1={250.802}
              x2={2800.107}
              y2={250.802}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_359_)' d='M566.51 147.7l-7.18 4.17v-.77l6.98-4.06.2-.12z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_360_'
              gradientUnits='userSpaceOnUse'
              x1={2792.909}
              y1={249.437}
              x2={2800.109}
              y2={249.437}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              fill='url(#dataMigr_banner_svg__SVGID_360_)'
              d='M566.52 149.06l-7.18 4.17v-.22l-.01-.55 6.99-4.06.19-.11z'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_361_'
                gradientUnits='userSpaceOnUse'
                x1={2792.92}
                y1={252.167}
                x2={2800.113}
                y2={252.167}
                gradientTransform='rotate(180 1679.786 198.591)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path fill='url(#dataMigr_banner_svg__SVGID_361_)' d='M566.5 146.33l-7.18 4.17v-.77l6.98-4.06.2-.11z' />
            </g>
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M566.31 147.59l-6.98 4.06v-.55l6.98-4.06zM566.32 148.96l-6.98 4.05-.01-.55 6.99-4.06zM566.3 146.22l-6.98 4.06v-.55l6.98-4.06z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_362_'
              gradientUnits='userSpaceOnUse'
              x1={2792.918}
              y1={245.422}
              x2={2800.111}
              y2={245.422}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              fill='url(#dataMigr_banner_svg__SVGID_362_)'
              d='M566.52 153.08l-7.17 4.17-.01-.22v-.56l6.98-4.05.2-.12z'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_363_'
              gradientUnits='userSpaceOnUse'
              x1={2792.912}
              y1={244.057}
              x2={2800.105}
              y2={244.057}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_363_)' d='M566.53 154.44l-7.18 4.17v-.77l6.98-4.06.2-.11z' />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_364_'
                gradientUnits='userSpaceOnUse'
                x1={2792.916}
                y1={246.787}
                x2={2800.116}
                y2={246.787}
                gradientTransform='rotate(180 1679.786 198.591)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                fill='url(#dataMigr_banner_svg__SVGID_364_)'
                d='M566.52 151.71l-7.18 4.17v-.22l-.01-.55 6.99-4.06.19-.11z'
              />
            </g>
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M566.33 152.97l-6.99 4.06v-.56l6.98-4.05zM566.33 154.33l-6.98 4.06v-.55l6.98-4.06zM566.32 151.6l-6.98 4.06-.01-.55 6.99-4.06z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_365_'
              gradientUnits='userSpaceOnUse'
              x1={2805.349}
              y1={260.076}
              x2={2809.058}
              y2={260.076}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_365_)' d='M554.05 140.82l.01.79-3.72-2.13v-.79l.11.07.06.03z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_366_'
              gradientUnits='userSpaceOnUse'
              x1={2805.351}
              y1={258.686}
              x2={2809.067}
              y2={258.686}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_366_)' d='M554.06 142.21v.79l-3.72-2.14v-.78l.17.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_367_'
              gradientUnits='userSpaceOnUse'
              x1={2805.353}
              y1={261.461}
              x2={2809.06}
              y2={261.461}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_367_)' d='M554.05 139.44v.78l-3.71-2.13v-.78l.17.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M554.05 140.82l.01.58-3.55-2.03v-.58zM554.06 142.21v.58l-3.55-2.03v-.58zM554.05 139.44v.58l-3.54-2.03v-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_368_'
              gradientUnits='userSpaceOnUse'
              x1={2805.352}
              y1={254.626}
              x2={2809.058}
              y2={254.626}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_368_)' d='M554.07 146.27v.79l-3.71-2.13v-.79l.11.07.06.03z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_369_'
              gradientUnits='userSpaceOnUse'
              x1={2805.352}
              y1={253.236}
              x2={2809.066}
              y2={253.236}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_369_)' d='M554.07 147.66l.01.79-3.72-2.14v-.78l.17.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_370_'
              gradientUnits='userSpaceOnUse'
              x1={2805.352}
              y1={256.011}
              x2={2809.059}
              y2={256.011}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_370_)' d='M554.07 144.89v.78l-3.71-2.13v-.78l.17.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M554.07 146.27v.59l-3.54-2.04v-.58zM554.07 147.66v.58l-3.54-2.03v-.58zM554.07 144.89v.58l-3.54-2.03v-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_371_'
              gradientUnits='userSpaceOnUse'
              x1={2805.349}
              y1={249.171}
              x2={2809.058}
              y2={249.171}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_371_)' d='M554.08 151.73l.01.78-3.72-2.13v-.78l.11.06.06.04z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_372_'
              gradientUnits='userSpaceOnUse'
              x1={2805.35}
              y1={247.786}
              x2={2809.067}
              y2={247.786}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_372_)' d='M554.09 153.11v.79l-3.72-2.14v-.78l.17.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_373_'
              gradientUnits='userSpaceOnUse'
              x1={2805.353}
              y1={250.561}
              x2={2809.059}
              y2={250.561}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_373_)' d='M554.08 150.34v.78l-3.71-2.13v-.78l.17.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M554.08 151.73l.01.58-3.55-2.04v-.57zM554.09 153.11v.58l-3.55-2.03v-.58zM554.08 150.34v.58l-3.54-2.03v-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_374_'
              gradientUnits='userSpaceOnUse'
              x1={2805.351}
              y1={243.721}
              x2={2809.058}
              y2={243.721}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_374_)' d='M554.1 157.18v.78l-3.71-2.13v-.78l.11.06.06.04z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_375_'
              gradientUnits='userSpaceOnUse'
              x1={2805.352}
              y1={242.336}
              x2={2809.066}
              y2={242.336}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_375_)' d='M554.1 158.56l.01.79-3.72-2.13v-.79l.17.1z' />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_376_'
              gradientUnits='userSpaceOnUse'
              x1={2805.352}
              y1={245.106}
              x2={2809.058}
              y2={245.106}
              gradientTransform='rotate(180 1679.786 198.591)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path fill='url(#dataMigr_banner_svg__SVGID_376_)' d='M554.1 155.79v.79l-3.71-2.13v-.79l.17.1z' />
          </g>
          <g>
            <path
              className='dataMigr_banner_svg__st25'
              d='M554.1 157.18v.58l-3.54-2.03v-.58zM554.1 158.56v.59l-3.54-2.04v-.58zM554.1 155.79v.58l-3.54-2.03v-.58z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_377_'
              gradientUnits='userSpaceOnUse'
              x1={-3085.029}
              y1={-2234.119}
              x2={-3080.191}
              y2={-2234.119}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M564.52 128.03c-1.34-.76-3.5-.75-4.82.02-1.32.78-1.31 2.03.03 2.79s3.5.75 4.82-.02c1.32-.78 1.31-2.03-.03-2.79'
              fill='url(#dataMigr_banner_svg__SVGID_377_)'
            />
            <path
              className='dataMigr_banner_svg__st25'
              d='M564.02 128.32c-1.06-.6-2.77-.6-3.82.02-1.05.61-1.04 1.61.02 2.21s2.77.6 3.82-.02c1.05-.61 1.04-1.61-.02-2.21'
            />
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_378_'
                gradientUnits='userSpaceOnUse'
                x1={-3084.45}
                y1={-2234.153}
                x2={-3080.19}
                y2={-2234.153}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M560.25 127.79c-.03.01-.06.02-.09.04-.01.01-.03.01-.04.02h-.01c-.06.03-.13.06-.19.09-.01.01-.03.01-.04.02-.06.03-.12.06-.18.1-.33.19-.57.42-.74.65-.04.06-.08.12-.11.18s-.06.12-.08.18c-.04.12-.06.25-.06.38v.15c0-.5.33-1.01.98-1.39.06-.04.12-.07.18-.1.01-.01.03-.01.04-.02.06-.03.12-.06.19-.09.02-.01.04-.01.05-.02.03-.01.06-.02.09-.04.02-.01.04-.02.06-.02l.09-.03c.02-.01.03-.01.05-.02.08-.03.16-.05.24-.07.01 0 .03-.01.04-.01.07-.02.14-.03.21-.05h.02c.07-.01.14-.03.21-.04.02 0 .04-.01.05-.01l.18-.03h.03c.07-.01.14-.01.2-.02h.05c.05 0 .11-.01.16-.01h.53c.07 0 .15.01.22.01h.03c.08.01.15.01.23.02h.03c.09.01.19.03.28.04.01 0 .02 0 .03.01.12.02.23.05.35.08.01 0 .02.01.04.01.07.02.15.04.22.07.01 0 .01 0 .02.01.07.02.14.05.22.08.01.01.03.01.04.02.07.03.14.06.2.09.01.01.02.01.03.02.07.03.13.07.2.1l.15.09c.01.01.03.02.04.03.04.02.07.05.1.07.01.01.02.02.04.03.03.02.06.05.09.07.01.01.02.01.02.02.04.03.07.06.1.09l.06.06.02.02c.03.03.05.06.07.08l.01.01c.02.02.04.05.06.07.01.01.01.02.02.03.01.02.02.03.03.05.03.04.05.08.07.12 0 .01.01.01.01.02.02.03.03.07.04.1 0 .01.01.02.01.03.01.04.03.08.04.12.01.04.02.08.02.12v.03c0 .03.01.07.01.1v.03-.15-.02-.02c0-.03 0-.07-.01-.1v-.03c-.01-.04-.01-.08-.02-.12a.564.564 0 00-.04-.12v-.01c0-.01-.01-.01-.01-.02-.01-.03-.03-.07-.04-.1 0-.01 0-.01-.01-.02-.02-.04-.05-.08-.07-.12 0 0 0-.01-.01-.01a.138.138 0 01-.03-.04c-.01-.01-.01-.02-.02-.03-.02-.02-.04-.05-.06-.07v-.01c-.02-.03-.05-.06-.07-.08l-.02-.02c-.02-.02-.03-.04-.05-.05-.03-.03-.07-.06-.1-.09-.01-.01-.02-.01-.02-.02-.03-.02-.06-.05-.09-.07l-.01-.01c-.01-.01-.02-.01-.02-.02l-.1-.07c-.01-.01-.03-.02-.04-.03l-.15-.09c-.06-.04-.13-.07-.2-.1-.01-.01-.02-.01-.03-.02-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.14-.05-.22-.08-.01 0-.01 0-.02-.01-.07-.02-.14-.04-.22-.06-.01 0-.01 0-.02-.01h-.01c-.06-.01-.11-.03-.17-.04-.06-.01-.12-.03-.17-.04h-.03c-.09-.02-.18-.03-.28-.04h-.03c-.08-.01-.15-.02-.23-.02h-.03c-.08-.01-.15-.01-.22-.01h-.53c-.05 0-.11.01-.16.01h-.05c-.07.01-.14.01-.2.02h-.03l-.18.03h-.05c-.07.01-.14.02-.21.04h-.02c-.07.02-.14.03-.21.05-.01 0-.02 0-.03.01h-.01c-.08.02-.16.05-.24.07-.01 0-.01 0-.02.01-.01 0-.02.01-.03.01l-.09.03c-.04-.01-.06 0-.09.01z'
                fill='url(#dataMigr_banner_svg__SVGID_378_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_379_'
                gradientUnits='userSpaceOnUse'
                x1={-3085.285}
                y1={-2233.963}
                x2={-3080.806}
                y2={-2233.963}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M564.44 131.02c-.06.03-.13.06-.2.09-.02.01-.04.02-.06.02-.03.01-.06.03-.1.04-.02.01-.04.02-.07.02-.03.01-.06.02-.1.03-.02.01-.04.01-.05.02-.08.03-.17.05-.25.07-.01 0-.03.01-.04.01-.07.02-.15.04-.22.05h-.02c-.07.02-.15.03-.22.04-.02 0-.04.01-.06.01l-.19.03h-.03c-.07.01-.14.02-.21.02h-.06c-.06 0-.11.01-.17.01h-.56c-.08 0-.15-.01-.23-.01h-.04l-.24-.03h-.03a2.5 2.5 0 01-.29-.05c-.01 0-.02 0-.04-.01-.06-.01-.12-.02-.18-.04-.06-.01-.12-.03-.18-.04-.01 0-.03-.01-.04-.01-.08-.02-.15-.04-.23-.07-.01 0-.01 0-.02-.01-.08-.03-.15-.05-.23-.08-.01-.01-.03-.01-.04-.02l-.21-.09c-.01-.01-.02-.01-.04-.02-.07-.03-.14-.07-.21-.11-.05-.03-.11-.06-.16-.1-.01-.01-.03-.02-.04-.03-.04-.02-.07-.05-.11-.08-.01-.01-.03-.02-.04-.03-.03-.02-.06-.05-.09-.07-.01-.01-.02-.01-.03-.02-.04-.03-.07-.06-.11-.1l-.06-.06-.02-.02c-.03-.03-.05-.06-.08-.09 0 0 0-.01-.01-.01-.02-.03-.04-.05-.06-.08-.01-.01-.01-.02-.02-.03-.01-.02-.02-.03-.03-.05-.03-.04-.05-.09-.07-.13 0-.01-.01-.01-.01-.02-.02-.04-.03-.07-.05-.11 0-.01-.01-.02-.01-.03-.01-.04-.03-.08-.04-.12-.01-.04-.02-.08-.02-.12v-.04c0-.03-.01-.07-.01-.1v-.03V129.61c0 .03 0 .07.01.1v.04c.01.04.01.08.02.12.01.04.02.08.04.13v.01c0 .01.01.01.01.02.01.04.03.07.05.11 0 .01 0 .01.01.02.02.04.05.09.07.13v.01c.01.02.02.03.03.04s.01.02.02.03c.02.03.04.05.06.08 0 0 0 .01.01.01.02.03.05.06.08.09l.02.02c.02.02.04.04.05.06.04.03.07.07.11.1.01.01.02.01.03.02.03.02.06.05.09.07l.01.01c.01.01.02.01.03.02.03.03.07.05.11.08.01.01.03.02.04.03.05.03.1.06.16.1.07.04.14.07.21.11.01.01.02.01.04.02l.21.09c.01.01.03.01.04.02.07.03.15.06.23.08.01 0 .01 0 .02.01.07.02.15.05.23.07.01 0 .02 0 .02.01h.02c.06.02.12.03.18.04.06.01.12.03.18.04h.04c.1.02.19.03.29.05h.03l.24.03h.03c.08.01.15.01.23.01h.56c.06 0 .12-.01.17-.01h.06c.07-.01.14-.01.21-.02h.03l.19-.03h.05c.07-.01.15-.03.22-.04h.02c.07-.02.15-.03.22-.05.01 0 .02 0 .03-.01h.01c.09-.02.17-.05.25-.07.01 0 .02 0 .02-.01.01 0 .02-.01.03-.01.03-.01.06-.02.1-.03.02-.01.04-.02.07-.02.03-.01.06-.03.1-.04.02-.01.03-.01.05-.02 0 0 .01 0 .01-.01.07-.03.13-.06.2-.09.01-.01.03-.01.04-.02.07-.03.13-.07.19-.11.48-.28.79-.62.93-.97.03-.06.05-.13.06-.2.01-.03.01-.07.02-.1.01-.07.02-.13.02-.2v-.15c0 .53-.34 1.06-1.03 1.47-.06.04-.13.07-.19.11.02 0 .01 0-.01.01z'
                fill='url(#dataMigr_banner_svg__SVGID_379_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_380_'
                gradientUnits='userSpaceOnUse'
                x1={-3085.155}
                y1={-2234.119}
                x2={-3080.059}
                y2={-2234.119}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M559.6 130.92c-1.41-.8-1.42-2.12-.03-2.94 1.39-.82 3.67-.83 5.08-.03 1.41.8 1.42 2.12.03 2.94-1.39.82-3.67.83-5.08.03zm4.92-2.89c-1.34-.76-3.5-.75-4.82.02-1.32.78-1.31 2.03.03 2.79s3.5.75 4.82-.02c1.32-.78 1.31-2.03-.03-2.79'
                fill='url(#dataMigr_banner_svg__SVGID_380_)'
              />
            </g>
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_381_'
                gradientUnits='userSpaceOnUse'
                x1={-3082.146}
                y1={-2235.19}
                x2={-3081.195}
                y2={-2233.552}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M561.02 128.88c-.01-.03-.03-.06-.04-.09-.35-.74 1.02-1.06 1.09-1.08l.44.93.3.64a.642.642 0 00-.13-.1c-.15-.09-.35-.13-.56-.13l-1.1-.17z'
                fill='url(#dataMigr_banner_svg__SVGID_381_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_382_'
                gradientUnits='userSpaceOnUse'
                x1={-3082.475}
                y1={-2234.205}
                x2={-3081.101}
                y2={-2231.836}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M559.85 129.53c-.58-.33-.45-.86-.44-.89l1.61.24 1.11.17c-.21 0-.42.05-.57.14-.31.18-.31.47.01.65.05.03.11.06.18.08-.07-.01-.15-.02-.24-.04-.25-.04-.58-.09-.86-.13a.875.875 0 00-.16-.02c-.29-.05-.49-.12-.64-.2z'
                fill='url(#dataMigr_banner_svg__SVGID_382_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_383_'
                  gradientUnits='userSpaceOnUse'
                  x1={-3082.672}
                  y1={-2233.353}
                  x2={-3082.672}
                  y2={-2234.809}
                  gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
                >
                  <stop offset={0} stopColor='#7f64ff' />
                  <stop offset={0.484} stopColor='#7d62ff' />
                  <stop offset={0.752} stopColor='#775aff' />
                  <stop offset={0.967} stopColor='#6d4cff' />
                  <stop offset={1} stopColor='#6b49ff' />
                </linearGradient>
                <path
                  d='M561.56 129.84c-.31-.18-.32-.47-.01-.65.16-.09.37-.14.57-.14s.4.04.56.13c.05.03.1.06.13.1.14.14.14.32 0 .46-.03.03-.07.06-.12.09-.16.09-.36.14-.57.14-.13 0-.26-.02-.38-.06-.06-.02-.12-.04-.18-.07z'
                  fill='url(#dataMigr_banner_svg__SVGID_383_)'
                />
              </g>
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_384_'
                  gradientUnits='userSpaceOnUse'
                  x1={-3083.089}
                  y1={-2233.385}
                  x2={-3081.948}
                  y2={-2231.418}
                  gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
                >
                  <stop offset={0.117} stopColor='#dddcf9' />
                  <stop offset={0.562} stopColor='#fff' />
                  <stop offset={0.708} stopColor='#f9f8fe' />
                  <stop offset={0.915} stopColor='#e6e6fb' />
                  <stop offset={1} stopColor='#dddcf9' />
                </linearGradient>
                <path
                  d='M559.46 130.44l1.17-.69c.29.04.61.09.86.13l.24.5c-.04.02-.08.05-.12.07-.92.54-2.09.02-2.15-.01z'
                  fill='url(#dataMigr_banner_svg__SVGID_384_)'
                />
              </g>
            </g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_385_'
              gradientUnits='userSpaceOnUse'
              x1={-3083.602}
              y1={-2236.628}
              x2={-3082.46}
              y2={-2234.661}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M562.81 129.74c.14-.14.14-.32 0-.46l-.3-.64c.04-.02.08-.05.12-.07.93-.55 2.1-.02 2.16.01l-1.17.69-.81.47z'
              fill='url(#dataMigr_banner_svg__SVGID_385_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_386_'
              gradientUnits='userSpaceOnUse'
              x1={-3084.323}
              y1={-2236.281}
              x2={-3082.949}
              y2={-2233.915}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M562.12 129.97c.21 0 .41-.05.57-.14.05-.03.09-.06.12-.09l.8-.47c.05.01.11.02.16.02.27.04.47.11.62.2.58.33.45.86.44.89l-1.61-.24-1.1-.17z'
              fill='url(#dataMigr_banner_svg__SVGID_386_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_387_'
                gradientUnits='userSpaceOnUse'
                x1={-3084.214}
                y1={-2234.573}
                x2={-3083.297}
                y2={-2232.993}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M562.17 131.31l-.44-.93-.24-.5c.09.01.17.03.24.04.12.04.25.06.38.06l1.1.17c.01.03.03.06.04.09.37.73-1 1.05-1.08 1.07z'
                fill='url(#dataMigr_banner_svg__SVGID_387_)'
              />
            </g>
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_388_'
                gradientUnits='userSpaceOnUse'
                x1={-3083.348}
                y1={-2234.971}
                x2={-3078.756}
                y2={-2234.971}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
              </linearGradient>
              <path
                d='M565.12 127.04c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.36.21.63.46.79.73zm-6.01 1.2c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.05.38.16.56z'
                fill='url(#dataMigr_banner_svg__SVGID_388_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_389_'
                gradientUnits='userSpaceOnUse'
                x1={-3081.948}
                y1={-2235.739}
                x2={-3077.356}
                y2={-2235.739}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0} stopColor='#2afadf' stopOpacity={0} />
                <stop offset={0.275} stopColor='#36d1ea' stopOpacity={0.165} />
                <stop offset={0.596} stopColor='#42a7f5' stopOpacity={0.358} />
                <stop offset={0.849} stopColor='#498dfc' stopOpacity={0.51} />
                <stop offset={1} stopColor='#4c83ff' stopOpacity={0.6} />
              </linearGradient>
              <path
                d='M565.08 125.45c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.36.2.63.45.79.73zm-6.01 1.19c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26l.02-.04-.02.04c-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.05.38.16.56z'
                fill='url(#dataMigr_banner_svg__SVGID_389_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_390_'
                  gradientUnits='userSpaceOnUse'
                  x1={-3080.556}
                  y1={-2236.475}
                  x2={-3075.964}
                  y2={-2236.475}
                  gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
                >
                  <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                  <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                  <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                  <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
                </linearGradient>
                <path
                  d='M565.01 123.87c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.36.2.63.45.79.73zm-6.01 1.19c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26l.02-.04-.02.04c-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.06.38.16.56z'
                  fill='url(#dataMigr_banner_svg__SVGID_390_)'
                />
              </g>
            </g>
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_391_'
              gradientUnits='userSpaceOnUse'
              x1={-3084.862}
              y1={-2227.15}
              x2={-3080.024}
              y2={-2227.15}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M558.42 131.4c-1.34-.76-3.5-.75-4.82.02-1.32.78-1.31 2.03.03 2.79s3.5.75 4.82-.02c1.32-.77 1.3-2.03-.03-2.79'
              fill='url(#dataMigr_banner_svg__SVGID_391_)'
            />
            <path
              className='dataMigr_banner_svg__st25'
              d='M557.91 131.7c-1.06-.6-2.77-.6-3.82.02-1.05.61-1.04 1.61.02 2.21s2.77.6 3.82-.02 1.04-1.61-.02-2.21'
            />
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_392_'
                gradientUnits='userSpaceOnUse'
                x1={-3084.285}
                y1={-2227.189}
                x2={-3080.024}
                y2={-2227.189}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M554.15 131.16c-.03.01-.06.02-.09.04-.01.01-.03.01-.04.02h-.01c-.06.03-.13.06-.19.09-.01.01-.03.01-.04.02-.06.03-.12.06-.18.1-.33.19-.57.42-.74.65-.04.06-.08.12-.11.18s-.06.12-.08.18c-.04.12-.06.25-.06.38v.15c0-.5.33-1.01.98-1.39.06-.04.12-.07.18-.1.01-.01.03-.01.04-.02.06-.03.12-.06.19-.09.02-.01.04-.01.05-.02.03-.01.06-.02.09-.04.02-.01.04-.02.06-.02l.09-.03c.02-.01.03-.01.05-.02.08-.03.16-.05.24-.07.01 0 .03-.01.04-.01.07-.02.14-.03.21-.05h.02c.07-.01.14-.03.21-.04.02 0 .04-.01.05-.01l.18-.03h.03c.07-.01.14-.01.2-.02h.05c.05 0 .11-.01.16-.01h.53c.07 0 .15.01.22.01h.03c.08.01.15.01.23.02h.03c.09.01.19.03.28.04.01 0 .02 0 .03.01.12.02.23.05.35.08.01 0 .02.01.04.01.07.02.15.04.22.07.01 0 .01 0 .02.01.07.02.14.05.22.08.01.01.03.01.04.02.07.03.14.06.2.09.01.01.02.01.03.02.07.03.13.07.2.1l.15.09c.01.01.03.02.04.03.04.02.07.05.1.07.01.01.02.02.04.03.03.02.06.05.09.07.01.01.02.01.02.02.04.03.07.06.1.09l.06.06.02.02c.03.03.05.06.07.08l.01.01c.02.02.04.05.06.07.01.01.01.02.02.03.01.02.02.03.03.05.03.04.05.08.07.12 0 .01.01.01.01.02.02.03.03.07.04.1 0 .01.01.02.01.03.01.04.03.08.04.12.01.04.02.08.02.12v.03c0 .03.01.07.01.1v.03-.15-.02-.02c0-.03 0-.07-.01-.1v-.03c-.01-.04-.01-.08-.02-.12a.564.564 0 00-.04-.12v-.01c0-.01-.01-.01-.01-.02-.01-.03-.03-.07-.04-.1 0-.01 0-.01-.01-.02v-.01a.746.746 0 00-.07-.12s0-.01-.01-.01a.138.138 0 01-.03-.04c-.01-.01-.01-.02-.02-.03-.02-.02-.04-.05-.06-.07v-.01c-.02-.03-.05-.06-.07-.08l-.02-.02c-.02-.02-.03-.04-.05-.05-.03-.03-.07-.06-.1-.09-.01-.01-.02-.01-.02-.02-.03-.02-.06-.05-.09-.07l-.01-.01c-.01-.01-.02-.01-.02-.02l-.1-.07c-.01-.01-.03-.02-.04-.03l-.15-.09c-.06-.04-.13-.07-.2-.1-.01-.01-.02-.01-.03-.02-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.14-.05-.22-.08-.01 0-.01 0-.02-.01-.07-.02-.14-.04-.22-.06-.01 0-.01 0-.02-.01h-.01c-.06-.01-.11-.03-.17-.04-.06-.01-.12-.03-.17-.04h-.03c-.09-.02-.18-.03-.28-.04h-.03c-.08-.01-.15-.02-.23-.02h-.03c-.07-.01-.15-.01-.22-.01h-.48-.05c-.05 0-.11.01-.16.01h-.05c-.07.01-.14.01-.2.02h-.02l-.18.03h-.05c-.07.01-.14.02-.21.04h-.01c-.08.02-.15.03-.22.05-.01 0-.02 0-.03.01h-.01c-.08.02-.16.05-.24.07-.01 0-.01 0-.02.01-.01 0-.02.01-.03.01l-.09.03c-.06 0-.08.01-.1.02z'
                fill='url(#dataMigr_banner_svg__SVGID_392_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_393_'
                gradientUnits='userSpaceOnUse'
                x1={-3085.119}
                y1={-2227.012}
                x2={-3080.64}
                y2={-2227.012}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M558.34 134.39c-.07.03-.13.06-.2.09-.02.01-.04.02-.06.02-.03.01-.06.03-.1.04-.02.01-.04.02-.07.02-.03.01-.06.02-.1.03-.02.01-.04.01-.05.02-.08.03-.17.05-.25.07-.01 0-.03.01-.04.01-.07.02-.15.04-.22.05h-.02c-.07.02-.15.03-.22.04-.02 0-.04.01-.06.01l-.19.03h-.03c-.07.01-.14.02-.21.02h-.06c-.06 0-.11.01-.17.01h-.56c-.08 0-.15-.01-.23-.01h-.04l-.24-.03h-.03a2.5 2.5 0 01-.29-.05c-.01 0-.02 0-.04-.01-.06-.01-.12-.02-.18-.04-.06-.01-.12-.03-.18-.04-.01 0-.03-.01-.04-.01-.08-.02-.15-.04-.23-.07-.01 0-.01 0-.02-.01-.08-.03-.15-.05-.23-.08-.01-.01-.03-.01-.04-.02l-.21-.09c-.01-.01-.02-.01-.04-.02-.07-.03-.14-.07-.21-.11-.05-.03-.11-.06-.16-.1-.01-.01-.03-.02-.04-.03-.04-.02-.07-.05-.11-.08-.01-.01-.03-.02-.04-.03-.03-.02-.06-.05-.09-.07-.01-.01-.02-.01-.03-.02-.04-.03-.07-.06-.11-.1l-.06-.06-.02-.02c-.03-.03-.05-.06-.08-.09v-.01c-.02-.03-.04-.05-.06-.08-.01-.01-.01-.02-.02-.03-.01-.02-.02-.03-.03-.05-.03-.04-.05-.09-.07-.13 0-.01-.01-.01-.01-.02-.02-.04-.03-.07-.05-.11 0-.01-.01-.02-.01-.03-.01-.04-.03-.08-.04-.12-.01-.04-.02-.08-.02-.12v-.04c0-.03-.01-.07-.01-.1v-.03V132.98c0 .03 0 .07.01.1v.04c.01.04.01.08.02.12.01.04.02.08.04.13v.01c0 .01.01.01.01.02.01.04.03.07.05.11 0 .01 0 .01.01.02v.01c.02.04.05.09.07.13 0 0 0 .01.01.01.01.01.02.03.03.04s.01.02.02.03c.02.03.04.05.06.08 0 0 0 .01.01.01.02.03.05.06.08.09l.02.02c.02.02.04.04.05.06h.01c.03.03.07.07.11.1.01.01.02.01.03.02.03.02.06.05.09.07l.01.01c.01.01.02.01.03.02.03.03.07.05.11.08.01.01.03.02.04.03.05.03.1.06.16.1.07.04.14.07.21.11.01.01.02.01.04.02l.21.09c.01.01.03.01.04.02.07.03.15.06.23.08.01 0 .01 0 .02.01.07.02.15.05.23.07.01 0 .02 0 .02.01h.02c.06.02.12.03.18.04.06.01.12.03.18.04h.04c.1.02.19.03.29.05h.03l.24.03h.03c.08.01.16.01.24.01h.56c.06 0 .12-.01.17-.01h.06c.07-.01.14-.01.21-.02h.03l.19-.03h.05c.07-.01.15-.03.22-.04h.02c.07-.02.15-.03.22-.05.01 0 .02 0 .03-.01h.01c.09-.02.17-.05.25-.07.01 0 .02 0 .02-.01.01 0 .02-.01.03-.01.03-.01.06-.02.1-.03.02-.01.04-.02.07-.02.03-.01.06-.03.1-.04.02-.01.03-.01.05-.02h.01c.07-.03.14-.06.2-.09.01-.01.03-.01.04-.02.07-.03.13-.07.19-.11.48-.28.79-.62.93-.97.03-.06.05-.13.06-.2.01-.03.01-.07.02-.1.01-.07.02-.13.02-.2v-.15c0 .53-.34 1.06-1.03 1.47-.06.04-.13.07-.19.11-.02-.02-.04-.01-.05-.01z'
                fill='url(#dataMigr_banner_svg__SVGID_393_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_394_'
                gradientUnits='userSpaceOnUse'
                x1={-3084.992}
                y1={-2227.144}
                x2={-3079.896}
                y2={-2227.144}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M553.49 134.29c-1.41-.8-1.42-2.12-.03-2.94 1.39-.82 3.67-.83 5.08-.03 1.41.8 1.42 2.12.03 2.94-1.39.83-3.67.84-5.08.03zm4.93-2.89c-1.34-.76-3.5-.75-4.82.02-1.32.78-1.31 2.03.03 2.79s3.5.75 4.82-.02c1.32-.77 1.3-2.03-.03-2.79'
                fill='url(#dataMigr_banner_svg__SVGID_394_)'
              />
            </g>
            <g className='dataMigr_banner_svg__st1'>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_395_'
                gradientUnits='userSpaceOnUse'
                x1={-3081.984}
                y1={-2228.212}
                x2={-3081.033}
                y2={-2226.574}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M554.92 132.26c-.02-.03-.03-.06-.04-.09-.35-.74 1.02-1.06 1.09-1.08l.44.93.3.64a.642.642 0 00-.13-.1c-.15-.09-.35-.13-.56-.13l-1.1-.17z'
                fill='url(#dataMigr_banner_svg__SVGID_395_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_396_'
                gradientUnits='userSpaceOnUse'
                x1={-3082.305}
                y1={-2227.232}
                x2={-3080.93}
                y2={-2224.863}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M553.74 132.9c-.58-.33-.45-.86-.44-.89l1.61.24 1.11.17c-.21 0-.42.05-.57.14-.31.18-.31.47.01.65.05.03.11.06.18.08-.07-.01-.15-.02-.24-.04-.25-.04-.58-.09-.86-.13a.875.875 0 00-.16-.02c-.28-.04-.48-.11-.64-.2z'
                fill='url(#dataMigr_banner_svg__SVGID_396_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_397_'
                  gradientUnits='userSpaceOnUse'
                  x1={-3082.506}
                  y1={-2226.379}
                  x2={-3082.506}
                  y2={-2227.835}
                  gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
                >
                  <stop offset={0} stopColor='#7f64ff' />
                  <stop offset={0.484} stopColor='#7d62ff' />
                  <stop offset={0.752} stopColor='#775aff' />
                  <stop offset={0.967} stopColor='#6d4cff' />
                  <stop offset={1} stopColor='#6b49ff' />
                </linearGradient>
                <path
                  d='M555.46 133.21c-.31-.18-.32-.47-.01-.65.16-.09.37-.14.57-.14s.4.04.56.13c.05.03.1.06.13.1.14.14.14.32 0 .46-.03.03-.07.06-.12.09-.16.09-.36.14-.57.14-.13 0-.26-.02-.38-.06a.484.484 0 01-.18-.07z'
                  fill='url(#dataMigr_banner_svg__SVGID_397_)'
                />
              </g>
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_398_'
                  gradientUnits='userSpaceOnUse'
                  x1={-3082.921}
                  y1={-2226.412}
                  x2={-3081.78}
                  y2={-2224.445}
                  gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
                >
                  <stop offset={0.117} stopColor='#dddcf9' />
                  <stop offset={0.562} stopColor='#fff' />
                  <stop offset={0.708} stopColor='#f9f8fe' />
                  <stop offset={0.915} stopColor='#e6e6fb' />
                  <stop offset={1} stopColor='#dddcf9' />
                </linearGradient>
                <path
                  d='M553.35 133.81l1.17-.69c.29.04.61.09.86.13l.24.5c-.04.02-.08.05-.12.07-.92.55-2.09.02-2.15-.01z'
                  fill='url(#dataMigr_banner_svg__SVGID_398_)'
                />
              </g>
            </g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_399_'
              gradientUnits='userSpaceOnUse'
              x1={-3083.44}
              y1={-2229.65}
              x2={-3082.299}
              y2={-2227.683}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M556.71 133.12c.14-.14.14-.32 0-.46l-.3-.64c.04-.02.08-.05.12-.07.93-.55 2.1-.02 2.16.01l-1.17.69-.81.47z'
              fill='url(#dataMigr_banner_svg__SVGID_399_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_400_'
              gradientUnits='userSpaceOnUse'
              x1={-3084.161}
              y1={-2229.304}
              x2={-3082.788}
              y2={-2226.938}
              gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M556.01 133.35c.21 0 .41-.05.57-.14.05-.03.09-.06.12-.09l.8-.47c.05.01.11.02.16.02.27.04.47.11.62.2.58.33.45.86.44.89l-1.61-.24-1.1-.17z'
              fill='url(#dataMigr_banner_svg__SVGID_400_)'
            />
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_401_'
                gradientUnits='userSpaceOnUse'
                x1={-3084.044}
                y1={-2227.602}
                x2={-3083.127}
                y2={-2226.021}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0.117} stopColor='#dddcf9' />
                <stop offset={0.562} stopColor='#fff' />
                <stop offset={0.708} stopColor='#f9f8fe' />
                <stop offset={0.915} stopColor='#e6e6fb' />
                <stop offset={1} stopColor='#dddcf9' />
              </linearGradient>
              <path
                d='M556.07 134.68l-.44-.93-.24-.5c.09.01.17.03.24.04.12.04.25.06.38.06l1.1.17c.02.03.03.06.04.09.36.73-1.01 1.06-1.08 1.07z'
                fill='url(#dataMigr_banner_svg__SVGID_401_)'
              />
            </g>
            <g>
              <linearGradient
                id='dataMigr_banner_svg__SVGID_402_'
                gradientUnits='userSpaceOnUse'
                x1={-3083.185}
                y1={-2227.991}
                x2={-3078.593}
                y2={-2227.991}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
              </linearGradient>
              <path
                d='M559.01 130.42c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34s.33-.98.94-1.34c1.24-.73 3.27-.74 4.53-.02.37.2.63.45.79.73zm-6.01 1.19c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.06.38.16.56z'
                fill='url(#dataMigr_banner_svg__SVGID_402_)'
              />
              <linearGradient
                id='dataMigr_banner_svg__SVGID_403_'
                gradientUnits='userSpaceOnUse'
                x1={-3081.783}
                y1={-2228.763}
                x2={-3077.191}
                y2={-2228.763}
                gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
              >
                <stop offset={0} stopColor='#2afadf' stopOpacity={0} />
                <stop offset={0.275} stopColor='#36d1ea' stopOpacity={0.165} />
                <stop offset={0.596} stopColor='#42a7f5' stopOpacity={0.358} />
                <stop offset={0.849} stopColor='#498dfc' stopOpacity={0.51} />
                <stop offset={1} stopColor='#4c83ff' stopOpacity={0.6} />
              </linearGradient>
              <path
                d='M558.97 128.82c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34s.33-.98.94-1.34c1.24-.73 3.27-.74 4.53-.02.36.21.63.46.79.73zm-6.01 1.19c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26l.02-.04-.02.04c-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.06.38.16.56z'
                fill='url(#dataMigr_banner_svg__SVGID_403_)'
              />
              <g>
                <linearGradient
                  id='dataMigr_banner_svg__SVGID_404_'
                  gradientUnits='userSpaceOnUse'
                  x1={-3080.389}
                  y1={-2229.508}
                  x2={-3075.797}
                  y2={-2229.508}
                  gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
                >
                  <stop offset={0} stopColor='#00dcf3' stopOpacity={0.6} />
                  <stop offset={0.281} stopColor='#00d2f0' stopOpacity={0.431} />
                  <stop offset={0.751} stopColor='#00b8e8' stopOpacity={0.15} />
                  <stop offset={1} stopColor='#00a8e3' stopOpacity={0} />
                </linearGradient>
                <path
                  d='M558.91 127.24c.11.19.17.4.17.61 0 .51-.33.98-.94 1.34-1.24.73-3.27.74-4.53.02-.62-.35-.96-.83-.96-1.34 0-.51.33-.98.94-1.34 1.24-.73 3.27-.74 4.53-.02.36.21.63.46.79.73zm-6.02 1.2c.15.26.41.5.76.7 1.23.7 3.23.69 4.45-.02.58-.34.9-.79.89-1.26 0-.48-.33-.93-.92-1.26l.02-.04-.02.04c-1.23-.7-3.23-.69-4.45.02-.58.34-.9.79-.89 1.26 0 .19.06.38.16.56z'
                  fill='url(#dataMigr_banner_svg__SVGID_404_)'
                />
              </g>
            </g>
          </g>
        </g>
        <g className='dataMigr_banner_svg__st233'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_405_'
            gradientUnits='userSpaceOnUse'
            x1={-3060.254}
            y1={-2221.313}
            x2={-3052.343}
            y2={-2225.905}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M537.91 107.77c-.03.01-.06.02-.09.04-.01.01-.03.01-.04.02h-.01c-.06.03-.13.06-.19.09-.01.01-.03.01-.04.02-.06.03-.12.06-.18.1-.66.39-.98.89-.98 1.39l.02 7.17c0-.5.33-1.01.98-1.39.06-.03.12-.07.18-.1.01-.01.03-.01.04-.02.06-.03.12-.06.19-.09.02-.01.04-.01.05-.02.03-.01.06-.02.09-.04.02-.01.04-.02.06-.02l.09-.03c.02-.01.03-.01.05-.02.08-.03.16-.05.24-.07.01 0 .03-.01.04-.01.07-.02.14-.03.21-.05h.02c.07-.01.14-.03.21-.04.02 0 .04-.01.05-.01l.18-.03h.03c.07-.01.14-.01.2-.02h.05c.05 0 .11-.01.16-.01h.53c.07 0 .15.01.22.01h.03c.08.01.15.01.23.02h.03c.09.01.19.03.28.04.01 0 .02 0 .03.01.06.01.12.02.17.04.06.01.12.03.17.04.01 0 .02.01.04.01l.22.06c.01 0 .01 0 .02.01.07.02.14.05.21.08.01.01.03.01.04.02.07.03.14.06.2.09.01.01.02.01.03.02.07.03.13.07.2.1l.15.09c.01.01.03.02.04.03.04.02.07.05.1.07.01.01.02.02.04.03.03.02.06.05.09.07.01.01.02.01.02.02.04.03.07.06.1.09l.06.06.02.02c.03.03.05.06.07.08l.01.01c.02.02.04.05.06.07.01.01.01.02.02.03.01.02.02.03.03.05.03.04.05.08.07.12 0 .01.01.01.01.02.02.03.03.07.04.1 0 .01.01.02.01.03.01.04.03.08.04.12.01.04.02.08.02.12v.03c0 .03.01.07.01.1v.03l-.02-7.17v-.02-.02c0-.03 0-.07-.01-.1v-.03c-.01-.04-.01-.08-.02-.12a.564.564 0 00-.04-.12v-.01c0-.01-.01-.02-.01-.02-.01-.03-.03-.07-.04-.1 0-.01 0-.01-.01-.02v-.01a.746.746 0 00-.07-.12v-.01c-.01-.02-.02-.03-.03-.04s-.01-.02-.02-.03c-.02-.03-.04-.05-.06-.07l-.01-.01c-.02-.03-.05-.06-.07-.08l-.02-.02c-.02-.02-.03-.04-.05-.05-.03-.03-.07-.06-.1-.09-.01-.01-.02-.01-.02-.02-.03-.02-.06-.05-.09-.07l-.01-.01c-.01-.01-.02-.01-.02-.02l-.1-.07c-.01-.01-.03-.02-.04-.03l-.15-.09c-.06-.04-.13-.07-.2-.1-.01-.01-.02-.01-.03-.02-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.14-.05-.21-.08-.01 0-.01 0-.02-.01-.07-.02-.14-.04-.22-.06-.01 0-.01 0-.02-.01h-.01c-.06-.02-.11-.03-.17-.04-.06-.01-.12-.03-.17-.04h-.03c-.09-.02-.18-.03-.28-.04h-.03c-.08-.01-.15-.02-.23-.02h-.03c-.08-.01-.15-.01-.22-.01h-.53c-.05 0-.11.01-.16.01h-.05c-.07.01-.14.01-.2.02h-.03l-.18.03h-.05c-.07.01-.14.02-.21.04h-.01c-.07.02-.14.03-.21.05-.01 0-.02 0-.03.01h-.01c-.08.02-.16.05-.24.07-.01 0-.01 0-.02.01-.01 0-.02.01-.03.01l-.09.03c-.06.01-.08.02-.1.03z'
            fill='url(#dataMigr_banner_svg__SVGID_405_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_406_'
            gradientUnits='userSpaceOnUse'
            x1={-3061.964}
            y1={-2220.303}
            x2={-3054.04}
            y2={-2224.902}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M537.07 110.64a.138.138 0 00-.04-.03c-.03-.02-.06-.05-.09-.07-.01-.01-.02-.01-.02-.02a.902.902 0 01-.1-.09l-.06-.06-.02-.02c-.03-.03-.05-.06-.07-.08l-.01-.01c-.02-.02-.04-.05-.06-.07-.01-.01-.01-.02-.02-.03-.01-.02-.02-.03-.03-.05-.03-.04-.05-.08-.07-.12 0-.01-.01-.01-.01-.02-.02-.03-.03-.07-.04-.1 0-.01-.01-.02-.01-.03-.01-.04-.03-.08-.04-.12-.01-.04-.02-.08-.02-.12v-.03c0-.03-.01-.07-.01-.1v-.03l.02 7.17v.04c0 .03 0 .07.01.1v.03c.01.04.01.08.02.12.01.04.02.08.04.12v.01c0 .01.01.02.01.02.01.03.03.07.04.1 0 .01 0 .01.01.02.02.04.05.08.07.12 0 0 0 .01.01.01.01.01.02.02.03.04.01.01.01.02.02.03.02.03.04.05.06.08l.01.01c.02.03.05.06.07.08l.02.02c.02.02.03.04.05.05.03.03.07.06.1.09.01.01.02.01.02.02.03.02.06.05.09.07l.01.01c.01.01.02.01.02.02l.1.07c.01.01.03.02.04.03l.15.09c.06.04.13.07.2.1.01.01.02.01.03.02.07.03.13.06.2.09.01.01.03.01.04.02.07.03.14.05.22.08.01 0 .01 0 .02.01.07.02.14.05.22.07.01 0 .01 0 .02.01h.01c.06.02.12.03.18.04.06.01.12.03.18.04h.04c.09.02.19.03.28.04h.03c.08.01.15.02.23.02h.03c.07.01.15.01.22.01h.53c.05 0 .11-.01.16-.01h.05c.07-.01.14-.01.2-.02h.03l.18-.03h.05c.07-.01.14-.02.21-.04h.01c.07-.02.14-.03.21-.05.01 0 .02 0 .03-.01h.01c.08-.02.16-.05.24-.07.01 0 .01 0 .02-.01.01 0 .02-.01.03-.01l.09-.03c.02-.01.04-.02.06-.02.03-.01.06-.02.09-.04.01-.01.03-.01.04-.02h.01c.06-.03.13-.06.19-.09.01-.01.03-.01.04-.02.06-.03.13-.07.19-.1.66-.39.99-.89.99-1.4l-.02-7.17c0 .51-.33 1.01-.99 1.4-.06.04-.12.07-.19.1-.01.01-.03.01-.04.02-.06.03-.13.06-.19.09-.02.01-.04.01-.05.02-.03.01-.06.02-.09.04-.02.01-.04.02-.06.02l-.09.03c-.02.01-.03.01-.05.02-.08.03-.16.05-.24.07-.01 0-.03.01-.04.01-.07.02-.14.04-.21.05h-.02c-.07.01-.14.03-.21.04-.02 0-.04.01-.05.01l-.18.03h-.03c-.07.01-.14.01-.2.02h-.05c-.05 0-.11.01-.16.01h-.53c-.07 0-.15-.01-.22-.01h-.03c-.08-.01-.15-.01-.23-.02h-.03c-.09-.01-.19-.03-.28-.04-.01 0-.02 0-.04-.01-.06-.01-.12-.02-.17-.04-.06-.01-.12-.03-.17-.04-.01 0-.02-.01-.04-.01-.07-.02-.15-.04-.22-.07-.01 0-.01 0-.02-.01-.07-.02-.15-.05-.22-.08-.01-.01-.03-.01-.04-.02-.07-.03-.14-.06-.2-.09-.01-.01-.02-.01-.03-.02-.07-.03-.14-.07-.2-.1l-.15-.09c-.01-.01-.03-.02-.04-.03-.02-.03-.05-.05-.09-.08z'
            fill='url(#dataMigr_banner_svg__SVGID_406_)'
          />
        </g>
        <g className='dataMigr_banner_svg__st233'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_407_'
            gradientUnits='userSpaceOnUse'
            x1={-3060.08}
            y1={-2214.333}
            x2={-3052.168}
            y2={-2218.925}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M531.8 111.14c-.03.01-.06.02-.09.04-.01.01-.03.01-.04.02h-.01c-.06.03-.13.06-.19.09-.01.01-.03.01-.04.02-.06.03-.12.06-.18.1-.66.39-.98.89-.98 1.39l.02 7.17c0-.5.33-1.01.98-1.39.06-.04.12-.07.18-.1.01-.01.03-.01.04-.02.06-.03.12-.06.19-.09.02-.01.04-.01.05-.02.03-.01.06-.02.09-.04.02-.01.04-.02.06-.02l.09-.03c.02-.01.03-.01.05-.02.08-.03.16-.05.24-.07.01 0 .03-.01.04-.01.07-.02.14-.03.21-.05h.02c.07-.01.14-.03.21-.04.02 0 .04-.01.05-.01l.18-.03h.03c.07-.01.14-.01.2-.02h.05c.05 0 .11-.01.16-.01h.53c.07 0 .15.01.22.01h.03c.08.01.15.01.23.02h.03c.09.01.19.03.28.04.01 0 .02 0 .03.01.06.01.12.02.17.04.06.01.11.03.17.04.01 0 .02.01.04.01l.22.06c.01 0 .01 0 .02.01.07.02.14.05.21.08.01.01.03.01.04.02.07.03.14.06.2.09.01.01.02.01.03.02.07.03.13.07.2.1l.15.09c.01.01.03.02.04.03.04.02.07.05.1.07.01.01.02.02.04.03.03.02.06.05.09.07.01.01.02.01.02.02.04.03.07.06.1.09l.06.06.02.02c.03.03.05.06.07.08.02.03.04.05.06.08.01.01.01.02.02.03.01.02.02.03.03.05.03.04.05.08.07.12 0 .01.01.01.01.02.02.03.03.07.04.1 0 .01.01.02.01.03.01.04.03.08.04.12.01.04.02.08.02.12v.03c0 .03.01.07.01.1v.03l-.02-7.17v-.02-.02c0-.03 0-.07-.01-.1v-.03c-.01-.04-.01-.08-.02-.12a.564.564 0 00-.04-.12v-.01c0-.01-.01-.01-.01-.02-.01-.03-.03-.07-.04-.1 0-.01 0-.01-.01-.02v-.01a.746.746 0 00-.07-.12s0-.01-.01-.01a.138.138 0 01-.03-.04c-.01-.01-.01-.02-.02-.03-.02-.03-.04-.05-.06-.07l-.01-.01c-.02-.03-.05-.06-.07-.08l-.02-.02c-.02-.02-.03-.04-.05-.05-.03-.03-.07-.06-.1-.09-.01-.01-.02-.01-.02-.02-.03-.02-.06-.05-.09-.07l-.01-.01c-.01-.01-.02-.01-.03-.02l-.1-.07c-.01-.01-.03-.02-.04-.03l-.15-.09c-.06-.04-.13-.07-.2-.1-.01-.01-.02-.01-.03-.02-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.14-.05-.21-.08-.01 0-.01 0-.02-.01-.07-.02-.14-.04-.22-.06-.01 0-.01 0-.02-.01h-.01c-.06-.02-.11-.03-.17-.04-.06-.01-.12-.03-.17-.04h-.04c-.09-.02-.18-.03-.28-.04h-.03c-.08-.01-.15-.02-.23-.02h-.03c-.08-.01-.15-.01-.22-.01h-.48-.05c-.05 0-.11.01-.16.01h-.05c-.07.01-.14.01-.2.02h-.03l-.18.03h-.05c-.07.01-.14.02-.21.04h-.02c-.07.02-.14.03-.21.05-.01 0-.02 0-.03.01h-.01c-.08.02-.16.05-.24.07-.01 0-.01 0-.02.01-.01 0-.02.01-.03.01l-.09.03c0 .02-.03.02-.05.03z'
            fill='url(#dataMigr_banner_svg__SVGID_407_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_408_'
            gradientUnits='userSpaceOnUse'
            x1={-3061.796}
            y1={-2213.325}
            x2={-3053.873}
            y2={-2217.924}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M530.97 114.02a.138.138 0 00-.04-.03c-.03-.02-.06-.05-.09-.07-.01-.01-.02-.01-.02-.02a.902.902 0 01-.1-.09l-.06-.06-.02-.02c-.03-.03-.05-.06-.07-.08l-.01-.01c-.02-.02-.04-.05-.06-.07-.01-.01-.01-.02-.02-.03-.01-.02-.02-.03-.03-.05-.03-.04-.05-.08-.07-.12 0-.01-.01-.01-.01-.02-.02-.03-.03-.07-.04-.1 0-.01-.01-.02-.01-.03-.01-.04-.03-.08-.04-.12-.01-.04-.02-.08-.02-.12v-.03c0-.03-.01-.07-.01-.1v-.03l.02 7.17v.04c0 .03 0 .07.01.1v.03c.01.04.01.08.02.12.01.04.02.08.04.12v.01c0 .01.01.01.01.02.01.03.03.07.04.1 0 .01 0 .01.01.02v.01a.746.746 0 00.08.13c.01.01.02.02.03.04.01.01.01.02.02.03.02.03.04.05.06.08.02.03.05.06.07.08l.02.02c.02.02.03.04.05.05.03.03.07.06.1.09.01.01.02.01.02.02.03.02.06.05.09.07l.01.01c.01.01.02.01.02.02l.1.07c.01.01.03.02.04.03l.15.09c.06.04.13.07.2.1.01.01.02.01.03.02.07.03.13.06.2.09.01.01.03.01.04.02.07.03.14.05.22.08.01 0 .01 0 .02.01.07.02.14.05.22.07.01 0 .01 0 .02.01h.01c.06.02.11.03.17.04.06.01.12.03.18.04h.04c.09.02.19.03.28.04h.03c.08.01.15.02.23.02h.03c.08.01.15.01.22.01h.53c.05 0 .11-.01.16-.01h.05c.07-.01.14-.01.2-.02h.03l.18-.03h.05c.07-.01.14-.02.21-.04h.01c.08-.02.15-.03.22-.05.01 0 .02 0 .03-.01h.01c.08-.02.16-.05.24-.07.01 0 .01 0 .02-.01.01 0 .02-.01.03-.01l.09-.03c.02-.01.04-.02.06-.02.03-.01.06-.02.09-.04.01-.01.03-.01.04-.02h.01c.06-.03.13-.06.19-.09.01-.01.03-.01.04-.02.06-.03.13-.07.18-.1.66-.39.99-.89.99-1.4l-.02-7.17c0 .51-.33 1.01-.99 1.4-.06.04-.12.07-.19.1-.01.01-.03.01-.04.02-.06.03-.13.06-.19.09-.02.01-.04.01-.05.02-.03.01-.06.02-.09.04-.02.01-.04.02-.06.02l-.09.03c-.02.01-.03.01-.05.02-.08.03-.16.05-.24.07-.01 0-.03.01-.04.01-.07.02-.14.04-.21.05h-.02c-.07.01-.14.03-.21.04-.02 0-.04.01-.05.01l-.18.03h-.03c-.07.01-.14.01-.2.02h-.05c-.05 0-.11.01-.16.01h-.53c-.07 0-.15-.01-.22-.01h-.03c-.08-.01-.15-.01-.23-.02h-.03c-.09-.01-.19-.03-.28-.04-.01 0-.02 0-.04-.01-.06-.01-.12-.02-.17-.04-.06-.01-.12-.03-.17-.04-.01 0-.02-.01-.04-.01-.07-.02-.15-.04-.22-.07-.01 0-.01 0-.02-.01-.07-.02-.15-.05-.22-.08-.01-.01-.03-.01-.04-.02-.07-.03-.14-.06-.2-.09-.01-.01-.02-.01-.03-.02-.07-.03-.14-.07-.2-.1l-.15-.09c-.01-.01-.03-.02-.04-.03 0-.03-.04-.06-.07-.08z'
            fill='url(#dataMigr_banner_svg__SVGID_408_)'
          />
        </g>
        <g className='dataMigr_banner_svg__st233'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_409_'
            gradientUnits='userSpaceOnUse'
            x1={-3071.415}
            y1={-2227.729}
            x2={-3063.503}
            y2={-2232.322}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M549.08 114.17c-.03.01-.06.02-.09.04-.01.01-.03.01-.04.02h-.01c-.06.03-.13.06-.19.09-.01.01-.03.01-.04.02-.06.03-.12.06-.18.1-.66.39-.98.89-.98 1.39l.02 7.17c0-.5.33-1.01.98-1.39.06-.04.12-.07.18-.1.01-.01.03-.01.04-.02.06-.03.12-.06.19-.09.02-.01.04-.01.05-.02.03-.01.06-.02.09-.04.02-.01.04-.02.06-.02l.09-.03c.02-.01.03-.01.05-.02.08-.03.16-.05.24-.07.01 0 .03-.01.04-.01.07-.02.14-.03.21-.05h.02c.07-.01.14-.03.21-.04.02 0 .04-.01.05-.01l.18-.03h.03c.07-.01.14-.01.2-.02h.05c.05 0 .11-.01.16-.01h.53c.07 0 .15.01.22.01h.03c.08.01.15.01.23.02h.03c.09.01.19.03.28.04.01 0 .02 0 .03.01.06.01.12.02.17.04.06.01.12.03.17.04.01 0 .02.01.04.01l.22.06c.01 0 .01 0 .02.01.07.02.14.05.21.08.01.01.03.01.04.02.07.03.14.06.2.09.01.01.02.01.03.02.07.03.13.07.2.1l.15.09c.01.01.03.02.04.03.04.02.07.05.1.07.01.01.02.02.04.03.03.02.06.05.09.07.01.01.02.01.02.02.04.03.07.06.1.09l.06.06.02.02c.03.03.05.06.07.08l.01.01c.02.02.04.05.06.07.01.01.01.02.02.03.01.02.02.03.03.05.03.04.05.08.07.12 0 .01.01.01.01.02.02.03.03.07.04.1 0 .01.01.02.01.03.01.04.03.08.04.12.01.04.02.08.02.12v.03c0 .03.01.07.01.1v.03l-.02-7.17v-.02-.02c0-.03 0-.07-.01-.1v-.03c-.01-.04-.01-.08-.02-.12a.564.564 0 00-.04-.12v-.01c0-.01-.01-.01-.01-.02-.01-.03-.03-.07-.04-.1 0-.01 0-.01-.01-.02v-.01a.746.746 0 00-.07-.12s0-.01-.01-.01a.138.138 0 01-.03-.04c-.01-.01-.01-.02-.02-.03-.02-.03-.04-.05-.06-.07l-.01-.01c-.02-.03-.05-.06-.07-.08l-.02-.02c-.02-.02-.03-.04-.05-.05-.03-.03-.07-.06-.1-.09-.01-.01-.02-.01-.02-.02-.03-.02-.06-.05-.09-.07l-.01-.01c-.01-.01-.02-.01-.02-.02l-.1-.07c-.01-.01-.03-.02-.04-.03l-.15-.09c-.06-.04-.13-.07-.2-.1-.01-.01-.02-.01-.03-.02-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.14-.05-.21-.08-.01 0-.01 0-.02-.01-.07-.02-.14-.04-.22-.06-.01 0-.01 0-.02-.01h-.01c-.06-.02-.11-.03-.17-.04-.06-.01-.12-.03-.17-.04h-.03c-.09-.02-.18-.03-.28-.04h-.02c-.08-.01-.15-.02-.23-.02h-.03c-.08-.01-.15-.01-.22-.01h-.53c-.05 0-.11.01-.16.01h-.05c-.07.01-.14.01-.2.02h-.03l-.18.03h-.05c-.07.01-.14.02-.21.04h-.02c-.07.02-.14.03-.21.05-.01 0-.02 0-.03.01h-.01c-.08.02-.16.05-.24.07-.01 0-.01 0-.02.01-.01 0-.02.01-.03.01l-.09.03c-.05.02-.07.03-.09.03z'
            fill='url(#dataMigr_banner_svg__SVGID_409_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_410_'
            gradientUnits='userSpaceOnUse'
            x1={-3073.131}
            y1={-2226.722}
            x2={-3065.207}
            y2={-2231.321}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M548.25 117.05a.138.138 0 00-.04-.03c-.03-.02-.06-.05-.09-.07-.01-.01-.02-.01-.02-.02a.902.902 0 01-.1-.09l-.06-.06-.02-.02c-.03-.03-.05-.06-.07-.08l-.01-.01c-.02-.02-.04-.05-.06-.07-.01-.01-.01-.02-.02-.03-.01-.02-.02-.03-.03-.05-.03-.04-.05-.08-.07-.12 0-.01-.01-.01-.01-.02-.02-.03-.03-.07-.04-.1 0-.01-.01-.02-.01-.03-.01-.04-.03-.08-.04-.12-.01-.04-.02-.08-.02-.12v-.03c0-.03-.01-.07-.01-.1v-.03l.02 7.17v.04c0 .03 0 .07.01.1v.03c.01.04.01.08.02.12.01.04.02.08.04.12v.01c0 .01.01.01.01.02.01.03.03.07.04.1 0 .01 0 .01.01.02v.01a.746.746 0 00.08.13c.01.01.02.02.03.04.01.01.01.02.02.03.02.03.04.05.06.08.02.03.05.06.07.08l.02.02c.02.02.03.04.05.05.03.03.07.06.1.09.01.01.02.01.02.02.03.02.06.05.09.07l.01.01c.01.01.02.01.03.02l.1.07c.01.01.03.02.04.03l.15.09c.06.04.13.07.2.1.01.01.02.01.03.02.07.03.13.06.2.09.01.01.03.01.04.02.07.03.14.05.22.08.01 0 .01 0 .02.01.07.02.14.05.22.07.01 0 .01 0 .02.01h.01c.06.02.11.03.17.04.06.01.12.03.18.04h.04c.09.02.19.03.28.04h.03c.08.01.15.02.23.02h.03c.07.01.15.01.22.01h.53c.05 0 .11-.01.16-.01h.05c.07-.01.14-.01.2-.02h.03l.18-.03h.05c.07-.01.14-.02.21-.04h.01c.07-.02.14-.03.21-.05.01 0 .02 0 .03-.01h.01c.08-.02.16-.05.24-.07.01 0 .01 0 .02-.01.01 0 .02-.01.03-.01l.09-.03c.02-.01.04-.02.06-.02.03-.01.06-.02.09-.04.01-.01.03-.01.04-.02h.01c.06-.03.13-.06.19-.09.01-.01.03-.01.04-.02.06-.03.13-.07.19-.1.66-.39.99-.89.99-1.4l-.02-7.17c0 .51-.33 1.01-.99 1.4-.06.04-.12.07-.19.1-.01.01-.03.01-.04.02-.06.03-.13.06-.19.09-.02.01-.04.01-.05.02-.03.01-.06.02-.09.04-.02.01-.04.02-.06.02l-.09.03c-.02.01-.03.01-.05.02-.08.03-.16.05-.24.07-.01 0-.03.01-.04.01-.07.02-.14.04-.21.05h-.02c-.07.01-.14.03-.21.04-.02 0-.04.01-.05.01l-.18.03h-.03c-.07.01-.14.01-.2.02h-.05c-.05 0-.11.01-.16.01h-.53c-.07 0-.15-.01-.22-.01h-.03c-.08-.01-.15-.01-.23-.02h-.03c-.09-.01-.19-.03-.28-.04-.01 0-.02 0-.04-.01-.06-.01-.12-.02-.17-.04-.06-.01-.12-.03-.17-.04-.01 0-.02-.01-.04-.01-.07-.02-.15-.04-.22-.07-.01 0-.01 0-.02-.01-.07-.02-.15-.05-.22-.08-.01-.01-.03-.01-.04-.02-.07-.03-.14-.06-.2-.09-.01-.01-.02-.01-.03-.02-.07-.03-.14-.07-.2-.1l-.15-.09c-.01-.01-.03-.02-.04-.03a.304.304 0 00-.08-.08z'
            fill='url(#dataMigr_banner_svg__SVGID_410_)'
          />
        </g>
        <g className='dataMigr_banner_svg__st233'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_411_'
            gradientUnits='userSpaceOnUse'
            x1={-3071.256}
            y1={-2220.758}
            x2={-3063.344}
            y2={-2225.35}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M542.98 117.55c-.03.01-.06.02-.09.04-.01.01-.03.01-.04.02h-.01c-.06.03-.13.06-.19.09-.01.01-.03.01-.04.02-.06.03-.12.06-.18.1-.66.39-.98.89-.98 1.39l.02 7.17c0-.5.33-1.01.98-1.39.06-.03.12-.07.18-.1.01-.01.03-.01.04-.02.06-.03.12-.06.19-.09.02-.01.04-.01.05-.02.03-.01.06-.02.09-.04.02-.01.04-.02.06-.02l.09-.03c.02-.01.03-.01.05-.02.08-.03.16-.05.24-.07.01 0 .03-.01.04-.01.07-.02.14-.03.21-.05h.02c.07-.01.14-.03.21-.04.02 0 .04-.01.05-.01l.18-.03h.03c.07-.01.14-.01.2-.02h.05c.05 0 .11-.01.16-.01h.53c.07 0 .15.01.22.01h.03c.08.01.15.01.23.02h.03c.09.01.19.03.28.04.01 0 .02 0 .03.01.06.01.12.02.17.04.06.01.11.03.17.04.01 0 .02.01.04.01l.22.06c.01 0 .01 0 .02.01.07.02.14.05.21.08.01.01.03.01.04.02.07.03.14.06.2.09.01.01.02.01.03.02.07.03.13.07.2.1l.15.09c.01.01.03.02.04.03.04.02.07.05.1.07.01.01.02.02.04.03.03.02.06.05.09.07.01.01.02.01.02.02.04.03.07.06.1.09l.06.06.02.02c.03.03.05.06.07.08l.01.01c.02.02.04.05.06.07.01.01.01.02.02.03.01.02.02.03.03.05.03.04.05.08.07.12 0 .01.01.01.01.02.02.03.03.07.04.1 0 .01.01.02.01.03.01.04.03.08.04.12.01.04.02.08.02.12v.03c0 .03.01.07.01.1v.03l-.02-7.17v-.02-.02c0-.03 0-.07-.01-.1v-.03c-.01-.04-.01-.08-.02-.12a.564.564 0 00-.04-.12v-.01c0-.01-.01-.01-.01-.02-.01-.03-.03-.07-.04-.1 0-.01 0-.01-.01-.02v-.01a.746.746 0 00-.07-.12v-.01c-.01-.02-.02-.03-.03-.04s-.01-.02-.02-.03c-.02-.03-.04-.05-.06-.07l-.01-.01c-.02-.03-.05-.06-.07-.08l-.02-.02c-.02-.02-.03-.04-.05-.05-.03-.03-.07-.06-.1-.09-.01-.01-.02-.01-.02-.02-.03-.02-.06-.05-.09-.07l-.01-.01c-.01-.01-.02-.01-.02-.02l-.1-.07c-.01-.01-.03-.02-.04-.03l-.15-.09c-.06-.04-.13-.07-.2-.1-.01-.01-.02-.01-.03-.02-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.14-.05-.21-.08-.01 0-.01 0-.02-.01-.07-.02-.14-.04-.22-.06-.01 0-.01 0-.02-.01h-.01c-.06-.02-.11-.03-.17-.04-.06-.01-.12-.03-.17-.04h-.04c-.09-.02-.18-.03-.28-.04h-.03c-.08-.01-.15-.02-.23-.02h-.03c-.08-.01-.15-.01-.22-.01h-.53c-.05 0-.11.01-.16.01h-.05c-.07.01-.14.01-.2.02h-.03l-.18.03h-.05c-.07.01-.14.02-.21.04h-.01c-.07.02-.14.03-.21.05-.01 0-.02 0-.03.01h-.01c-.08.02-.16.05-.24.07-.01 0-.01 0-.02.01-.01 0-.02.01-.03.01l-.09.03c-.05.01-.07.02-.09.03z'
            fill='url(#dataMigr_banner_svg__SVGID_411_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_412_'
            gradientUnits='userSpaceOnUse'
            x1={-3072.965}
            y1={-2219.748}
            x2={-3065.042}
            y2={-2224.347}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M542.14 120.42a.138.138 0 00-.04-.03c-.03-.02-.06-.05-.09-.07-.01-.01-.02-.01-.02-.02a.902.902 0 01-.1-.09l-.06-.06-.02-.02c-.03-.03-.05-.06-.07-.08-.02-.03-.04-.05-.06-.08-.01-.01-.01-.02-.02-.03-.01-.02-.02-.03-.03-.05-.03-.04-.05-.08-.07-.12 0-.01-.01-.01-.01-.02-.02-.03-.03-.07-.04-.1 0-.01-.01-.02-.01-.03-.01-.04-.03-.08-.04-.12-.01-.04-.02-.08-.02-.12v-.03c0-.03-.01-.07-.01-.1v-.03l.02 7.17v.04c0 .03 0 .07.01.1v.03c.01.04.01.08.02.12.01.04.02.08.04.12v.01c0 .01.01.01.01.02.01.03.03.07.04.1v.01c0 .01 0 .01.01.01.02.04.04.08.07.12v.01c.01.02.02.03.03.04s.01.02.02.03c.02.03.04.05.06.08l.01.01c.02.03.05.06.07.08l.02.02c.02.02.03.04.05.05.03.03.07.06.1.09.01.01.02.01.02.02.03.02.06.05.09.07l.01.01c.01.01.02.01.02.02l.1.07c.01.01.03.02.04.03l.15.09c.06.04.13.07.2.1.01.01.02.01.03.02.07.03.13.06.2.09.01.01.03.01.04.02.07.03.14.05.22.08.01 0 .01 0 .02.01.07.02.14.05.22.07.01 0 .01 0 .02.01h.01c.06.02.11.03.17.04.06.01.12.03.18.04h.04c.09.02.19.03.28.04h.03c.08.01.15.02.23.02h.03c.08.01.15.01.22.01h.53c.05 0 .11-.01.16-.01h.05c.07-.01.14-.01.2-.02h.03l.18-.03h.05c.07-.01.14-.02.21-.04h.02c.07-.02.14-.03.21-.05.01 0 .02 0 .03-.01h.01c.08-.02.16-.05.24-.07.01 0 .01 0 .02-.01.01 0 .02-.01.03-.01l.09-.03c.02-.01.04-.02.06-.02.03-.01.06-.02.09-.04.01-.01.03-.01.04-.02h.01c.06-.03.13-.06.19-.09.01-.01.03-.01.04-.02.06-.03.13-.07.18-.1.66-.39.99-.89.99-1.4l-.02-7.17c0 .51-.33 1.01-.99 1.4-.06.04-.12.07-.19.1-.01.01-.03.01-.04.02-.06.03-.13.06-.19.09-.02.01-.04.01-.05.02-.03.01-.06.02-.09.04-.02.01-.04.02-.06.02l-.09.03c-.02.01-.03.01-.05.02-.08.03-.16.05-.24.07-.01 0-.03.01-.04.01-.07.02-.14.04-.21.05h-.02c-.07.01-.14.03-.21.04-.02 0-.04.01-.05.01l-.18.03h-.03c-.07.01-.14.01-.2.02h-.05c-.05 0-.11.01-.16.01h-.53c-.07 0-.15-.01-.22-.01h-.03c-.08-.01-.15-.01-.23-.02h-.03c-.09-.01-.19-.03-.28-.04-.01 0-.02 0-.04-.01-.06-.01-.12-.02-.17-.04-.06-.01-.12-.03-.17-.04-.01 0-.02-.01-.04-.01-.07-.02-.15-.04-.22-.07-.01 0-.01 0-.02-.01-.07-.02-.15-.05-.22-.08-.01-.01-.03-.01-.04-.02-.07-.03-.14-.06-.2-.09-.01-.01-.02-.01-.03-.02-.07-.03-.14-.07-.2-.1l-.15-.09c-.01-.01-.03-.02-.04-.03-.01-.03-.05-.05-.08-.08z'
            fill='url(#dataMigr_banner_svg__SVGID_412_)'
          />
        </g>
        <g className='dataMigr_banner_svg__st233'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_413_'
            gradientUnits='userSpaceOnUse'
            x1={-3082.592}
            y1={-2234.136}
            x2={-3074.679}
            y2={-2238.729}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M560.25 120.59c-.03.01-.06.02-.09.04-.01.01-.03.01-.04.02h-.01c-.07.03-.13.06-.19.09-.01.01-.03.01-.04.02-.06.03-.12.06-.18.1-.66.39-.98.89-.98 1.39l.02 7.17c0-.5.33-1.01.98-1.39.06-.03.12-.07.18-.1.01-.01.03-.01.04-.02.06-.03.12-.06.19-.09.02-.01.04-.01.05-.02.03-.01.06-.02.09-.04.02-.01.04-.02.06-.02l.09-.03c.02-.01.03-.01.05-.02.08-.03.16-.05.24-.07.01 0 .03-.01.04-.01.07-.02.14-.03.21-.05h.02c.07-.01.14-.03.21-.04.02 0 .04-.01.05-.01l.18-.03h.03c.07-.01.14-.01.2-.02h.05c.05 0 .11-.01.16-.01h.53c.07 0 .15.01.22.01h.03c.08.01.15.01.23.02h.03c.09.01.19.03.28.04.01 0 .02 0 .03.01.06.01.12.02.17.04.06.01.12.03.17.04.01 0 .02.01.04.01l.22.06c.01 0 .01 0 .02.01.07.02.14.05.21.08.01.01.03.01.04.02.07.03.14.06.2.09.01.01.02.01.03.02.07.03.13.07.2.1l.15.09c.01.01.03.02.04.03.04.02.07.05.1.07.01.01.02.02.04.03.03.02.06.05.09.07.01.01.02.01.02.02.04.03.07.06.1.09l.06.06.02.02c.03.03.05.06.07.08l.01.01c.02.02.04.05.06.07.01.01.01.02.02.03.01.02.02.03.03.05.03.04.05.08.07.12 0 .01.01.01.01.02.02.03.03.07.04.1 0 .01.01.02.01.03.01.04.03.08.04.12.01.04.02.08.02.12v.03c0 .03.01.07.01.1v.03l-.02-7.17v-.02-.02c0-.03 0-.07-.01-.1v-.03c-.01-.04-.01-.08-.02-.12a.564.564 0 00-.04-.12v-.01c0-.01-.01-.01-.01-.02-.01-.03-.03-.07-.04-.1 0-.01 0-.01-.01-.02v-.01a.746.746 0 00-.07-.12v-.01c-.01-.02-.02-.03-.03-.04s-.01-.02-.02-.03c-.02-.03-.04-.05-.06-.07l-.01-.01c-.02-.03-.05-.06-.07-.08l-.02-.02c-.02-.02-.03-.04-.05-.05-.03-.03-.07-.06-.1-.09-.01-.01-.02-.01-.02-.02-.03-.02-.06-.05-.09-.07l-.01-.01c-.01-.01-.02-.01-.03-.02l-.1-.07c-.01-.01-.03-.02-.04-.03l-.15-.09c-.06-.04-.13-.07-.2-.1-.01-.01-.02-.01-.03-.02-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.14-.05-.21-.08-.01 0-.01 0-.02-.01-.07-.02-.14-.04-.22-.06-.01 0-.01 0-.02-.01h-.01c-.06-.02-.11-.03-.17-.04-.06-.01-.12-.03-.17-.04h-.03c-.09-.02-.18-.03-.28-.04h-.03c-.08-.01-.15-.02-.23-.02h-.03c-.08-.01-.15-.01-.22-.01h-.53c-.05 0-.11.01-.16.01h-.05c-.07.01-.14.01-.2.02h-.03l-.18.03h-.05c-.07.01-.14.02-.21.04h-.01c-.07.02-.14.03-.21.05-.01 0-.02 0-.03.01h-.01c-.08.02-.16.05-.24.07-.01 0-.01 0-.02.01-.01 0-.02.01-.03.01l-.09.03c-.04.02-.06.02-.09.03z'
            fill='url(#dataMigr_banner_svg__SVGID_413_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_414_'
            gradientUnits='userSpaceOnUse'
            x1={-3084.308}
            y1={-2233.134}
            x2={-3076.385}
            y2={-2237.733}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M559.42 123.47a.138.138 0 00-.04-.03c-.03-.02-.06-.05-.09-.07-.01-.01-.02-.01-.02-.02a.902.902 0 01-.1-.09l-.06-.06-.02-.02c-.03-.03-.05-.06-.07-.08-.02-.03-.04-.05-.06-.08-.01-.01-.01-.02-.02-.03-.01-.02-.02-.03-.03-.05-.03-.04-.05-.08-.07-.12 0-.01-.01-.01-.01-.02-.02-.03-.03-.07-.04-.1 0-.01-.01-.02-.01-.03-.01-.04-.03-.08-.04-.12-.01-.04-.02-.08-.02-.12v-.03c0-.03-.01-.07-.01-.1v-.03l.02 7.17v.04c0 .03 0 .07.01.1v.03c.01.04.01.08.02.12.01.04.02.08.04.12v.01c0 .01.01.01.01.02.01.03.03.07.04.1 0 .01 0 .01.01.02.02.04.05.08.07.12 0 0 0 .01.01.01.01.01.02.02.03.04.01.01.01.02.02.03.02.03.04.05.06.08.02.03.05.06.07.08l.02.02c.02.02.03.04.05.05.03.03.07.06.1.09.01.01.02.01.02.02.03.02.06.05.09.07l.01.01c.01.01.02.01.02.02l.1.07c.01.01.03.02.04.03l.15.09c.06.04.13.07.2.1.01.01.02.01.03.02.07.03.13.06.2.09.01.01.03.01.04.02.07.03.14.05.22.08.01 0 .01 0 .02.01.07.02.14.05.22.07.01 0 .01 0 .02.01h.01c.06.02.12.03.18.04.06.01.12.03.18.04h.04c.09.02.19.03.28.04h.03c.08.01.15.02.23.02h.03c.08.01.15.01.22.01h.53c.05 0 .11-.01.16-.01h.05c.07-.01.14-.01.2-.02h.03l.18-.03h.05c.07-.01.14-.02.21-.04h.01c.07-.02.14-.03.21-.05.01 0 .02 0 .03-.01h.01c.09-.02.17-.05.24-.07.01 0 .01 0 .02-.01.01 0 .02-.01.03-.01l.09-.03c.02-.01.04-.02.06-.02.03-.01.06-.02.09-.04.01-.01.03-.01.04-.02h.01c.06-.03.13-.06.19-.09.01-.01.03-.01.04-.02.06-.03.13-.07.18-.1.66-.39.99-.89.99-1.4l-.02-7.17c0 .51-.33 1.01-.99 1.4-.06.04-.12.07-.19.1-.01.01-.03.01-.04.02-.06.03-.13.06-.19.09-.02.01-.04.01-.05.02-.03.01-.06.02-.09.04-.02.01-.04.02-.06.02l-.09.03c-.02.01-.03.01-.05.02-.08.03-.16.05-.24.07-.01 0-.03.01-.04.01-.07.02-.14.04-.21.05h-.02c-.07.01-.14.03-.21.04-.02 0-.04.01-.05.01l-.18.03h-.03c-.07.01-.14.01-.2.02h-.05c-.05 0-.11.01-.16.01h-.53c-.07 0-.15-.01-.22-.01h-.03c-.08-.01-.15-.01-.23-.02h-.03c-.09-.01-.19-.03-.28-.04-.01 0-.02 0-.04-.01-.06-.01-.12-.02-.17-.04-.06-.01-.12-.03-.17-.04-.01 0-.02-.01-.04-.01-.07-.02-.15-.04-.22-.07-.01 0-.01 0-.02-.01-.07-.02-.15-.05-.22-.08-.01-.01-.03-.01-.04-.02-.07-.03-.14-.06-.2-.09-.01-.01-.02-.01-.03-.02-.07-.03-.14-.07-.2-.1l-.15-.09c-.01-.01-.03-.02-.04-.03-.01-.03-.05-.05-.08-.07z'
            fill='url(#dataMigr_banner_svg__SVGID_414_)'
          />
        </g>
        <g className='dataMigr_banner_svg__st233'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_415_'
            gradientUnits='userSpaceOnUse'
            x1={-3082.431}
            y1={-2227.16}
            x2={-3074.519}
            y2={-2231.752}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M554.15 123.97c-.03.01-.06.02-.09.04-.01.01-.03.01-.04.02h-.01c-.06.03-.13.06-.19.09-.01.01-.03.01-.04.02-.06.03-.12.06-.18.1-.66.39-.98.89-.98 1.39l.02 7.17c0-.5.33-1.01.98-1.39.06-.03.12-.07.18-.1.01-.01.03-.01.04-.02.06-.03.12-.06.19-.09.02-.01.04-.01.05-.02.03-.01.06-.02.09-.04.02-.01.04-.02.06-.02l.09-.03c.02-.01.03-.01.05-.02.08-.03.16-.05.24-.07.01 0 .03-.01.04-.01.07-.02.14-.03.21-.05h.02c.07-.01.14-.03.21-.04.02 0 .04-.01.05-.01l.18-.03h.03c.07-.01.14-.01.2-.02h.05c.05 0 .11-.01.16-.01h.53c.07 0 .15.01.22.01h.03c.08.01.15.01.23.02h.03c.09.01.19.03.28.04.01 0 .02 0 .03.01.06.01.12.02.17.04.06.01.11.03.17.04.01 0 .02.01.04.01l.22.06c.01 0 .01 0 .02.01.07.02.14.05.21.08.01.01.03.01.04.02.07.03.14.06.2.09.01.01.02.01.03.02.07.03.13.07.2.1l.15.09c.01.01.03.02.04.03.04.02.07.05.1.07.01.01.02.02.04.03.03.02.06.05.09.07.01.01.02.01.02.02.04.03.07.06.1.09l.06.06.02.02c.03.03.05.06.07.08.02.03.04.05.06.08.01.01.01.02.02.03.01.02.02.03.03.05.03.04.05.08.07.12 0 .01.01.01.01.02.02.03.03.07.04.1 0 .01.01.02.01.03.01.04.03.08.04.12.01.04.02.08.02.12v.03c0 .03.01.07.01.1v.03l-.02-7.17v-.02-.02c0-.03 0-.07-.01-.1v-.03c-.01-.04-.01-.08-.02-.12a.564.564 0 00-.04-.12v-.01c0-.01-.01-.01-.01-.02-.01-.03-.03-.07-.04-.1 0-.01 0-.01-.01-.02v-.01a.746.746 0 00-.07-.12s0-.01-.01-.01a.138.138 0 01-.03-.04c-.01-.01-.01-.02-.02-.03-.02-.03-.04-.05-.06-.07l-.01-.01c-.02-.03-.05-.06-.07-.08l-.02-.02c-.02-.02-.03-.04-.05-.05-.03-.03-.07-.06-.1-.09-.01-.01-.02-.01-.02-.02-.03-.02-.06-.05-.09-.07l-.01-.01c-.01-.01-.02-.01-.02-.02l-.1-.07c-.01-.01-.03-.02-.04-.03l-.15-.09c-.06-.04-.13-.07-.2-.1-.01-.01-.02-.01-.03-.02-.07-.03-.13-.06-.2-.09-.01-.01-.03-.01-.04-.02-.07-.03-.14-.05-.21-.08-.01 0-.01 0-.02-.01-.07-.02-.14-.04-.22-.06-.01 0-.01 0-.02-.01h-.01c-.06-.02-.11-.03-.17-.04-.06-.01-.12-.03-.17-.04h-.03c-.09-.02-.18-.03-.28-.04h-.02c-.08-.01-.15-.02-.23-.02h-.03c-.08-.01-.15-.01-.22-.01h-.53c-.05 0-.11.01-.16.01h-.05c-.07.01-.14.01-.2.02h-.02l-.18.03h-.05c-.07.01-.14.02-.21.04h-.02c-.07.02-.14.03-.21.05-.01 0-.02 0-.03.01h-.01c-.08.02-.16.05-.24.07-.01 0-.01 0-.02.01-.01 0-.02.01-.03.01l-.09.03c-.05.01-.07.02-.09.03z'
            fill='url(#dataMigr_banner_svg__SVGID_415_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_416_'
            gradientUnits='userSpaceOnUse'
            x1={-3084.141}
            y1={-2226.156}
            x2={-3076.217}
            y2={-2230.755}
            gradientTransform='scale(-1 1) rotate(-59.709 236.579 -3248.004)'
          >
            <stop offset={0} stopColor='#334bf2' />
            <stop offset={0.094} stopColor='#5367f4' stopOpacity={0.906} />
            <stop offset={0.263} stopColor='#8795f7' stopOpacity={0.737} />
            <stop offset={0.429} stopColor='#b2bbfa' stopOpacity={0.571} />
            <stop offset={0.589} stopColor='#d4d9fc' stopOpacity={0.411} />
            <stop offset={0.741} stopColor='#eceefe' stopOpacity={0.259} />
            <stop offset={0.882} stopColor='#fafbff' stopOpacity={0.118} />
            <stop offset={1} stopColor='#fff' stopOpacity={0} />
          </linearGradient>
          <path
            d='M553.31 126.84a.138.138 0 00-.04-.03c-.03-.02-.06-.05-.09-.07-.01-.01-.02-.01-.02-.02a.902.902 0 01-.1-.09l-.06-.06-.02-.02c-.03-.03-.05-.06-.07-.08l-.01-.01c-.02-.02-.04-.05-.06-.07-.01-.01-.01-.02-.02-.03-.01-.02-.02-.03-.03-.05-.03-.04-.05-.08-.07-.12 0-.01-.01-.01-.01-.02-.02-.03-.03-.07-.04-.1 0-.01-.01-.02-.01-.03-.01-.04-.03-.08-.04-.12-.01-.04-.02-.08-.02-.12v-.03c0-.03-.01-.07-.01-.1v-.03l.02 7.17v.04c0 .03 0 .07.01.1v.03c.01.04.01.08.02.12.01.04.02.08.04.12v.01c0 .01.01.01.01.02.01.03.03.07.04.1 0 .01 0 .01.01.02v.01a.746.746 0 00.08.13c.01.01.02.02.03.04.01.01.01.02.02.03.02.03.04.05.06.08.02.03.05.06.07.08l.02.02c.02.02.03.04.05.05.03.03.07.06.1.09.01.01.02.01.02.02.03.02.06.05.09.07l.01.01c.01.01.02.01.03.02l.1.07c.01.01.03.02.04.03l.15.09c.06.04.13.07.2.1.01.01.02.01.03.02.07.03.13.06.2.09.01.01.03.01.04.02.07.03.14.05.22.08.01 0 .01 0 .02.01.07.02.14.05.22.07.01 0 .01 0 .02.01h.01c.06.02.11.03.17.04.06.01.12.03.18.04h.04c.09.02.19.03.28.04h.03c.08.01.15.02.23.02h.03c.08.01.15.01.22.01h.53c.05 0 .11-.01.16-.01h.05c.07-.01.14-.01.2-.02h.03l.18-.03h.05c.07-.01.14-.02.21-.04h.01c.08-.02.15-.03.22-.05.01 0 .02 0 .03-.01h.01c.08-.02.16-.05.24-.07.01 0 .01 0 .02-.01.01 0 .02-.01.03-.01l.09-.03c.02-.01.04-.02.06-.02.03-.01.06-.02.09-.04.01-.01.03-.01.04-.02h.01c.06-.03.13-.06.19-.09.01-.01.03-.01.04-.02.06-.03.13-.07.19-.1.66-.39.99-.89.99-1.4l-.02-7.17c0 .51-.33 1.01-.99 1.4-.06.04-.12.07-.19.1-.01.01-.03.01-.04.02-.06.03-.13.06-.19.09-.02.01-.04.01-.05.02-.03.01-.06.02-.09.04-.02.01-.04.02-.06.02l-.09.03c-.02.01-.03.01-.05.02-.08.03-.16.05-.24.07-.01 0-.03.01-.04.01-.07.02-.14.04-.21.05h-.02c-.07.01-.14.03-.21.04-.02 0-.04.01-.05.01l-.18.03h-.03c-.07.01-.14.01-.2.02h-.05c-.05 0-.11.01-.16.01h-.53c-.07 0-.15-.01-.22-.01h-.03c-.08-.01-.15-.01-.23-.02h-.03c-.09-.01-.19-.03-.28-.04-.01 0-.02 0-.04-.01-.06-.01-.12-.02-.17-.04-.06-.01-.12-.03-.17-.04-.01 0-.02-.01-.04-.01-.07-.02-.15-.04-.22-.07-.01 0-.01 0-.02-.01-.07-.02-.15-.05-.22-.08-.01-.01-.03-.01-.04-.02-.07-.03-.14-.06-.2-.09-.01-.01-.02-.01-.03-.02-.07-.03-.14-.07-.2-.1l-.15-.09c-.01-.01-.03-.02-.04-.03a.236.236 0 00-.09-.08z'
            fill='url(#dataMigr_banner_svg__SVGID_416_)'
          />
        </g>
      </g>
      <g>
        <g className='dataMigr_banner_svg__st1'>
          <path
            className='dataMigr_banner_svg__st25'
            d='M484.84 161.29c-.26.15-.42.48-.42.94v3.58l5.56-3.25v-3.58c0-.46.16-.79.42-.94l-5.56 3.25z'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_417_'
            gradientUnits='userSpaceOnUse'
            x1={481.512}
            y1={240.738}
            x2={490.606}
            y2={240.738}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#5c90fe' />
            <stop offset={0.562} stopColor='#466cf5' />
            <stop offset={0.691} stopColor='#4265f3' />
            <stop offset={0.875} stopColor='#3853ef' />
            <stop offset={1} stopColor='#2e42eb' />
          </linearGradient>
          <path
            d='M485.89 156.24c-3.28-1.88-5.96-.35-5.96 3.42v3.58l4.49 2.58v-3.58c0-.93.66-1.31 1.47-.84l3.12 1.79v-5.15l-3.12-1.8z'
            fill='url(#dataMigr_banner_svg__SVGID_417_)'
          />
          <path className='dataMigr_banner_svg__st25' d='M489 163.18l5.56-3.25v-5.15l-5.56 3.25z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_418_'
            gradientUnits='userSpaceOnUse'
            x1={483.258}
            y1={246.233}
            x2={496.166}
            y2={246.233}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#5c90fe' />
            <stop offset={0.562} stopColor='#466cf5' />
            <stop offset={0.691} stopColor='#4265f3' />
            <stop offset={0.875} stopColor='#3853ef' />
            <stop offset={1} stopColor='#2e42eb' />
          </linearGradient>
          <path
            d='M491.44 152.99l-.27-.15c-.02-.01-.05-.02-.07-.04a5.92 5.92 0 00-.25-.12c-.01 0-.02-.01-.03-.01l-.21-.09c-.01 0-.02-.01-.04-.01-.09-.03-.17-.07-.26-.1-.02-.01-.05-.02-.07-.03-.11-.04-.21-.07-.32-.1h-.02c-.06-.02-.12-.03-.18-.04-.03-.01-.05-.01-.08-.02-.09-.02-.18-.04-.27-.05h-.02l-.23-.03c-.03 0-.05 0-.08-.01-.04 0-.07-.01-.11-.01h-.4c-.07 0-.13.01-.2.02-.02 0-.03 0-.05.01-.04.01-.07.01-.11.02-.01 0-.02.01-.04.01-.1.02-.2.04-.3.07h-.01c-.09.03-.18.06-.27.1-.01 0-.02.01-.03.01-.01.01-.03.01-.04.02-.07.03-.15.07-.22.11-.01.01-.03.01-.04.02-.01.01-.02.01-.03.02l-5.56 3.25c.02-.01.05-.02.07-.04.07-.04.14-.08.22-.11.03-.01.05-.02.08-.03.09-.04.18-.07.27-.1h.01c.1-.03.2-.05.3-.07.05-.01.1-.02.15-.02.02 0 .03-.01.05-.01.07-.01.15-.02.22-.02h.32c.06 0 .11 0 .17.01.03 0 .05 0 .08.01l.23.03h.02c.09.01.18.03.27.05.03.01.05.01.08.02.06.01.13.03.19.05.11.03.21.06.32.1.02.01.05.02.07.03.09.03.17.06.26.1.08.03.17.07.25.11.01 0 .02.01.03.01.08.04.16.08.25.12.02.01.05.02.07.04l.27.15 3.12 1.79 5.56-3.25-3.12-1.82z'
            fill='url(#dataMigr_banner_svg__SVGID_418_)'
          />
        </g>
        <g className='dataMigr_banner_svg__st1'>
          <path
            className='dataMigr_banner_svg__st25'
            d='M534.69 162.18c0-.46-.17-.79-.43-.94l-5.58-3.22c.26.15.43.48.43.94l.02 3.58 5.58 3.22-.02-3.58z'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_419_'
            gradientUnits='userSpaceOnUse'
            x1={531.675}
            y1={240.657}
            x2={540.771}
            y2={240.657}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#5c90fe' />
            <stop offset={0.562} stopColor='#466cf5' />
            <stop offset={0.691} stopColor='#4265f3' />
            <stop offset={0.875} stopColor='#3853ef' />
            <stop offset={1} stopColor='#2e42eb' />
          </linearGradient>
          <path
            d='M533.19 156.2c3.27-1.9 5.95-.38 5.98 3.38l.02 3.58-4.48 2.6-.02-3.58c-.01-.93-.66-1.3-1.47-.83l-3.11 1.81-.03-5.15 3.11-1.81z'
            fill='url(#dataMigr_banner_svg__SVGID_419_)'
          />
          <path className='dataMigr_banner_svg__st25' d='M530.11 163.15l-5.57-3.22-.03-5.15 5.57 3.22z' />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_420_'
            gradientUnits='userSpaceOnUse'
            x1={526.114}
            y1={246.182}
            x2={539.023}
            y2={246.182}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#5c90fe' />
            <stop offset={0.562} stopColor='#466cf5' />
            <stop offset={0.691} stopColor='#4265f3' />
            <stop offset={0.875} stopColor='#3853ef' />
            <stop offset={1} stopColor='#2e42eb' />
          </linearGradient>
          <path
            d='M533.54 156.01c.08-.04.16-.08.25-.12.01 0 .02-.01.03-.01.08-.04.17-.07.25-.11.09-.04.17-.07.26-.1.02-.01.05-.02.07-.03.11-.04.21-.07.32-.1.07-.02.13-.03.19-.05.03-.01.05-.01.08-.02.09-.02.18-.04.27-.05h.02l.23-.03c.03 0 .05 0 .08-.01.06 0 .11-.01.17-.01h.32c.08 0 .15.01.22.02.02 0 .03 0 .05.01.05.01.1.02.15.02.1.02.2.04.3.07h.01c.09.03.18.06.27.1.03.01.05.02.08.03.08.03.15.07.22.11.02.01.05.02.07.04l-5.58-3.22c-.01-.01-.02-.01-.03-.02-.01-.01-.03-.01-.04-.02-.07-.04-.15-.07-.22-.11-.01-.01-.03-.01-.04-.02-.01 0-.02-.01-.03-.01-.09-.04-.18-.07-.27-.1h-.01c-.1-.03-.2-.05-.3-.07-.01 0-.02-.01-.04-.01-.04-.01-.07-.01-.11-.02-.02 0-.03 0-.05-.01-.07-.01-.13-.01-.2-.02h-.4c-.04 0-.07.01-.11.01-.03 0-.05 0-.08.01l-.23.03h-.02c-.09.01-.18.03-.27.05-.03.01-.05.01-.08.02-.06.01-.12.03-.18.04h-.02c-.11.03-.21.06-.32.1-.02.01-.05.02-.07.03-.08.03-.17.06-.26.1-.01 0-.02.01-.04.01l-.21.09c-.01 0-.02.01-.03.01-.08.04-.16.08-.25.12-.02.01-.05.02-.07.04l-.27.15-3.11 1.81 5.58 3.22 3.11-1.81.27-.15c.02.01.04 0 .07-.01z'
            fill='url(#dataMigr_banner_svg__SVGID_420_)'
          />
        </g>
        <g className='dataMigr_banner_svg__st1'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_421_'
            gradientUnits='userSpaceOnUse'
            x1={541.399}
            y1={237.817}
            x2={480.922}
            y2={237.817}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M537.48 160.17c3.1 1.78 3.12 4.68.05 6.47l-22.23 13c-3.07 1.79-8.07 1.81-11.17.03l-22.45-12.88c-3.1-1.78-3.12-4.67-.05-6.47l22.23-13c3.07-1.79 8.07-1.81 11.17-.03l22.45 12.88z'
            fill='url(#dataMigr_banner_svg__SVGID_421_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_422_'
            gradientUnits='userSpaceOnUse'
            x1={541.411}
            y1={222.657}
            x2={480.866}
            y2={222.657}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M539.81 163.56c0 .04 0 .08-.01.12 0 .03-.01.07-.01.1-.01.04-.01.08-.02.12-.01.03-.01.07-.02.1l-.03.12-.03.1c-.01.04-.02.08-.04.11-.01.03-.02.07-.04.1-.02.04-.03.08-.05.12-.01.03-.03.07-.05.1l-.06.12c-.02.03-.03.06-.05.1-.03.05-.06.09-.09.14-.02.03-.04.06-.05.08-.04.05-.07.1-.11.15-.02.02-.03.04-.05.07-.06.08-.13.16-.2.24l-.06.06-.18.18c-.03.03-.06.05-.09.08-.04.03-.08.07-.11.1-.04.03-.07.06-.11.09s-.08.07-.12.1l-.12.09c-.04.03-.09.06-.13.09s-.08.06-.13.09-.09.06-.14.09c-.06.04-.12.08-.18.11l-22.23 13c-.12.07-.24.13-.36.2-.04.02-.07.04-.11.05-.1.05-.19.09-.29.14-.03.01-.07.03-.1.04-.13.06-.26.11-.39.16-.02.01-.05.02-.07.03-.11.04-.23.08-.34.12-.05.02-.09.03-.14.05-.06.02-.13.04-.19.06-.05.02-.11.03-.16.05-.07.02-.13.04-.2.05-.05.01-.11.03-.17.04-.07.02-.13.03-.2.05-.06.01-.11.03-.17.04-.07.01-.14.03-.21.04l-.16.03c-.15.03-.3.05-.45.07-.02 0-.04.01-.06.01-.13.02-.26.03-.39.05-.05.01-.1.01-.15.02-.08.01-.17.02-.25.02-.05 0-.11.01-.16.01-.09.01-.18.01-.27.01-.05 0-.1 0-.15.01-.08 0-.15 0-.23.01h-.56c-.08 0-.15-.01-.23-.01-.05 0-.1 0-.16-.01-.08 0-.16-.01-.25-.02-.05 0-.09-.01-.14-.01l-.31-.03c-.02 0-.05 0-.07-.01-.13-.01-.25-.03-.38-.05-.02 0-.04-.01-.06-.01-.11-.02-.21-.03-.32-.05-.05-.01-.09-.02-.13-.02-.08-.01-.16-.03-.24-.05-.04-.01-.08-.02-.13-.03l-.27-.06c-.05-.01-.1-.02-.15-.04l-.24-.06c-.05-.01-.09-.03-.13-.04-.13-.04-.25-.07-.37-.12-.02-.01-.04-.01-.07-.02l-.42-.15a1.22 1.22 0 01-.17-.07.694.694 0 00-.13-.05c-.06-.03-.12-.05-.18-.08-.04-.02-.08-.04-.12-.05-.07-.03-.13-.06-.2-.1-.03-.02-.06-.03-.1-.05-.1-.05-.19-.1-.29-.16l-22.45-12.88a5.761 5.761 0 01-1.42-1.11c-.24-.27-.44-.54-.59-.83-.22-.43-.33-.87-.33-1.31v12.88c0 1.18.78 2.36 2.34 3.25l22.45 12.88c.09.05.19.11.29.16.03.02.06.03.1.05.07.03.13.07.2.1.04.02.08.04.12.05.06.03.12.06.18.08.04.02.09.04.13.05.04.02.08.04.13.05.01.01.03.01.04.01l.42.15c.02.01.04.01.07.02.12.04.25.08.37.11.02.01.04.01.06.02.02.01.05.01.07.02l.24.06c.05.01.1.02.15.04a609862459997344.1 609862459997344.1 0 00.4.09c.08.02.16.03.24.05.04.01.09.02.13.02.11.02.21.03.32.05.02 0 .04.01.06.01.13.02.25.03.38.05.03 0 .05 0 .08.01l.3.03h.01c.04 0 .09.01.13.01.08.01.16.01.25.02.05 0 .1 0 .16.01.08 0 .15.01.23.01h.56c.08 0 .15 0 .23-.01h.04c.04 0 .07 0 .11-.01.09 0 .18-.01.27-.01.05 0 .11-.01.16-.01.08-.01.17-.01.25-.02.03 0 .06 0 .09-.01.02 0 .04-.01.06-.01.13-.01.26-.03.39-.05.02 0 .04-.01.06-.01.15-.02.3-.05.45-.07.01 0 .03 0 .04-.01.04-.01.08-.02.12-.02.07-.01.14-.03.21-.04.06-.01.11-.02.17-.04.07-.02.14-.03.2-.05.06-.01.11-.03.17-.04.07-.02.13-.03.2-.05.05-.02.11-.03.16-.05.06-.02.13-.04.19-.06.03-.01.06-.02.08-.03s.04-.01.06-.02c.12-.04.23-.08.34-.12.02-.01.05-.02.07-.03.13-.05.26-.11.39-.16.03-.01.07-.03.1-.04.1-.04.2-.09.29-.14.04-.02.07-.04.11-.05.12-.06.25-.13.36-.2l22.23-13c.03-.02.06-.04.1-.06.03-.02.06-.04.09-.05.05-.03.1-.06.14-.09.04-.03.08-.06.13-.09s.09-.06.13-.09l.12-.09c.04-.03.08-.06.12-.1.04-.03.07-.06.11-.09s.08-.07.11-.1c.02-.01.03-.03.05-.04l.04-.04.18-.18.06-.06c.07-.08.14-.16.2-.24l.01-.01c.01-.02.03-.04.04-.06.04-.05.08-.1.11-.15l.06-.09c.03-.05.06-.09.09-.14.01-.01.02-.03.02-.04l.03-.06.06-.12c.02-.03.03-.07.05-.1.02-.04.03-.08.05-.12.01-.02.02-.04.02-.05.01-.02.01-.03.02-.05.01-.04.03-.08.04-.11l.03-.1.03-.12c0-.02.01-.04.01-.06 0-.01 0-.03.01-.04.01-.04.01-.08.02-.12 0-.03.01-.07.01-.1 0-.04.01-.08.01-.12v-.07V163.39c-.01.08-.02.12-.02.17z'
            fill='url(#dataMigr_banner_svg__SVGID_422_)'
          />
          <g>
            <path
              d='M509.72 178.63c-1.68 0-3.28-.36-4.41-1.01l-22.45-12.88c-.79-.45-1.15-.94-1.15-1.19s.35-.73 1.11-1.18l22.23-13c1.11-.65 2.71-1.03 4.39-1.03 1.68 0 3.28.36 4.41 1.01l22.45 12.88c.79.45 1.15.94 1.15 1.19s-.35.73-1.11 1.17l-22.23 13c-1.12.66-2.72 1.03-4.39 1.04z'
              fill='none'
              stroke='#f2f2f2'
              strokeWidth={0.506}
              strokeMiterlimit={10}
            />
          </g>
        </g>
        <path
          className='dataMigr_banner_svg__st25'
          d='M509.74 185.4c-2.23.01-4.34-.49-5.94-1.41l-3.25-1.86v-1.09l3.72 2.13c1.46.84 3.4 1.29 5.46 1.29 2.07-.01 4-.47 5.44-1.32l3.63-2.12v1.1l-3.16 1.85c-1.57.91-3.67 1.42-5.9 1.43z'
        />
        <path
          className='dataMigr_banner_svg__st25'
          d='M509.75 187.99c-2.23.01-4.34-.49-5.94-1.41l-3.25-1.86v-1.09l3.72 2.13c1.46.84 3.4 1.29 5.46 1.29 2.07-.01 4-.47 5.44-1.32l3.63-2.12v1.1l-3.16 1.85c-1.57.91-3.67 1.42-5.9 1.43z'
        />
        <path
          className='dataMigr_banner_svg__st25'
          d='M509.75 190.58c-2.23.01-4.34-.49-5.94-1.41l-3.25-1.86v-1.09l3.72 2.13c1.46.84 3.4 1.29 5.46 1.29 2.07-.01 4-.47 5.44-1.32l3.63-2.12v1.1l-3.16 1.85c-1.56.92-3.66 1.43-5.9 1.43z'
        />
        <g className='dataMigr_banner_svg__st1'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_423_'
            gradientUnits='userSpaceOnUse'
            x1={526.147}
            y1={215.244}
            x2={535.208}
            y2={215.244}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#5c90fe' />
            <stop offset={0.562} stopColor='#466cf5' />
            <stop offset={0.691} stopColor='#4265f3' />
            <stop offset={0.875} stopColor='#3853ef' />
            <stop offset={1} stopColor='#2e42eb' />
          </linearGradient>
          <path
            d='M527.74 179.98c3.28 1.88 5.96 6.48 5.96 10.25v3.58l-4.49-2.58v-3.58c0-.93-.66-2.06-1.47-2.52l-3.12-1.79v-5.15l3.12 1.79z'
            fill='url(#dataMigr_banner_svg__SVGID_423_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_424_'
            gradientUnits='userSpaceOnUse'
            x1={526.163}
            y1={216.872}
            x2={540.77}
            y2={216.872}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#5c90fe' />
            <stop offset={0.562} stopColor='#466cf5' />
            <stop offset={0.691} stopColor='#4265f3' />
            <stop offset={0.875} stopColor='#3853ef' />
            <stop offset={1} stopColor='#2e42eb' />
          </linearGradient>
          <path
            d='M539.25 186.71v-.05c0-.04 0-.07-.01-.11 0-.04 0-.08-.01-.13 0-.03-.01-.07-.01-.1 0-.04-.01-.08-.01-.11 0-.02 0-.05-.01-.07-.01-.06-.01-.11-.02-.17 0-.03-.01-.06-.01-.09v-.03c-.01-.1-.03-.2-.04-.3v-.01c0-.02-.01-.03-.01-.05-.01-.08-.03-.16-.04-.24 0-.02-.01-.03-.01-.05-.01-.04-.02-.08-.02-.12-.01-.05-.02-.1-.03-.14-.01-.03-.01-.06-.02-.08l-.03-.13c-.01-.03-.01-.06-.02-.1l-.03-.12-.03-.13c-.01-.02-.01-.04-.02-.06-.02-.06-.03-.12-.05-.18l-.03-.11c0-.01-.01-.02-.01-.03-.03-.1-.06-.21-.1-.31v-.01c0-.01-.01-.03-.01-.04-.03-.09-.06-.17-.09-.26-.01-.01-.01-.03-.02-.04-.01-.03-.03-.07-.04-.1-.02-.05-.04-.09-.05-.14-.01-.03-.03-.06-.04-.1-.02-.04-.03-.08-.05-.11-.01-.03-.02-.05-.03-.08-.02-.06-.05-.11-.07-.17-.01-.03-.02-.06-.04-.09 0-.01-.01-.02-.01-.03-.04-.1-.09-.19-.13-.29 0 0 0-.01-.01-.01-.01-.03-.03-.06-.04-.08-.04-.07-.07-.15-.11-.22-.01-.01-.01-.02-.02-.03l-.09-.18c-.03-.05-.05-.1-.07-.14 0-.01-.01-.02-.01-.03-.08-.15-.17-.31-.26-.46-.01-.01-.01-.03-.02-.04-.02-.04-.05-.08-.07-.11-.04-.06-.08-.13-.11-.19-.03-.05-.07-.11-.1-.16l-.12-.18c-.01-.02-.03-.04-.04-.06-.01-.02-.03-.04-.04-.06-.11-.16-.22-.32-.34-.48-.01-.02-.02-.03-.03-.05-.07-.1-.14-.19-.22-.28 0-.01-.01-.01-.01-.02-.06-.07-.12-.14-.17-.21-.02-.02-.03-.04-.05-.06-.08-.09-.15-.18-.23-.27l-.01-.01c-.03-.03-.05-.05-.07-.08-.05-.06-.1-.12-.16-.17l-.03-.03c-.03-.04-.07-.07-.1-.11l-.12-.12-.04-.04-.11-.11-.1-.1c-.02-.02-.04-.03-.05-.05-.04-.04-.08-.07-.12-.11-.03-.03-.06-.05-.09-.08a.435.435 0 00-.07-.06c-.04-.04-.08-.07-.12-.11a.5.5 0 01-.08-.07c-.03-.02-.05-.04-.08-.06-.04-.03-.08-.07-.12-.1-.02-.02-.04-.04-.06-.05-.03-.03-.07-.05-.1-.08-.04-.03-.07-.06-.11-.08-.02-.01-.03-.02-.05-.04-.05-.03-.09-.06-.14-.1-.03-.02-.06-.05-.1-.07-.01-.01-.02-.01-.03-.02-.08-.06-.17-.11-.25-.17-.01 0-.01-.01-.01-.01-.08-.05-.16-.1-.24-.14l-.06-.03-3.12-1.79-5.56 3.25 3.12 1.79c.1.06.2.12.29.18l.01.01c.09.06.19.12.28.18.03.02.06.04.1.07.06.04.12.09.18.13.04.03.07.06.11.08.06.04.11.09.17.13.04.03.08.06.12.1.05.04.1.09.16.13.04.04.08.07.12.11.05.05.1.09.15.14.04.04.08.07.12.11l.15.15.11.11c.05.05.1.11.16.16.03.04.07.07.1.11.06.07.12.13.18.2.02.03.05.05.07.07.08.09.16.19.24.28.02.02.04.04.05.07.06.08.12.15.18.23.07.09.15.19.22.29.01.01.02.03.03.04.12.16.23.32.34.48.03.04.05.08.08.12l.12.18c.03.05.07.11.1.16.04.06.08.13.12.19l.09.15c.09.15.18.3.26.46.03.06.06.11.09.17l.09.18c.04.08.08.17.12.25.01.03.03.06.04.09l.15.33c.01.03.03.06.04.09.04.08.07.16.1.25.02.04.03.08.05.11l.09.24c.01.03.03.07.04.1.04.1.07.2.11.3 0 .01.01.03.01.04.04.11.08.23.11.34l.03.11c.02.08.05.16.07.24l.03.13.06.22.03.13c.02.08.03.15.05.23.01.04.02.08.02.12.02.1.04.19.05.29 0 .02.01.04.01.05.02.11.03.22.05.34 0 .03.01.06.01.09l.03.24c0 .04.01.08.01.11.01.08.01.15.01.23 0 .04 0 .07.01.11 0 .11.01.21.01.32v3.58l5.56-3.25v-3.58-.27z'
            fill='url(#dataMigr_banner_svg__SVGID_424_)'
          />
        </g>
        <g className='dataMigr_banner_svg__st1'>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_425_'
            gradientUnits='userSpaceOnUse'
            x1={487.078}
            y1={215.245}
            x2={496.137}
            y2={215.245}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#5c90fe' />
            <stop offset={0.562} stopColor='#466cf5' />
            <stop offset={0.691} stopColor='#4265f3' />
            <stop offset={0.875} stopColor='#3853ef' />
            <stop offset={1} stopColor='#2e42eb' />
          </linearGradient>
          <path
            d='M491.47 180.08c-3.27 1.9-5.92 6.51-5.9 10.28l.02 3.58 4.48-2.6-.02-3.58c-.01-.93.65-2.06 1.45-2.53l3.11-1.81-.03-5.15-3.11 1.81z'
            fill='url(#dataMigr_banner_svg__SVGID_425_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_426_'
            gradientUnits='userSpaceOnUse'
            x1={481.517}
            y1={216.877}
            x2={496.111}
            y2={216.877}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#5c90fe' />
            <stop offset={0.562} stopColor='#466cf5' />
            <stop offset={0.691} stopColor='#4265f3' />
            <stop offset={0.875} stopColor='#3853ef' />
            <stop offset={1} stopColor='#2e42eb' />
          </linearGradient>
          <path
            d='M485.58 189.94c0-.08.01-.15.01-.23 0-.04.01-.08.01-.11.01-.08.01-.16.02-.24 0-.03.01-.06.01-.09.01-.11.03-.22.05-.34 0-.02.01-.04.01-.05.02-.1.03-.19.05-.29.01-.04.02-.08.02-.12.02-.08.03-.15.05-.23l.03-.13c.02-.07.04-.15.05-.22l.03-.13c.02-.08.04-.16.07-.24l.03-.11c.03-.11.07-.23.11-.34 0-.01.01-.03.01-.04.03-.1.07-.2.11-.3.01-.03.03-.07.04-.1l.09-.24c.02-.04.03-.08.05-.11.03-.08.07-.17.1-.25.01-.03.02-.06.04-.09l.15-.33c.01-.03.03-.06.04-.09.04-.08.08-.17.12-.25l.09-.18c.03-.06.06-.11.09-.17.08-.15.17-.31.26-.46l.09-.15c.04-.06.08-.13.11-.19.03-.05.07-.11.1-.16l.12-.18c.03-.04.05-.08.08-.12.11-.16.22-.32.34-.48.01-.01.02-.03.03-.04.07-.1.14-.19.22-.29.06-.08.12-.15.18-.23a.18.18 0 00.05-.07c.08-.1.16-.19.24-.29.02-.03.05-.05.07-.08.06-.07.12-.13.18-.2.03-.04.07-.07.1-.11.05-.05.1-.11.16-.16l.11-.11.15-.15c.04-.04.08-.08.12-.11.05-.05.1-.09.15-.14.04-.04.08-.07.12-.11.05-.04.1-.09.16-.13.04-.03.08-.07.12-.1.05-.04.11-.09.17-.13.04-.03.07-.06.11-.09.06-.05.12-.09.18-.13.03-.02.06-.05.1-.07.09-.06.18-.13.28-.19l.01-.01c.1-.06.19-.12.29-.18l3.11-1.81-5.58-3.22-3.11 1.81-.06.03c-.08.05-.16.1-.23.14l-.01.01c-.08.05-.17.11-.25.17-.01.01-.02.01-.03.02-.03.02-.06.05-.09.07-.05.03-.09.06-.14.1-.02.01-.03.02-.05.04-.04.03-.07.06-.11.09-.03.03-.07.05-.1.08-.02.02-.04.04-.06.05-.04.03-.08.07-.12.1a.5.5 0 00-.08.07.5.5 0 00-.08.07c-.04.04-.08.07-.12.11-.02.02-.04.04-.07.06-.03.03-.06.05-.09.08-.04.04-.08.07-.12.11-.02.02-.04.03-.05.05l-.1.1-.11.11-.04.04-.12.12c-.03.04-.07.07-.1.11l-.03.03c-.05.06-.1.11-.15.17-.02.02-.04.05-.07.07l-.01.01c-.08.09-.15.18-.23.27-.02.02-.03.04-.05.06-.06.07-.12.14-.17.22 0 .01-.01.01-.01.02-.07.09-.14.19-.22.28-.01.02-.02.03-.03.05-.11.16-.23.32-.33.48-.01.02-.03.04-.04.06s-.03.04-.04.06l-.12.18c-.03.05-.07.11-.1.16-.04.06-.08.13-.11.19-.02.04-.05.08-.07.11-.01.01-.01.03-.02.04-.09.15-.17.3-.26.46 0 .01-.01.02-.01.03-.03.05-.05.1-.07.14l-.09.18c-.01.01-.01.02-.02.03-.04.07-.07.15-.11.22-.01.03-.03.06-.04.08 0 0 0 .01-.01.01-.04.1-.09.19-.13.29 0 .01-.01.02-.01.03-.01.03-.02.06-.04.09-.02.06-.05.11-.07.17-.01.03-.02.05-.03.08-.02.04-.03.08-.05.11-.01.03-.03.06-.04.1-.02.05-.04.09-.05.14-.01.03-.03.07-.04.1-.01.02-.01.03-.02.04-.03.09-.06.17-.09.26 0 .01-.01.03-.01.04v.01c-.03.1-.07.21-.1.31 0 .01-.01.02-.01.03l-.03.11c-.02.06-.04.12-.05.18-.01.02-.01.04-.02.06l-.03.13-.03.12c-.01.03-.01.06-.02.1l-.03.13c-.01.03-.01.06-.02.08-.01.05-.02.1-.03.14s-.02.08-.02.12c0 .02-.01.03-.01.05-.01.08-.03.16-.04.24 0 .02-.01.03-.01.05v.01c-.02.1-.03.2-.04.3v.03c0 .03-.01.06-.01.09-.01.06-.01.11-.02.17 0 .02 0 .05-.01.07 0 .04-.01.08-.01.11s-.01.07-.01.1c0 .04 0 .08-.01.13V187.13l.02 3.58 5.58 3.22-.02-3.58c0-.11 0-.21.01-.32-.01-.02-.01-.06-.01-.09z'
            fill='url(#dataMigr_banner_svg__SVGID_426_)'
          />
        </g>
        <g>
          <path
            className='dataMigr_banner_svg__st25'
            d='M509.71 173.23c-4.42.01-8.59-.98-11.75-2.79-3.3-1.89-5.12-4.46-5.15-7.23-.02-2.78 1.76-5.36 5.03-7.27 3.13-1.83 7.29-2.85 11.7-2.86 4.42-.01 8.59.98 11.75 2.79 3.3 1.89 5.12 4.46 5.15 7.23.02 2.78-1.76 5.36-5.03 7.27-3.13 1.84-7.28 2.85-11.7 2.86z'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_427_'
            gradientUnits='userSpaceOnUse'
            x1={527.232}
            y1={236.764}
            x2={495.199}
            y2={236.764}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M525.63 156.59c.02 2.37-1.52 4.75-4.64 6.57-6.22 3.64-16.36 3.67-22.65.06-3.14-1.8-4.72-4.17-4.74-6.55l.02 6.53c.02 2.37 1.6 4.74 4.74 6.55 6.28 3.61 16.42 3.58 22.65-.06 3.11-1.82 4.66-4.2 4.64-6.57l-.02-6.53z'
            fill='url(#dataMigr_banner_svg__SVGID_427_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_428_'
            gradientUnits='userSpaceOnUse'
            x1={527.232}
            y1={236.764}
            x2={495.199}
            y2={236.764}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M525.63 156.59c.02 2.37-1.52 4.75-4.64 6.57-6.22 3.64-16.36 3.67-22.65.06-3.14-1.8-4.72-4.17-4.74-6.55l.02 6.53c.02 2.37 1.6 4.74 4.74 6.55 6.28 3.61 16.42 3.58 22.65-.06 3.11-1.82 4.66-4.2 4.64-6.57l-.02-6.53z'
            fill='url(#dataMigr_banner_svg__SVGID_428_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_429_'
            gradientUnits='userSpaceOnUse'
            x1={527.229}
            y1={244.665}
            x2={495.209}
            y2={244.665}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M498.34 163.22c6.28 3.61 16.42 3.58 22.65-.06 3.11-1.82 4.66-4.2 4.64-6.57-.02-2.37-1.6-4.74-4.74-6.55-6.28-3.6-16.42-3.58-22.65.06-3.11 1.82-4.65 4.2-4.63 6.57.01 2.38 1.59 4.75 4.73 6.55z'
            fill='url(#dataMigr_banner_svg__SVGID_429_)'
          />
          <path
            className='dataMigr_banner_svg__st25'
            d='M522.51 164.89v1.02c-.4.3-.84.59-1.31.86-3.16 1.85-7.33 2.78-11.5 2.79-4.17.01-8.35-.9-11.55-2.73-.5-.29-.96-.59-1.39-.9v-1.01c.53.43 1.12.84 1.79 1.22 6.16 3.54 16.14 3.51 22.24-.06.64-.38 1.21-.77 1.72-1.19z'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_430_'
            gradientUnits='userSpaceOnUse'
            x1={527.223}
            y1={244.514}
            x2={495.19}
            y2={244.514}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M525.6 148.84c.02 2.37-1.52 4.75-4.64 6.57-6.22 3.64-16.36 3.67-22.65.06-3.14-1.8-4.73-4.17-4.74-6.55l.02 6.53c.02 2.37 1.6 4.74 4.74 6.55 6.28 3.61 16.42 3.58 22.65-.06 3.11-1.82 4.66-4.2 4.64-6.57l-.02-6.53z'
            fill='url(#dataMigr_banner_svg__SVGID_430_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_431_'
            gradientUnits='userSpaceOnUse'
            x1={527.223}
            y1={244.514}
            x2={495.19}
            y2={244.514}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M525.6 148.84c.02 2.37-1.52 4.75-4.64 6.57-6.22 3.64-16.36 3.67-22.65.06-3.14-1.8-4.73-4.17-4.74-6.55l.02 6.53c.02 2.37 1.6 4.74 4.74 6.55 6.28 3.61 16.42 3.58 22.65-.06 3.11-1.82 4.66-4.2 4.64-6.57l-.02-6.53z'
            fill='url(#dataMigr_banner_svg__SVGID_431_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_432_'
            gradientUnits='userSpaceOnUse'
            x1={527.23}
            y1={252.415}
            x2={495.21}
            y2={252.415}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M498.32 155.47c6.28 3.61 16.42 3.58 22.65-.06 3.11-1.82 4.66-4.2 4.64-6.57-.02-2.37-1.6-4.74-4.74-6.55-6.28-3.6-16.42-3.58-22.65.06-3.11 1.82-4.65 4.2-4.63 6.57.01 2.38 1.59 4.75 4.73 6.55z'
            fill='url(#dataMigr_banner_svg__SVGID_432_)'
          />
          <path
            className='dataMigr_banner_svg__st25'
            d='M522.49 157.14v1.02c-.4.3-.84.59-1.31.86-3.16 1.85-7.33 2.78-11.5 2.79-4.17.01-8.35-.9-11.55-2.73-.5-.29-.96-.59-1.39-.9v-1.01c.53.43 1.12.84 1.79 1.22 6.16 3.54 16.14 3.51 22.24-.06.64-.37 1.21-.77 1.72-1.19z'
          />
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_433_'
              gradientUnits='userSpaceOnUse'
              x1={527.224}
              y1={252.264}
              x2={495.191}
              y2={252.264}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M525.58 141.09c.02 2.37-1.52 4.75-4.64 6.57-6.22 3.64-16.36 3.67-22.65.06-3.14-1.8-4.73-4.17-4.74-6.55l.02 6.53c.02 2.37 1.6 4.74 4.74 6.55 6.28 3.61 16.42 3.58 22.65-.06 3.11-1.82 4.66-4.2 4.64-6.57l-.02-6.53z'
              fill='url(#dataMigr_banner_svg__SVGID_433_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_434_'
              gradientUnits='userSpaceOnUse'
              x1={527.224}
              y1={252.264}
              x2={495.191}
              y2={252.264}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M525.58 141.09c.02 2.37-1.52 4.75-4.64 6.57-6.22 3.64-16.36 3.67-22.65.06-3.14-1.8-4.73-4.17-4.74-6.55l.02 6.53c.02 2.37 1.6 4.74 4.74 6.55 6.28 3.61 16.42 3.58 22.65-.06 3.11-1.82 4.66-4.2 4.64-6.57l-.02-6.53z'
              fill='url(#dataMigr_banner_svg__SVGID_434_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_435_'
              gradientUnits='userSpaceOnUse'
              x1={527.231}
              y1={260.155}
              x2={495.201}
              y2={260.155}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M498.3 147.73c6.28 3.61 16.42 3.58 22.65-.06 3.11-1.82 4.66-4.2 4.64-6.57-.02-2.37-1.6-4.74-4.75-6.55-6.28-3.6-16.42-3.58-22.65.06-3.11 1.82-4.65 4.2-4.63 6.57.02 2.37 1.6 4.74 4.74 6.55z'
              fill='url(#dataMigr_banner_svg__SVGID_435_)'
            />
            <path
              className='dataMigr_banner_svg__st25'
              d='M522.46 149.4v1.02c-.4.3-.84.59-1.31.86-3.16 1.85-7.33 2.78-11.5 2.79-4.17.01-8.35-.9-11.55-2.73-.5-.29-.96-.59-1.39-.9v-1.01c.53.43 1.12.84 1.79 1.22 6.16 3.54 16.14 3.51 22.24-.06.65-.38 1.22-.78 1.72-1.19z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_436_'
              gradientUnits='userSpaceOnUse'
              x1={527.225}
              y1={260.004}
              x2={495.192}
              y2={260.004}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M525.56 133.35c.02 2.37-1.52 4.75-4.64 6.57-6.22 3.64-16.36 3.67-22.65.06-3.14-1.8-4.73-4.17-4.74-6.55l.02 6.53c.02 2.37 1.6 4.74 4.74 6.55 6.28 3.61 16.42 3.58 22.65-.06 3.11-1.82 4.66-4.2 4.64-6.57l-.02-6.53z'
              fill='url(#dataMigr_banner_svg__SVGID_436_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_437_'
              gradientUnits='userSpaceOnUse'
              x1={527.225}
              y1={260.004}
              x2={495.192}
              y2={260.004}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M525.56 133.35c.02 2.37-1.52 4.75-4.64 6.57-6.22 3.64-16.36 3.67-22.65.06-3.14-1.8-4.73-4.17-4.74-6.55l.02 6.53c.02 2.37 1.6 4.74 4.74 6.55 6.28 3.61 16.42 3.58 22.65-.06 3.11-1.82 4.66-4.2 4.64-6.57l-.02-6.53z'
              fill='url(#dataMigr_banner_svg__SVGID_437_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_438_'
              gradientUnits='userSpaceOnUse'
              x1={527.232}
              y1={267.905}
              x2={495.212}
              y2={267.905}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M498.28 139.98c6.28 3.61 16.42 3.58 22.65-.06 3.11-1.82 4.66-4.2 4.64-6.57-.02-2.37-1.6-4.74-4.74-6.55-6.28-3.6-16.42-3.58-22.65.06-3.11 1.82-4.65 4.2-4.63 6.57 0 2.38 1.59 4.75 4.73 6.55z'
              fill='url(#dataMigr_banner_svg__SVGID_438_)'
            />
            <path
              className='dataMigr_banner_svg__st25'
              d='M522.44 141.65v1.02c-.4.3-.84.59-1.31.86-3.16 1.85-7.33 2.78-11.5 2.79-4.17.01-8.35-.9-11.55-2.73-.5-.29-.96-.59-1.39-.9v-1.01c.53.43 1.12.84 1.79 1.22 6.16 3.54 16.14 3.51 22.24-.06.65-.38 1.22-.77 1.72-1.19z'
            />
          </g>
          <g>
            <linearGradient
              id='dataMigr_banner_svg__SVGID_439_'
              gradientUnits='userSpaceOnUse'
              x1={527.225}
              y1={267.754}
              x2={495.193}
              y2={267.754}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M525.54 125.6c.02 2.37-1.52 4.75-4.64 6.57-6.22 3.64-16.36 3.67-22.65.06-3.14-1.8-4.73-4.17-4.74-6.55l.02 6.53c.02 2.37 1.6 4.74 4.74 6.55 6.28 3.61 16.42 3.58 22.65-.06 3.11-1.82 4.66-4.2 4.64-6.57l-.02-6.53z'
              fill='url(#dataMigr_banner_svg__SVGID_439_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_440_'
              gradientUnits='userSpaceOnUse'
              x1={527.225}
              y1={267.754}
              x2={495.193}
              y2={267.754}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M525.54 125.6c.02 2.37-1.52 4.75-4.64 6.57-6.22 3.64-16.36 3.67-22.65.06-3.14-1.8-4.73-4.17-4.74-6.55l.02 6.53c.02 2.37 1.6 4.74 4.74 6.55 6.28 3.61 16.42 3.58 22.65-.06 3.11-1.82 4.66-4.2 4.64-6.57l-.02-6.53z'
              fill='url(#dataMigr_banner_svg__SVGID_440_)'
            />
            <linearGradient
              id='dataMigr_banner_svg__SVGID_441_'
              gradientUnits='userSpaceOnUse'
              x1={527.233}
              y1={275.655}
              x2={495.213}
              y2={275.655}
              gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
            >
              <stop offset={0.117} stopColor='#dddcf9' />
              <stop offset={0.562} stopColor='#fff' />
              <stop offset={0.708} stopColor='#f9f8fe' />
              <stop offset={0.915} stopColor='#e6e6fb' />
              <stop offset={1} stopColor='#dddcf9' />
            </linearGradient>
            <path
              d='M498.26 132.23c6.28 3.61 16.42 3.58 22.65-.06 3.11-1.82 4.66-4.2 4.64-6.57-.02-2.37-1.6-4.74-4.74-6.55-6.28-3.6-16.42-3.58-22.65.06-3.11 1.82-4.65 4.2-4.63 6.57 0 2.38 1.59 4.75 4.73 6.55z'
              fill='url(#dataMigr_banner_svg__SVGID_441_)'
            />
            <path
              className='dataMigr_banner_svg__st25'
              d='M522.42 133.9v1.02c-.4.3-.84.59-1.31.86-3.16 1.85-7.33 2.78-11.5 2.79-4.17.01-8.35-.9-11.55-2.73-.5-.29-.96-.59-1.39-.9v-1.01c.53.43 1.12.84 1.79 1.22 6.16 3.54 16.14 3.51 22.24-.06.65-.37 1.22-.77 1.72-1.19z'
            />
          </g>
          <linearGradient
            id='dataMigr_banner_svg__SVGID_442_'
            gradientUnits='userSpaceOnUse'
            x1={502.133}
            y1={275.657}
            x2={520.293}
            y2={275.657}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0.117} stopColor='#dddcf9' />
            <stop offset={0.562} stopColor='#fff' />
            <stop offset={0.708} stopColor='#f9f8fe' />
            <stop offset={0.915} stopColor='#e6e6fb' />
            <stop offset={1} stopColor='#dddcf9' />
          </linearGradient>
          <path
            d='M503.14 129.38c3.56 2.04 9.31 2.03 12.84-.04 1.76-1.03 2.64-2.38 2.63-3.73-.01-1.35-.91-2.69-2.69-3.71-3.56-2.04-9.31-2.03-12.84.04-1.76 1.03-2.64 2.38-2.63 3.73.01 1.34.91 2.69 2.69 3.71z'
            fill='url(#dataMigr_banner_svg__SVGID_442_)'
          />
          <path
            className='dataMigr_banner_svg__st25'
            d='M506 127.71c1.97 1.13 5.14 1.12 7.09-.02.97-.57 1.46-1.31 1.45-2.06-.01-.74-.5-1.49-1.49-2.05-1.97-1.13-5.14-1.12-7.09.02-.97.57-1.46 1.31-1.45 2.06.01.74.51 1.48 1.49 2.05z'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_443_'
            gradientUnits='userSpaceOnUse'
            x1={511.207}
            y1={272.756}
            x2={511.207}
            y2={311.843}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0} stopColor='#5c90fe' />
            <stop offset={0.287} stopColor='#5180fc' stopOpacity={0.713} />
            <stop offset={0.613} stopColor='#4a75fa' stopOpacity={0.387} />
            <stop offset={1} stopColor='#4872fa' stopOpacity={0} />
          </linearGradient>
          <path
            d='M504.41 89.47l.1 36.18c.01.74.5 1.49 1.49 2.05 1.97 1.13 5.14 1.12 7.09-.02.97-.57 1.46-1.31 1.45-2.06l-.1-36.18-10.03.03z'
            fill='url(#dataMigr_banner_svg__SVGID_443_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_444_'
            gradientUnits='userSpaceOnUse'
            x1={511.209}
            y1={270.396}
            x2={511.209}
            y2={294.364}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0} stopColor='#5c90fe' />
            <stop offset={0.287} stopColor='#5180fc' stopOpacity={0.713} />
            <stop offset={0.613} stopColor='#4a75fa' stopOpacity={0.387} />
            <stop offset={1} stopColor='#4872fa' stopOpacity={0} />
          </linearGradient>
          <path
            d='M493.46 106.99l6.99 18.68c.01 1.35.91 2.69 2.69 3.71 3.56 2.04 9.31 2.03 12.84-.04 1.76-1.03 2.64-2.38 2.63-3.73l6.88-18.72-32.03.1z'
            fill='url(#dataMigr_banner_svg__SVGID_444_)'
          />
          <linearGradient
            id='dataMigr_banner_svg__SVGID_445_'
            gradientUnits='userSpaceOnUse'
            x1={511.212}
            y1={270.396}
            x2={511.212}
            y2={304.682}
            gradientTransform='matrix(1 -.0027 -.0027 -1 -.939 402.677)'
          >
            <stop offset={0} stopColor='#5c90fe' />
            <stop offset={0.287} stopColor='#5180fc' stopOpacity={0.713} />
            <stop offset={0.613} stopColor='#4a75fa' stopOpacity={0.387} />
            <stop offset={1} stopColor='#4872fa' stopOpacity={0} />
          </linearGradient>
          <path
            d='M500.37 96.65l.08 29.02c.01 1.35.91 2.69 2.69 3.71 3.56 2.04 9.31 2.03 12.84-.04 1.76-1.03 2.64-2.38 2.63-3.73l-.08-29.02-18.16.06z'
            fill='url(#dataMigr_banner_svg__SVGID_445_)'
          />
        </g>
      </g>
    </g>
  </svg>
)
export default SvgDataMigrBanner
